const faMetadata = {
  "far": [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "fill-drip",
    "arrows-to-circle",
    "chevron-circle-right",
    "circle-chevron-right",
    "wagon-covered",
    "line-height",
    "bagel",
    "transporter-7",
    "at",
    "rectangles-mixed",
    "phone-arrow-up",
    "phone-outgoing",
    "phone-arrow-up-right",
    "trash-alt",
    "trash-can",
    "circle-l",
    "head-vr",
    "head-side-goggles",
    "text-height",
    "user-times",
    "user-xmark",
    "face-hand-yawn",
    "tachometer-slowest",
    "gauge-simple-min",
    "stethoscope",
    "coffin",
    "comment-alt",
    "message",
    "bowl-salad",
    "salad",
    "info",
    "robot-astromech",
    "ring-diamond",
    "fondue-pot",
    "theta",
    "face-hand-peeking",
    "square-user",
    "compress-alt",
    "down-left-and-up-right-to-center",
    "explosion",
    "file-alt",
    "file-text",
    "file-lines",
    "wave-square",
    "ring",
    "building-un",
    "dice-three",
    "tire-pressure-warning",
    "wifi-2",
    "wifi-fair",
    "calendar-alt",
    "calendar-days",
    "mp3-player",
    "anchor-circle-check",
    "tally-4",
    "rectangle-history",
    "building-circle-arrow-right",
    "volleyball-ball",
    "volleyball",
    "sun-haze",
    "text-size",
    "ufo",
    "utensil-fork",
    "fork",
    "arrows-up-to-line",
    "mobile-signal",
    "barcode-scan",
    "sort-desc",
    "sort-down",
    "folder-download",
    "folder-arrow-down",
    "minus-circle",
    "circle-minus",
    "face-icicles",
    "shovel",
    "door-open",
    "films",
    "sign-out-alt",
    "right-from-bracket",
    "face-glasses",
    "nfc",
    "atom",
    "soap",
    "heart-music-camera-bolt",
    "icons",
    "microphone-alt-slash",
    "microphone-lines-slash",
    "closed-captioning-slash",
    "calculator-alt",
    "calculator-simple",
    "bridge-circle-check",
    "sliders-v",
    "sliders-up",
    "map-marker-minus",
    "location-minus",
    "pump-medical",
    "fingerprint",
    "ski-boot",
    "rectangle-sd",
    "standard-definition",
    "h1",
    "hand-point-right",
    "search-location",
    "magnifying-glass-location",
    "message-bot",
    "step-forward",
    "forward-step",
    "smile-beam",
    "face-smile-beam",
    "light-ceiling",
    "comment-alt-exclamation",
    "message-exclamation",
    "bowl-shaved-ice",
    "bowl-scoop",
    "square-x",
    "building-memo",
    "utility-pole-double",
    "flag-checkered",
    "chevron-double-up",
    "chevrons-up",
    "football-ball",
    "football",
    "user-vneck",
    "school-circle-exclamation",
    "crop",
    "angle-double-down",
    "angles-down",
    "users-rectangle",
    "people-roof",
    "arrow-square-right",
    "square-arrow-right",
    "map-marker-plus",
    "location-plus",
    "lightbulb-exclamation-on",
    "people-line",
    "beer",
    "beer-mug-empty",
    "crate-empty",
    "diagram-predecessor",
    "transporter",
    "calendar-circle-user",
    "long-arrow-up",
    "arrow-up-long",
    "person-carry",
    "person-carry-box",
    "burn",
    "fire-flame-simple",
    "male",
    "person",
    "laptop",
    "file-csv",
    "menorah",
    "union",
    "chevron-double-left",
    "chevrons-left",
    "heart-circle",
    "circle-heart",
    "truck-plane",
    "record-vinyl",
    "bring-forward",
    "square-p",
    "grin-stars",
    "face-grin-stars",
    "sigma",
    "camera-movie",
    "bong",
    "clarinet",
    "truck-flatbed",
    "pastafarianism",
    "spaghetti-monster-flying",
    "arrow-down-up-across-line",
    "arrows-rotate-reverse",
    "leaf-heart",
    "house-building",
    "cheese-swiss",
    "utensil-spoon",
    "spoon",
    "jar-wheat",
    "mail-bulk",
    "envelopes-bulk",
    "file-circle-exclamation",
    "bow-arrow",
    "cart-xmark",
    "times-hexagon",
    "xmark-hexagon",
    "hexagon-xmark",
    "hospital-symbol",
    "circle-h",
    "merge",
    "pager",
    "cart-minus",
    "contact-book",
    "address-book",
    "pan-frying",
    "grid-3",
    "grid",
    "football-helmet",
    "hand-love",
    "trees",
    "strikethrough",
    "page",
    "k",
    "diagram-previous",
    "tachometer-alt-slowest",
    "gauge-min",
    "folder-grid",
    "eggplant",
    "excavator",
    "ram",
    "landmark-flag",
    "lips",
    "pencil-alt",
    "pencil",
    "backward",
    "caret-right",
    "comments",
    "file-clipboard",
    "paste",
    "desktop-arrow-down",
    "code-pull-request",
    "pumpkin",
    "clipboard-list",
    "pen-field",
    "blueberries",
    "truck-loading",
    "truck-ramp-box",
    "note",
    "arrow-down-to-square",
    "user-check",
    "cloud-xmark",
    "vial-virus",
    "book-alt",
    "book-blank",
    "golf-flag-hole",
    "comment-alt-arrow-down",
    "message-arrow-down",
    "face-unamused",
    "sheet-plastic",
    "circle-9",
    "blog",
    "user-ninja",
    "pencil-slash",
    "bowling-pins",
    "person-arrow-up-from-line",
    "down-right",
    "torah",
    "scroll-torah",
    "webhook",
    "blinds-open",
    "fence",
    "arrow-alt-up",
    "up",
    "quidditch",
    "quidditch-broom-ball",
    "broom-ball",
    "drumstick",
    "square-v",
    "gave-dandy",
    "face-awesome",
    "dial-off",
    "toggle-off",
    "face-smile-horns",
    "archive",
    "box-archive",
    "grapes",
    "person-drowning",
    "dial-max",
    "circle-m",
    "calendar-image",
    "caret-circle-down",
    "circle-caret-down",
    "sort-numeric-desc",
    "sort-numeric-down-alt",
    "arrow-down-9-1",
    "grin-tongue-squint",
    "face-grin-tongue-squint",
    "shish-kebab",
    "spray-can",
    "alarm-snooze",
    "scarecrow",
    "truck-monster",
    "gift-card",
    "w",
    "code-pull-request-draft",
    "square-b",
    "elephant",
    "globe-africa",
    "earth-africa",
    "rainbow",
    "circle-notch",
    "tablet-alt",
    "tablet-screen-button",
    "paw",
    "message-question",
    "cloud",
    "trowel-bricks",
    "square-3",
    "flushed",
    "face-flushed",
    "hospital-user",
    "microwave",
    "chf-sign",
    "tent-arrow-left-right",
    "cart-circle-arrow-up",
    "trash-clock",
    "reflect-both",
    "legal",
    "gavel",
    "sprinkler-ceiling",
    "browsers",
    "trillium",
    "music-slash",
    "truck-ramp",
    "binoculars",
    "microphone-slash",
    "box-tissue",
    "circle-c",
    "star-christmas",
    "chart-bullet",
    "motorcycle",
    "tree-christmas",
    "tire-flat",
    "sunglasses",
    "badge",
    "comment-alt-edit",
    "message-edit",
    "message-pen",
    "concierge-bell",
    "bell-concierge",
    "pencil-ruler",
    "pen-ruler",
    "file-mp3",
    "arrow-progress",
    "chess-rook-alt",
    "chess-rook-piece",
    "square-root",
    "album-collection-circle-plus",
    "people-arrows-left-right",
    "people-arrows",
    "sign-post",
    "face-angry-horns",
    "mars-and-venus-burst",
    "tombstone",
    "caret-square-right",
    "square-caret-right",
    "cut",
    "scissors",
    "list-music",
    "sun-plant-wilt",
    "toilets-portable",
    "hockey-puck",
    "mustache",
    "hyphen",
    "table",
    "user-chef",
    "comment-alt-image",
    "message-image",
    "users-medical",
    "sensor-alert",
    "sensor-triangle-exclamation",
    "magnifying-glass-arrow-right",
    "digital-tachograph",
    "tachograph-digital",
    "face-mask",
    "pickleball",
    "star-sharp-half",
    "users-slash",
    "clover",
    "meat",
    "mail-reply",
    "reply",
    "star-and-crescent",
    "empty-set",
    "house-fire",
    "minus-square",
    "square-minus",
    "helicopter",
    "bird",
    "compass",
    "caret-square-down",
    "square-caret-down",
    "heart-half-alt",
    "heart-half-stroke",
    "file-circle-question",
    "truck-utensils",
    "laptop-code",
    "joystick",
    "grill-fire",
    "rectangle-vertical-history",
    "swatchbook",
    "prescription-bottle",
    "navicon",
    "bars",
    "keyboard-left",
    "people-group",
    "hourglass-3",
    "hourglass-end",
    "heart-broken",
    "heart-crack",
    "face-beam-hand-over-mouth",
    "humidity",
    "droplet-percent",
    "external-link-square-alt",
    "square-up-right",
    "kiss-beam",
    "face-kiss-beam",
    "corn",
    "roller-coaster",
    "photo-film-music",
    "radar",
    "sickle",
    "film",
    "coconut",
    "ruler-horizontal",
    "shield-cross",
    "cassette-tape",
    "square-terminal",
    "people-robbery",
    "lightbulb",
    "caret-left",
    "comment-middle",
    "trash-can-list",
    "block",
    "exclamation-circle",
    "circle-exclamation",
    "school-circle-xmark",
    "sign-out",
    "arrow-right-from-bracket",
    "face-frown-slight",
    "chevron-circle-down",
    "circle-chevron-down",
    "sidebar-flip",
    "unlock-alt",
    "unlock-keyhole",
    "temperature-list",
    "cloud-showers-heavy",
    "headphones-alt",
    "headphones-simple",
    "sitemap",
    "pipe-section",
    "space-station-moon-alt",
    "space-station-moon-construction",
    "donate",
    "circle-dollar-to-slot",
    "memory",
    "face-sleeping",
    "road-spikes",
    "fire-burner",
    "squirrel",
    "arrow-to-top",
    "arrow-up-to-line",
    "flag",
    "face-cowboy-hat",
    "hanukiah",
    "chart-scatter-3d",
    "display-chart-up",
    "square-code",
    "feather",
    "volume-down",
    "volume-low",
    "times-to-slot",
    "vote-nay",
    "xmark-to-slot",
    "box-alt",
    "box-taped",
    "comment-slash",
    "swords",
    "cloud-sun-rain",
    "album",
    "circle-n",
    "compress",
    "wheat-alt",
    "wheat-awn",
    "ankh",
    "hands-holding-child",
    "asterisk",
    "key-skeleton-left-right",
    "comment-lines",
    "luchador",
    "mask-luchador",
    "luchador-mask",
    "check-square",
    "square-check",
    "shredder",
    "book-open-alt",
    "book-open-cover",
    "sandwich",
    "peseta-sign",
    "parking-slash",
    "square-parking-slash",
    "train-tunnel",
    "header",
    "heading",
    "ghost",
    "face-anguished",
    "hockey-sticks",
    "abacus",
    "film-alt",
    "film-simple",
    "list-squares",
    "list",
    "tree-palm",
    "phone-square-alt",
    "square-phone-flip",
    "cart-plus",
    "gamepad",
    "border-center-v",
    "dot-circle",
    "circle-dot",
    "clipboard-medical",
    "dizzy",
    "face-dizzy",
    "egg",
    "arrow-alt-to-top",
    "up-to-line",
    "house-medical-circle-xmark",
    "watch-fitness",
    "clock-nine-thirty",
    "campground",
    "folder-plus",
    "jug",
    "futbol-ball",
    "soccer-ball",
    "futbol",
    "snow-blowing",
    "paint-brush",
    "paintbrush",
    "lock",
    "arrow-from-top",
    "arrow-down-from-line",
    "gas-pump",
    "signal-alt-slash",
    "signal-bars-slash",
    "monkey",
    "pro",
    "rectangle-pro",
    "house-night",
    "hot-tub",
    "hot-tub-person",
    "globe-pointer",
    "blanket",
    "map-marked",
    "map-location",
    "house-flood-water",
    "comments-question-check",
    "tree",
    "arrows-cross",
    "backpack",
    "square-small",
    "folder-upload",
    "folder-arrow-up",
    "bridge-lock",
    "crosshairs-simple",
    "sack-dollar",
    "edit",
    "pen-to-square",
    "sliders-h-square",
    "square-sliders",
    "car-side",
    "comment-middle-top-alt",
    "message-middle-top",
    "lightbulb-on",
    "utensil-knife",
    "knife",
    "share-alt",
    "share-nodes",
    "display-chart-up-circle-dollar",
    "wave-sine",
    "heart-circle-minus",
    "circle-w",
    "calendar-circle",
    "circle-calendar",
    "hourglass-2",
    "hourglass-half",
    "microscope",
    "sunset",
    "sink",
    "calendar-exclamation",
    "truck-container-empty",
    "hand-heart",
    "shopping-bag",
    "bag-shopping",
    "sort-alpha-desc",
    "sort-alpha-down-alt",
    "arrow-down-z-a",
    "mitten",
    "reply-time",
    "reply-clock",
    "person-rays",
    "arrow-alt-right",
    "right",
    "circle-f",
    "users",
    "face-pleading",
    "eye-slash",
    "flask-vial",
    "police-box",
    "cucumber",
    "head-side-brain",
    "hand-paper",
    "hand",
    "biking-mountain",
    "person-biking-mountain",
    "utensils-slash",
    "print-search",
    "print-magnifying-glass",
    "turn-right",
    "folder-bookmark",
    "arrow-turn-left-down",
    "om",
    "pi",
    "flask-potion",
    "flask-round-potion",
    "face-shush",
    "worm",
    "house-circle-xmark",
    "plug",
    "calendar-circle-exclamation",
    "square-i",
    "chevron-up",
    "face-saluting",
    "tachometer-slow",
    "gauge-simple-low",
    "face-persevering",
    "camera-circle",
    "circle-camera",
    "hand-spock",
    "spider-web",
    "microphone-circle",
    "circle-microphone",
    "book-arrow-up",
    "popsicle",
    "command",
    "blinds",
    "stopwatch",
    "saxophone",
    "square-2",
    "field-hockey",
    "field-hockey-stick-ball",
    "sort-shapes-up-alt",
    "arrow-up-square-triangle",
    "face-scream",
    "square-m",
    "webcam",
    "camera-web",
    "comment-arrow-down",
    "lightbulb-cfl",
    "window-frame-open",
    "kiss",
    "face-kiss",
    "bridge-circle-xmark",
    "period",
    "grin-tongue",
    "face-grin-tongue",
    "up-to-dotted-line",
    "thought-bubble",
    "skeleton-ribs",
    "raygun",
    "flute",
    "acorn",
    "video-arrow-up-right",
    "grate-droplet",
    "seal-exclamation",
    "chess-bishop",
    "message-sms",
    "coffee-beans",
    "hat-witch",
    "grin-wink",
    "face-grin-wink",
    "clock-three-thirty",
    "deaf",
    "deafness",
    "hard-of-hearing",
    "ear-deaf",
    "alarm-clock",
    "eclipse",
    "face-relieved",
    "road-circle-check",
    "dice-five",
    "minus-octagon",
    "octagon-minus",
    "rss-square",
    "square-rss",
    "face-zany",
    "tricycle",
    "land-mine-on",
    "square-arrow-up-left",
    "i-cursor",
    "chart-mixed-up-circle-dollar",
    "salt-shaker",
    "stamp",
    "file-plus",
    "draw-square",
    "toilet-paper-reverse-slash",
    "toilet-paper-under-slash",
    "stairs",
    "drone-alt",
    "drone-front",
    "glass-empty",
    "dial-high",
    "user-construction",
    "user-hard-hat",
    "user-helmet-safety",
    "i",
    "hryvnia",
    "hryvnia-sign",
    "arrow-down-left-and-arrow-up-right-to-center",
    "pills",
    "grin-alt",
    "face-grin-wide",
    "tooth",
    "basketball-hoop",
    "objects-align-bottom",
    "v",
    "sparkles",
    "squid",
    "leafy-green",
    "circle-arrow-up-right",
    "calendars",
    "bangladeshi-taka-sign",
    "bicycle",
    "hammer-war",
    "circle-d",
    "spider-black-widow",
    "rod-asclepius",
    "rod-snake",
    "staff-aesculapius",
    "staff-snake",
    "pear",
    "head-side-cough-slash",
    "file-mov",
    "triangle",
    "apartment",
    "ambulance",
    "truck-medical",
    "pepper",
    "piano",
    "gun-squirt",
    "wheat-awn-circle-exclamation",
    "snowman",
    "user-alien",
    "shield-check",
    "mortar-pestle",
    "road-barrier",
    "chart-candlestick",
    "briefcase-blank",
    "school",
    "igloo",
    "parenthesis",
    "bracket-round",
    "joint",
    "horse-saddle",
    "mug-marshmallows",
    "filters",
    "bell-on",
    "angle-right",
    "dial-med",
    "horse",
    "q",
    "monitor-heart-rate",
    "monitor-waveform",
    "link-simple",
    "whistle",
    "g",
    "fragile",
    "wine-glass-crack",
    "slot-machine",
    "notes-medical",
    "car-wash",
    "escalator",
    "comment-image",
    "temperature-2",
    "thermometer-2",
    "thermometer-half",
    "temperature-half",
    "dong-sign",
    "doughnut",
    "donut",
    "capsules",
    "poo-bolt",
    "poo-storm",
    "tally-1",
    "file-vector",
    "frown-open",
    "face-frown-open",
    "square-dashed",
    "bag-shopping-plus",
    "square-j",
    "hand-point-up",
    "money-bill",
    "sort-size-up",
    "arrow-up-big-small",
    "barcode-read",
    "baguette",
    "bowl-soft-serve",
    "face-holding-back-tears",
    "arrow-alt-square-up",
    "square-up",
    "subway-tunnel",
    "train-subway-tunnel",
    "exclamation-square",
    "square-exclamation",
    "semicolon",
    "bookmark",
    "fan-table",
    "align-justify",
    "battery-1",
    "battery-low",
    "credit-card-front",
    "mind-share",
    "brain-arrow-curved-right",
    "umbrella-beach",
    "helmet-un",
    "map-marker-smile",
    "location-smile",
    "arrow-to-left",
    "arrow-left-to-line",
    "bullseye",
    "nigiri",
    "sushi",
    "comment-alt-captions",
    "message-captions",
    "trash-list",
    "bacon",
    "option",
    "raccoon",
    "hand-point-down",
    "arrow-up-from-bracket",
    "head-side-gear",
    "trash-plus",
    "file-cad",
    "objects-align-top",
    "folder-blank",
    "folder",
    "face-anxious-sweat",
    "credit-card-blank",
    "file-medical-alt",
    "file-waveform",
    "microchip-ai",
    "mug",
    "plane-up-slash",
    "radiation",
    "pen-circle",
    "bag-seedling",
    "chart-simple",
    "crutches",
    "parking-circle",
    "circle-parking",
    "mars-stroke",
    "leaf-oak",
    "square-bolt",
    "vial",
    "dashboard",
    "gauge-med",
    "tachometer-alt-average",
    "gauge",
    "magic-wand-sparkles",
    "wand-magic-sparkles",
    "lambda",
    "e",
    "pizza",
    "bowl-chopsticks-noodles",
    "h3",
    "pen-alt",
    "pen-clip",
    "bridge-circle-exclamation",
    "badge-percent",
    "rotate-reverse",
    "user",
    "sensor",
    "comma",
    "school-circle-check",
    "toilet-paper-reverse",
    "toilet-paper-under",
    "light-emergency",
    "arrow-down-to-arc",
    "dumpster",
    "shuttle-van",
    "van-shuttle",
    "building-user",
    "light-switch",
    "caret-square-left",
    "square-caret-left",
    "highlighter",
    "heart-rate",
    "wave-pulse",
    "key",
    "arrow-left-to-bracket",
    "hat-santa",
    "tamale",
    "box-check",
    "bullhorn",
    "steak",
    "location-slash",
    "location-crosshairs-slash",
    "person-dolly",
    "globe",
    "synagogue",
    "file-chart-line",
    "file-chart-column",
    "person-half-dress",
    "folder-image",
    "calendar-edit",
    "calendar-pen",
    "road-bridge",
    "face-smile-tear",
    "comment-alt-plus",
    "message-plus",
    "location-arrow",
    "c",
    "tablet-button",
    "person-dress-fairy",
    "rectangle-history-circle-user",
    "building-lock",
    "chart-line-up",
    "mailbox",
    "sign-posts",
    "truck-bolt",
    "pizza-slice",
    "money-bill-wave",
    "area-chart",
    "chart-area",
    "house-flag",
    "circle-three-quarters-stroke",
    "person-circle-minus",
    "scalpel",
    "cancel",
    "ban",
    "bell-exclamation",
    "bookmark-circle",
    "circle-bookmark",
    "egg-fried",
    "face-weary",
    "uniform-martial-arts",
    "camera-rotate",
    "sun-dust",
    "comment-text",
    "air-freshener",
    "spray-can-sparkles",
    "signal-alt",
    "signal-alt-4",
    "signal-bars-strong",
    "signal-bars",
    "diamond-exclamation",
    "star",
    "dial-min",
    "repeat",
    "cross",
    "file-caret-down",
    "page-caret-down",
    "box",
    "venus-mars",
    "clock-seven-thirty",
    "mouse-pointer",
    "arrow-pointer",
    "clock-four-thirty",
    "signal-alt-3",
    "signal-bars-good",
    "cactus",
    "lightbulb-gear",
    "expand-arrows-alt",
    "maximize",
    "charging-station",
    "triangle-circle-square",
    "shapes",
    "plane-tail",
    "tachometer-fastest",
    "gauge-simple-max",
    "circle-u",
    "shield-slash",
    "phone-square-down",
    "square-phone-hangup",
    "arrow-up-left",
    "transporter-1",
    "peanuts",
    "random",
    "shuffle",
    "running",
    "person-running",
    "mobile-retro",
    "grip-lines-vertical",
    "bin-bottles-recycle",
    "arrow-up-from-square",
    "page-break",
    "file-dashed-line",
    "bracket-curly-right",
    "spider",
    "clock-three",
    "hands-bound",
    "scalpel-path",
    "scalpel-line-dashed",
    "file-invoice-dollar",
    "pipe-smoking",
    "face-astonished",
    "window",
    "plane-circle-exclamation",
    "ear",
    "file-lock",
    "diagram-venn",
    "arrow-down-from-bracket",
    "x-ray",
    "goal-net",
    "coffin-cross",
    "spell-check",
    "map-marker-times",
    "map-marker-xmark",
    "location-xmark",
    "circle-quarter-stroke",
    "lasso",
    "slash",
    "portal-enter",
    "person-to-portal",
    "calendar-star",
    "mouse",
    "computer-mouse",
    "sign-in",
    "arrow-right-to-bracket",
    "pegasus",
    "files-medical",
    "cannon",
    "nfc-lock",
    "ski-lift",
    "person-ski-lift",
    "square-6",
    "store-alt-slash",
    "shop-slash",
    "wind-turbine",
    "sliders-simple",
    "grid-round",
    "badge-sheriff",
    "server",
    "virus-covid-slash",
    "intersection",
    "shop-lock",
    "family",
    "hourglass-1",
    "hourglass-start",
    "user-hair-buns",
    "blender-phone",
    "hourglass-clock",
    "person-seat-reclined",
    "paper-plane-alt",
    "send",
    "paper-plane-top",
    "comment-alt-arrow-up",
    "message-arrow-up",
    "lightbulb-exclamation",
    "layer-group-minus",
    "layer-minus",
    "chart-pie-simple-circle-currency",
    "circle-e",
    "building-wheat",
    "tachometer-alt-fastest",
    "gauge-max",
    "person-breastfeeding",
    "apostrophe",
    "file-png",
    "fire-hydrant",
    "sign-in-alt",
    "right-to-bracket",
    "video-plus",
    "arrow-alt-square-right",
    "square-right",
    "comment-smile",
    "venus",
    "passport",
    "inbox-arrow-down",
    "inbox-in",
    "heartbeat",
    "heart-pulse",
    "circle-8",
    "clouds-moon",
    "clock-ten-thirty",
    "people-carry",
    "people-carry-box",
    "folder-user",
    "trash-can-xmark",
    "temperature-high",
    "microchip",
    "left-long-to-line",
    "crown",
    "weight-hanging",
    "xmarks-lines",
    "file-prescription",
    "table-cells-lock",
    "calendar-range",
    "flower-daffodil",
    "hand-back-point-up",
    "weight",
    "weight-scale",
    "arrow-up-to-arc",
    "star-exclamation",
    "books",
    "user-friends",
    "user-group",
    "sort-alpha-up",
    "arrow-up-a-z",
    "layer-group-plus",
    "layer-plus",
    "play-pause",
    "block-question",
    "zzz",
    "snooze",
    "scanner-image",
    "tv-retro",
    "square-t",
    "barn-silo",
    "farm",
    "chess-knight",
    "bars-sort",
    "palette-boxes",
    "pallet-alt",
    "pallet-boxes",
    "laugh-squint",
    "face-laugh-squint",
    "code-simple",
    "bolt-slash",
    "panel-fire",
    "binary-circle-check",
    "comment-minus",
    "burrito",
    "violin",
    "objects-column",
    "chevron-square-down",
    "square-chevron-down",
    "comment-plus",
    "triangle-music",
    "triangle-instrument",
    "wheelchair",
    "user-pilot-tie",
    "piano-keyboard",
    "bed-empty",
    "arrow-circle-up",
    "circle-arrow-up",
    "toggle-on",
    "rectangle-portrait",
    "rectangle-vertical",
    "walking",
    "person-walking",
    "l",
    "signal-stream",
    "down-to-bracket",
    "circle-z",
    "stars",
    "fire",
    "procedures",
    "bed-pulse",
    "house-day",
    "space-shuttle",
    "shuttle-space",
    "shirt-long-sleeve",
    "chart-pie-alt",
    "chart-pie-simple",
    "laugh",
    "face-laugh",
    "folder-open",
    "album-collection-circle-user",
    "candy",
    "soup",
    "bowl-hot",
    "flatbread",
    "heart-circle-plus",
    "code-fork",
    "city",
    "signal-alt-1",
    "signal-bars-weak",
    "microphone-alt",
    "microphone-lines",
    "clock-twelve",
    "pepper-hot",
    "citrus-slice",
    "sheep",
    "unlock",
    "colon-sign",
    "headset",
    "badger-honey",
    "h4",
    "store-slash",
    "road-circle-xmark",
    "signal-slash",
    "user-minus",
    "mars-stroke-v",
    "mars-stroke-up",
    "glass-cheers",
    "champagne-glasses",
    "taco",
    "plus-hexagon",
    "hexagon-plus",
    "clipboard",
    "house-circle-exclamation",
    "file-upload",
    "file-arrow-up",
    "wifi-3",
    "wifi-strong",
    "wifi",
    "comments-alt",
    "messages",
    "bathtub",
    "bath",
    "umbrella-alt",
    "umbrella-simple",
    "rectangle-history-circle-plus",
    "underline",
    "prescription-bottle-pill",
    "user-edit",
    "user-pen",
    "binary-slash",
    "square-o",
    "caduceus",
    "signature",
    "stroopwafel",
    "bold",
    "anchor-lock",
    "building-ngo",
    "transporter-3",
    "engine-exclamation",
    "engine-warning",
    "circle-down-right",
    "square-k",
    "manat-sign",
    "money-check-edit",
    "money-check-pen",
    "not-equal",
    "border-style",
    "border-top-left",
    "map-marked-alt",
    "map-location-dot",
    "tilde",
    "jedi",
    "poll",
    "square-poll-vertical",
    "sort-shapes-down-alt",
    "arrow-down-square-triangle",
    "mug-hot",
    "dog-leashed",
    "battery-car",
    "car-battery",
    "face-downcast-sweat",
    "mailbox-flag-up",
    "memo-circle-info",
    "gift",
    "dice-two",
    "volume-medium",
    "volume",
    "transporter-5",
    "gauge-circle-bolt",
    "coin-front",
    "file-slash",
    "message-arrow-up-right",
    "treasure-chest",
    "chess-queen",
    "paint-brush-alt",
    "paint-brush-fine",
    "paintbrush-alt",
    "paintbrush-fine",
    "glasses",
    "hood-cloak",
    "square-quote",
    "up-left",
    "bring-front",
    "chess-board",
    "cheeseburger",
    "burger-cheese",
    "building-circle-check",
    "repeat-1",
    "arrow-to-bottom",
    "arrow-down-to-line",
    "grid-5",
    "swap-arrows",
    "right-long-to-line",
    "person-chalkboard",
    "mars-stroke-h",
    "mars-stroke-right",
    "hand-rock",
    "hand-back-fist",
    "grid-round-5",
    "tally-5",
    "tally",
    "caret-square-up",
    "square-caret-up",
    "cloud-showers-water",
    "bar-chart",
    "chart-bar",
    "hands-wash",
    "hands-bubbles",
    "less-than-equal",
    "train",
    "up-from-dotted-line",
    "low-vision",
    "eye-low-vision",
    "traffic-light-go",
    "face-exhaling",
    "sensor-fire",
    "user-unlock",
    "hexagon-divide",
    "00",
    "crow",
    "betamax",
    "cassette-betamax",
    "sailboat",
    "window-restore",
    "nfc-magnifying-glass",
    "file-binary",
    "circle-v",
    "plus-square",
    "square-plus",
    "bowl-scoops",
    "mistletoe",
    "custard",
    "lacrosse-stick",
    "hockey-mask",
    "sunrise",
    "subtitles",
    "panel-ews",
    "torii-gate",
    "cloud-exclamation",
    "comment-alt-lines",
    "message-lines",
    "frog",
    "bucket",
    "floppy-disk-pen",
    "image",
    "window-frame",
    "microphone",
    "cow",
    "file-zip",
    "square-ring",
    "arrow-alt-from-top",
    "down-from-line",
    "caret-up",
    "shield-times",
    "shield-xmark",
    "screwdriver",
    "sort-circle-down",
    "circle-sort-down",
    "folder-closed",
    "house-tsunami",
    "square-nfi",
    "forklift",
    "arrow-up-from-ground-water",
    "bracket-square-right",
    "glass-martini-alt",
    "martini-glass",
    "rotate-back",
    "rotate-backward",
    "undo-alt",
    "rotate-left",
    "columns",
    "table-columns",
    "square-a",
    "tick",
    "lemon",
    "head-side-mask",
    "handshake",
    "gem",
    "dolly-box",
    "dolly",
    "smoking",
    "compress-arrows-alt",
    "minimize",
    "refrigerator",
    "monument",
    "times-octagon",
    "xmark-octagon",
    "octagon-xmark",
    "align-slash",
    "snowplow",
    "angle-double-right",
    "angles-right",
    "truck-couch",
    "truck-ramp-couch",
    "cannabis",
    "play-circle",
    "circle-play",
    "arrow-up-right-and-arrow-down-left-from-center",
    "location-arrow-up",
    "tablets",
    "360-degrees",
    "ethernet",
    "eur",
    "euro",
    "euro-sign",
    "chair",
    "check-circle",
    "circle-check",
    "square-dashed-circle-plus",
    "hand-holding-circle-dollar",
    "money-simple-from-bracket",
    "bat",
    "stop-circle",
    "circle-stop",
    "head-side-headphones",
    "phone-rotary",
    "arrow-up-to-bracket",
    "drafting-compass",
    "compass-drafting",
    "plate-wheat",
    "calendar-circle-minus",
    "chopsticks",
    "car-mechanic",
    "car-wrench",
    "icicles",
    "person-shelter",
    "neuter",
    "id-badge",
    "kazoo",
    "marker",
    "bin-bottles",
    "laugh-beam",
    "face-laugh-beam",
    "square-arrow-down-left",
    "battery-bolt",
    "tree-large",
    "helicopter-symbol",
    "aperture",
    "universal-access",
    "gear-complex",
    "file-search",
    "file-magnifying-glass",
    "up-right",
    "chevron-circle-up",
    "circle-chevron-up",
    "user-police",
    "lari-sign",
    "volcano",
    "teddy-bear",
    "stocking",
    "person-walking-dashed-line-arrow-right",
    "image-slash",
    "mask-snorkel",
    "smoke",
    "gbp",
    "pound-sign",
    "sterling-sign",
    "battery-exclamation",
    "viruses",
    "square-person-confined",
    "user-tie",
    "up-to-bracket",
    "long-arrow-down",
    "arrow-down-long",
    "tent-arrow-down-to-line",
    "certificate",
    "crystal-ball",
    "mail-reply-all",
    "reply-all",
    "suitcase",
    "skating",
    "person-skating",
    "star-shooting",
    "binary-lock",
    "funnel-dollar",
    "filter-circle-dollar",
    "camera-retro",
    "arrow-circle-down",
    "circle-arrow-down",
    "comment-edit",
    "comment-pen",
    "arrow-right-to-file",
    "file-import",
    "banjo",
    "external-link-square",
    "square-arrow-up-right",
    "light-emergency-on",
    "kerning",
    "box-open",
    "square-f",
    "scroll",
    "spa",
    "arrow-from-right",
    "arrow-left-from-line",
    "strawberry",
    "location-pin-lock",
    "pause",
    "clock-eight-thirty",
    "plane-alt",
    "plane-engines",
    "hill-avalanche",
    "temperature-0",
    "thermometer-0",
    "thermometer-empty",
    "temperature-empty",
    "bomb",
    "tachometer-alt-slow",
    "gauge-low",
    "registered",
    "trash-can-plus",
    "contact-card",
    "vcard",
    "address-card",
    "balance-scale-right",
    "scale-unbalanced-flip",
    "globe-snow",
    "subscript",
    "directions",
    "diamond-turn-right",
    "integral",
    "burst",
    "laptop-house",
    "house-laptop",
    "tired",
    "face-tired",
    "money-bills",
    "blinds-raised",
    "smog",
    "ufo-beam",
    "caret-circle-up",
    "circle-caret-up",
    "user-vneck-hair-long",
    "square-a-lock",
    "crutch",
    "gas-pump-slash",
    "font-awesome-flag",
    "font-awesome-logo-full",
    "font-awesome",
    "cloud-upload",
    "cloud-upload-alt",
    "cloud-arrow-up",
    "palette",
    "transporter-4",
    "chart-mixed-up-circle-currency",
    "objects-align-right",
    "arrows-turn-right",
    "vest",
    "pig",
    "inbox-full",
    "envelope-circle",
    "circle-envelope",
    "construction",
    "triangle-person-digging",
    "ferry",
    "bullseye-arrow",
    "arrows-down-to-people",
    "sprout",
    "seedling",
    "clock-seven",
    "arrows-alt-h",
    "left-right",
    "boxes-packing",
    "arrow-circle-left",
    "circle-arrow-left",
    "flashlight",
    "file-jpg",
    "group-arrows-rotate",
    "bowl-food",
    "square-9",
    "candy-cane",
    "sort-amount-asc",
    "sort-amount-down",
    "arrow-down-wide-short",
    "dollar-square",
    "usd-square",
    "square-dollar",
    "phone-arrow-right",
    "hand-holding-seedling",
    "comment-alt-check",
    "message-check",
    "thunderstorm",
    "cloud-bolt",
    "chart-line-up-down",
    "remove-format",
    "text-slash",
    "watch",
    "circle-down-left",
    "text",
    "projector",
    "smile-wink",
    "face-smile-wink",
    "tombstone-alt",
    "tombstone-blank",
    "chess-king-alt",
    "chess-king-piece",
    "circle-6",
    "waves-sine",
    "arrow-alt-left",
    "left",
    "file-word",
    "file-powerpoint",
    "arrow-alt-square-down",
    "square-down",
    "objects-align-center-vertical",
    "arrows-h",
    "arrows-left-right",
    "house-lock",
    "cloud-download",
    "cloud-download-alt",
    "cloud-arrow-down",
    "wreath",
    "children",
    "meter-droplet",
    "blackboard",
    "chalkboard",
    "user-alt-slash",
    "user-large-slash",
    "signal-4",
    "signal-strong",
    "lollypop",
    "lollipop",
    "list-tree",
    "envelope-open",
    "draw-circle",
    "cat-space",
    "handshake-alt-slash",
    "handshake-simple-slash",
    "rabbit-fast",
    "rabbit-running",
    "memo-pad",
    "mattress-pillow",
    "alarm-plus",
    "alicorn",
    "comment-question",
    "gingerbread-man",
    "guarani-sign",
    "burger-fries",
    "mug-tea",
    "border-top",
    "refresh",
    "sync",
    "arrows-rotate",
    "book-circle",
    "circle-book-open",
    "arrows-to-dotted-line",
    "fire-extinguisher",
    "magnifying-glass-arrows-rotate",
    "garage-open",
    "shelves-empty",
    "cruzeiro-sign",
    "watch-apple",
    "watch-calculator",
    "list-dropdown",
    "cabinet-filing",
    "burger-soda",
    "arrow-square-up",
    "square-arrow-up",
    "greater-than-equal",
    "pallet-box",
    "face-confounded",
    "shield-alt",
    "shield-halved",
    "truck-plow",
    "atlas",
    "book-atlas",
    "virus",
    "grid-round-2",
    "comment-middle-top",
    "wave",
    "envelope-circle-check",
    "layer-group",
    "restroom-simple",
    "arrows-to-dot",
    "border-outer",
    "hashtag-lock",
    "clock-two-thirty",
    "archway",
    "heart-circle-check",
    "house-damage",
    "house-chimney-crack",
    "file-archive",
    "file-zipper",
    "ticket-perforated",
    "heart-half",
    "comment-check",
    "square",
    "memo",
    "glass-martini",
    "martini-glass-empty",
    "couch",
    "cedi-sign",
    "italic",
    "glass-citrus",
    "calendar-lines-pen",
    "table-cells-column-lock",
    "church",
    "snowmobile",
    "person-snowmobiling",
    "face-hushed",
    "comments-dollar",
    "tickets-simple",
    "pickaxe",
    "link-simple-slash",
    "democrat",
    "face-confused",
    "pinball",
    "z",
    "skiing",
    "person-skiing",
    "deer",
    "input-pipe",
    "road-lock",
    "a",
    "bookmark-slash",
    "temperature-down",
    "temperature-arrow-down",
    "mace",
    "feather-alt",
    "feather-pointed",
    "sausage",
    "trash-can-clock",
    "p",
    "broom-wide",
    "snowflake",
    "stomach",
    "newspaper",
    "ad",
    "rectangle-ad",
    "guitar-electric",
    "arrow-turn-down-right",
    "moon-cloud",
    "bread-slice-butter",
    "arrow-circle-right",
    "circle-arrow-right",
    "users-crown",
    "user-group-crown",
    "circle-i",
    "toilet-paper-check",
    "filter-circle-xmark",
    "locust",
    "unsorted",
    "sort",
    "list-1-2",
    "list-numeric",
    "list-ol",
    "chart-waterfall",
    "sparkle",
    "face-party",
    "kidneys",
    "wifi-exclamation",
    "chart-network",
    "person-dress-burst",
    "dice-d4",
    "money-check-alt",
    "money-check-dollar",
    "vector-square",
    "bread-slice",
    "language",
    "wheat-awn-slash",
    "kiss-wink-heart",
    "face-kiss-wink-heart",
    "dagger",
    "podium",
    "memo-circle-check",
    "route-highway",
    "arrow-alt-to-bottom",
    "down-to-line",
    "filter",
    "square-g",
    "phone-circle",
    "circle-phone",
    "clipboard-prescription",
    "user-nurse-hair",
    "question",
    "file-signature",
    "toggle-large-on",
    "arrows-alt",
    "up-down-left-right",
    "dryer-alt",
    "dryer-heat",
    "house-chimney-user",
    "hand-holding-heart",
    "sort-size-up-alt",
    "arrow-up-small-big",
    "train-track",
    "puzzle-piece",
    "money-check",
    "star-half-alt",
    "star-half-stroke",
    "file-exclamation",
    "code",
    "glass-whiskey",
    "whiskey-glass",
    "moon-stars",
    "building-circle-exclamation",
    "clothes-hanger",
    "mobile-iphone",
    "mobile-notch",
    "magnifying-glass-chart",
    "external-link",
    "arrow-up-right-from-square",
    "cubes-stacked",
    "images-user",
    "krw",
    "won",
    "won-sign",
    "image-polaroid-user",
    "virus-covid",
    "square-ellipsis",
    "pie",
    "chess-knight-alt",
    "chess-knight-piece",
    "austral-sign",
    "cloud-plus",
    "f",
    "leaf",
    "bed-bunk",
    "road",
    "cab",
    "taxi",
    "person-circle-plus",
    "pie-chart",
    "chart-pie",
    "bolt-lightning",
    "clock-eight",
    "sack-xmark",
    "file-xls",
    "file-excel",
    "file-contract",
    "fish-fins",
    "circle-q",
    "building-flag",
    "grin-beam",
    "face-grin-beam",
    "object-ungroup",
    "face-disguise",
    "circle-arrow-down-right",
    "alien-monster",
    "alien-8bit",
    "hand-point-ribbon",
    "poop",
    "object-exclude",
    "telescope",
    "map-marker",
    "location-pin",
    "square-list",
    "kaaba",
    "toilet-paper",
    "hard-hat",
    "hat-hard",
    "helmet-safety",
    "comment-code",
    "sim-cards",
    "starship",
    "eject",
    "arrow-alt-circle-right",
    "circle-right",
    "plane-circle-check",
    "seal",
    "user-cowboy",
    "hexagon-vertical-nft",
    "meh-rolling-eyes",
    "face-rolling-eyes",
    "bread-loaf",
    "rings-wedding",
    "object-group",
    "french-fries",
    "line-chart",
    "chart-line",
    "calendar-download",
    "calendar-arrow-down",
    "send-back",
    "mask-ventilator",
    "tickets",
    "signature-lock",
    "arrow-right",
    "map-signs",
    "signs-post",
    "plus-octagon",
    "octagon-plus",
    "cash-register",
    "person-circle-question",
    "melon-slice",
    "space-station-moon",
    "comment-alt-smile",
    "message-smile",
    "cup-straw",
    "arrow-alt-from-right",
    "left-from-line",
    "h",
    "shopping-basket-alt",
    "basket-shopping-simple",
    "hands-heart",
    "hands-holding-heart",
    "clock-nine",
    "hammer-brush",
    "tarp",
    "face-sleepy",
    "hand-horns",
    "tools",
    "screwdriver-wrench",
    "arrows-to-eye",
    "circle-three-quarters",
    "trophy-alt",
    "trophy-star",
    "plug-circle-bolt",
    "face-thermometer",
    "grid-round-4",
    "sign-posts-wrench",
    "shirt-running",
    "book-circle-arrow-up",
    "face-nauseated",
    "heart",
    "file-chart-pie",
    "mars-and-venus",
    "home-user",
    "house-user",
    "circle-arrow-down-left",
    "dumpster-fire",
    "minus-hexagon",
    "hexagon-minus",
    "arrow-alt-to-left",
    "left-to-line",
    "house-crack",
    "paw-alt",
    "paw-simple",
    "arrow-left-long-to-line",
    "parentheses",
    "brackets-round",
    "cocktail",
    "martini-glass-citrus",
    "user-shakespeare",
    "arrow-right-to-arc",
    "surprise",
    "face-surprise",
    "bottle-water",
    "pause-circle",
    "circle-pause",
    "gauge-circle-plus",
    "folders",
    "angel",
    "value-absolute",
    "rabbit",
    "toilet-paper-slash",
    "circle-euro",
    "apple-alt",
    "apple-whole",
    "kitchen-set",
    "diamond-half",
    "lock-alt",
    "lock-keyhole",
    "r",
    "temperature-1",
    "thermometer-1",
    "thermometer-quarter",
    "temperature-quarter",
    "info-square",
    "square-info",
    "wifi-slash",
    "toilet-paper-xmark",
    "hands-usd",
    "hands-holding-dollar",
    "cube",
    "sort-shapes-down",
    "arrow-down-triangle-square",
    "bitcoin-sign",
    "shutters",
    "shield-dog",
    "solar-panel",
    "lock-open",
    "table-tree",
    "house-chimney-heart",
    "tally-3",
    "elevator",
    "money-bill-transfer",
    "money-bill-trend-up",
    "house-flood-water-circle-arrow-right",
    "poll-h",
    "square-poll-horizontal",
    "circle",
    "left-to-bracket",
    "cart-circle-exclamation",
    "sword",
    "fast-backward",
    "backward-fast",
    "recycle",
    "user-astronaut",
    "interrobang",
    "plane-slash",
    "circle-dashed",
    "trademark",
    "basketball-ball",
    "basketball",
    "utensils-alt",
    "fork-knife",
    "satellite-dish",
    "badge-check",
    "arrow-alt-circle-up",
    "circle-up",
    "slider",
    "mobile-alt",
    "mobile-screen-button",
    "clock-one-thirty",
    "inbox-arrow-up",
    "inbox-out",
    "cloud-slash",
    "volume-up",
    "volume-high",
    "users-rays",
    "wallet",
    "octagon-check",
    "flatbread-stuffed",
    "clipboard-check",
    "cart-circle-plus",
    "shipping-timed",
    "truck-clock",
    "pool-8-ball",
    "file-audio",
    "turn-down-left",
    "lock-hashtag",
    "chart-radar",
    "staff",
    "hamburger",
    "burger",
    "utility-pole",
    "transporter-6",
    "arrow-turn-left",
    "wrench",
    "bugs",
    "vector-polygon",
    "diagram-nested",
    "rupee",
    "rupee-sign",
    "file-image",
    "question-circle",
    "circle-question",
    "tickets-perforated",
    "image-user",
    "buoy",
    "plane-departure",
    "handshake-slash",
    "book-bookmark",
    "border-center-h",
    "can-food",
    "typewriter",
    "arrow-right-from-arc",
    "circle-k",
    "face-hand-over-mouth",
    "popcorn",
    "house-flood",
    "house-water",
    "object-subtract",
    "code-branch",
    "warehouse-alt",
    "warehouse-full",
    "hat-cowboy",
    "bridge",
    "phone-alt",
    "phone-flip",
    "arrow-down-from-dotted-line",
    "file-doc",
    "square-quarters",
    "truck-front",
    "cat",
    "trash-xmark",
    "caret-circle-left",
    "circle-caret-left",
    "files",
    "anchor-circle-exclamation",
    "face-clouds",
    "user-crown",
    "basket-shopping-plus",
    "truck-field",
    "route",
    "cart-circle-check",
    "clipboard-question",
    "panorama",
    "comment-medical",
    "teeth-open",
    "user-tie-hair-long",
    "file-circle-minus",
    "head-side-medical",
    "arrow-turn-right",
    "tags",
    "wine-glass",
    "fast-forward",
    "forward-fast",
    "meh-blank",
    "face-meh-blank",
    "user-robot",
    "parking",
    "square-parking",
    "card-diamond",
    "face-zipper",
    "face-raised-eyebrow",
    "house-signal",
    "chevron-square-up",
    "square-chevron-up",
    "nfc-symbol",
    "tasks-alt",
    "bars-progress",
    "faucet-drip",
    "arrows-to-line",
    "dolphin",
    "arrow-up-right",
    "circle-r",
    "dolly-flatbed",
    "cart-flatbed",
    "smoking-ban",
    "ban-smoking",
    "sort-circle-up",
    "circle-sort-up",
    "terminal",
    "mobile-button",
    "house-medical-flag",
    "shopping-basket",
    "basket-shopping",
    "tape",
    "chestnut",
    "bus-alt",
    "bus-simple",
    "eye",
    "sad-cry",
    "face-sad-cry",
    "heat",
    "ticket-perforated-plane",
    "ticket-plane",
    "ticket-airline",
    "boot-heeled",
    "compress-arrows",
    "arrows-minimize",
    "audio-description",
    "person-military-to-person",
    "file-shield",
    "hexagon",
    "manhole",
    "user-slash",
    "pen",
    "tower-observation",
    "floppy-disks",
    "toilet-paper-reverse-alt",
    "toilet-paper-blank-under",
    "file-code",
    "signal-5",
    "signal-perfect",
    "signal",
    "pump",
    "bus",
    "heart-circle-xmark",
    "arrow-up-left-from-circle",
    "home-lg",
    "house-chimney",
    "window-maximize",
    "dryer",
    "frown",
    "face-frown",
    "chess-bishop-alt",
    "chess-bishop-piece",
    "shirt-tank-top",
    "scroll-ribbon",
    "diploma",
    "screencast",
    "walker",
    "prescription",
    "store-alt",
    "shop",
    "save",
    "floppy-disk",
    "vihara",
    "face-kiss-closed-eyes",
    "balance-scale-left",
    "scale-unbalanced",
    "file-user",
    "user-police-tie",
    "face-tongue-money",
    "tennis-ball",
    "square-l",
    "sort-asc",
    "sort-up",
    "calendar-upload",
    "calendar-arrow-up",
    "commenting",
    "comment-dots",
    "plant-wilt",
    "scarf",
    "album-circle-plus",
    "user-nurse-hair-long",
    "diamond",
    "arrow-alt-square-left",
    "square-left",
    "grin-squint",
    "face-grin-squint",
    "circle-ellipsis-vertical",
    "hand-holding-usd",
    "hand-holding-dollar",
    "grid-dividers",
    "bacterium",
    "hand-pointer",
    "drum-steelpan",
    "hand-scissors",
    "praying-hands",
    "hands-praying",
    "face-pensive",
    "user-music",
    "arrow-right-rotate",
    "arrow-rotate-forward",
    "redo",
    "arrow-rotate-right",
    "comments-alt-dollar",
    "messages-dollar",
    "sensor-on",
    "balloon",
    "web-awesome",
    "biohazard",
    "chess-queen-alt",
    "chess-queen-piece",
    "location",
    "location-crosshairs",
    "mars-double",
    "left-from-bracket",
    "house-leave",
    "house-person-depart",
    "house-person-leave",
    "ruler-triangle",
    "card-club",
    "child-dress",
    "users-between-lines",
    "lungs-virus",
    "spinner-third",
    "grin-tears",
    "face-grin-tears",
    "phone",
    "mouse-alt",
    "computer-mouse-scrollwheel",
    "calendar-times",
    "calendar-xmark",
    "child-reaching",
    "table-layout",
    "narwhal",
    "ramp-loading",
    "calendar-circle-plus",
    "toothbrush",
    "border-inner",
    "paw-claws",
    "kiwi-fruit",
    "traffic-light-slow",
    "rectangle-code",
    "head-side-virus",
    "keyboard-brightness",
    "books-medical",
    "lightbulb-slash",
    "home-blank",
    "house-blank",
    "square-5",
    "heart-square",
    "square-heart",
    "puzzle",
    "user-cog",
    "user-gear",
    "pipe-circle-check",
    "sort-numeric-up",
    "arrow-up-1-9",
    "octagon-exclamation",
    "dial-low",
    "door-closed",
    "phone-laptop",
    "laptop-mobile",
    "conveyor-belt-alt",
    "conveyor-belt-boxes",
    "shield-virus",
    "starfighter-alt-advanced",
    "starfighter-twin-ion-engine-advanced",
    "dice-six",
    "starfighter-alt",
    "starfighter-twin-ion-engine",
    "rocket-launch",
    "mosquito-net",
    "vent-damper",
    "bridge-water",
    "debug",
    "ban-bug",
    "person-booth",
    "text-width",
    "garage-car",
    "square-kanban",
    "hat-wizard",
    "chart-kanban",
    "pen-fancy",
    "coffee-pot",
    "mouse-field",
    "digging",
    "person-digging",
    "shower-alt",
    "shower-down",
    "box-circle-check",
    "brightness",
    "car-side-bolt",
    "file-xml",
    "ornament",
    "phone-arrow-down",
    "phone-incoming",
    "phone-arrow-down-left",
    "cloud-word",
    "hand-fingers-crossed",
    "trash",
    "gauge-simple-med",
    "tachometer-average",
    "gauge-simple",
    "sort-size-down-alt",
    "arrow-down-small-big",
    "book-medical",
    "face-melting",
    "poo",
    "pen-alt-slash",
    "pen-clip-slash",
    "quote-right-alt",
    "quote-right",
    "scroll-old",
    "guitars",
    "phone-xmark",
    "hose",
    "clock-six",
    "t-shirt",
    "tshirt",
    "shirt",
    "billboard",
    "square-r",
    "cubes",
    "envelope-open-dollar",
    "divide",
    "sun-cloud",
    "lamp-floor",
    "square-7",
    "tenge",
    "tenge-sign",
    "headphones",
    "hands-holding",
    "campfire",
    "circle-ampersand",
    "snowflakes",
    "hands-clapping",
    "republican",
    "leaf-maple",
    "arrow-left",
    "person-circle-xmark",
    "ruler",
    "arrow-left-from-bracket",
    "cup-straw-swoosh",
    "temperature-hot",
    "temperature-sun",
    "align-left",
    "dice-d6",
    "restroom",
    "rectangle-hd",
    "high-definition",
    "j",
    "galaxy",
    "users-viewfinder",
    "file-video",
    "cherries",
    "external-link-alt",
    "up-right-from-square",
    "sort-circle",
    "circle-sort",
    "th",
    "table-cells",
    "bag-shopping-minus",
    "file-pdf",
    "siren",
    "arrow-up-to-dotted-line",
    "landscape",
    "image-landscape",
    "tank-water",
    "curling",
    "curling-stone",
    "gamepad-alt",
    "gamepad-modern",
    "messages-question",
    "bible",
    "book-bible",
    "o",
    "medkit",
    "suitcase-medical",
    "briefcase-arrow-right",
    "expand-wide",
    "clock-eleven-thirty",
    "rv",
    "user-secret",
    "otter",
    "dreidel",
    "female",
    "person-dress",
    "comment-dollar",
    "briefcase-clock",
    "business-time",
    "flower-tulip",
    "people-pants-simple",
    "cloud-drizzle",
    "th-large",
    "table-cells-large",
    "tanakh",
    "book-tanakh",
    "solar-system",
    "seal-question",
    "volume-control-phone",
    "phone-volume",
    "disc-drive",
    "hat-cowboy-side",
    "rows",
    "table-rows",
    "map-marker-exclamation",
    "location-exclamation",
    "face-fearful",
    "clipboard-user",
    "bus-school",
    "film-slash",
    "square-arrow-down-right",
    "book-spells",
    "book-sparkles",
    "washer",
    "washing-machine",
    "child",
    "lira-sign",
    "user-visor",
    "file-plus-minus",
    "chess-clock-alt",
    "chess-clock-flip",
    "satellite",
    "truck-fire",
    "plane-lock",
    "steering-wheel",
    "tag",
    "stretcher",
    "book-law",
    "book-section",
    "inboxes",
    "coffee-bean",
    "circle-yen",
    "brackets-curly",
    "ellipsis-v-alt",
    "ellipsis-stroke-vertical",
    "comment",
    "square-1",
    "birthday-cake",
    "cake",
    "cake-candles",
    "head-side",
    "truck-ladder",
    "envelope",
    "dolly-empty",
    "face-tissue",
    "angle-double-up",
    "angles-up",
    "bin-recycle",
    "paperclip",
    "chart-line-down",
    "arrow-right-to-city",
    "lock-a",
    "ribbon",
    "lungs",
    "person-pinball",
    "sort-numeric-up-alt",
    "arrow-up-9-1",
    "apple-core",
    "circle-y",
    "h6",
    "litecoin-sign",
    "bottle-baby",
    "circle-small",
    "border-none",
    "arrow-turn-down-left",
    "circle-wifi-group",
    "circle-wifi-circle-wifi",
    "circle-nodes",
    "parachute-box",
    "reflect-horizontal",
    "comment-alt-medical",
    "message-medical",
    "rugby-ball",
    "comment-music",
    "indent",
    "tree-alt",
    "tree-deciduous",
    "puzzle-piece-alt",
    "puzzle-piece-simple",
    "truck-field-un",
    "nfc-trash",
    "hourglass-empty",
    "hourglass",
    "mountain",
    "file-times",
    "file-xmark",
    "home-heart",
    "house-heart",
    "house-chimney-blank",
    "meter-bolt",
    "user-md",
    "user-doctor",
    "slash-back",
    "info-circle",
    "circle-info",
    "fishing-rod",
    "hammer-crash",
    "message-heart",
    "cloud-meatball",
    "camera-polaroid",
    "camera-alt",
    "camera",
    "square-virus",
    "cart-arrow-up",
    "meteor",
    "car-on",
    "sleigh",
    "sort-numeric-asc",
    "sort-numeric-down",
    "arrow-down-1-9",
    "buoy-mooring",
    "square-4",
    "hand-holding-water",
    "hand-holding-droplet",
    "file-eps",
    "tricycle-adult",
    "waveform",
    "water",
    "star-sharp-half-alt",
    "star-sharp-half-stroke",
    "nfc-signal",
    "plane-prop",
    "calendar-check",
    "clock-desk",
    "calendar-time",
    "calendar-clock",
    "braille",
    "prescription-bottle-alt",
    "prescription-bottle-medical",
    "plate-utensils",
    "family-pants",
    "hose-reel",
    "house-window",
    "landmark",
    "truck",
    "music-magnifying-glass",
    "crosshairs",
    "cloud-rainbow",
    "person-cane",
    "alien",
    "tent",
    "laptop-binary",
    "vest-patches",
    "people-dress-simple",
    "check-double",
    "sort-alpha-asc",
    "sort-alpha-down",
    "arrow-down-a-z",
    "bowling-ball-pin",
    "bell-school-slash",
    "plus-large",
    "money-bill-wheat",
    "screenshot",
    "camera-viewfinder",
    "comment-alt-music",
    "message-music",
    "car-building",
    "border-style-alt",
    "border-bottom-right",
    "octagon",
    "comment-arrow-up-right",
    "octagon-divide",
    "cookie",
    "arrow-left-rotate",
    "arrow-rotate-back",
    "arrow-rotate-backward",
    "undo",
    "arrow-rotate-left",
    "tv-music",
    "hdd",
    "hard-drive",
    "reel",
    "grin-squint-tears",
    "face-grin-squint-tears",
    "dumbbell",
    "list-alt",
    "rectangle-list",
    "tarp-droplet",
    "alarm-exclamation",
    "house-medical-circle-check",
    "traffic-cone",
    "grate",
    "arrow-down-right",
    "skiing-nordic",
    "person-skiing-nordic",
    "calendar-plus",
    "portal-exit",
    "person-from-portal",
    "plane-arrival",
    "cowbell-more",
    "cowbell-circle-plus",
    "arrow-alt-circle-left",
    "circle-left",
    "distribute-spacing-vertical",
    "signal-alt-2",
    "signal-bars-fair",
    "sportsball",
    "game-console-handheld-crank",
    "subway",
    "train-subway",
    "chart-gantt",
    "face-smile-upside-down",
    "ball-pile",
    "badge-dollar",
    "money-bills-alt",
    "money-bills-simple",
    "list-timeline",
    "indian-rupee",
    "inr",
    "indian-rupee-sign",
    "crop-alt",
    "crop-simple",
    "money-bill-alt",
    "money-bill-1",
    "long-arrow-alt-left",
    "left-long",
    "keyboard-down",
    "circle-up-right",
    "thunderstorm-moon",
    "cloud-bolt-moon",
    "turn-left-up",
    "dna",
    "virus-slash",
    "bracket-round-right",
    "circle-sterling",
    "circle-5",
    "subtract",
    "minus",
    "flame",
    "fire-flame",
    "arrow-alt-to-right",
    "right-to-line",
    "gif",
    "chess",
    "trash-slash",
    "long-arrow-left",
    "arrow-left-long",
    "plug-circle-check",
    "font-case",
    "street-view",
    "arrow-down-left",
    "franc-sign",
    "flask-poison",
    "flask-round-poison",
    "volume-off",
    "book-circle-arrow-right",
    "user-chart",
    "chart-user",
    "american-sign-language-interpreting",
    "asl-interpreting",
    "hands-american-sign-language-interpreting",
    "hands-asl-interpreting",
    "presentation",
    "presentation-screen",
    "circle-bolt",
    "face-smile-halo",
    "cart-circle-arrow-down",
    "house-person-arrive",
    "house-return",
    "house-person-return",
    "comment-alt-times",
    "message-times",
    "message-xmark",
    "file-award",
    "file-certificate",
    "user-doctor-hair-long",
    "camera-home",
    "camera-security",
    "cog",
    "gear",
    "tint-slash",
    "droplet-slash",
    "book-heart",
    "mosque",
    "duck",
    "mosquito",
    "star-of-david",
    "flag-alt",
    "flag-swallowtail",
    "person-military-rifle",
    "car-garage",
    "shopping-cart",
    "cart-shopping",
    "book-font",
    "shield-plus",
    "vials",
    "eye-dropper-full",
    "distribute-spacing-horizontal",
    "tablet-rugged",
    "temperature-frigid",
    "temperature-snow",
    "moped",
    "smile-plus",
    "face-smile-plus",
    "radio-alt",
    "radio-tuner",
    "face-swear",
    "water-lower",
    "water-arrow-down",
    "scanner-touchscreen",
    "circle-7",
    "plug-circle-plus",
    "ski-jump",
    "person-ski-jumping",
    "place-of-worship",
    "water-rise",
    "water-arrow-up",
    "waveform-path",
    "waveform-lines",
    "split",
    "film-cannister",
    "film-canister",
    "folder-times",
    "folder-xmark",
    "toilet-paper-alt",
    "toilet-paper-blank",
    "tablet-android-alt",
    "tablet-screen",
    "hexagon-vertical-nft-slanted",
    "folder-music",
    "desktop-medical",
    "display-medical",
    "share-all",
    "peapod",
    "chess-clock",
    "axe",
    "square-d",
    "grip-vertical",
    "mobile-signal-out",
    "level-up",
    "arrow-turn-up",
    "u",
    "arrow-up-from-dotted-line",
    "square-root-alt",
    "square-root-variable",
    "light-switch-on",
    "sort-alt",
    "arrow-down-arrow-up",
    "raindrops",
    "minus-large",
    "dash",
    "clock-four",
    "clock",
    "input-numeric",
    "truck-tow",
    "step-backward",
    "backward-step",
    "pallet",
    "car-bolt",
    "expand-arrows",
    "arrows-maximize",
    "faucet",
    "cloud-sleet",
    "lamp-street",
    "list-radio",
    "pen-nib-slash",
    "baseball-bat-ball",
    "square-up-left",
    "overline",
    "s",
    "timeline",
    "keyboard",
    "arrows-from-dotted-line",
    "usb-drive",
    "ballot",
    "caret-down",
    "map-marker-alt-slash",
    "location-dot-slash",
    "cards",
    "clinic-medical",
    "house-chimney-medical",
    "glove-boxing",
    "boxing-glove",
    "temperature-3",
    "thermometer-3",
    "thermometer-three-quarters",
    "temperature-three-quarters",
    "bell-school",
    "mobile-android-alt",
    "mobile-screen",
    "plane-up",
    "folder-heart",
    "location-circle",
    "circle-location-arrow",
    "face-head-bandage",
    "maki-roll",
    "makizushi",
    "sushi-roll",
    "car-bump",
    "piggy-bank",
    "racquet",
    "car-mirrors",
    "industry-alt",
    "industry-windows",
    "bolt-auto",
    "battery-3",
    "battery-half",
    "flux-capacitor",
    "mountain-city",
    "coins",
    "honey-pot",
    "olive",
    "khanda",
    "filter-list",
    "outlet",
    "sliders-h",
    "sliders",
    "cauldron",
    "people",
    "folder-tree",
    "network-wired",
    "croissant",
    "map-pin",
    "hamsa",
    "cent-sign",
    "swords-laser",
    "flask",
    "person-pregnant",
    "square-u",
    "wand-sparkles",
    "router",
    "ellipsis-v",
    "ellipsis-vertical",
    "sword-laser-alt",
    "ticket",
    "power-off",
    "coin",
    "laptop-slash",
    "long-arrow-alt-right",
    "right-long",
    "circle-b",
    "person-dress-simple",
    "pipe-collar",
    "lights-holiday",
    "citrus",
    "flag-usa",
    "laptop-file",
    "teletype",
    "tty",
    "chart-tree-map",
    "diagram-next",
    "person-rifle",
    "clock-five-thirty",
    "pipe-valve",
    "arrow-up-from-arc",
    "face-spiral-eyes",
    "compress-wide",
    "phone-circle-down",
    "circle-phone-hangup",
    "gear-complex-code",
    "house-medical-circle-exclamation",
    "badminton",
    "closed-captioning",
    "hiking",
    "person-hiking",
    "arrow-alt-from-left",
    "right-from-line",
    "venus-double",
    "images",
    "calculator",
    "shuttlecock",
    "user-hair",
    "eye-evil",
    "people-pulling",
    "n",
    "swap",
    "garage",
    "tram",
    "cable-car",
    "shovel-snow",
    "cloud-rain",
    "face-lying",
    "sprinkler",
    "building-circle-xmark",
    "sledding",
    "person-sledding",
    "game-console-handheld",
    "ship",
    "clock-six-thirty",
    "battery-slash",
    "tugrik-sign",
    "arrows-down-to-line",
    "download",
    "angles-up-down",
    "inventory",
    "shelves",
    "cloud-snow",
    "grin",
    "face-grin",
    "backspace",
    "delete-left",
    "oven",
    "cloud-binary",
    "eye-dropper-empty",
    "eyedropper",
    "eye-dropper",
    "comment-captions",
    "comments-question",
    "scribble",
    "rotate-exclamation",
    "file-circle-check",
    "glass",
    "loader",
    "forward",
    "user-pilot",
    "mobile-android",
    "mobile-phone",
    "mobile",
    "code-pull-request-closed",
    "meh",
    "face-meh",
    "align-center",
    "book-dead",
    "book-skull",
    "drivers-license",
    "id-card",
    "face-dotted",
    "face-worried",
    "dedent",
    "outdent",
    "court-sport",
    "heart-circle-exclamation",
    "home",
    "home-alt",
    "home-lg-alt",
    "house",
    "vector-circle",
    "car-circle-bolt",
    "calendar-week",
    "flying-disc",
    "laptop-medical",
    "square-down-right",
    "b",
    "seat-airline",
    "eclipse-alt",
    "moon-over-sun",
    "pipe",
    "file-medical",
    "potato",
    "dice-one",
    "circle-a",
    "helmet-battle",
    "butter",
    "blanket-fire",
    "kiwi-bird",
    "castle",
    "golf-club",
    "exchange",
    "arrow-right-arrow-left",
    "redo-alt",
    "rotate-forward",
    "rotate-right",
    "cutlery",
    "utensils",
    "sort-amount-up",
    "arrow-up-wide-short",
    "chart-pie-simple-circle-dollar",
    "balloons",
    "mill-sign",
    "bowl-rice",
    "timeline-arrow",
    "skull",
    "game-board-alt",
    "game-board-simple",
    "video-circle",
    "circle-video",
    "chart-scatter-bubble",
    "house-turret",
    "banana",
    "hand-holding-skull",
    "people-dress",
    "couch-small",
    "loveseat",
    "broadcast-tower",
    "tower-broadcast",
    "truck-pickup",
    "block-quote",
    "long-arrow-alt-up",
    "up-long",
    "stop",
    "code-merge",
    "money-check-edit-alt",
    "money-check-dollar-pen",
    "arrow-alt-from-bottom",
    "up-from-line",
    "upload",
    "hurricane",
    "grid-round-2-plus",
    "people-pants",
    "mound",
    "windsock",
    "circle-half",
    "brake-warning",
    "toilet-portable",
    "compact-disc",
    "file-download",
    "file-arrow-down",
    "sax-hot",
    "saxophone-fire",
    "webcam-slash",
    "camera-web-slash",
    "folder-medical",
    "folder-cog",
    "folder-gear",
    "hand-wave",
    "sort-up-down",
    "arrow-up-arrow-down",
    "caravan",
    "shield-cat",
    "comment-alt-slash",
    "message-slash",
    "zap",
    "bolt",
    "trash-can-check",
    "glass-water",
    "oil-well",
    "person-simple",
    "arrow-turn-left-up",
    "vault",
    "mars",
    "toilet",
    "plane-circle-xmark",
    "cny",
    "jpy",
    "rmb",
    "yen",
    "yen-sign",
    "gear-code",
    "notes",
    "rouble",
    "rub",
    "ruble",
    "ruble-sign",
    "trash-arrow-turn-left",
    "trash-undo",
    "glass-champagne",
    "champagne-glass",
    "objects-align-center-horizontal",
    "sun",
    "trash-alt-slash",
    "trash-can-slash",
    "users-class",
    "screen-users",
    "guitar",
    "arrow-square-left",
    "square-arrow-left",
    "square-8",
    "face-smile-hearts",
    "brackets",
    "brackets-square",
    "laptop-arrow-down",
    "hockey-stick-puck",
    "house-tree",
    "signal-2",
    "signal-fair",
    "laugh-wink",
    "face-laugh-wink",
    "dollar-circle",
    "usd-circle",
    "circle-dollar",
    "horse-head",
    "repeat-alt",
    "arrows-repeat",
    "bore-hole",
    "industry",
    "image-polaroid",
    "wave-triangle",
    "turn-left-down",
    "person-running-fast",
    "arrow-alt-circle-down",
    "circle-down",
    "grill",
    "arrows-turn-to-dots",
    "analytics",
    "chart-mixed",
    "florin-sign",
    "sort-amount-desc",
    "sort-amount-down-alt",
    "arrow-down-short-wide",
    "less-than",
    "desktop-code",
    "display-code",
    "face-drooling",
    "oil-temp",
    "oil-temperature",
    "question-square",
    "square-question",
    "air-conditioner",
    "angle-down",
    "mountains",
    "omega",
    "car-tunnel",
    "person-dolly-empty",
    "pan-food",
    "head-side-cough",
    "grip-lines",
    "thumbs-down",
    "user-lock",
    "long-arrow-right",
    "arrow-right-long",
    "tickets-perforated-plane",
    "tickets-plane",
    "tickets-airline",
    "tent-double-peak",
    "anchor-circle-xmark",
    "ellipsis-h",
    "ellipsis",
    "nfc-slash",
    "chess-pawn",
    "first-aid",
    "kit-medical",
    "grid-2-plus",
    "bells",
    "person-through-window",
    "toolbox",
    "envelope-badge",
    "envelope-dot",
    "magnifying-glass-waveform",
    "hands-holding-circle",
    "bug",
    "bowl-chopsticks",
    "credit-card-alt",
    "credit-card",
    "circle-s",
    "box-ballot",
    "automobile",
    "car",
    "hand-holding-hand",
    "user-tie-hair",
    "podium-star",
    "business-front",
    "party-back",
    "trian-balbot",
    "user-hair-mullet",
    "microphone-stand",
    "book-reader",
    "book-open-reader",
    "family-dress",
    "circle-x",
    "cabin",
    "mountain-sun",
    "chart-simple-horizontal",
    "bluetooth",
    "arrows-left-right-to-line",
    "hand-back-point-left",
    "comment-alt-dots",
    "messaging",
    "message-dots",
    "file-heart",
    "beer-foam",
    "beer-mug",
    "dice-d20",
    "drone",
    "truck-droplet",
    "file-circle-xmark",
    "temperature-up",
    "temperature-arrow-up",
    "medal",
    "person-fairy",
    "bed",
    "book-copy",
    "h-square",
    "square-h",
    "square-c",
    "clock-two",
    "square-ellipsis-vertical",
    "calendar-users",
    "podcast",
    "bee",
    "temperature-4",
    "thermometer-4",
    "thermometer-full",
    "temperature-full",
    "bell",
    "chocolate-bar",
    "candy-bar",
    "xmark-large",
    "pinata",
    "file-ppt",
    "arrows-from-line",
    "superscript",
    "bowl-spoon",
    "hexagon-check",
    "plug-circle-xmark",
    "star-of-life",
    "phone-slash",
    "traffic-light-stop",
    "paint-roller",
    "accent-grave",
    "hands-helping",
    "handshake-angle",
    "circle-0",
    "dial-med-low",
    "map-marker-alt",
    "location-dot",
    "crab",
    "box-full",
    "box-open-full",
    "file",
    "greater-than",
    "quotes",
    "pretzel",
    "t-rex",
    "swimmer",
    "person-swimming",
    "arrow-down",
    "user-robot-xmarks",
    "comment-alt-quote",
    "message-quote",
    "candy-corn",
    "folder-search",
    "folder-magnifying-glass",
    "notebook",
    "circle-wifi",
    "tint",
    "droplet",
    "bullseye-pointer",
    "eraser",
    "hexagon-image",
    "earth",
    "earth-america",
    "globe-americas",
    "earth-americas",
    "file-svg",
    "apple-crate",
    "crate-apple",
    "person-burst",
    "game-board",
    "hat-chef",
    "hand-back-point-right",
    "dove",
    "snowflake-droplets",
    "battery-0",
    "battery-empty",
    "grid-4",
    "socks",
    "face-sunglasses",
    "inbox",
    "square-0",
    "section",
    "box-up",
    "square-this-way-up",
    "tachometer-alt",
    "tachometer-alt-fast",
    "gauge-high",
    "square-ampersand",
    "envelope-open-text",
    "lamp-desk",
    "hospital-alt",
    "hospital-wide",
    "hospital",
    "poll-people",
    "glass-whiskey-rocks",
    "whiskey-glass-ice",
    "wine-bottle",
    "chess-rook",
    "user-bounty-hunter",
    "reorder",
    "stream",
    "bars-staggered",
    "diagram-sankey",
    "cloud-hail-mixed",
    "circle-up-left",
    "dharmachakra",
    "objects-align-left",
    "oil-can-drip",
    "face-smiling-hands",
    "broccoli",
    "route-interstate",
    "ear-muffs",
    "hotdog",
    "transporter-empty",
    "blind",
    "person-walking-with-cane",
    "angle-90",
    "rectangle-terminal",
    "kite",
    "drum",
    "scrubber",
    "ice-cream",
    "heart-circle-bolt",
    "fish-bones",
    "deer-rudolph",
    "fax",
    "paragraph",
    "head-side-heart",
    "square-e",
    "meter-fire",
    "cloud-hail",
    "vote-yea",
    "check-to-slot",
    "money-from-bracket",
    "star-half",
    "car-bus",
    "speaker",
    "timer",
    "boxes",
    "boxes-alt",
    "boxes-stacked",
    "landmark-magnifying-glass",
    "grill-hot",
    "ballot-check",
    "chain",
    "link",
    "assistive-listening-systems",
    "ear-listen",
    "file-minus",
    "tree-city",
    "play",
    "font",
    "coffee-togo",
    "cup-togo",
    "square-down-left",
    "burger-lettuce",
    "table-cells-row-lock",
    "rupiah-sign",
    "search",
    "magnifying-glass",
    "ping-pong-paddle-ball",
    "table-tennis",
    "table-tennis-paddle-ball",
    "diagnoses",
    "person-dots-from-line",
    "chevron-double-down",
    "chevrons-down",
    "trash-restore-alt",
    "trash-can-arrow-up",
    "signal-3",
    "signal-good",
    "map-marker-question",
    "location-question",
    "floppy-disk-times",
    "save-circle-xmark",
    "save-times",
    "floppy-disk-circle-xmark",
    "naira-sign",
    "peach",
    "taxi-bus",
    "bracket-curly-left",
    "bracket-curly",
    "lobster",
    "dolly-flatbed-empty",
    "cart-flatbed-empty",
    "colon",
    "cart-arrow-down",
    "wand",
    "walkie-talkie",
    "file-edit",
    "file-pen",
    "receipt",
    "table-picnic",
    "pen-square",
    "pencil-square",
    "square-pen",
    "microphone-circle-alt",
    "circle-microphone-lines",
    "desktop-slash",
    "display-slash",
    "suitcase-rolling",
    "person-circle-exclamation",
    "transporter-2",
    "hand-receiving",
    "hands-holding-diamond",
    "money-bill-simple-wave",
    "chevron-down",
    "battery",
    "battery-5",
    "battery-full",
    "bell-plus",
    "book-arrow-right",
    "hospitals",
    "club",
    "skull-crossbones",
    "dewpoint",
    "droplet-degree",
    "code-compare",
    "list-dots",
    "list-ul",
    "hand-holding-magic",
    "watermelon-slice",
    "circle-ellipsis",
    "school-lock",
    "tower-cell",
    "sd-cards",
    "jug-bottle",
    "long-arrow-alt-down",
    "down-long",
    "envelopes",
    "phone-office",
    "ranking-star",
    "chess-king",
    "nfc-pen",
    "person-harassing",
    "magnifying-glass-play",
    "hat-winter",
    "brazilian-real-sign",
    "landmark-alt",
    "landmark-dome",
    "bone-break",
    "arrow-up",
    "down-from-dotted-line",
    "television",
    "tv-alt",
    "tv",
    "border-left",
    "circle-divide",
    "shrimp",
    "tasks",
    "list-check",
    "diagram-subtask",
    "jug-detergent",
    "user-circle",
    "circle-user",
    "square-y",
    "user-doctor-hair",
    "planet-ringed",
    "mushroom",
    "user-shield",
    "megaphone",
    "wreath-laurel",
    "circle-exclamation-check",
    "wind",
    "box-usd",
    "box-dollar",
    "car-crash",
    "car-burst",
    "y",
    "user-headset",
    "retweet-alt",
    "arrows-retweet",
    "snowboarding",
    "person-snowboarding",
    "chevron-square-right",
    "square-chevron-right",
    "lacrosse-stick-ball",
    "shipping-fast",
    "truck-fast",
    "user-magnifying-glass",
    "star-sharp",
    "comment-heart",
    "circle-1",
    "star-circle",
    "circle-star",
    "fish",
    "fog",
    "cloud-fog",
    "waffle",
    "music-alt",
    "music-note",
    "hexagon-exclamation",
    "cart-shopping-fast",
    "object-union",
    "user-graduate",
    "starfighter",
    "adjust",
    "circle-half-stroke",
    "arrow-right-long-to-line",
    "arrow-square-down",
    "square-arrow-down",
    "diamond-half-stroke",
    "clapperboard",
    "chevron-square-left",
    "square-chevron-left",
    "phone-intercom",
    "chain-horizontal",
    "link-horizontal",
    "mango",
    "music-alt-slash",
    "music-note-slash",
    "radiation-alt",
    "circle-radiation",
    "face-tongue-sweat",
    "globe-stand",
    "baseball-ball",
    "baseball",
    "circle-p",
    "award-simple",
    "jet-fighter-up",
    "project-diagram",
    "diagram-project",
    "pedestal",
    "chart-pyramid",
    "sidebar",
    "frosty-head",
    "snowman-head",
    "copy",
    "burger-glass",
    "volume-mute",
    "volume-times",
    "volume-xmark",
    "hand-sparkles",
    "bars-filter",
    "paintbrush-pencil",
    "party-bell",
    "user-vneck-hair",
    "jack-o-lantern",
    "grip-horizontal",
    "grip",
    "share-square",
    "share-from-square",
    "keynote",
    "child-rifle",
    "child-combatant",
    "gun",
    "phone-square",
    "square-phone",
    "hat-beach",
    "add",
    "plus",
    "expand",
    "computer",
    "fort",
    "cloud-check",
    "close",
    "multiply",
    "remove",
    "times",
    "xmark",
    "face-smirking",
    "arrows",
    "arrows-up-down-left-right",
    "chalkboard-teacher",
    "chalkboard-user",
    "rhombus",
    "claw-marks",
    "peso-sign",
    "face-smile-tongue",
    "cart-circle-xmark",
    "building-shield",
    "phone-circle-alt",
    "circle-phone-flip",
    "baby",
    "users-line",
    "quote-left-alt",
    "quote-left",
    "tractor",
    "down-from-bracket",
    "key-skeleton",
    "trash-restore",
    "trash-arrow-up",
    "arrow-down-up-lock",
    "arrow-down-to-bracket",
    "lines-leaning",
    "square-q",
    "ruler-combined",
    "icons-alt",
    "symbols",
    "copyright",
    "flask-gear",
    "highlighter-line",
    "bracket",
    "bracket-left",
    "bracket-square",
    "island-tree-palm",
    "island-tropical",
    "arrow-from-left",
    "arrow-right-from-line",
    "h2",
    "equals",
    "shortcake",
    "cake-slice",
    "building-magnifying-glass",
    "peanut",
    "wrench-simple",
    "blender",
    "teeth",
    "tally-2",
    "ils",
    "shekel",
    "sheqel",
    "sheqel-sign",
    "shekel-sign",
    "cars",
    "axe-battle",
    "user-hair-long",
    "map",
    "arrow-left-from-arc",
    "file-circle-info",
    "face-disappointed",
    "lasso-sparkles",
    "clock-eleven",
    "rocket",
    "siren-on",
    "clock-ten",
    "candle-holder",
    "video-arrow-down-left",
    "photo-video",
    "photo-film",
    "save-circle-arrow-right",
    "floppy-disk-circle-arrow-right",
    "folder-minus",
    "planet-moon",
    "face-eyes-xmarks",
    "chart-scatter",
    "circle-gf",
    "display-arrow-down",
    "store",
    "arrow-trend-up",
    "plug-circle-minus",
    "olive-branch",
    "angle",
    "vacuum-robot",
    "sign",
    "sign-hanging",
    "square-divide",
    "folder-check",
    "signal-stream-slash",
    "bezier-curve",
    "eye-dropper-half",
    "store-lock",
    "bell-slash",
    "thunderstorm-sun",
    "cloud-bolt-sun",
    "camera-slash",
    "comment-quote",
    "tablet-android",
    "tablet",
    "school-flag",
    "message-code",
    "glass-half-empty",
    "glass-half-full",
    "glass-half",
    "fill",
    "comment-alt-minus",
    "message-minus",
    "angle-up",
    "dinosaur",
    "drumstick-bite",
    "chain-horizontal-slash",
    "link-horizontal-slash",
    "holly-berry",
    "nose",
    "arrow-left-to-arc",
    "chevron-left",
    "bacteria",
    "clouds",
    "money-bill-simple",
    "hand-lizard",
    "table-pivot",
    "filter-slash",
    "trash-can-arrow-turn-left",
    "trash-undo-alt",
    "trash-can-undo",
    "notdef",
    "disease",
    "person-to-door",
    "turntable",
    "briefcase-medical",
    "genderless",
    "chevron-right",
    "signal-1",
    "signal-weak",
    "clock-five",
    "retweet",
    "car-alt",
    "car-rear",
    "pump-soap",
    "computer-classic",
    "frame",
    "video-slash",
    "battery-2",
    "battery-quarter",
    "ellipsis-h-alt",
    "ellipsis-stroke",
    "radio",
    "carriage-baby",
    "baby-carriage",
    "face-expressionless",
    "down-to-dotted-line",
    "cloud-music",
    "traffic-light",
    "cloud-minus",
    "thermometer",
    "shield-minus",
    "vr-cardboard",
    "car-tilt",
    "gauge-circle-minus",
    "brightness-low",
    "hand-middle-finger",
    "percentage",
    "percent",
    "truck-moving",
    "glass-water-droplet",
    "conveyor-belt",
    "map-marker-check",
    "location-check",
    "coin-vertical",
    "display",
    "person-sign",
    "smile",
    "face-smile",
    "phone-hangup",
    "signature-slash",
    "thumb-tack",
    "thumbtack",
    "wheat-slash",
    "trophy",
    "clouds-sun",
    "pray",
    "person-praying",
    "hammer",
    "face-vomit",
    "speakers",
    "teletype-answer",
    "tty-answer",
    "mug-tea-saucer",
    "diagram-lean-canvas",
    "alt",
    "dial-med-high",
    "dial",
    "hand-peace",
    "trash-circle",
    "circle-trash",
    "sync-alt",
    "rotate",
    "circle-quarters",
    "spinner",
    "tower-control",
    "sort-shapes-up",
    "arrow-up-triangle-square",
    "whale",
    "robot",
    "peace",
    "party-horn",
    "cogs",
    "gears",
    "sun-alt",
    "sun-bright",
    "warehouse",
    "conveyor-belt-arm",
    "lock-open-alt",
    "lock-keyhole-open",
    "box-fragile",
    "square-wine-glass-crack",
    "square-fragile",
    "arrow-up-right-dots",
    "square-n",
    "splotch",
    "grin-hearts",
    "face-grin-hearts",
    "meter",
    "mandolin",
    "dice-four",
    "sim-card",
    "transgender-alt",
    "transgender",
    "mercury",
    "up-from-bracket",
    "knife-kitchen",
    "border-right",
    "level-down",
    "arrow-turn-down",
    "spade",
    "card-spade",
    "line-columns",
    "ant",
    "arrow-to-right",
    "arrow-right-to-line",
    "person-falling-burst",
    "pennant",
    "flag-pennant",
    "conveyor-belt-empty",
    "user-group-simple",
    "award",
    "ticket-alt",
    "ticket-simple",
    "building",
    "angle-double-left",
    "angles-left",
    "video-handheld",
    "camcorder",
    "pancakes",
    "album-circle-user",
    "subtitles-slash",
    "qrcode",
    "dice-d10",
    "fireplace",
    "browser",
    "pencil-paintbrush",
    "pen-paintbrush",
    "fish-cooked",
    "chair-office",
    "magnifying-glass-music",
    "nesting-dolls",
    "history",
    "clock-rotate-left",
    "trumpet",
    "grin-beam-sweat",
    "face-grin-beam-sweat",
    "fire-smoke",
    "phone-missed",
    "arrow-right-from-file",
    "file-export",
    "shield-blank",
    "shield",
    "sort-amount-up-alt",
    "arrow-up-short-wide",
    "repeat-1-alt",
    "arrows-repeat-1",
    "gun-slash",
    "avocado",
    "binary",
    "glasses-alt",
    "glasses-round",
    "phone-plus",
    "ditto",
    "person-seat",
    "house-medical",
    "golf-ball",
    "golf-ball-tee",
    "chevron-circle-left",
    "circle-chevron-left",
    "house-chimney-window",
    "scythe",
    "pen-nib",
    "parking-circle-slash",
    "ban-parking",
    "tent-arrow-turn-left",
    "face-diagonal-mouth",
    "diagram-cells",
    "cricket",
    "cricket-bat-ball",
    "tents",
    "magic",
    "wand-magic",
    "dog",
    "pen-line",
    "atom-alt",
    "atom-simple",
    "ampersand",
    "carrot",
    "arrow-from-bottom",
    "arrow-up-from-line",
    "moon",
    "pen-slash",
    "wine-glass-alt",
    "wine-glass-empty",
    "square-star",
    "cheese",
    "send-backward",
    "yin-yang",
    "music",
    "compass-slash",
    "clock-one",
    "file-music",
    "code-commit",
    "temperature-low",
    "biking",
    "person-biking",
    "display-chart-up-circle-currency",
    "skeleton",
    "circle-g",
    "circle-arrow-up-left",
    "coin-blank",
    "broom",
    "vacuum",
    "shield-heart",
    "card-heart",
    "lightbulb-cfl-on",
    "melon",
    "gopuram",
    "globe-oceania",
    "earth-oceania",
    "container-storage",
    "face-pouting",
    "times-square",
    "xmark-square",
    "square-xmark",
    "exploding-head",
    "face-explode",
    "hashtag",
    "expand-alt",
    "up-right-and-down-left-from-center",
    "oil-can",
    "t",
    "transformer-bolt",
    "hippo",
    "chart-column",
    "vhs",
    "cassette-vhs",
    "infinity",
    "vial-circle-check",
    "chimney",
    "object-intersect",
    "person-arrow-down-to-line",
    "voicemail",
    "wall-brick",
    "block-brick",
    "fan",
    "bags-shopping",
    "paragraph-rtl",
    "paragraph-left",
    "person-walking-luggage",
    "caravan-alt",
    "caravan-simple",
    "turtle",
    "pencil-mechanical",
    "arrows-alt-v",
    "up-down",
    "cloud-moon-rain",
    "booth-curtain",
    "calendar",
    "box-heart",
    "trailer",
    "user-md-chat",
    "user-doctor-message",
    "haykal",
    "bahai",
    "lighthouse",
    "amp-guitar",
    "sd-card",
    "volume-slash",
    "border-bottom",
    "wifi-1",
    "wifi-weak",
    "dragon",
    "shoe-prints",
    "plus-circle",
    "circle-plus",
    "grin-tongue-wink",
    "face-grin-tongue-wink",
    "hand-holding",
    "plug-circle-exclamation",
    "chain-broken",
    "chain-slash",
    "unlink",
    "link-slash",
    "clone",
    "person-walking-arrow-loop-left",
    "sort-alpha-up-alt",
    "arrow-up-z-a",
    "fire-alt",
    "fire-flame-curved",
    "tornado",
    "file-circle-plus",
    "delete-right",
    "quran",
    "book-quran",
    "circle-quarter",
    "anchor",
    "border-all",
    "function",
    "angry",
    "face-angry",
    "people-simple",
    "cookie-bite",
    "arrow-trend-down",
    "feed",
    "rss",
    "face-monocle",
    "draw-polygon",
    "balance-scale",
    "scale-balanced",
    "calendar-note",
    "calendar-lines",
    "sort-size-down",
    "arrow-down-big-small",
    "tachometer",
    "tachometer-fast",
    "gauge-simple-high",
    "do-not-enter",
    "shower",
    "dice-d8",
    "desktop-alt",
    "desktop",
    "m",
    "spinner-scale",
    "grip-dots-vertical",
    "face-viewfinder",
    "creemee",
    "soft-serve",
    "h5",
    "hand-back-point-down",
    "th-list",
    "table-list",
    "basket-shopping-minus",
    "sms",
    "comment-sms",
    "rectangle-landscape",
    "rectangle",
    "clipboard-list-check",
    "turkey",
    "book",
    "user-plus",
    "ice-skate",
    "check",
    "battery-4",
    "battery-three-quarters",
    "tomato",
    "sword-laser",
    "house-circle-check",
    "buildings",
    "angle-left",
    "dolly-flatbed-alt",
    "cart-flatbed-boxes",
    "diagram-successor",
    "truck-arrow-right",
    "square-w",
    "arrows-split-up-and-left",
    "lamp",
    "airplay",
    "fist-raised",
    "hand-fist",
    "shield-quartered",
    "slash-forward",
    "map-marker-edit",
    "location-pen",
    "cloud-moon",
    "pot-food",
    "briefcase",
    "person-falling",
    "portrait",
    "image-portrait",
    "user-tag",
    "rug",
    "print-slash",
    "globe-europe",
    "earth-europe",
    "luggage-cart",
    "cart-flatbed-suitcase",
    "hand-back-point-ribbon",
    "rectangle-times",
    "times-rectangle",
    "window-close",
    "rectangle-xmark",
    "tire-rugged",
    "lightbulb-dollar",
    "cowbell",
    "baht-sign",
    "corner",
    "chevron-double-right",
    "chevrons-right",
    "book-open",
    "journal-whills",
    "book-journal-whills",
    "inhaler",
    "handcuffs",
    "snake",
    "exclamation-triangle",
    "warning",
    "triangle-exclamation",
    "note-medical",
    "database",
    "down-left",
    "mail-forward",
    "share",
    "face-thinking",
    "turn-down-right",
    "bottle-droplet",
    "mask-face",
    "hill-rockslide",
    "scanner-keyboard",
    "circle-o",
    "grid-horizontal",
    "comment-alt-dollar",
    "message-dollar",
    "exchange-alt",
    "right-left",
    "columns-3",
    "paper-plane",
    "road-circle-exclamation",
    "dungeon",
    "hand-holding-box",
    "input-text",
    "window-alt",
    "window-flip",
    "align-right",
    "scanner",
    "scanner-gun",
    "tire",
    "engine",
    "money-bill-wave-alt",
    "money-bill-1-wave",
    "life-ring",
    "sign-language",
    "signing",
    "hands",
    "caret-circle-right",
    "circle-caret-right",
    "turn-left",
    "wheat",
    "file-spreadsheet",
    "audio-description-slash",
    "bell-ring",
    "calendar-day",
    "ladder-water",
    "swimming-pool",
    "water-ladder",
    "arrows-v",
    "arrows-up-down",
    "chess-pawn-alt",
    "chess-pawn-piece",
    "grimace",
    "face-grimace",
    "wheelchair-alt",
    "wheelchair-move",
    "level-down-alt",
    "turn-down",
    "square-s",
    "barcode-alt",
    "rectangle-barcode",
    "person-walking-arrow-right",
    "envelope-square",
    "square-envelope",
    "dice",
    "unicorn",
    "bowling-ball",
    "pompebled",
    "brain",
    "watch-smart",
    "book-user",
    "sensor-smoke",
    "sensor-cloud",
    "clapperboard-play",
    "band-aid",
    "bandage",
    "calendar-minus",
    "times-circle",
    "xmark-circle",
    "circle-xmark",
    "circle-4",
    "gifts",
    "album-collection",
    "hotel",
    "globe-asia",
    "earth-asia",
    "id-card-alt",
    "id-card-clip",
    "search-plus",
    "magnifying-glass-plus",
    "thumbs-up",
    "cloud-showers",
    "user-clock",
    "onion",
    "clock-twelve-thirty",
    "arrow-down-to-dotted-line",
    "allergies",
    "hand-dots",
    "file-invoice",
    "window-minimize",
    "rectangle-wide",
    "comment-arrow-up",
    "garlic",
    "coffee",
    "mug-saucer",
    "brush",
    "tree-decorated",
    "mask",
    "calendar-heart",
    "search-minus",
    "magnifying-glass-minus",
    "flower",
    "arrow-down-from-arc",
    "right-left-large",
    "ruler-vertical",
    "circles-overlap",
    "user-alt",
    "user-large",
    "starship-freighter",
    "train-tram",
    "bridge-suspension",
    "trash-check",
    "user-nurse",
    "boombox",
    "syringe",
    "cloud-sun",
    "shield-exclamation",
    "stopwatch-20",
    "square-full",
    "grip-dots",
    "comment-exclamation",
    "pen-swirl",
    "falafel",
    "circle-2",
    "magnet",
    "jar",
    "gramophone",
    "dice-d12",
    "sticky-note",
    "note-sticky",
    "arrow-alt-down",
    "down",
    "100",
    "hundred-points",
    "paperclip-vertical",
    "wind-circle-exclamation",
    "wind-warning",
    "map-marker-slash",
    "location-pin-slash",
    "face-sad-sweat",
    "bug-slash",
    "cupcake",
    "light-switch-off",
    "toggle-large-off",
    "pen-fancy-slash",
    "truck-container",
    "boot",
    "arrow-up-from-water-pump",
    "file-check",
    "bone",
    "cards-blank",
    "circle-3",
    "bench-tree",
    "keyboard-brightness-low",
    "ski-boot-ski",
    "brain-circuit",
    "user-injured",
    "firewall",
    "block-brick-fire",
    "sad-tear",
    "face-sad-tear",
    "plane",
    "tent-arrows-down",
    "exclamation",
    "arrows-spin",
    "face-smile-relaxed",
    "comment-times",
    "comment-xmark",
    "print",
    "try",
    "turkish-lira",
    "turkish-lira-sign",
    "face-nose-steam",
    "waveform-circle",
    "circle-waveform-lines",
    "dollar",
    "usd",
    "dollar-sign",
    "ferris-wheel",
    "computer-speaker",
    "skull-cow",
    "x",
    "search-dollar",
    "magnifying-glass-dollar",
    "users-cog",
    "users-gear",
    "person-military-pointing",
    "bank",
    "institution",
    "museum",
    "university",
    "building-columns",
    "circle-t",
    "sack",
    "grid-2",
    "cctv",
    "camera-cctv",
    "umbrella",
    "trowel",
    "horizontal-rule",
    "bed-alt",
    "bed-front",
    "d",
    "stapler",
    "theater-masks",
    "masks-theater",
    "file-gif",
    "kip-sign",
    "face-woozy",
    "cloud-question",
    "pineapple",
    "hand-point-left",
    "gallery-thumbnails",
    "circle-j",
    "eyes",
    "handshake-alt",
    "handshake-simple",
    "file-caret-up",
    "page-caret-up",
    "fighter-jet",
    "jet-fighter",
    "comet",
    "share-alt-square",
    "square-share-nodes",
    "reflect-vertical",
    "shield-keyhole",
    "file-mp4",
    "barcode",
    "bulldozer",
    "plus-minus",
    "sliders-v-square",
    "square-sliders-vertical",
    "video-camera",
    "video",
    "comment-middle-alt",
    "message-middle",
    "mortar-board",
    "graduation-cap",
    "hand-holding-medical",
    "person-circle-check",
    "square-z",
    "comment-alt-text",
    "message-text",
    "level-up-alt",
    "turn-up"
  ],
  "fal": [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "fill-drip",
    "arrows-to-circle",
    "chevron-circle-right",
    "circle-chevron-right",
    "wagon-covered",
    "line-height",
    "bagel",
    "transporter-7",
    "at",
    "rectangles-mixed",
    "phone-arrow-up",
    "phone-outgoing",
    "phone-arrow-up-right",
    "trash-alt",
    "trash-can",
    "circle-l",
    "head-vr",
    "head-side-goggles",
    "text-height",
    "user-times",
    "user-xmark",
    "face-hand-yawn",
    "tachometer-slowest",
    "gauge-simple-min",
    "stethoscope",
    "coffin",
    "comment-alt",
    "message",
    "bowl-salad",
    "salad",
    "info",
    "robot-astromech",
    "ring-diamond",
    "fondue-pot",
    "theta",
    "face-hand-peeking",
    "square-user",
    "compress-alt",
    "down-left-and-up-right-to-center",
    "explosion",
    "file-alt",
    "file-text",
    "file-lines",
    "wave-square",
    "ring",
    "building-un",
    "dice-three",
    "tire-pressure-warning",
    "wifi-2",
    "wifi-fair",
    "calendar-alt",
    "calendar-days",
    "mp3-player",
    "anchor-circle-check",
    "tally-4",
    "rectangle-history",
    "building-circle-arrow-right",
    "volleyball-ball",
    "volleyball",
    "sun-haze",
    "text-size",
    "ufo",
    "utensil-fork",
    "fork",
    "arrows-up-to-line",
    "mobile-signal",
    "barcode-scan",
    "sort-desc",
    "sort-down",
    "folder-download",
    "folder-arrow-down",
    "minus-circle",
    "circle-minus",
    "face-icicles",
    "shovel",
    "door-open",
    "films",
    "sign-out-alt",
    "right-from-bracket",
    "face-glasses",
    "nfc",
    "atom",
    "soap",
    "heart-music-camera-bolt",
    "icons",
    "microphone-alt-slash",
    "microphone-lines-slash",
    "closed-captioning-slash",
    "calculator-alt",
    "calculator-simple",
    "bridge-circle-check",
    "sliders-v",
    "sliders-up",
    "map-marker-minus",
    "location-minus",
    "pump-medical",
    "fingerprint",
    "ski-boot",
    "rectangle-sd",
    "standard-definition",
    "h1",
    "hand-point-right",
    "search-location",
    "magnifying-glass-location",
    "message-bot",
    "step-forward",
    "forward-step",
    "smile-beam",
    "face-smile-beam",
    "light-ceiling",
    "comment-alt-exclamation",
    "message-exclamation",
    "bowl-shaved-ice",
    "bowl-scoop",
    "square-x",
    "building-memo",
    "utility-pole-double",
    "flag-checkered",
    "chevron-double-up",
    "chevrons-up",
    "football-ball",
    "football",
    "user-vneck",
    "school-circle-exclamation",
    "crop",
    "angle-double-down",
    "angles-down",
    "users-rectangle",
    "people-roof",
    "arrow-square-right",
    "square-arrow-right",
    "map-marker-plus",
    "location-plus",
    "lightbulb-exclamation-on",
    "people-line",
    "beer",
    "beer-mug-empty",
    "crate-empty",
    "diagram-predecessor",
    "transporter",
    "calendar-circle-user",
    "long-arrow-up",
    "arrow-up-long",
    "person-carry",
    "person-carry-box",
    "burn",
    "fire-flame-simple",
    "male",
    "person",
    "laptop",
    "file-csv",
    "menorah",
    "union",
    "chevron-double-left",
    "chevrons-left",
    "heart-circle",
    "circle-heart",
    "truck-plane",
    "record-vinyl",
    "bring-forward",
    "square-p",
    "grin-stars",
    "face-grin-stars",
    "sigma",
    "camera-movie",
    "bong",
    "clarinet",
    "truck-flatbed",
    "pastafarianism",
    "spaghetti-monster-flying",
    "arrow-down-up-across-line",
    "arrows-rotate-reverse",
    "leaf-heart",
    "house-building",
    "cheese-swiss",
    "utensil-spoon",
    "spoon",
    "jar-wheat",
    "mail-bulk",
    "envelopes-bulk",
    "file-circle-exclamation",
    "bow-arrow",
    "cart-xmark",
    "times-hexagon",
    "xmark-hexagon",
    "hexagon-xmark",
    "hospital-symbol",
    "circle-h",
    "merge",
    "pager",
    "cart-minus",
    "contact-book",
    "address-book",
    "pan-frying",
    "grid-3",
    "grid",
    "football-helmet",
    "hand-love",
    "trees",
    "strikethrough",
    "page",
    "k",
    "diagram-previous",
    "tachometer-alt-slowest",
    "gauge-min",
    "folder-grid",
    "eggplant",
    "excavator",
    "ram",
    "landmark-flag",
    "lips",
    "pencil-alt",
    "pencil",
    "backward",
    "caret-right",
    "comments",
    "file-clipboard",
    "paste",
    "desktop-arrow-down",
    "code-pull-request",
    "pumpkin",
    "clipboard-list",
    "pen-field",
    "blueberries",
    "truck-loading",
    "truck-ramp-box",
    "note",
    "arrow-down-to-square",
    "user-check",
    "cloud-xmark",
    "vial-virus",
    "book-alt",
    "book-blank",
    "golf-flag-hole",
    "comment-alt-arrow-down",
    "message-arrow-down",
    "face-unamused",
    "sheet-plastic",
    "circle-9",
    "blog",
    "user-ninja",
    "pencil-slash",
    "bowling-pins",
    "person-arrow-up-from-line",
    "down-right",
    "torah",
    "scroll-torah",
    "webhook",
    "blinds-open",
    "fence",
    "arrow-alt-up",
    "up",
    "quidditch",
    "quidditch-broom-ball",
    "broom-ball",
    "drumstick",
    "square-v",
    "gave-dandy",
    "face-awesome",
    "dial-off",
    "toggle-off",
    "face-smile-horns",
    "archive",
    "box-archive",
    "grapes",
    "person-drowning",
    "dial-max",
    "circle-m",
    "calendar-image",
    "caret-circle-down",
    "circle-caret-down",
    "sort-numeric-desc",
    "sort-numeric-down-alt",
    "arrow-down-9-1",
    "grin-tongue-squint",
    "face-grin-tongue-squint",
    "shish-kebab",
    "spray-can",
    "alarm-snooze",
    "scarecrow",
    "truck-monster",
    "gift-card",
    "w",
    "code-pull-request-draft",
    "square-b",
    "elephant",
    "globe-africa",
    "earth-africa",
    "rainbow",
    "circle-notch",
    "tablet-alt",
    "tablet-screen-button",
    "paw",
    "message-question",
    "cloud",
    "trowel-bricks",
    "square-3",
    "flushed",
    "face-flushed",
    "hospital-user",
    "microwave",
    "chf-sign",
    "tent-arrow-left-right",
    "cart-circle-arrow-up",
    "trash-clock",
    "reflect-both",
    "legal",
    "gavel",
    "sprinkler-ceiling",
    "browsers",
    "trillium",
    "music-slash",
    "truck-ramp",
    "binoculars",
    "microphone-slash",
    "box-tissue",
    "circle-c",
    "star-christmas",
    "chart-bullet",
    "motorcycle",
    "tree-christmas",
    "tire-flat",
    "sunglasses",
    "badge",
    "comment-alt-edit",
    "message-edit",
    "message-pen",
    "concierge-bell",
    "bell-concierge",
    "pencil-ruler",
    "pen-ruler",
    "file-mp3",
    "arrow-progress",
    "chess-rook-alt",
    "chess-rook-piece",
    "square-root",
    "album-collection-circle-plus",
    "people-arrows-left-right",
    "people-arrows",
    "sign-post",
    "face-angry-horns",
    "mars-and-venus-burst",
    "tombstone",
    "caret-square-right",
    "square-caret-right",
    "cut",
    "scissors",
    "list-music",
    "sun-plant-wilt",
    "toilets-portable",
    "hockey-puck",
    "mustache",
    "hyphen",
    "table",
    "user-chef",
    "comment-alt-image",
    "message-image",
    "users-medical",
    "sensor-alert",
    "sensor-triangle-exclamation",
    "magnifying-glass-arrow-right",
    "digital-tachograph",
    "tachograph-digital",
    "face-mask",
    "pickleball",
    "star-sharp-half",
    "users-slash",
    "clover",
    "meat",
    "mail-reply",
    "reply",
    "star-and-crescent",
    "empty-set",
    "house-fire",
    "minus-square",
    "square-minus",
    "helicopter",
    "bird",
    "compass",
    "caret-square-down",
    "square-caret-down",
    "heart-half-alt",
    "heart-half-stroke",
    "file-circle-question",
    "truck-utensils",
    "laptop-code",
    "joystick",
    "grill-fire",
    "rectangle-vertical-history",
    "swatchbook",
    "prescription-bottle",
    "navicon",
    "bars",
    "keyboard-left",
    "people-group",
    "hourglass-3",
    "hourglass-end",
    "heart-broken",
    "heart-crack",
    "face-beam-hand-over-mouth",
    "humidity",
    "droplet-percent",
    "external-link-square-alt",
    "square-up-right",
    "kiss-beam",
    "face-kiss-beam",
    "corn",
    "roller-coaster",
    "photo-film-music",
    "radar",
    "sickle",
    "film",
    "coconut",
    "ruler-horizontal",
    "shield-cross",
    "cassette-tape",
    "square-terminal",
    "people-robbery",
    "lightbulb",
    "caret-left",
    "comment-middle",
    "trash-can-list",
    "block",
    "exclamation-circle",
    "circle-exclamation",
    "school-circle-xmark",
    "sign-out",
    "arrow-right-from-bracket",
    "face-frown-slight",
    "chevron-circle-down",
    "circle-chevron-down",
    "sidebar-flip",
    "unlock-alt",
    "unlock-keyhole",
    "temperature-list",
    "cloud-showers-heavy",
    "headphones-alt",
    "headphones-simple",
    "sitemap",
    "pipe-section",
    "space-station-moon-alt",
    "space-station-moon-construction",
    "donate",
    "circle-dollar-to-slot",
    "memory",
    "face-sleeping",
    "road-spikes",
    "fire-burner",
    "squirrel",
    "arrow-to-top",
    "arrow-up-to-line",
    "flag",
    "face-cowboy-hat",
    "hanukiah",
    "chart-scatter-3d",
    "display-chart-up",
    "square-code",
    "feather",
    "volume-down",
    "volume-low",
    "times-to-slot",
    "vote-nay",
    "xmark-to-slot",
    "box-alt",
    "box-taped",
    "comment-slash",
    "swords",
    "cloud-sun-rain",
    "album",
    "circle-n",
    "compress",
    "wheat-alt",
    "wheat-awn",
    "ankh",
    "hands-holding-child",
    "asterisk",
    "key-skeleton-left-right",
    "comment-lines",
    "luchador",
    "mask-luchador",
    "luchador-mask",
    "check-square",
    "square-check",
    "shredder",
    "book-open-alt",
    "book-open-cover",
    "sandwich",
    "peseta-sign",
    "parking-slash",
    "square-parking-slash",
    "train-tunnel",
    "header",
    "heading",
    "ghost",
    "face-anguished",
    "hockey-sticks",
    "abacus",
    "film-alt",
    "film-simple",
    "list-squares",
    "list",
    "tree-palm",
    "phone-square-alt",
    "square-phone-flip",
    "cart-plus",
    "gamepad",
    "border-center-v",
    "dot-circle",
    "circle-dot",
    "clipboard-medical",
    "dizzy",
    "face-dizzy",
    "egg",
    "arrow-alt-to-top",
    "up-to-line",
    "house-medical-circle-xmark",
    "watch-fitness",
    "clock-nine-thirty",
    "campground",
    "folder-plus",
    "jug",
    "futbol-ball",
    "soccer-ball",
    "futbol",
    "snow-blowing",
    "paint-brush",
    "paintbrush",
    "lock",
    "arrow-from-top",
    "arrow-down-from-line",
    "gas-pump",
    "signal-alt-slash",
    "signal-bars-slash",
    "monkey",
    "pro",
    "rectangle-pro",
    "house-night",
    "hot-tub",
    "hot-tub-person",
    "globe-pointer",
    "blanket",
    "map-marked",
    "map-location",
    "house-flood-water",
    "comments-question-check",
    "tree",
    "arrows-cross",
    "backpack",
    "square-small",
    "folder-upload",
    "folder-arrow-up",
    "bridge-lock",
    "crosshairs-simple",
    "sack-dollar",
    "edit",
    "pen-to-square",
    "sliders-h-square",
    "square-sliders",
    "car-side",
    "comment-middle-top-alt",
    "message-middle-top",
    "lightbulb-on",
    "utensil-knife",
    "knife",
    "share-alt",
    "share-nodes",
    "display-chart-up-circle-dollar",
    "wave-sine",
    "heart-circle-minus",
    "circle-w",
    "calendar-circle",
    "circle-calendar",
    "hourglass-2",
    "hourglass-half",
    "microscope",
    "sunset",
    "sink",
    "calendar-exclamation",
    "truck-container-empty",
    "hand-heart",
    "shopping-bag",
    "bag-shopping",
    "sort-alpha-desc",
    "sort-alpha-down-alt",
    "arrow-down-z-a",
    "mitten",
    "reply-time",
    "reply-clock",
    "person-rays",
    "arrow-alt-right",
    "right",
    "circle-f",
    "users",
    "face-pleading",
    "eye-slash",
    "flask-vial",
    "police-box",
    "cucumber",
    "head-side-brain",
    "hand-paper",
    "hand",
    "biking-mountain",
    "person-biking-mountain",
    "utensils-slash",
    "print-search",
    "print-magnifying-glass",
    "turn-right",
    "folder-bookmark",
    "arrow-turn-left-down",
    "om",
    "pi",
    "flask-potion",
    "flask-round-potion",
    "face-shush",
    "worm",
    "house-circle-xmark",
    "plug",
    "calendar-circle-exclamation",
    "square-i",
    "chevron-up",
    "face-saluting",
    "tachometer-slow",
    "gauge-simple-low",
    "face-persevering",
    "camera-circle",
    "circle-camera",
    "hand-spock",
    "spider-web",
    "microphone-circle",
    "circle-microphone",
    "book-arrow-up",
    "popsicle",
    "command",
    "blinds",
    "stopwatch",
    "saxophone",
    "square-2",
    "field-hockey",
    "field-hockey-stick-ball",
    "sort-shapes-up-alt",
    "arrow-up-square-triangle",
    "face-scream",
    "square-m",
    "webcam",
    "camera-web",
    "comment-arrow-down",
    "lightbulb-cfl",
    "window-frame-open",
    "kiss",
    "face-kiss",
    "bridge-circle-xmark",
    "period",
    "grin-tongue",
    "face-grin-tongue",
    "up-to-dotted-line",
    "thought-bubble",
    "skeleton-ribs",
    "raygun",
    "flute",
    "acorn",
    "video-arrow-up-right",
    "grate-droplet",
    "seal-exclamation",
    "chess-bishop",
    "message-sms",
    "coffee-beans",
    "hat-witch",
    "grin-wink",
    "face-grin-wink",
    "clock-three-thirty",
    "deaf",
    "deafness",
    "hard-of-hearing",
    "ear-deaf",
    "alarm-clock",
    "eclipse",
    "face-relieved",
    "road-circle-check",
    "dice-five",
    "minus-octagon",
    "octagon-minus",
    "rss-square",
    "square-rss",
    "face-zany",
    "tricycle",
    "land-mine-on",
    "square-arrow-up-left",
    "i-cursor",
    "chart-mixed-up-circle-dollar",
    "salt-shaker",
    "stamp",
    "file-plus",
    "draw-square",
    "toilet-paper-reverse-slash",
    "toilet-paper-under-slash",
    "stairs",
    "drone-alt",
    "drone-front",
    "glass-empty",
    "dial-high",
    "user-construction",
    "user-hard-hat",
    "user-helmet-safety",
    "i",
    "hryvnia",
    "hryvnia-sign",
    "arrow-down-left-and-arrow-up-right-to-center",
    "pills",
    "grin-alt",
    "face-grin-wide",
    "tooth",
    "basketball-hoop",
    "objects-align-bottom",
    "v",
    "sparkles",
    "squid",
    "leafy-green",
    "circle-arrow-up-right",
    "calendars",
    "bangladeshi-taka-sign",
    "bicycle",
    "hammer-war",
    "circle-d",
    "spider-black-widow",
    "rod-asclepius",
    "rod-snake",
    "staff-aesculapius",
    "staff-snake",
    "pear",
    "head-side-cough-slash",
    "file-mov",
    "triangle",
    "apartment",
    "ambulance",
    "truck-medical",
    "pepper",
    "piano",
    "gun-squirt",
    "wheat-awn-circle-exclamation",
    "snowman",
    "user-alien",
    "shield-check",
    "mortar-pestle",
    "road-barrier",
    "chart-candlestick",
    "briefcase-blank",
    "school",
    "igloo",
    "parenthesis",
    "bracket-round",
    "joint",
    "horse-saddle",
    "mug-marshmallows",
    "filters",
    "bell-on",
    "angle-right",
    "dial-med",
    "horse",
    "q",
    "monitor-heart-rate",
    "monitor-waveform",
    "link-simple",
    "whistle",
    "g",
    "fragile",
    "wine-glass-crack",
    "slot-machine",
    "notes-medical",
    "car-wash",
    "escalator",
    "comment-image",
    "temperature-2",
    "thermometer-2",
    "thermometer-half",
    "temperature-half",
    "dong-sign",
    "doughnut",
    "donut",
    "capsules",
    "poo-bolt",
    "poo-storm",
    "tally-1",
    "file-vector",
    "frown-open",
    "face-frown-open",
    "square-dashed",
    "bag-shopping-plus",
    "square-j",
    "hand-point-up",
    "money-bill",
    "sort-size-up",
    "arrow-up-big-small",
    "barcode-read",
    "baguette",
    "bowl-soft-serve",
    "face-holding-back-tears",
    "arrow-alt-square-up",
    "square-up",
    "subway-tunnel",
    "train-subway-tunnel",
    "exclamation-square",
    "square-exclamation",
    "semicolon",
    "bookmark",
    "fan-table",
    "align-justify",
    "battery-1",
    "battery-low",
    "credit-card-front",
    "mind-share",
    "brain-arrow-curved-right",
    "umbrella-beach",
    "helmet-un",
    "map-marker-smile",
    "location-smile",
    "arrow-to-left",
    "arrow-left-to-line",
    "bullseye",
    "nigiri",
    "sushi",
    "comment-alt-captions",
    "message-captions",
    "trash-list",
    "bacon",
    "option",
    "raccoon",
    "hand-point-down",
    "arrow-up-from-bracket",
    "head-side-gear",
    "trash-plus",
    "file-cad",
    "objects-align-top",
    "folder-blank",
    "folder",
    "face-anxious-sweat",
    "credit-card-blank",
    "file-medical-alt",
    "file-waveform",
    "microchip-ai",
    "mug",
    "plane-up-slash",
    "radiation",
    "pen-circle",
    "bag-seedling",
    "chart-simple",
    "crutches",
    "parking-circle",
    "circle-parking",
    "mars-stroke",
    "leaf-oak",
    "square-bolt",
    "vial",
    "dashboard",
    "gauge-med",
    "tachometer-alt-average",
    "gauge",
    "magic-wand-sparkles",
    "wand-magic-sparkles",
    "lambda",
    "e",
    "pizza",
    "bowl-chopsticks-noodles",
    "h3",
    "pen-alt",
    "pen-clip",
    "bridge-circle-exclamation",
    "badge-percent",
    "rotate-reverse",
    "user",
    "sensor",
    "comma",
    "school-circle-check",
    "toilet-paper-reverse",
    "toilet-paper-under",
    "light-emergency",
    "arrow-down-to-arc",
    "dumpster",
    "shuttle-van",
    "van-shuttle",
    "building-user",
    "light-switch",
    "caret-square-left",
    "square-caret-left",
    "highlighter",
    "heart-rate",
    "wave-pulse",
    "key",
    "arrow-left-to-bracket",
    "hat-santa",
    "tamale",
    "box-check",
    "bullhorn",
    "steak",
    "location-slash",
    "location-crosshairs-slash",
    "person-dolly",
    "globe",
    "synagogue",
    "file-chart-line",
    "file-chart-column",
    "person-half-dress",
    "folder-image",
    "calendar-edit",
    "calendar-pen",
    "road-bridge",
    "face-smile-tear",
    "comment-alt-plus",
    "message-plus",
    "location-arrow",
    "c",
    "tablet-button",
    "person-dress-fairy",
    "rectangle-history-circle-user",
    "building-lock",
    "chart-line-up",
    "mailbox",
    "sign-posts",
    "truck-bolt",
    "pizza-slice",
    "money-bill-wave",
    "area-chart",
    "chart-area",
    "house-flag",
    "circle-three-quarters-stroke",
    "person-circle-minus",
    "scalpel",
    "cancel",
    "ban",
    "bell-exclamation",
    "bookmark-circle",
    "circle-bookmark",
    "egg-fried",
    "face-weary",
    "uniform-martial-arts",
    "camera-rotate",
    "sun-dust",
    "comment-text",
    "air-freshener",
    "spray-can-sparkles",
    "signal-alt",
    "signal-alt-4",
    "signal-bars-strong",
    "signal-bars",
    "diamond-exclamation",
    "star",
    "dial-min",
    "repeat",
    "cross",
    "file-caret-down",
    "page-caret-down",
    "box",
    "venus-mars",
    "clock-seven-thirty",
    "mouse-pointer",
    "arrow-pointer",
    "clock-four-thirty",
    "signal-alt-3",
    "signal-bars-good",
    "cactus",
    "lightbulb-gear",
    "expand-arrows-alt",
    "maximize",
    "charging-station",
    "triangle-circle-square",
    "shapes",
    "plane-tail",
    "tachometer-fastest",
    "gauge-simple-max",
    "circle-u",
    "shield-slash",
    "phone-square-down",
    "square-phone-hangup",
    "arrow-up-left",
    "transporter-1",
    "peanuts",
    "random",
    "shuffle",
    "running",
    "person-running",
    "mobile-retro",
    "grip-lines-vertical",
    "bin-bottles-recycle",
    "arrow-up-from-square",
    "page-break",
    "file-dashed-line",
    "bracket-curly-right",
    "spider",
    "clock-three",
    "hands-bound",
    "scalpel-path",
    "scalpel-line-dashed",
    "file-invoice-dollar",
    "pipe-smoking",
    "face-astonished",
    "window",
    "plane-circle-exclamation",
    "ear",
    "file-lock",
    "diagram-venn",
    "arrow-down-from-bracket",
    "x-ray",
    "goal-net",
    "coffin-cross",
    "spell-check",
    "map-marker-times",
    "map-marker-xmark",
    "location-xmark",
    "circle-quarter-stroke",
    "lasso",
    "slash",
    "portal-enter",
    "person-to-portal",
    "calendar-star",
    "mouse",
    "computer-mouse",
    "sign-in",
    "arrow-right-to-bracket",
    "pegasus",
    "files-medical",
    "cannon",
    "nfc-lock",
    "ski-lift",
    "person-ski-lift",
    "square-6",
    "store-alt-slash",
    "shop-slash",
    "wind-turbine",
    "sliders-simple",
    "grid-round",
    "badge-sheriff",
    "server",
    "virus-covid-slash",
    "intersection",
    "shop-lock",
    "family",
    "hourglass-1",
    "hourglass-start",
    "user-hair-buns",
    "blender-phone",
    "hourglass-clock",
    "person-seat-reclined",
    "paper-plane-alt",
    "send",
    "paper-plane-top",
    "comment-alt-arrow-up",
    "message-arrow-up",
    "lightbulb-exclamation",
    "layer-group-minus",
    "layer-minus",
    "chart-pie-simple-circle-currency",
    "circle-e",
    "building-wheat",
    "tachometer-alt-fastest",
    "gauge-max",
    "person-breastfeeding",
    "apostrophe",
    "file-png",
    "fire-hydrant",
    "sign-in-alt",
    "right-to-bracket",
    "video-plus",
    "arrow-alt-square-right",
    "square-right",
    "comment-smile",
    "venus",
    "passport",
    "inbox-arrow-down",
    "inbox-in",
    "heartbeat",
    "heart-pulse",
    "circle-8",
    "clouds-moon",
    "clock-ten-thirty",
    "people-carry",
    "people-carry-box",
    "folder-user",
    "trash-can-xmark",
    "temperature-high",
    "microchip",
    "left-long-to-line",
    "crown",
    "weight-hanging",
    "xmarks-lines",
    "file-prescription",
    "table-cells-lock",
    "calendar-range",
    "flower-daffodil",
    "hand-back-point-up",
    "weight",
    "weight-scale",
    "arrow-up-to-arc",
    "star-exclamation",
    "books",
    "user-friends",
    "user-group",
    "sort-alpha-up",
    "arrow-up-a-z",
    "layer-group-plus",
    "layer-plus",
    "play-pause",
    "block-question",
    "zzz",
    "snooze",
    "scanner-image",
    "tv-retro",
    "square-t",
    "barn-silo",
    "farm",
    "chess-knight",
    "bars-sort",
    "palette-boxes",
    "pallet-alt",
    "pallet-boxes",
    "laugh-squint",
    "face-laugh-squint",
    "code-simple",
    "bolt-slash",
    "panel-fire",
    "binary-circle-check",
    "comment-minus",
    "burrito",
    "violin",
    "objects-column",
    "chevron-square-down",
    "square-chevron-down",
    "comment-plus",
    "triangle-music",
    "triangle-instrument",
    "wheelchair",
    "user-pilot-tie",
    "piano-keyboard",
    "bed-empty",
    "arrow-circle-up",
    "circle-arrow-up",
    "toggle-on",
    "rectangle-portrait",
    "rectangle-vertical",
    "walking",
    "person-walking",
    "l",
    "signal-stream",
    "down-to-bracket",
    "circle-z",
    "stars",
    "fire",
    "procedures",
    "bed-pulse",
    "house-day",
    "space-shuttle",
    "shuttle-space",
    "shirt-long-sleeve",
    "chart-pie-alt",
    "chart-pie-simple",
    "laugh",
    "face-laugh",
    "folder-open",
    "album-collection-circle-user",
    "candy",
    "soup",
    "bowl-hot",
    "flatbread",
    "heart-circle-plus",
    "code-fork",
    "city",
    "signal-alt-1",
    "signal-bars-weak",
    "microphone-alt",
    "microphone-lines",
    "clock-twelve",
    "pepper-hot",
    "citrus-slice",
    "sheep",
    "unlock",
    "colon-sign",
    "headset",
    "badger-honey",
    "h4",
    "store-slash",
    "road-circle-xmark",
    "signal-slash",
    "user-minus",
    "mars-stroke-v",
    "mars-stroke-up",
    "glass-cheers",
    "champagne-glasses",
    "taco",
    "plus-hexagon",
    "hexagon-plus",
    "clipboard",
    "house-circle-exclamation",
    "file-upload",
    "file-arrow-up",
    "wifi-3",
    "wifi-strong",
    "wifi",
    "comments-alt",
    "messages",
    "bathtub",
    "bath",
    "umbrella-alt",
    "umbrella-simple",
    "rectangle-history-circle-plus",
    "underline",
    "prescription-bottle-pill",
    "user-edit",
    "user-pen",
    "binary-slash",
    "square-o",
    "caduceus",
    "signature",
    "stroopwafel",
    "bold",
    "anchor-lock",
    "building-ngo",
    "transporter-3",
    "engine-exclamation",
    "engine-warning",
    "circle-down-right",
    "square-k",
    "manat-sign",
    "money-check-edit",
    "money-check-pen",
    "not-equal",
    "border-style",
    "border-top-left",
    "map-marked-alt",
    "map-location-dot",
    "tilde",
    "jedi",
    "poll",
    "square-poll-vertical",
    "sort-shapes-down-alt",
    "arrow-down-square-triangle",
    "mug-hot",
    "dog-leashed",
    "battery-car",
    "car-battery",
    "face-downcast-sweat",
    "mailbox-flag-up",
    "memo-circle-info",
    "gift",
    "dice-two",
    "volume-medium",
    "volume",
    "transporter-5",
    "gauge-circle-bolt",
    "coin-front",
    "file-slash",
    "message-arrow-up-right",
    "treasure-chest",
    "chess-queen",
    "paint-brush-alt",
    "paint-brush-fine",
    "paintbrush-alt",
    "paintbrush-fine",
    "glasses",
    "hood-cloak",
    "square-quote",
    "up-left",
    "bring-front",
    "chess-board",
    "cheeseburger",
    "burger-cheese",
    "building-circle-check",
    "repeat-1",
    "arrow-to-bottom",
    "arrow-down-to-line",
    "grid-5",
    "swap-arrows",
    "right-long-to-line",
    "person-chalkboard",
    "mars-stroke-h",
    "mars-stroke-right",
    "hand-rock",
    "hand-back-fist",
    "grid-round-5",
    "tally-5",
    "tally",
    "caret-square-up",
    "square-caret-up",
    "cloud-showers-water",
    "bar-chart",
    "chart-bar",
    "hands-wash",
    "hands-bubbles",
    "less-than-equal",
    "train",
    "up-from-dotted-line",
    "low-vision",
    "eye-low-vision",
    "traffic-light-go",
    "face-exhaling",
    "sensor-fire",
    "user-unlock",
    "hexagon-divide",
    "00",
    "crow",
    "betamax",
    "cassette-betamax",
    "sailboat",
    "window-restore",
    "nfc-magnifying-glass",
    "file-binary",
    "circle-v",
    "plus-square",
    "square-plus",
    "bowl-scoops",
    "mistletoe",
    "custard",
    "lacrosse-stick",
    "hockey-mask",
    "sunrise",
    "subtitles",
    "panel-ews",
    "torii-gate",
    "cloud-exclamation",
    "comment-alt-lines",
    "message-lines",
    "frog",
    "bucket",
    "floppy-disk-pen",
    "image",
    "window-frame",
    "microphone",
    "cow",
    "file-zip",
    "square-ring",
    "arrow-alt-from-top",
    "down-from-line",
    "caret-up",
    "shield-times",
    "shield-xmark",
    "screwdriver",
    "sort-circle-down",
    "circle-sort-down",
    "folder-closed",
    "house-tsunami",
    "square-nfi",
    "forklift",
    "arrow-up-from-ground-water",
    "bracket-square-right",
    "glass-martini-alt",
    "martini-glass",
    "rotate-back",
    "rotate-backward",
    "undo-alt",
    "rotate-left",
    "columns",
    "table-columns",
    "square-a",
    "tick",
    "lemon",
    "head-side-mask",
    "handshake",
    "gem",
    "dolly-box",
    "dolly",
    "smoking",
    "compress-arrows-alt",
    "minimize",
    "refrigerator",
    "monument",
    "times-octagon",
    "xmark-octagon",
    "octagon-xmark",
    "align-slash",
    "snowplow",
    "angle-double-right",
    "angles-right",
    "truck-couch",
    "truck-ramp-couch",
    "cannabis",
    "play-circle",
    "circle-play",
    "arrow-up-right-and-arrow-down-left-from-center",
    "location-arrow-up",
    "tablets",
    "360-degrees",
    "ethernet",
    "eur",
    "euro",
    "euro-sign",
    "chair",
    "check-circle",
    "circle-check",
    "square-dashed-circle-plus",
    "hand-holding-circle-dollar",
    "money-simple-from-bracket",
    "bat",
    "stop-circle",
    "circle-stop",
    "head-side-headphones",
    "phone-rotary",
    "arrow-up-to-bracket",
    "drafting-compass",
    "compass-drafting",
    "plate-wheat",
    "calendar-circle-minus",
    "chopsticks",
    "car-mechanic",
    "car-wrench",
    "icicles",
    "person-shelter",
    "neuter",
    "id-badge",
    "kazoo",
    "marker",
    "bin-bottles",
    "laugh-beam",
    "face-laugh-beam",
    "square-arrow-down-left",
    "battery-bolt",
    "tree-large",
    "helicopter-symbol",
    "aperture",
    "universal-access",
    "gear-complex",
    "file-search",
    "file-magnifying-glass",
    "up-right",
    "chevron-circle-up",
    "circle-chevron-up",
    "user-police",
    "lari-sign",
    "volcano",
    "teddy-bear",
    "stocking",
    "person-walking-dashed-line-arrow-right",
    "image-slash",
    "mask-snorkel",
    "smoke",
    "gbp",
    "pound-sign",
    "sterling-sign",
    "battery-exclamation",
    "viruses",
    "square-person-confined",
    "user-tie",
    "up-to-bracket",
    "long-arrow-down",
    "arrow-down-long",
    "tent-arrow-down-to-line",
    "certificate",
    "crystal-ball",
    "mail-reply-all",
    "reply-all",
    "suitcase",
    "skating",
    "person-skating",
    "star-shooting",
    "binary-lock",
    "funnel-dollar",
    "filter-circle-dollar",
    "camera-retro",
    "arrow-circle-down",
    "circle-arrow-down",
    "comment-edit",
    "comment-pen",
    "arrow-right-to-file",
    "file-import",
    "banjo",
    "external-link-square",
    "square-arrow-up-right",
    "light-emergency-on",
    "kerning",
    "box-open",
    "square-f",
    "scroll",
    "spa",
    "arrow-from-right",
    "arrow-left-from-line",
    "strawberry",
    "location-pin-lock",
    "pause",
    "clock-eight-thirty",
    "plane-alt",
    "plane-engines",
    "hill-avalanche",
    "temperature-0",
    "thermometer-0",
    "thermometer-empty",
    "temperature-empty",
    "bomb",
    "tachometer-alt-slow",
    "gauge-low",
    "registered",
    "trash-can-plus",
    "contact-card",
    "vcard",
    "address-card",
    "balance-scale-right",
    "scale-unbalanced-flip",
    "globe-snow",
    "subscript",
    "directions",
    "diamond-turn-right",
    "integral",
    "burst",
    "laptop-house",
    "house-laptop",
    "tired",
    "face-tired",
    "money-bills",
    "blinds-raised",
    "smog",
    "ufo-beam",
    "caret-circle-up",
    "circle-caret-up",
    "user-vneck-hair-long",
    "square-a-lock",
    "crutch",
    "gas-pump-slash",
    "font-awesome-flag",
    "font-awesome-logo-full",
    "font-awesome",
    "cloud-upload",
    "cloud-upload-alt",
    "cloud-arrow-up",
    "palette",
    "transporter-4",
    "chart-mixed-up-circle-currency",
    "objects-align-right",
    "arrows-turn-right",
    "vest",
    "pig",
    "inbox-full",
    "envelope-circle",
    "circle-envelope",
    "construction",
    "triangle-person-digging",
    "ferry",
    "bullseye-arrow",
    "arrows-down-to-people",
    "sprout",
    "seedling",
    "clock-seven",
    "arrows-alt-h",
    "left-right",
    "boxes-packing",
    "arrow-circle-left",
    "circle-arrow-left",
    "flashlight",
    "file-jpg",
    "group-arrows-rotate",
    "bowl-food",
    "square-9",
    "candy-cane",
    "sort-amount-asc",
    "sort-amount-down",
    "arrow-down-wide-short",
    "dollar-square",
    "usd-square",
    "square-dollar",
    "phone-arrow-right",
    "hand-holding-seedling",
    "comment-alt-check",
    "message-check",
    "thunderstorm",
    "cloud-bolt",
    "chart-line-up-down",
    "remove-format",
    "text-slash",
    "watch",
    "circle-down-left",
    "text",
    "projector",
    "smile-wink",
    "face-smile-wink",
    "tombstone-alt",
    "tombstone-blank",
    "chess-king-alt",
    "chess-king-piece",
    "circle-6",
    "waves-sine",
    "arrow-alt-left",
    "left",
    "file-word",
    "file-powerpoint",
    "arrow-alt-square-down",
    "square-down",
    "objects-align-center-vertical",
    "arrows-h",
    "arrows-left-right",
    "house-lock",
    "cloud-download",
    "cloud-download-alt",
    "cloud-arrow-down",
    "wreath",
    "children",
    "meter-droplet",
    "blackboard",
    "chalkboard",
    "user-alt-slash",
    "user-large-slash",
    "signal-4",
    "signal-strong",
    "lollypop",
    "lollipop",
    "list-tree",
    "envelope-open",
    "draw-circle",
    "cat-space",
    "handshake-alt-slash",
    "handshake-simple-slash",
    "rabbit-fast",
    "rabbit-running",
    "memo-pad",
    "mattress-pillow",
    "alarm-plus",
    "alicorn",
    "comment-question",
    "gingerbread-man",
    "guarani-sign",
    "burger-fries",
    "mug-tea",
    "border-top",
    "refresh",
    "sync",
    "arrows-rotate",
    "book-circle",
    "circle-book-open",
    "arrows-to-dotted-line",
    "fire-extinguisher",
    "magnifying-glass-arrows-rotate",
    "garage-open",
    "shelves-empty",
    "cruzeiro-sign",
    "watch-apple",
    "watch-calculator",
    "list-dropdown",
    "cabinet-filing",
    "burger-soda",
    "arrow-square-up",
    "square-arrow-up",
    "greater-than-equal",
    "pallet-box",
    "face-confounded",
    "shield-alt",
    "shield-halved",
    "truck-plow",
    "atlas",
    "book-atlas",
    "virus",
    "grid-round-2",
    "comment-middle-top",
    "wave",
    "envelope-circle-check",
    "layer-group",
    "restroom-simple",
    "arrows-to-dot",
    "border-outer",
    "hashtag-lock",
    "clock-two-thirty",
    "archway",
    "heart-circle-check",
    "house-damage",
    "house-chimney-crack",
    "file-archive",
    "file-zipper",
    "ticket-perforated",
    "heart-half",
    "comment-check",
    "square",
    "memo",
    "glass-martini",
    "martini-glass-empty",
    "couch",
    "cedi-sign",
    "italic",
    "glass-citrus",
    "calendar-lines-pen",
    "table-cells-column-lock",
    "church",
    "snowmobile",
    "person-snowmobiling",
    "face-hushed",
    "comments-dollar",
    "tickets-simple",
    "pickaxe",
    "link-simple-slash",
    "democrat",
    "face-confused",
    "pinball",
    "z",
    "skiing",
    "person-skiing",
    "deer",
    "input-pipe",
    "road-lock",
    "a",
    "bookmark-slash",
    "temperature-down",
    "temperature-arrow-down",
    "mace",
    "feather-alt",
    "feather-pointed",
    "sausage",
    "trash-can-clock",
    "p",
    "broom-wide",
    "snowflake",
    "stomach",
    "newspaper",
    "ad",
    "rectangle-ad",
    "guitar-electric",
    "arrow-turn-down-right",
    "moon-cloud",
    "bread-slice-butter",
    "arrow-circle-right",
    "circle-arrow-right",
    "users-crown",
    "user-group-crown",
    "circle-i",
    "toilet-paper-check",
    "filter-circle-xmark",
    "locust",
    "unsorted",
    "sort",
    "list-1-2",
    "list-numeric",
    "list-ol",
    "chart-waterfall",
    "sparkle",
    "face-party",
    "kidneys",
    "wifi-exclamation",
    "chart-network",
    "person-dress-burst",
    "dice-d4",
    "money-check-alt",
    "money-check-dollar",
    "vector-square",
    "bread-slice",
    "language",
    "wheat-awn-slash",
    "kiss-wink-heart",
    "face-kiss-wink-heart",
    "dagger",
    "podium",
    "memo-circle-check",
    "route-highway",
    "arrow-alt-to-bottom",
    "down-to-line",
    "filter",
    "square-g",
    "phone-circle",
    "circle-phone",
    "clipboard-prescription",
    "user-nurse-hair",
    "question",
    "file-signature",
    "toggle-large-on",
    "arrows-alt",
    "up-down-left-right",
    "dryer-alt",
    "dryer-heat",
    "house-chimney-user",
    "hand-holding-heart",
    "sort-size-up-alt",
    "arrow-up-small-big",
    "train-track",
    "puzzle-piece",
    "money-check",
    "star-half-alt",
    "star-half-stroke",
    "file-exclamation",
    "code",
    "glass-whiskey",
    "whiskey-glass",
    "moon-stars",
    "building-circle-exclamation",
    "clothes-hanger",
    "mobile-iphone",
    "mobile-notch",
    "magnifying-glass-chart",
    "external-link",
    "arrow-up-right-from-square",
    "cubes-stacked",
    "images-user",
    "krw",
    "won",
    "won-sign",
    "image-polaroid-user",
    "virus-covid",
    "square-ellipsis",
    "pie",
    "chess-knight-alt",
    "chess-knight-piece",
    "austral-sign",
    "cloud-plus",
    "f",
    "leaf",
    "bed-bunk",
    "road",
    "cab",
    "taxi",
    "person-circle-plus",
    "pie-chart",
    "chart-pie",
    "bolt-lightning",
    "clock-eight",
    "sack-xmark",
    "file-xls",
    "file-excel",
    "file-contract",
    "fish-fins",
    "circle-q",
    "building-flag",
    "grin-beam",
    "face-grin-beam",
    "object-ungroup",
    "face-disguise",
    "circle-arrow-down-right",
    "alien-monster",
    "alien-8bit",
    "hand-point-ribbon",
    "poop",
    "object-exclude",
    "telescope",
    "map-marker",
    "location-pin",
    "square-list",
    "kaaba",
    "toilet-paper",
    "hard-hat",
    "hat-hard",
    "helmet-safety",
    "comment-code",
    "sim-cards",
    "starship",
    "eject",
    "arrow-alt-circle-right",
    "circle-right",
    "plane-circle-check",
    "seal",
    "user-cowboy",
    "hexagon-vertical-nft",
    "meh-rolling-eyes",
    "face-rolling-eyes",
    "bread-loaf",
    "rings-wedding",
    "object-group",
    "french-fries",
    "line-chart",
    "chart-line",
    "calendar-download",
    "calendar-arrow-down",
    "send-back",
    "mask-ventilator",
    "tickets",
    "signature-lock",
    "arrow-right",
    "map-signs",
    "signs-post",
    "plus-octagon",
    "octagon-plus",
    "cash-register",
    "person-circle-question",
    "melon-slice",
    "space-station-moon",
    "comment-alt-smile",
    "message-smile",
    "cup-straw",
    "arrow-alt-from-right",
    "left-from-line",
    "h",
    "shopping-basket-alt",
    "basket-shopping-simple",
    "hands-heart",
    "hands-holding-heart",
    "clock-nine",
    "hammer-brush",
    "tarp",
    "face-sleepy",
    "hand-horns",
    "tools",
    "screwdriver-wrench",
    "arrows-to-eye",
    "circle-three-quarters",
    "trophy-alt",
    "trophy-star",
    "plug-circle-bolt",
    "face-thermometer",
    "grid-round-4",
    "sign-posts-wrench",
    "shirt-running",
    "book-circle-arrow-up",
    "face-nauseated",
    "heart",
    "file-chart-pie",
    "mars-and-venus",
    "home-user",
    "house-user",
    "circle-arrow-down-left",
    "dumpster-fire",
    "minus-hexagon",
    "hexagon-minus",
    "arrow-alt-to-left",
    "left-to-line",
    "house-crack",
    "paw-alt",
    "paw-simple",
    "arrow-left-long-to-line",
    "parentheses",
    "brackets-round",
    "cocktail",
    "martini-glass-citrus",
    "user-shakespeare",
    "arrow-right-to-arc",
    "surprise",
    "face-surprise",
    "bottle-water",
    "pause-circle",
    "circle-pause",
    "gauge-circle-plus",
    "folders",
    "angel",
    "value-absolute",
    "rabbit",
    "toilet-paper-slash",
    "circle-euro",
    "apple-alt",
    "apple-whole",
    "kitchen-set",
    "diamond-half",
    "lock-alt",
    "lock-keyhole",
    "r",
    "temperature-1",
    "thermometer-1",
    "thermometer-quarter",
    "temperature-quarter",
    "info-square",
    "square-info",
    "wifi-slash",
    "toilet-paper-xmark",
    "hands-usd",
    "hands-holding-dollar",
    "cube",
    "sort-shapes-down",
    "arrow-down-triangle-square",
    "bitcoin-sign",
    "shutters",
    "shield-dog",
    "solar-panel",
    "lock-open",
    "table-tree",
    "house-chimney-heart",
    "tally-3",
    "elevator",
    "money-bill-transfer",
    "money-bill-trend-up",
    "house-flood-water-circle-arrow-right",
    "poll-h",
    "square-poll-horizontal",
    "circle",
    "left-to-bracket",
    "cart-circle-exclamation",
    "sword",
    "fast-backward",
    "backward-fast",
    "recycle",
    "user-astronaut",
    "interrobang",
    "plane-slash",
    "circle-dashed",
    "trademark",
    "basketball-ball",
    "basketball",
    "utensils-alt",
    "fork-knife",
    "satellite-dish",
    "badge-check",
    "arrow-alt-circle-up",
    "circle-up",
    "slider",
    "mobile-alt",
    "mobile-screen-button",
    "clock-one-thirty",
    "inbox-arrow-up",
    "inbox-out",
    "cloud-slash",
    "volume-up",
    "volume-high",
    "users-rays",
    "wallet",
    "octagon-check",
    "flatbread-stuffed",
    "clipboard-check",
    "cart-circle-plus",
    "shipping-timed",
    "truck-clock",
    "pool-8-ball",
    "file-audio",
    "turn-down-left",
    "lock-hashtag",
    "chart-radar",
    "staff",
    "hamburger",
    "burger",
    "utility-pole",
    "transporter-6",
    "arrow-turn-left",
    "wrench",
    "bugs",
    "vector-polygon",
    "diagram-nested",
    "rupee",
    "rupee-sign",
    "file-image",
    "question-circle",
    "circle-question",
    "tickets-perforated",
    "image-user",
    "buoy",
    "plane-departure",
    "handshake-slash",
    "book-bookmark",
    "border-center-h",
    "can-food",
    "typewriter",
    "arrow-right-from-arc",
    "circle-k",
    "face-hand-over-mouth",
    "popcorn",
    "house-flood",
    "house-water",
    "object-subtract",
    "code-branch",
    "warehouse-alt",
    "warehouse-full",
    "hat-cowboy",
    "bridge",
    "phone-alt",
    "phone-flip",
    "arrow-down-from-dotted-line",
    "file-doc",
    "square-quarters",
    "truck-front",
    "cat",
    "trash-xmark",
    "caret-circle-left",
    "circle-caret-left",
    "files",
    "anchor-circle-exclamation",
    "face-clouds",
    "user-crown",
    "basket-shopping-plus",
    "truck-field",
    "route",
    "cart-circle-check",
    "clipboard-question",
    "panorama",
    "comment-medical",
    "teeth-open",
    "user-tie-hair-long",
    "file-circle-minus",
    "head-side-medical",
    "arrow-turn-right",
    "tags",
    "wine-glass",
    "fast-forward",
    "forward-fast",
    "meh-blank",
    "face-meh-blank",
    "user-robot",
    "parking",
    "square-parking",
    "card-diamond",
    "face-zipper",
    "face-raised-eyebrow",
    "house-signal",
    "chevron-square-up",
    "square-chevron-up",
    "nfc-symbol",
    "tasks-alt",
    "bars-progress",
    "faucet-drip",
    "arrows-to-line",
    "dolphin",
    "arrow-up-right",
    "circle-r",
    "dolly-flatbed",
    "cart-flatbed",
    "smoking-ban",
    "ban-smoking",
    "sort-circle-up",
    "circle-sort-up",
    "terminal",
    "mobile-button",
    "house-medical-flag",
    "shopping-basket",
    "basket-shopping",
    "tape",
    "chestnut",
    "bus-alt",
    "bus-simple",
    "eye",
    "sad-cry",
    "face-sad-cry",
    "heat",
    "ticket-perforated-plane",
    "ticket-plane",
    "ticket-airline",
    "boot-heeled",
    "compress-arrows",
    "arrows-minimize",
    "audio-description",
    "person-military-to-person",
    "file-shield",
    "hexagon",
    "manhole",
    "user-slash",
    "pen",
    "tower-observation",
    "floppy-disks",
    "toilet-paper-reverse-alt",
    "toilet-paper-blank-under",
    "file-code",
    "signal-5",
    "signal-perfect",
    "signal",
    "pump",
    "bus",
    "heart-circle-xmark",
    "arrow-up-left-from-circle",
    "home-lg",
    "house-chimney",
    "window-maximize",
    "dryer",
    "frown",
    "face-frown",
    "chess-bishop-alt",
    "chess-bishop-piece",
    "shirt-tank-top",
    "scroll-ribbon",
    "diploma",
    "screencast",
    "walker",
    "prescription",
    "store-alt",
    "shop",
    "save",
    "floppy-disk",
    "vihara",
    "face-kiss-closed-eyes",
    "balance-scale-left",
    "scale-unbalanced",
    "file-user",
    "user-police-tie",
    "face-tongue-money",
    "tennis-ball",
    "square-l",
    "sort-asc",
    "sort-up",
    "calendar-upload",
    "calendar-arrow-up",
    "commenting",
    "comment-dots",
    "plant-wilt",
    "scarf",
    "album-circle-plus",
    "user-nurse-hair-long",
    "diamond",
    "arrow-alt-square-left",
    "square-left",
    "grin-squint",
    "face-grin-squint",
    "circle-ellipsis-vertical",
    "hand-holding-usd",
    "hand-holding-dollar",
    "grid-dividers",
    "bacterium",
    "hand-pointer",
    "drum-steelpan",
    "hand-scissors",
    "praying-hands",
    "hands-praying",
    "face-pensive",
    "user-music",
    "arrow-right-rotate",
    "arrow-rotate-forward",
    "redo",
    "arrow-rotate-right",
    "comments-alt-dollar",
    "messages-dollar",
    "sensor-on",
    "balloon",
    "web-awesome",
    "biohazard",
    "chess-queen-alt",
    "chess-queen-piece",
    "location",
    "location-crosshairs",
    "mars-double",
    "left-from-bracket",
    "house-leave",
    "house-person-depart",
    "house-person-leave",
    "ruler-triangle",
    "card-club",
    "child-dress",
    "users-between-lines",
    "lungs-virus",
    "spinner-third",
    "grin-tears",
    "face-grin-tears",
    "phone",
    "mouse-alt",
    "computer-mouse-scrollwheel",
    "calendar-times",
    "calendar-xmark",
    "child-reaching",
    "table-layout",
    "narwhal",
    "ramp-loading",
    "calendar-circle-plus",
    "toothbrush",
    "border-inner",
    "paw-claws",
    "kiwi-fruit",
    "traffic-light-slow",
    "rectangle-code",
    "head-side-virus",
    "keyboard-brightness",
    "books-medical",
    "lightbulb-slash",
    "home-blank",
    "house-blank",
    "square-5",
    "heart-square",
    "square-heart",
    "puzzle",
    "user-cog",
    "user-gear",
    "pipe-circle-check",
    "sort-numeric-up",
    "arrow-up-1-9",
    "octagon-exclamation",
    "dial-low",
    "door-closed",
    "phone-laptop",
    "laptop-mobile",
    "conveyor-belt-alt",
    "conveyor-belt-boxes",
    "shield-virus",
    "starfighter-alt-advanced",
    "starfighter-twin-ion-engine-advanced",
    "dice-six",
    "starfighter-alt",
    "starfighter-twin-ion-engine",
    "rocket-launch",
    "mosquito-net",
    "vent-damper",
    "bridge-water",
    "debug",
    "ban-bug",
    "person-booth",
    "text-width",
    "garage-car",
    "square-kanban",
    "hat-wizard",
    "chart-kanban",
    "pen-fancy",
    "coffee-pot",
    "mouse-field",
    "digging",
    "person-digging",
    "shower-alt",
    "shower-down",
    "box-circle-check",
    "brightness",
    "car-side-bolt",
    "file-xml",
    "ornament",
    "phone-arrow-down",
    "phone-incoming",
    "phone-arrow-down-left",
    "cloud-word",
    "hand-fingers-crossed",
    "trash",
    "gauge-simple-med",
    "tachometer-average",
    "gauge-simple",
    "sort-size-down-alt",
    "arrow-down-small-big",
    "book-medical",
    "face-melting",
    "poo",
    "pen-alt-slash",
    "pen-clip-slash",
    "quote-right-alt",
    "quote-right",
    "scroll-old",
    "guitars",
    "phone-xmark",
    "hose",
    "clock-six",
    "t-shirt",
    "tshirt",
    "shirt",
    "billboard",
    "square-r",
    "cubes",
    "envelope-open-dollar",
    "divide",
    "sun-cloud",
    "lamp-floor",
    "square-7",
    "tenge",
    "tenge-sign",
    "headphones",
    "hands-holding",
    "campfire",
    "circle-ampersand",
    "snowflakes",
    "hands-clapping",
    "republican",
    "leaf-maple",
    "arrow-left",
    "person-circle-xmark",
    "ruler",
    "arrow-left-from-bracket",
    "cup-straw-swoosh",
    "temperature-hot",
    "temperature-sun",
    "align-left",
    "dice-d6",
    "restroom",
    "rectangle-hd",
    "high-definition",
    "j",
    "galaxy",
    "users-viewfinder",
    "file-video",
    "cherries",
    "external-link-alt",
    "up-right-from-square",
    "sort-circle",
    "circle-sort",
    "th",
    "table-cells",
    "bag-shopping-minus",
    "file-pdf",
    "siren",
    "arrow-up-to-dotted-line",
    "landscape",
    "image-landscape",
    "tank-water",
    "curling",
    "curling-stone",
    "gamepad-alt",
    "gamepad-modern",
    "messages-question",
    "bible",
    "book-bible",
    "o",
    "medkit",
    "suitcase-medical",
    "briefcase-arrow-right",
    "expand-wide",
    "clock-eleven-thirty",
    "rv",
    "user-secret",
    "otter",
    "dreidel",
    "female",
    "person-dress",
    "comment-dollar",
    "briefcase-clock",
    "business-time",
    "flower-tulip",
    "people-pants-simple",
    "cloud-drizzle",
    "th-large",
    "table-cells-large",
    "tanakh",
    "book-tanakh",
    "solar-system",
    "seal-question",
    "volume-control-phone",
    "phone-volume",
    "disc-drive",
    "hat-cowboy-side",
    "rows",
    "table-rows",
    "map-marker-exclamation",
    "location-exclamation",
    "face-fearful",
    "clipboard-user",
    "bus-school",
    "film-slash",
    "square-arrow-down-right",
    "book-spells",
    "book-sparkles",
    "washer",
    "washing-machine",
    "child",
    "lira-sign",
    "user-visor",
    "file-plus-minus",
    "chess-clock-alt",
    "chess-clock-flip",
    "satellite",
    "truck-fire",
    "plane-lock",
    "steering-wheel",
    "tag",
    "stretcher",
    "book-law",
    "book-section",
    "inboxes",
    "coffee-bean",
    "circle-yen",
    "brackets-curly",
    "ellipsis-v-alt",
    "ellipsis-stroke-vertical",
    "comment",
    "square-1",
    "birthday-cake",
    "cake",
    "cake-candles",
    "head-side",
    "truck-ladder",
    "envelope",
    "dolly-empty",
    "face-tissue",
    "angle-double-up",
    "angles-up",
    "bin-recycle",
    "paperclip",
    "chart-line-down",
    "arrow-right-to-city",
    "lock-a",
    "ribbon",
    "lungs",
    "person-pinball",
    "sort-numeric-up-alt",
    "arrow-up-9-1",
    "apple-core",
    "circle-y",
    "h6",
    "litecoin-sign",
    "bottle-baby",
    "circle-small",
    "border-none",
    "arrow-turn-down-left",
    "circle-wifi-group",
    "circle-wifi-circle-wifi",
    "circle-nodes",
    "parachute-box",
    "reflect-horizontal",
    "comment-alt-medical",
    "message-medical",
    "rugby-ball",
    "comment-music",
    "indent",
    "tree-alt",
    "tree-deciduous",
    "puzzle-piece-alt",
    "puzzle-piece-simple",
    "truck-field-un",
    "nfc-trash",
    "hourglass-empty",
    "hourglass",
    "mountain",
    "file-times",
    "file-xmark",
    "home-heart",
    "house-heart",
    "house-chimney-blank",
    "meter-bolt",
    "user-md",
    "user-doctor",
    "slash-back",
    "info-circle",
    "circle-info",
    "fishing-rod",
    "hammer-crash",
    "message-heart",
    "cloud-meatball",
    "camera-polaroid",
    "camera-alt",
    "camera",
    "square-virus",
    "cart-arrow-up",
    "meteor",
    "car-on",
    "sleigh",
    "sort-numeric-asc",
    "sort-numeric-down",
    "arrow-down-1-9",
    "buoy-mooring",
    "square-4",
    "hand-holding-water",
    "hand-holding-droplet",
    "file-eps",
    "tricycle-adult",
    "waveform",
    "water",
    "star-sharp-half-alt",
    "star-sharp-half-stroke",
    "nfc-signal",
    "plane-prop",
    "calendar-check",
    "clock-desk",
    "calendar-time",
    "calendar-clock",
    "braille",
    "prescription-bottle-alt",
    "prescription-bottle-medical",
    "plate-utensils",
    "family-pants",
    "hose-reel",
    "house-window",
    "landmark",
    "truck",
    "music-magnifying-glass",
    "crosshairs",
    "cloud-rainbow",
    "person-cane",
    "alien",
    "tent",
    "laptop-binary",
    "vest-patches",
    "people-dress-simple",
    "check-double",
    "sort-alpha-asc",
    "sort-alpha-down",
    "arrow-down-a-z",
    "bowling-ball-pin",
    "bell-school-slash",
    "plus-large",
    "money-bill-wheat",
    "screenshot",
    "camera-viewfinder",
    "comment-alt-music",
    "message-music",
    "car-building",
    "border-style-alt",
    "border-bottom-right",
    "octagon",
    "comment-arrow-up-right",
    "octagon-divide",
    "cookie",
    "arrow-left-rotate",
    "arrow-rotate-back",
    "arrow-rotate-backward",
    "undo",
    "arrow-rotate-left",
    "tv-music",
    "hdd",
    "hard-drive",
    "reel",
    "grin-squint-tears",
    "face-grin-squint-tears",
    "dumbbell",
    "list-alt",
    "rectangle-list",
    "tarp-droplet",
    "alarm-exclamation",
    "house-medical-circle-check",
    "traffic-cone",
    "grate",
    "arrow-down-right",
    "skiing-nordic",
    "person-skiing-nordic",
    "calendar-plus",
    "portal-exit",
    "person-from-portal",
    "plane-arrival",
    "cowbell-more",
    "cowbell-circle-plus",
    "arrow-alt-circle-left",
    "circle-left",
    "distribute-spacing-vertical",
    "signal-alt-2",
    "signal-bars-fair",
    "sportsball",
    "game-console-handheld-crank",
    "subway",
    "train-subway",
    "chart-gantt",
    "face-smile-upside-down",
    "ball-pile",
    "badge-dollar",
    "money-bills-alt",
    "money-bills-simple",
    "list-timeline",
    "indian-rupee",
    "inr",
    "indian-rupee-sign",
    "crop-alt",
    "crop-simple",
    "money-bill-alt",
    "money-bill-1",
    "long-arrow-alt-left",
    "left-long",
    "keyboard-down",
    "circle-up-right",
    "thunderstorm-moon",
    "cloud-bolt-moon",
    "turn-left-up",
    "dna",
    "virus-slash",
    "bracket-round-right",
    "circle-sterling",
    "circle-5",
    "subtract",
    "minus",
    "flame",
    "fire-flame",
    "arrow-alt-to-right",
    "right-to-line",
    "gif",
    "chess",
    "trash-slash",
    "long-arrow-left",
    "arrow-left-long",
    "plug-circle-check",
    "font-case",
    "street-view",
    "arrow-down-left",
    "franc-sign",
    "flask-poison",
    "flask-round-poison",
    "volume-off",
    "book-circle-arrow-right",
    "user-chart",
    "chart-user",
    "american-sign-language-interpreting",
    "asl-interpreting",
    "hands-american-sign-language-interpreting",
    "hands-asl-interpreting",
    "presentation",
    "presentation-screen",
    "circle-bolt",
    "face-smile-halo",
    "cart-circle-arrow-down",
    "house-person-arrive",
    "house-return",
    "house-person-return",
    "comment-alt-times",
    "message-times",
    "message-xmark",
    "file-award",
    "file-certificate",
    "user-doctor-hair-long",
    "camera-home",
    "camera-security",
    "cog",
    "gear",
    "tint-slash",
    "droplet-slash",
    "book-heart",
    "mosque",
    "duck",
    "mosquito",
    "star-of-david",
    "flag-alt",
    "flag-swallowtail",
    "person-military-rifle",
    "car-garage",
    "shopping-cart",
    "cart-shopping",
    "book-font",
    "shield-plus",
    "vials",
    "eye-dropper-full",
    "distribute-spacing-horizontal",
    "tablet-rugged",
    "temperature-frigid",
    "temperature-snow",
    "moped",
    "smile-plus",
    "face-smile-plus",
    "radio-alt",
    "radio-tuner",
    "face-swear",
    "water-lower",
    "water-arrow-down",
    "scanner-touchscreen",
    "circle-7",
    "plug-circle-plus",
    "ski-jump",
    "person-ski-jumping",
    "place-of-worship",
    "water-rise",
    "water-arrow-up",
    "waveform-path",
    "waveform-lines",
    "split",
    "film-cannister",
    "film-canister",
    "folder-times",
    "folder-xmark",
    "toilet-paper-alt",
    "toilet-paper-blank",
    "tablet-android-alt",
    "tablet-screen",
    "hexagon-vertical-nft-slanted",
    "folder-music",
    "desktop-medical",
    "display-medical",
    "share-all",
    "peapod",
    "chess-clock",
    "axe",
    "square-d",
    "grip-vertical",
    "mobile-signal-out",
    "level-up",
    "arrow-turn-up",
    "u",
    "arrow-up-from-dotted-line",
    "square-root-alt",
    "square-root-variable",
    "light-switch-on",
    "sort-alt",
    "arrow-down-arrow-up",
    "raindrops",
    "minus-large",
    "dash",
    "clock-four",
    "clock",
    "input-numeric",
    "truck-tow",
    "step-backward",
    "backward-step",
    "pallet",
    "car-bolt",
    "expand-arrows",
    "arrows-maximize",
    "faucet",
    "cloud-sleet",
    "lamp-street",
    "list-radio",
    "pen-nib-slash",
    "baseball-bat-ball",
    "square-up-left",
    "overline",
    "s",
    "timeline",
    "keyboard",
    "arrows-from-dotted-line",
    "usb-drive",
    "ballot",
    "caret-down",
    "map-marker-alt-slash",
    "location-dot-slash",
    "cards",
    "clinic-medical",
    "house-chimney-medical",
    "glove-boxing",
    "boxing-glove",
    "temperature-3",
    "thermometer-3",
    "thermometer-three-quarters",
    "temperature-three-quarters",
    "bell-school",
    "mobile-android-alt",
    "mobile-screen",
    "plane-up",
    "folder-heart",
    "location-circle",
    "circle-location-arrow",
    "face-head-bandage",
    "maki-roll",
    "makizushi",
    "sushi-roll",
    "car-bump",
    "piggy-bank",
    "racquet",
    "car-mirrors",
    "industry-alt",
    "industry-windows",
    "bolt-auto",
    "battery-3",
    "battery-half",
    "flux-capacitor",
    "mountain-city",
    "coins",
    "honey-pot",
    "olive",
    "khanda",
    "filter-list",
    "outlet",
    "sliders-h",
    "sliders",
    "cauldron",
    "people",
    "folder-tree",
    "network-wired",
    "croissant",
    "map-pin",
    "hamsa",
    "cent-sign",
    "swords-laser",
    "flask",
    "person-pregnant",
    "square-u",
    "wand-sparkles",
    "router",
    "ellipsis-v",
    "ellipsis-vertical",
    "sword-laser-alt",
    "ticket",
    "power-off",
    "coin",
    "laptop-slash",
    "long-arrow-alt-right",
    "right-long",
    "circle-b",
    "person-dress-simple",
    "pipe-collar",
    "lights-holiday",
    "citrus",
    "flag-usa",
    "laptop-file",
    "teletype",
    "tty",
    "chart-tree-map",
    "diagram-next",
    "person-rifle",
    "clock-five-thirty",
    "pipe-valve",
    "arrow-up-from-arc",
    "face-spiral-eyes",
    "compress-wide",
    "phone-circle-down",
    "circle-phone-hangup",
    "gear-complex-code",
    "house-medical-circle-exclamation",
    "badminton",
    "closed-captioning",
    "hiking",
    "person-hiking",
    "arrow-alt-from-left",
    "right-from-line",
    "venus-double",
    "images",
    "calculator",
    "shuttlecock",
    "user-hair",
    "eye-evil",
    "people-pulling",
    "n",
    "swap",
    "garage",
    "tram",
    "cable-car",
    "shovel-snow",
    "cloud-rain",
    "face-lying",
    "sprinkler",
    "building-circle-xmark",
    "sledding",
    "person-sledding",
    "game-console-handheld",
    "ship",
    "clock-six-thirty",
    "battery-slash",
    "tugrik-sign",
    "arrows-down-to-line",
    "download",
    "angles-up-down",
    "inventory",
    "shelves",
    "cloud-snow",
    "grin",
    "face-grin",
    "backspace",
    "delete-left",
    "oven",
    "cloud-binary",
    "eye-dropper-empty",
    "eyedropper",
    "eye-dropper",
    "comment-captions",
    "comments-question",
    "scribble",
    "rotate-exclamation",
    "file-circle-check",
    "glass",
    "loader",
    "forward",
    "user-pilot",
    "mobile-android",
    "mobile-phone",
    "mobile",
    "code-pull-request-closed",
    "meh",
    "face-meh",
    "align-center",
    "book-dead",
    "book-skull",
    "drivers-license",
    "id-card",
    "face-dotted",
    "face-worried",
    "dedent",
    "outdent",
    "court-sport",
    "heart-circle-exclamation",
    "home",
    "home-alt",
    "home-lg-alt",
    "house",
    "vector-circle",
    "car-circle-bolt",
    "calendar-week",
    "flying-disc",
    "laptop-medical",
    "square-down-right",
    "b",
    "seat-airline",
    "eclipse-alt",
    "moon-over-sun",
    "pipe",
    "file-medical",
    "potato",
    "dice-one",
    "circle-a",
    "helmet-battle",
    "butter",
    "blanket-fire",
    "kiwi-bird",
    "castle",
    "golf-club",
    "exchange",
    "arrow-right-arrow-left",
    "redo-alt",
    "rotate-forward",
    "rotate-right",
    "cutlery",
    "utensils",
    "sort-amount-up",
    "arrow-up-wide-short",
    "chart-pie-simple-circle-dollar",
    "balloons",
    "mill-sign",
    "bowl-rice",
    "timeline-arrow",
    "skull",
    "game-board-alt",
    "game-board-simple",
    "video-circle",
    "circle-video",
    "chart-scatter-bubble",
    "house-turret",
    "banana",
    "hand-holding-skull",
    "people-dress",
    "couch-small",
    "loveseat",
    "broadcast-tower",
    "tower-broadcast",
    "truck-pickup",
    "block-quote",
    "long-arrow-alt-up",
    "up-long",
    "stop",
    "code-merge",
    "money-check-edit-alt",
    "money-check-dollar-pen",
    "arrow-alt-from-bottom",
    "up-from-line",
    "upload",
    "hurricane",
    "grid-round-2-plus",
    "people-pants",
    "mound",
    "windsock",
    "circle-half",
    "brake-warning",
    "toilet-portable",
    "compact-disc",
    "file-download",
    "file-arrow-down",
    "sax-hot",
    "saxophone-fire",
    "webcam-slash",
    "camera-web-slash",
    "folder-medical",
    "folder-cog",
    "folder-gear",
    "hand-wave",
    "sort-up-down",
    "arrow-up-arrow-down",
    "caravan",
    "shield-cat",
    "comment-alt-slash",
    "message-slash",
    "zap",
    "bolt",
    "trash-can-check",
    "glass-water",
    "oil-well",
    "person-simple",
    "arrow-turn-left-up",
    "vault",
    "mars",
    "toilet",
    "plane-circle-xmark",
    "cny",
    "jpy",
    "rmb",
    "yen",
    "yen-sign",
    "gear-code",
    "notes",
    "rouble",
    "rub",
    "ruble",
    "ruble-sign",
    "trash-arrow-turn-left",
    "trash-undo",
    "glass-champagne",
    "champagne-glass",
    "objects-align-center-horizontal",
    "sun",
    "trash-alt-slash",
    "trash-can-slash",
    "users-class",
    "screen-users",
    "guitar",
    "arrow-square-left",
    "square-arrow-left",
    "square-8",
    "face-smile-hearts",
    "brackets",
    "brackets-square",
    "laptop-arrow-down",
    "hockey-stick-puck",
    "house-tree",
    "signal-2",
    "signal-fair",
    "laugh-wink",
    "face-laugh-wink",
    "dollar-circle",
    "usd-circle",
    "circle-dollar",
    "horse-head",
    "repeat-alt",
    "arrows-repeat",
    "bore-hole",
    "industry",
    "image-polaroid",
    "wave-triangle",
    "turn-left-down",
    "person-running-fast",
    "arrow-alt-circle-down",
    "circle-down",
    "grill",
    "arrows-turn-to-dots",
    "analytics",
    "chart-mixed",
    "florin-sign",
    "sort-amount-desc",
    "sort-amount-down-alt",
    "arrow-down-short-wide",
    "less-than",
    "desktop-code",
    "display-code",
    "face-drooling",
    "oil-temp",
    "oil-temperature",
    "question-square",
    "square-question",
    "air-conditioner",
    "angle-down",
    "mountains",
    "omega",
    "car-tunnel",
    "person-dolly-empty",
    "pan-food",
    "head-side-cough",
    "grip-lines",
    "thumbs-down",
    "user-lock",
    "long-arrow-right",
    "arrow-right-long",
    "tickets-perforated-plane",
    "tickets-plane",
    "tickets-airline",
    "tent-double-peak",
    "anchor-circle-xmark",
    "ellipsis-h",
    "ellipsis",
    "nfc-slash",
    "chess-pawn",
    "first-aid",
    "kit-medical",
    "grid-2-plus",
    "bells",
    "person-through-window",
    "toolbox",
    "envelope-badge",
    "envelope-dot",
    "magnifying-glass-waveform",
    "hands-holding-circle",
    "bug",
    "bowl-chopsticks",
    "credit-card-alt",
    "credit-card",
    "circle-s",
    "box-ballot",
    "automobile",
    "car",
    "hand-holding-hand",
    "user-tie-hair",
    "podium-star",
    "business-front",
    "party-back",
    "trian-balbot",
    "user-hair-mullet",
    "microphone-stand",
    "book-reader",
    "book-open-reader",
    "family-dress",
    "circle-x",
    "cabin",
    "mountain-sun",
    "chart-simple-horizontal",
    "bluetooth",
    "arrows-left-right-to-line",
    "hand-back-point-left",
    "comment-alt-dots",
    "messaging",
    "message-dots",
    "file-heart",
    "beer-foam",
    "beer-mug",
    "dice-d20",
    "drone",
    "truck-droplet",
    "file-circle-xmark",
    "temperature-up",
    "temperature-arrow-up",
    "medal",
    "person-fairy",
    "bed",
    "book-copy",
    "h-square",
    "square-h",
    "square-c",
    "clock-two",
    "square-ellipsis-vertical",
    "calendar-users",
    "podcast",
    "bee",
    "temperature-4",
    "thermometer-4",
    "thermometer-full",
    "temperature-full",
    "bell",
    "chocolate-bar",
    "candy-bar",
    "xmark-large",
    "pinata",
    "file-ppt",
    "arrows-from-line",
    "superscript",
    "bowl-spoon",
    "hexagon-check",
    "plug-circle-xmark",
    "star-of-life",
    "phone-slash",
    "traffic-light-stop",
    "paint-roller",
    "accent-grave",
    "hands-helping",
    "handshake-angle",
    "circle-0",
    "dial-med-low",
    "map-marker-alt",
    "location-dot",
    "crab",
    "box-full",
    "box-open-full",
    "file",
    "greater-than",
    "quotes",
    "pretzel",
    "t-rex",
    "swimmer",
    "person-swimming",
    "arrow-down",
    "user-robot-xmarks",
    "comment-alt-quote",
    "message-quote",
    "candy-corn",
    "folder-search",
    "folder-magnifying-glass",
    "notebook",
    "circle-wifi",
    "tint",
    "droplet",
    "bullseye-pointer",
    "eraser",
    "hexagon-image",
    "earth",
    "earth-america",
    "globe-americas",
    "earth-americas",
    "file-svg",
    "apple-crate",
    "crate-apple",
    "person-burst",
    "game-board",
    "hat-chef",
    "hand-back-point-right",
    "dove",
    "snowflake-droplets",
    "battery-0",
    "battery-empty",
    "grid-4",
    "socks",
    "face-sunglasses",
    "inbox",
    "square-0",
    "section",
    "box-up",
    "square-this-way-up",
    "tachometer-alt",
    "tachometer-alt-fast",
    "gauge-high",
    "square-ampersand",
    "envelope-open-text",
    "lamp-desk",
    "hospital-alt",
    "hospital-wide",
    "hospital",
    "poll-people",
    "glass-whiskey-rocks",
    "whiskey-glass-ice",
    "wine-bottle",
    "chess-rook",
    "user-bounty-hunter",
    "reorder",
    "stream",
    "bars-staggered",
    "diagram-sankey",
    "cloud-hail-mixed",
    "circle-up-left",
    "dharmachakra",
    "objects-align-left",
    "oil-can-drip",
    "face-smiling-hands",
    "broccoli",
    "route-interstate",
    "ear-muffs",
    "hotdog",
    "transporter-empty",
    "blind",
    "person-walking-with-cane",
    "angle-90",
    "rectangle-terminal",
    "kite",
    "drum",
    "scrubber",
    "ice-cream",
    "heart-circle-bolt",
    "fish-bones",
    "deer-rudolph",
    "fax",
    "paragraph",
    "head-side-heart",
    "square-e",
    "meter-fire",
    "cloud-hail",
    "vote-yea",
    "check-to-slot",
    "money-from-bracket",
    "star-half",
    "car-bus",
    "speaker",
    "timer",
    "boxes",
    "boxes-alt",
    "boxes-stacked",
    "landmark-magnifying-glass",
    "grill-hot",
    "ballot-check",
    "chain",
    "link",
    "assistive-listening-systems",
    "ear-listen",
    "file-minus",
    "tree-city",
    "play",
    "font",
    "coffee-togo",
    "cup-togo",
    "square-down-left",
    "burger-lettuce",
    "table-cells-row-lock",
    "rupiah-sign",
    "search",
    "magnifying-glass",
    "ping-pong-paddle-ball",
    "table-tennis",
    "table-tennis-paddle-ball",
    "diagnoses",
    "person-dots-from-line",
    "chevron-double-down",
    "chevrons-down",
    "trash-restore-alt",
    "trash-can-arrow-up",
    "signal-3",
    "signal-good",
    "map-marker-question",
    "location-question",
    "floppy-disk-times",
    "save-circle-xmark",
    "save-times",
    "floppy-disk-circle-xmark",
    "naira-sign",
    "peach",
    "taxi-bus",
    "bracket-curly-left",
    "bracket-curly",
    "lobster",
    "dolly-flatbed-empty",
    "cart-flatbed-empty",
    "colon",
    "cart-arrow-down",
    "wand",
    "walkie-talkie",
    "file-edit",
    "file-pen",
    "receipt",
    "table-picnic",
    "pen-square",
    "pencil-square",
    "square-pen",
    "microphone-circle-alt",
    "circle-microphone-lines",
    "desktop-slash",
    "display-slash",
    "suitcase-rolling",
    "person-circle-exclamation",
    "transporter-2",
    "hand-receiving",
    "hands-holding-diamond",
    "money-bill-simple-wave",
    "chevron-down",
    "battery",
    "battery-5",
    "battery-full",
    "bell-plus",
    "book-arrow-right",
    "hospitals",
    "club",
    "skull-crossbones",
    "dewpoint",
    "droplet-degree",
    "code-compare",
    "list-dots",
    "list-ul",
    "hand-holding-magic",
    "watermelon-slice",
    "circle-ellipsis",
    "school-lock",
    "tower-cell",
    "sd-cards",
    "jug-bottle",
    "long-arrow-alt-down",
    "down-long",
    "envelopes",
    "phone-office",
    "ranking-star",
    "chess-king",
    "nfc-pen",
    "person-harassing",
    "magnifying-glass-play",
    "hat-winter",
    "brazilian-real-sign",
    "landmark-alt",
    "landmark-dome",
    "bone-break",
    "arrow-up",
    "down-from-dotted-line",
    "television",
    "tv-alt",
    "tv",
    "border-left",
    "circle-divide",
    "shrimp",
    "tasks",
    "list-check",
    "diagram-subtask",
    "jug-detergent",
    "user-circle",
    "circle-user",
    "square-y",
    "user-doctor-hair",
    "planet-ringed",
    "mushroom",
    "user-shield",
    "megaphone",
    "wreath-laurel",
    "circle-exclamation-check",
    "wind",
    "box-usd",
    "box-dollar",
    "car-crash",
    "car-burst",
    "y",
    "user-headset",
    "retweet-alt",
    "arrows-retweet",
    "snowboarding",
    "person-snowboarding",
    "chevron-square-right",
    "square-chevron-right",
    "lacrosse-stick-ball",
    "shipping-fast",
    "truck-fast",
    "user-magnifying-glass",
    "star-sharp",
    "comment-heart",
    "circle-1",
    "star-circle",
    "circle-star",
    "fish",
    "fog",
    "cloud-fog",
    "waffle",
    "music-alt",
    "music-note",
    "hexagon-exclamation",
    "cart-shopping-fast",
    "object-union",
    "user-graduate",
    "starfighter",
    "adjust",
    "circle-half-stroke",
    "arrow-right-long-to-line",
    "arrow-square-down",
    "square-arrow-down",
    "diamond-half-stroke",
    "clapperboard",
    "chevron-square-left",
    "square-chevron-left",
    "phone-intercom",
    "chain-horizontal",
    "link-horizontal",
    "mango",
    "music-alt-slash",
    "music-note-slash",
    "radiation-alt",
    "circle-radiation",
    "face-tongue-sweat",
    "globe-stand",
    "baseball-ball",
    "baseball",
    "circle-p",
    "award-simple",
    "jet-fighter-up",
    "project-diagram",
    "diagram-project",
    "pedestal",
    "chart-pyramid",
    "sidebar",
    "frosty-head",
    "snowman-head",
    "copy",
    "burger-glass",
    "volume-mute",
    "volume-times",
    "volume-xmark",
    "hand-sparkles",
    "bars-filter",
    "paintbrush-pencil",
    "party-bell",
    "user-vneck-hair",
    "jack-o-lantern",
    "grip-horizontal",
    "grip",
    "share-square",
    "share-from-square",
    "keynote",
    "child-rifle",
    "child-combatant",
    "gun",
    "phone-square",
    "square-phone",
    "hat-beach",
    "add",
    "plus",
    "expand",
    "computer",
    "fort",
    "cloud-check",
    "close",
    "multiply",
    "remove",
    "times",
    "xmark",
    "face-smirking",
    "arrows",
    "arrows-up-down-left-right",
    "chalkboard-teacher",
    "chalkboard-user",
    "rhombus",
    "claw-marks",
    "peso-sign",
    "face-smile-tongue",
    "cart-circle-xmark",
    "building-shield",
    "phone-circle-alt",
    "circle-phone-flip",
    "baby",
    "users-line",
    "quote-left-alt",
    "quote-left",
    "tractor",
    "down-from-bracket",
    "key-skeleton",
    "trash-restore",
    "trash-arrow-up",
    "arrow-down-up-lock",
    "arrow-down-to-bracket",
    "lines-leaning",
    "square-q",
    "ruler-combined",
    "icons-alt",
    "symbols",
    "copyright",
    "flask-gear",
    "highlighter-line",
    "bracket",
    "bracket-left",
    "bracket-square",
    "island-tree-palm",
    "island-tropical",
    "arrow-from-left",
    "arrow-right-from-line",
    "h2",
    "equals",
    "shortcake",
    "cake-slice",
    "building-magnifying-glass",
    "peanut",
    "wrench-simple",
    "blender",
    "teeth",
    "tally-2",
    "ils",
    "shekel",
    "sheqel",
    "sheqel-sign",
    "shekel-sign",
    "cars",
    "axe-battle",
    "user-hair-long",
    "map",
    "arrow-left-from-arc",
    "file-circle-info",
    "face-disappointed",
    "lasso-sparkles",
    "clock-eleven",
    "rocket",
    "siren-on",
    "clock-ten",
    "candle-holder",
    "video-arrow-down-left",
    "photo-video",
    "photo-film",
    "save-circle-arrow-right",
    "floppy-disk-circle-arrow-right",
    "folder-minus",
    "planet-moon",
    "face-eyes-xmarks",
    "chart-scatter",
    "circle-gf",
    "display-arrow-down",
    "store",
    "arrow-trend-up",
    "plug-circle-minus",
    "olive-branch",
    "angle",
    "vacuum-robot",
    "sign",
    "sign-hanging",
    "square-divide",
    "folder-check",
    "signal-stream-slash",
    "bezier-curve",
    "eye-dropper-half",
    "store-lock",
    "bell-slash",
    "thunderstorm-sun",
    "cloud-bolt-sun",
    "camera-slash",
    "comment-quote",
    "tablet-android",
    "tablet",
    "school-flag",
    "message-code",
    "glass-half-empty",
    "glass-half-full",
    "glass-half",
    "fill",
    "comment-alt-minus",
    "message-minus",
    "angle-up",
    "dinosaur",
    "drumstick-bite",
    "chain-horizontal-slash",
    "link-horizontal-slash",
    "holly-berry",
    "nose",
    "arrow-left-to-arc",
    "chevron-left",
    "bacteria",
    "clouds",
    "money-bill-simple",
    "hand-lizard",
    "table-pivot",
    "filter-slash",
    "trash-can-arrow-turn-left",
    "trash-undo-alt",
    "trash-can-undo",
    "notdef",
    "disease",
    "person-to-door",
    "turntable",
    "briefcase-medical",
    "genderless",
    "chevron-right",
    "signal-1",
    "signal-weak",
    "clock-five",
    "retweet",
    "car-alt",
    "car-rear",
    "pump-soap",
    "computer-classic",
    "frame",
    "video-slash",
    "battery-2",
    "battery-quarter",
    "ellipsis-h-alt",
    "ellipsis-stroke",
    "radio",
    "carriage-baby",
    "baby-carriage",
    "face-expressionless",
    "down-to-dotted-line",
    "cloud-music",
    "traffic-light",
    "cloud-minus",
    "thermometer",
    "shield-minus",
    "vr-cardboard",
    "car-tilt",
    "gauge-circle-minus",
    "brightness-low",
    "hand-middle-finger",
    "percentage",
    "percent",
    "truck-moving",
    "glass-water-droplet",
    "conveyor-belt",
    "map-marker-check",
    "location-check",
    "coin-vertical",
    "display",
    "person-sign",
    "smile",
    "face-smile",
    "phone-hangup",
    "signature-slash",
    "thumb-tack",
    "thumbtack",
    "wheat-slash",
    "trophy",
    "clouds-sun",
    "pray",
    "person-praying",
    "hammer",
    "face-vomit",
    "speakers",
    "teletype-answer",
    "tty-answer",
    "mug-tea-saucer",
    "diagram-lean-canvas",
    "alt",
    "dial-med-high",
    "dial",
    "hand-peace",
    "trash-circle",
    "circle-trash",
    "sync-alt",
    "rotate",
    "circle-quarters",
    "spinner",
    "tower-control",
    "sort-shapes-up",
    "arrow-up-triangle-square",
    "whale",
    "robot",
    "peace",
    "party-horn",
    "cogs",
    "gears",
    "sun-alt",
    "sun-bright",
    "warehouse",
    "conveyor-belt-arm",
    "lock-open-alt",
    "lock-keyhole-open",
    "box-fragile",
    "square-wine-glass-crack",
    "square-fragile",
    "arrow-up-right-dots",
    "square-n",
    "splotch",
    "grin-hearts",
    "face-grin-hearts",
    "meter",
    "mandolin",
    "dice-four",
    "sim-card",
    "transgender-alt",
    "transgender",
    "mercury",
    "up-from-bracket",
    "knife-kitchen",
    "border-right",
    "level-down",
    "arrow-turn-down",
    "spade",
    "card-spade",
    "line-columns",
    "ant",
    "arrow-to-right",
    "arrow-right-to-line",
    "person-falling-burst",
    "pennant",
    "flag-pennant",
    "conveyor-belt-empty",
    "user-group-simple",
    "award",
    "ticket-alt",
    "ticket-simple",
    "building",
    "angle-double-left",
    "angles-left",
    "video-handheld",
    "camcorder",
    "pancakes",
    "album-circle-user",
    "subtitles-slash",
    "qrcode",
    "dice-d10",
    "fireplace",
    "browser",
    "pencil-paintbrush",
    "pen-paintbrush",
    "fish-cooked",
    "chair-office",
    "magnifying-glass-music",
    "nesting-dolls",
    "history",
    "clock-rotate-left",
    "trumpet",
    "grin-beam-sweat",
    "face-grin-beam-sweat",
    "fire-smoke",
    "phone-missed",
    "arrow-right-from-file",
    "file-export",
    "shield-blank",
    "shield",
    "sort-amount-up-alt",
    "arrow-up-short-wide",
    "repeat-1-alt",
    "arrows-repeat-1",
    "gun-slash",
    "avocado",
    "binary",
    "glasses-alt",
    "glasses-round",
    "phone-plus",
    "ditto",
    "person-seat",
    "house-medical",
    "golf-ball",
    "golf-ball-tee",
    "chevron-circle-left",
    "circle-chevron-left",
    "house-chimney-window",
    "scythe",
    "pen-nib",
    "parking-circle-slash",
    "ban-parking",
    "tent-arrow-turn-left",
    "face-diagonal-mouth",
    "diagram-cells",
    "cricket",
    "cricket-bat-ball",
    "tents",
    "magic",
    "wand-magic",
    "dog",
    "pen-line",
    "atom-alt",
    "atom-simple",
    "ampersand",
    "carrot",
    "arrow-from-bottom",
    "arrow-up-from-line",
    "moon",
    "pen-slash",
    "wine-glass-alt",
    "wine-glass-empty",
    "square-star",
    "cheese",
    "send-backward",
    "yin-yang",
    "music",
    "compass-slash",
    "clock-one",
    "file-music",
    "code-commit",
    "temperature-low",
    "biking",
    "person-biking",
    "display-chart-up-circle-currency",
    "skeleton",
    "circle-g",
    "circle-arrow-up-left",
    "coin-blank",
    "broom",
    "vacuum",
    "shield-heart",
    "card-heart",
    "lightbulb-cfl-on",
    "melon",
    "gopuram",
    "globe-oceania",
    "earth-oceania",
    "container-storage",
    "face-pouting",
    "times-square",
    "xmark-square",
    "square-xmark",
    "exploding-head",
    "face-explode",
    "hashtag",
    "expand-alt",
    "up-right-and-down-left-from-center",
    "oil-can",
    "t",
    "transformer-bolt",
    "hippo",
    "chart-column",
    "vhs",
    "cassette-vhs",
    "infinity",
    "vial-circle-check",
    "chimney",
    "object-intersect",
    "person-arrow-down-to-line",
    "voicemail",
    "wall-brick",
    "block-brick",
    "fan",
    "bags-shopping",
    "paragraph-rtl",
    "paragraph-left",
    "person-walking-luggage",
    "caravan-alt",
    "caravan-simple",
    "turtle",
    "pencil-mechanical",
    "arrows-alt-v",
    "up-down",
    "cloud-moon-rain",
    "booth-curtain",
    "calendar",
    "box-heart",
    "trailer",
    "user-md-chat",
    "user-doctor-message",
    "haykal",
    "bahai",
    "lighthouse",
    "amp-guitar",
    "sd-card",
    "volume-slash",
    "border-bottom",
    "wifi-1",
    "wifi-weak",
    "dragon",
    "shoe-prints",
    "plus-circle",
    "circle-plus",
    "grin-tongue-wink",
    "face-grin-tongue-wink",
    "hand-holding",
    "plug-circle-exclamation",
    "chain-broken",
    "chain-slash",
    "unlink",
    "link-slash",
    "clone",
    "person-walking-arrow-loop-left",
    "sort-alpha-up-alt",
    "arrow-up-z-a",
    "fire-alt",
    "fire-flame-curved",
    "tornado",
    "file-circle-plus",
    "delete-right",
    "quran",
    "book-quran",
    "circle-quarter",
    "anchor",
    "border-all",
    "function",
    "angry",
    "face-angry",
    "people-simple",
    "cookie-bite",
    "arrow-trend-down",
    "feed",
    "rss",
    "face-monocle",
    "draw-polygon",
    "balance-scale",
    "scale-balanced",
    "calendar-note",
    "calendar-lines",
    "sort-size-down",
    "arrow-down-big-small",
    "tachometer",
    "tachometer-fast",
    "gauge-simple-high",
    "do-not-enter",
    "shower",
    "dice-d8",
    "desktop-alt",
    "desktop",
    "m",
    "spinner-scale",
    "grip-dots-vertical",
    "face-viewfinder",
    "creemee",
    "soft-serve",
    "h5",
    "hand-back-point-down",
    "th-list",
    "table-list",
    "basket-shopping-minus",
    "sms",
    "comment-sms",
    "rectangle-landscape",
    "rectangle",
    "clipboard-list-check",
    "turkey",
    "book",
    "user-plus",
    "ice-skate",
    "check",
    "battery-4",
    "battery-three-quarters",
    "tomato",
    "sword-laser",
    "house-circle-check",
    "buildings",
    "angle-left",
    "dolly-flatbed-alt",
    "cart-flatbed-boxes",
    "diagram-successor",
    "truck-arrow-right",
    "square-w",
    "arrows-split-up-and-left",
    "lamp",
    "airplay",
    "fist-raised",
    "hand-fist",
    "shield-quartered",
    "slash-forward",
    "map-marker-edit",
    "location-pen",
    "cloud-moon",
    "pot-food",
    "briefcase",
    "person-falling",
    "portrait",
    "image-portrait",
    "user-tag",
    "rug",
    "print-slash",
    "globe-europe",
    "earth-europe",
    "luggage-cart",
    "cart-flatbed-suitcase",
    "hand-back-point-ribbon",
    "rectangle-times",
    "times-rectangle",
    "window-close",
    "rectangle-xmark",
    "tire-rugged",
    "lightbulb-dollar",
    "cowbell",
    "baht-sign",
    "corner",
    "chevron-double-right",
    "chevrons-right",
    "book-open",
    "journal-whills",
    "book-journal-whills",
    "inhaler",
    "handcuffs",
    "snake",
    "exclamation-triangle",
    "warning",
    "triangle-exclamation",
    "note-medical",
    "database",
    "down-left",
    "mail-forward",
    "share",
    "face-thinking",
    "turn-down-right",
    "bottle-droplet",
    "mask-face",
    "hill-rockslide",
    "scanner-keyboard",
    "circle-o",
    "grid-horizontal",
    "comment-alt-dollar",
    "message-dollar",
    "exchange-alt",
    "right-left",
    "columns-3",
    "paper-plane",
    "road-circle-exclamation",
    "dungeon",
    "hand-holding-box",
    "input-text",
    "window-alt",
    "window-flip",
    "align-right",
    "scanner",
    "scanner-gun",
    "tire",
    "engine",
    "money-bill-wave-alt",
    "money-bill-1-wave",
    "life-ring",
    "sign-language",
    "signing",
    "hands",
    "caret-circle-right",
    "circle-caret-right",
    "turn-left",
    "wheat",
    "file-spreadsheet",
    "audio-description-slash",
    "bell-ring",
    "calendar-day",
    "ladder-water",
    "swimming-pool",
    "water-ladder",
    "arrows-v",
    "arrows-up-down",
    "chess-pawn-alt",
    "chess-pawn-piece",
    "grimace",
    "face-grimace",
    "wheelchair-alt",
    "wheelchair-move",
    "level-down-alt",
    "turn-down",
    "square-s",
    "barcode-alt",
    "rectangle-barcode",
    "person-walking-arrow-right",
    "envelope-square",
    "square-envelope",
    "dice",
    "unicorn",
    "bowling-ball",
    "pompebled",
    "brain",
    "watch-smart",
    "book-user",
    "sensor-smoke",
    "sensor-cloud",
    "clapperboard-play",
    "band-aid",
    "bandage",
    "calendar-minus",
    "times-circle",
    "xmark-circle",
    "circle-xmark",
    "circle-4",
    "gifts",
    "album-collection",
    "hotel",
    "globe-asia",
    "earth-asia",
    "id-card-alt",
    "id-card-clip",
    "search-plus",
    "magnifying-glass-plus",
    "thumbs-up",
    "cloud-showers",
    "user-clock",
    "onion",
    "clock-twelve-thirty",
    "arrow-down-to-dotted-line",
    "allergies",
    "hand-dots",
    "file-invoice",
    "window-minimize",
    "rectangle-wide",
    "comment-arrow-up",
    "garlic",
    "coffee",
    "mug-saucer",
    "brush",
    "tree-decorated",
    "mask",
    "calendar-heart",
    "search-minus",
    "magnifying-glass-minus",
    "flower",
    "arrow-down-from-arc",
    "right-left-large",
    "ruler-vertical",
    "circles-overlap",
    "user-alt",
    "user-large",
    "starship-freighter",
    "train-tram",
    "bridge-suspension",
    "trash-check",
    "user-nurse",
    "boombox",
    "syringe",
    "cloud-sun",
    "shield-exclamation",
    "stopwatch-20",
    "square-full",
    "grip-dots",
    "comment-exclamation",
    "pen-swirl",
    "falafel",
    "circle-2",
    "magnet",
    "jar",
    "gramophone",
    "dice-d12",
    "sticky-note",
    "note-sticky",
    "arrow-alt-down",
    "down",
    "100",
    "hundred-points",
    "paperclip-vertical",
    "wind-circle-exclamation",
    "wind-warning",
    "map-marker-slash",
    "location-pin-slash",
    "face-sad-sweat",
    "bug-slash",
    "cupcake",
    "light-switch-off",
    "toggle-large-off",
    "pen-fancy-slash",
    "truck-container",
    "boot",
    "arrow-up-from-water-pump",
    "file-check",
    "bone",
    "cards-blank",
    "circle-3",
    "bench-tree",
    "keyboard-brightness-low",
    "ski-boot-ski",
    "brain-circuit",
    "user-injured",
    "firewall",
    "block-brick-fire",
    "sad-tear",
    "face-sad-tear",
    "plane",
    "tent-arrows-down",
    "exclamation",
    "arrows-spin",
    "face-smile-relaxed",
    "comment-times",
    "comment-xmark",
    "print",
    "try",
    "turkish-lira",
    "turkish-lira-sign",
    "face-nose-steam",
    "waveform-circle",
    "circle-waveform-lines",
    "dollar",
    "usd",
    "dollar-sign",
    "ferris-wheel",
    "computer-speaker",
    "skull-cow",
    "x",
    "search-dollar",
    "magnifying-glass-dollar",
    "users-cog",
    "users-gear",
    "person-military-pointing",
    "bank",
    "institution",
    "museum",
    "university",
    "building-columns",
    "circle-t",
    "sack",
    "grid-2",
    "cctv",
    "camera-cctv",
    "umbrella",
    "trowel",
    "horizontal-rule",
    "bed-alt",
    "bed-front",
    "d",
    "stapler",
    "theater-masks",
    "masks-theater",
    "file-gif",
    "kip-sign",
    "face-woozy",
    "cloud-question",
    "pineapple",
    "hand-point-left",
    "gallery-thumbnails",
    "circle-j",
    "eyes",
    "handshake-alt",
    "handshake-simple",
    "file-caret-up",
    "page-caret-up",
    "fighter-jet",
    "jet-fighter",
    "comet",
    "share-alt-square",
    "square-share-nodes",
    "reflect-vertical",
    "shield-keyhole",
    "file-mp4",
    "barcode",
    "bulldozer",
    "plus-minus",
    "sliders-v-square",
    "square-sliders-vertical",
    "video-camera",
    "video",
    "comment-middle-alt",
    "message-middle",
    "mortar-board",
    "graduation-cap",
    "hand-holding-medical",
    "person-circle-check",
    "square-z",
    "comment-alt-text",
    "message-text",
    "level-up-alt",
    "turn-up"
  ],
  "fas": [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "fill-drip",
    "arrows-to-circle",
    "chevron-circle-right",
    "circle-chevron-right",
    "wagon-covered",
    "line-height",
    "bagel",
    "transporter-7",
    "at",
    "rectangles-mixed",
    "phone-arrow-up",
    "phone-outgoing",
    "phone-arrow-up-right",
    "trash-alt",
    "trash-can",
    "circle-l",
    "head-vr",
    "head-side-goggles",
    "text-height",
    "user-times",
    "user-xmark",
    "face-hand-yawn",
    "tachometer-slowest",
    "gauge-simple-min",
    "stethoscope",
    "coffin",
    "comment-alt",
    "message",
    "bowl-salad",
    "salad",
    "info",
    "robot-astromech",
    "ring-diamond",
    "fondue-pot",
    "theta",
    "face-hand-peeking",
    "square-user",
    "compress-alt",
    "down-left-and-up-right-to-center",
    "explosion",
    "file-alt",
    "file-text",
    "file-lines",
    "wave-square",
    "ring",
    "building-un",
    "dice-three",
    "tire-pressure-warning",
    "wifi-2",
    "wifi-fair",
    "calendar-alt",
    "calendar-days",
    "mp3-player",
    "anchor-circle-check",
    "tally-4",
    "rectangle-history",
    "building-circle-arrow-right",
    "volleyball-ball",
    "volleyball",
    "sun-haze",
    "text-size",
    "ufo",
    "utensil-fork",
    "fork",
    "arrows-up-to-line",
    "mobile-signal",
    "barcode-scan",
    "sort-desc",
    "sort-down",
    "folder-download",
    "folder-arrow-down",
    "minus-circle",
    "circle-minus",
    "face-icicles",
    "shovel",
    "door-open",
    "films",
    "sign-out-alt",
    "right-from-bracket",
    "face-glasses",
    "nfc",
    "atom",
    "soap",
    "heart-music-camera-bolt",
    "icons",
    "microphone-alt-slash",
    "microphone-lines-slash",
    "closed-captioning-slash",
    "calculator-alt",
    "calculator-simple",
    "bridge-circle-check",
    "sliders-v",
    "sliders-up",
    "map-marker-minus",
    "location-minus",
    "pump-medical",
    "fingerprint",
    "ski-boot",
    "rectangle-sd",
    "standard-definition",
    "h1",
    "hand-point-right",
    "search-location",
    "magnifying-glass-location",
    "message-bot",
    "step-forward",
    "forward-step",
    "smile-beam",
    "face-smile-beam",
    "light-ceiling",
    "comment-alt-exclamation",
    "message-exclamation",
    "bowl-shaved-ice",
    "bowl-scoop",
    "square-x",
    "building-memo",
    "utility-pole-double",
    "flag-checkered",
    "chevron-double-up",
    "chevrons-up",
    "football-ball",
    "football",
    "user-vneck",
    "school-circle-exclamation",
    "crop",
    "angle-double-down",
    "angles-down",
    "users-rectangle",
    "people-roof",
    "arrow-square-right",
    "square-arrow-right",
    "map-marker-plus",
    "location-plus",
    "lightbulb-exclamation-on",
    "people-line",
    "beer",
    "beer-mug-empty",
    "crate-empty",
    "diagram-predecessor",
    "transporter",
    "calendar-circle-user",
    "long-arrow-up",
    "arrow-up-long",
    "person-carry",
    "person-carry-box",
    "burn",
    "fire-flame-simple",
    "male",
    "person",
    "laptop",
    "file-csv",
    "menorah",
    "union",
    "chevron-double-left",
    "chevrons-left",
    "heart-circle",
    "circle-heart",
    "truck-plane",
    "record-vinyl",
    "bring-forward",
    "square-p",
    "grin-stars",
    "face-grin-stars",
    "sigma",
    "camera-movie",
    "bong",
    "clarinet",
    "truck-flatbed",
    "pastafarianism",
    "spaghetti-monster-flying",
    "arrow-down-up-across-line",
    "arrows-rotate-reverse",
    "leaf-heart",
    "house-building",
    "cheese-swiss",
    "utensil-spoon",
    "spoon",
    "jar-wheat",
    "mail-bulk",
    "envelopes-bulk",
    "file-circle-exclamation",
    "bow-arrow",
    "cart-xmark",
    "times-hexagon",
    "xmark-hexagon",
    "hexagon-xmark",
    "hospital-symbol",
    "circle-h",
    "merge",
    "pager",
    "cart-minus",
    "contact-book",
    "address-book",
    "pan-frying",
    "grid-3",
    "grid",
    "football-helmet",
    "hand-love",
    "trees",
    "strikethrough",
    "page",
    "k",
    "diagram-previous",
    "tachometer-alt-slowest",
    "gauge-min",
    "folder-grid",
    "eggplant",
    "excavator",
    "ram",
    "landmark-flag",
    "lips",
    "pencil-alt",
    "pencil",
    "backward",
    "caret-right",
    "comments",
    "file-clipboard",
    "paste",
    "desktop-arrow-down",
    "code-pull-request",
    "pumpkin",
    "clipboard-list",
    "pen-field",
    "blueberries",
    "truck-loading",
    "truck-ramp-box",
    "note",
    "arrow-down-to-square",
    "user-check",
    "cloud-xmark",
    "vial-virus",
    "book-alt",
    "book-blank",
    "golf-flag-hole",
    "comment-alt-arrow-down",
    "message-arrow-down",
    "face-unamused",
    "sheet-plastic",
    "circle-9",
    "blog",
    "user-ninja",
    "pencil-slash",
    "bowling-pins",
    "person-arrow-up-from-line",
    "down-right",
    "torah",
    "scroll-torah",
    "webhook",
    "blinds-open",
    "fence",
    "arrow-alt-up",
    "up",
    "quidditch",
    "quidditch-broom-ball",
    "broom-ball",
    "drumstick",
    "square-v",
    "gave-dandy",
    "face-awesome",
    "dial-off",
    "toggle-off",
    "face-smile-horns",
    "archive",
    "box-archive",
    "grapes",
    "person-drowning",
    "dial-max",
    "circle-m",
    "calendar-image",
    "caret-circle-down",
    "circle-caret-down",
    "sort-numeric-desc",
    "sort-numeric-down-alt",
    "arrow-down-9-1",
    "grin-tongue-squint",
    "face-grin-tongue-squint",
    "shish-kebab",
    "spray-can",
    "alarm-snooze",
    "scarecrow",
    "truck-monster",
    "gift-card",
    "w",
    "code-pull-request-draft",
    "square-b",
    "elephant",
    "globe-africa",
    "earth-africa",
    "rainbow",
    "circle-notch",
    "tablet-alt",
    "tablet-screen-button",
    "paw",
    "message-question",
    "cloud",
    "trowel-bricks",
    "square-3",
    "flushed",
    "face-flushed",
    "hospital-user",
    "microwave",
    "chf-sign",
    "tent-arrow-left-right",
    "cart-circle-arrow-up",
    "trash-clock",
    "reflect-both",
    "legal",
    "gavel",
    "sprinkler-ceiling",
    "browsers",
    "trillium",
    "music-slash",
    "truck-ramp",
    "binoculars",
    "microphone-slash",
    "box-tissue",
    "circle-c",
    "star-christmas",
    "chart-bullet",
    "motorcycle",
    "tree-christmas",
    "tire-flat",
    "sunglasses",
    "badge",
    "comment-alt-edit",
    "message-edit",
    "message-pen",
    "concierge-bell",
    "bell-concierge",
    "pencil-ruler",
    "pen-ruler",
    "file-mp3",
    "arrow-progress",
    "chess-rook-alt",
    "chess-rook-piece",
    "square-root",
    "album-collection-circle-plus",
    "people-arrows-left-right",
    "people-arrows",
    "sign-post",
    "face-angry-horns",
    "mars-and-venus-burst",
    "tombstone",
    "caret-square-right",
    "square-caret-right",
    "cut",
    "scissors",
    "list-music",
    "sun-plant-wilt",
    "toilets-portable",
    "hockey-puck",
    "mustache",
    "hyphen",
    "table",
    "user-chef",
    "comment-alt-image",
    "message-image",
    "users-medical",
    "sensor-alert",
    "sensor-triangle-exclamation",
    "magnifying-glass-arrow-right",
    "digital-tachograph",
    "tachograph-digital",
    "face-mask",
    "pickleball",
    "star-sharp-half",
    "users-slash",
    "clover",
    "meat",
    "mail-reply",
    "reply",
    "star-and-crescent",
    "empty-set",
    "house-fire",
    "minus-square",
    "square-minus",
    "helicopter",
    "bird",
    "compass",
    "caret-square-down",
    "square-caret-down",
    "heart-half-alt",
    "heart-half-stroke",
    "file-circle-question",
    "truck-utensils",
    "laptop-code",
    "joystick",
    "grill-fire",
    "rectangle-vertical-history",
    "swatchbook",
    "prescription-bottle",
    "navicon",
    "bars",
    "keyboard-left",
    "people-group",
    "hourglass-3",
    "hourglass-end",
    "heart-broken",
    "heart-crack",
    "face-beam-hand-over-mouth",
    "humidity",
    "droplet-percent",
    "external-link-square-alt",
    "square-up-right",
    "kiss-beam",
    "face-kiss-beam",
    "corn",
    "roller-coaster",
    "photo-film-music",
    "radar",
    "sickle",
    "film",
    "coconut",
    "ruler-horizontal",
    "shield-cross",
    "cassette-tape",
    "square-terminal",
    "people-robbery",
    "lightbulb",
    "caret-left",
    "comment-middle",
    "trash-can-list",
    "block",
    "exclamation-circle",
    "circle-exclamation",
    "school-circle-xmark",
    "sign-out",
    "arrow-right-from-bracket",
    "face-frown-slight",
    "chevron-circle-down",
    "circle-chevron-down",
    "sidebar-flip",
    "unlock-alt",
    "unlock-keyhole",
    "temperature-list",
    "cloud-showers-heavy",
    "headphones-alt",
    "headphones-simple",
    "sitemap",
    "pipe-section",
    "space-station-moon-alt",
    "space-station-moon-construction",
    "donate",
    "circle-dollar-to-slot",
    "memory",
    "face-sleeping",
    "road-spikes",
    "fire-burner",
    "squirrel",
    "arrow-to-top",
    "arrow-up-to-line",
    "flag",
    "face-cowboy-hat",
    "hanukiah",
    "chart-scatter-3d",
    "display-chart-up",
    "square-code",
    "feather",
    "volume-down",
    "volume-low",
    "times-to-slot",
    "vote-nay",
    "xmark-to-slot",
    "box-alt",
    "box-taped",
    "comment-slash",
    "swords",
    "cloud-sun-rain",
    "album",
    "circle-n",
    "compress",
    "wheat-alt",
    "wheat-awn",
    "ankh",
    "hands-holding-child",
    "asterisk",
    "key-skeleton-left-right",
    "comment-lines",
    "luchador",
    "mask-luchador",
    "luchador-mask",
    "check-square",
    "square-check",
    "shredder",
    "book-open-alt",
    "book-open-cover",
    "sandwich",
    "peseta-sign",
    "parking-slash",
    "square-parking-slash",
    "train-tunnel",
    "header",
    "heading",
    "ghost",
    "face-anguished",
    "hockey-sticks",
    "abacus",
    "film-alt",
    "film-simple",
    "list-squares",
    "list",
    "tree-palm",
    "phone-square-alt",
    "square-phone-flip",
    "cart-plus",
    "gamepad",
    "border-center-v",
    "dot-circle",
    "circle-dot",
    "clipboard-medical",
    "dizzy",
    "face-dizzy",
    "egg",
    "arrow-alt-to-top",
    "up-to-line",
    "house-medical-circle-xmark",
    "watch-fitness",
    "clock-nine-thirty",
    "campground",
    "folder-plus",
    "jug",
    "futbol-ball",
    "soccer-ball",
    "futbol",
    "snow-blowing",
    "paint-brush",
    "paintbrush",
    "lock",
    "arrow-from-top",
    "arrow-down-from-line",
    "gas-pump",
    "signal-alt-slash",
    "signal-bars-slash",
    "monkey",
    "pro",
    "rectangle-pro",
    "house-night",
    "hot-tub",
    "hot-tub-person",
    "globe-pointer",
    "blanket",
    "map-marked",
    "map-location",
    "house-flood-water",
    "comments-question-check",
    "tree",
    "arrows-cross",
    "backpack",
    "square-small",
    "folder-upload",
    "folder-arrow-up",
    "bridge-lock",
    "crosshairs-simple",
    "sack-dollar",
    "edit",
    "pen-to-square",
    "sliders-h-square",
    "square-sliders",
    "car-side",
    "comment-middle-top-alt",
    "message-middle-top",
    "lightbulb-on",
    "utensil-knife",
    "knife",
    "share-alt",
    "share-nodes",
    "display-chart-up-circle-dollar",
    "wave-sine",
    "heart-circle-minus",
    "circle-w",
    "calendar-circle",
    "circle-calendar",
    "hourglass-2",
    "hourglass-half",
    "microscope",
    "sunset",
    "sink",
    "calendar-exclamation",
    "truck-container-empty",
    "hand-heart",
    "shopping-bag",
    "bag-shopping",
    "sort-alpha-desc",
    "sort-alpha-down-alt",
    "arrow-down-z-a",
    "mitten",
    "reply-time",
    "reply-clock",
    "person-rays",
    "arrow-alt-right",
    "right",
    "circle-f",
    "users",
    "face-pleading",
    "eye-slash",
    "flask-vial",
    "police-box",
    "cucumber",
    "head-side-brain",
    "hand-paper",
    "hand",
    "biking-mountain",
    "person-biking-mountain",
    "utensils-slash",
    "print-search",
    "print-magnifying-glass",
    "turn-right",
    "folder-bookmark",
    "arrow-turn-left-down",
    "om",
    "pi",
    "flask-potion",
    "flask-round-potion",
    "face-shush",
    "worm",
    "house-circle-xmark",
    "plug",
    "calendar-circle-exclamation",
    "square-i",
    "chevron-up",
    "face-saluting",
    "tachometer-slow",
    "gauge-simple-low",
    "face-persevering",
    "camera-circle",
    "circle-camera",
    "hand-spock",
    "spider-web",
    "microphone-circle",
    "circle-microphone",
    "book-arrow-up",
    "popsicle",
    "command",
    "blinds",
    "stopwatch",
    "saxophone",
    "square-2",
    "field-hockey",
    "field-hockey-stick-ball",
    "sort-shapes-up-alt",
    "arrow-up-square-triangle",
    "face-scream",
    "square-m",
    "webcam",
    "camera-web",
    "comment-arrow-down",
    "lightbulb-cfl",
    "window-frame-open",
    "kiss",
    "face-kiss",
    "bridge-circle-xmark",
    "period",
    "grin-tongue",
    "face-grin-tongue",
    "up-to-dotted-line",
    "thought-bubble",
    "skeleton-ribs",
    "raygun",
    "flute",
    "acorn",
    "video-arrow-up-right",
    "grate-droplet",
    "seal-exclamation",
    "chess-bishop",
    "message-sms",
    "coffee-beans",
    "hat-witch",
    "grin-wink",
    "face-grin-wink",
    "clock-three-thirty",
    "deaf",
    "deafness",
    "hard-of-hearing",
    "ear-deaf",
    "alarm-clock",
    "eclipse",
    "face-relieved",
    "road-circle-check",
    "dice-five",
    "minus-octagon",
    "octagon-minus",
    "rss-square",
    "square-rss",
    "face-zany",
    "tricycle",
    "land-mine-on",
    "square-arrow-up-left",
    "i-cursor",
    "chart-mixed-up-circle-dollar",
    "salt-shaker",
    "stamp",
    "file-plus",
    "draw-square",
    "toilet-paper-reverse-slash",
    "toilet-paper-under-slash",
    "stairs",
    "drone-alt",
    "drone-front",
    "glass-empty",
    "dial-high",
    "user-construction",
    "user-hard-hat",
    "user-helmet-safety",
    "i",
    "hryvnia",
    "hryvnia-sign",
    "arrow-down-left-and-arrow-up-right-to-center",
    "pills",
    "grin-alt",
    "face-grin-wide",
    "tooth",
    "basketball-hoop",
    "objects-align-bottom",
    "v",
    "sparkles",
    "squid",
    "leafy-green",
    "circle-arrow-up-right",
    "calendars",
    "bangladeshi-taka-sign",
    "bicycle",
    "hammer-war",
    "circle-d",
    "spider-black-widow",
    "rod-asclepius",
    "rod-snake",
    "staff-aesculapius",
    "staff-snake",
    "pear",
    "head-side-cough-slash",
    "file-mov",
    "triangle",
    "apartment",
    "ambulance",
    "truck-medical",
    "pepper",
    "piano",
    "gun-squirt",
    "wheat-awn-circle-exclamation",
    "snowman",
    "user-alien",
    "shield-check",
    "mortar-pestle",
    "road-barrier",
    "chart-candlestick",
    "briefcase-blank",
    "school",
    "igloo",
    "parenthesis",
    "bracket-round",
    "joint",
    "horse-saddle",
    "mug-marshmallows",
    "filters",
    "bell-on",
    "angle-right",
    "dial-med",
    "horse",
    "q",
    "monitor-heart-rate",
    "monitor-waveform",
    "link-simple",
    "whistle",
    "g",
    "fragile",
    "wine-glass-crack",
    "slot-machine",
    "notes-medical",
    "car-wash",
    "escalator",
    "comment-image",
    "temperature-2",
    "thermometer-2",
    "thermometer-half",
    "temperature-half",
    "dong-sign",
    "doughnut",
    "donut",
    "capsules",
    "poo-bolt",
    "poo-storm",
    "tally-1",
    "file-vector",
    "frown-open",
    "face-frown-open",
    "square-dashed",
    "bag-shopping-plus",
    "square-j",
    "hand-point-up",
    "money-bill",
    "sort-size-up",
    "arrow-up-big-small",
    "barcode-read",
    "baguette",
    "bowl-soft-serve",
    "face-holding-back-tears",
    "arrow-alt-square-up",
    "square-up",
    "subway-tunnel",
    "train-subway-tunnel",
    "exclamation-square",
    "square-exclamation",
    "semicolon",
    "bookmark",
    "fan-table",
    "align-justify",
    "battery-1",
    "battery-low",
    "credit-card-front",
    "mind-share",
    "brain-arrow-curved-right",
    "umbrella-beach",
    "helmet-un",
    "map-marker-smile",
    "location-smile",
    "arrow-to-left",
    "arrow-left-to-line",
    "bullseye",
    "nigiri",
    "sushi",
    "comment-alt-captions",
    "message-captions",
    "trash-list",
    "bacon",
    "option",
    "raccoon",
    "hand-point-down",
    "arrow-up-from-bracket",
    "head-side-gear",
    "trash-plus",
    "file-cad",
    "objects-align-top",
    "folder-blank",
    "folder",
    "face-anxious-sweat",
    "credit-card-blank",
    "file-medical-alt",
    "file-waveform",
    "microchip-ai",
    "mug",
    "plane-up-slash",
    "radiation",
    "pen-circle",
    "bag-seedling",
    "chart-simple",
    "crutches",
    "parking-circle",
    "circle-parking",
    "mars-stroke",
    "leaf-oak",
    "square-bolt",
    "vial",
    "dashboard",
    "gauge-med",
    "tachometer-alt-average",
    "gauge",
    "magic-wand-sparkles",
    "wand-magic-sparkles",
    "lambda",
    "e",
    "pizza",
    "bowl-chopsticks-noodles",
    "h3",
    "pen-alt",
    "pen-clip",
    "bridge-circle-exclamation",
    "badge-percent",
    "rotate-reverse",
    "user",
    "sensor",
    "comma",
    "school-circle-check",
    "toilet-paper-reverse",
    "toilet-paper-under",
    "light-emergency",
    "arrow-down-to-arc",
    "dumpster",
    "shuttle-van",
    "van-shuttle",
    "building-user",
    "light-switch",
    "caret-square-left",
    "square-caret-left",
    "highlighter",
    "heart-rate",
    "wave-pulse",
    "key",
    "arrow-left-to-bracket",
    "hat-santa",
    "tamale",
    "box-check",
    "bullhorn",
    "steak",
    "location-slash",
    "location-crosshairs-slash",
    "person-dolly",
    "globe",
    "synagogue",
    "file-chart-line",
    "file-chart-column",
    "person-half-dress",
    "folder-image",
    "calendar-edit",
    "calendar-pen",
    "road-bridge",
    "face-smile-tear",
    "comment-alt-plus",
    "message-plus",
    "location-arrow",
    "c",
    "tablet-button",
    "person-dress-fairy",
    "rectangle-history-circle-user",
    "building-lock",
    "chart-line-up",
    "mailbox",
    "sign-posts",
    "truck-bolt",
    "pizza-slice",
    "money-bill-wave",
    "area-chart",
    "chart-area",
    "house-flag",
    "circle-three-quarters-stroke",
    "person-circle-minus",
    "scalpel",
    "cancel",
    "ban",
    "bell-exclamation",
    "bookmark-circle",
    "circle-bookmark",
    "egg-fried",
    "face-weary",
    "uniform-martial-arts",
    "camera-rotate",
    "sun-dust",
    "comment-text",
    "air-freshener",
    "spray-can-sparkles",
    "signal-alt",
    "signal-alt-4",
    "signal-bars-strong",
    "signal-bars",
    "diamond-exclamation",
    "star",
    "dial-min",
    "repeat",
    "cross",
    "file-caret-down",
    "page-caret-down",
    "box",
    "venus-mars",
    "clock-seven-thirty",
    "mouse-pointer",
    "arrow-pointer",
    "clock-four-thirty",
    "signal-alt-3",
    "signal-bars-good",
    "cactus",
    "lightbulb-gear",
    "expand-arrows-alt",
    "maximize",
    "charging-station",
    "triangle-circle-square",
    "shapes",
    "plane-tail",
    "tachometer-fastest",
    "gauge-simple-max",
    "circle-u",
    "shield-slash",
    "phone-square-down",
    "square-phone-hangup",
    "arrow-up-left",
    "transporter-1",
    "peanuts",
    "random",
    "shuffle",
    "running",
    "person-running",
    "mobile-retro",
    "grip-lines-vertical",
    "bin-bottles-recycle",
    "arrow-up-from-square",
    "page-break",
    "file-dashed-line",
    "bracket-curly-right",
    "spider",
    "clock-three",
    "hands-bound",
    "scalpel-path",
    "scalpel-line-dashed",
    "file-invoice-dollar",
    "pipe-smoking",
    "face-astonished",
    "window",
    "plane-circle-exclamation",
    "ear",
    "file-lock",
    "diagram-venn",
    "arrow-down-from-bracket",
    "x-ray",
    "goal-net",
    "coffin-cross",
    "spell-check",
    "map-marker-times",
    "map-marker-xmark",
    "location-xmark",
    "circle-quarter-stroke",
    "lasso",
    "slash",
    "portal-enter",
    "person-to-portal",
    "calendar-star",
    "mouse",
    "computer-mouse",
    "sign-in",
    "arrow-right-to-bracket",
    "pegasus",
    "files-medical",
    "cannon",
    "nfc-lock",
    "ski-lift",
    "person-ski-lift",
    "square-6",
    "store-alt-slash",
    "shop-slash",
    "wind-turbine",
    "sliders-simple",
    "grid-round",
    "badge-sheriff",
    "server",
    "virus-covid-slash",
    "intersection",
    "shop-lock",
    "family",
    "hourglass-1",
    "hourglass-start",
    "user-hair-buns",
    "blender-phone",
    "hourglass-clock",
    "person-seat-reclined",
    "paper-plane-alt",
    "send",
    "paper-plane-top",
    "comment-alt-arrow-up",
    "message-arrow-up",
    "lightbulb-exclamation",
    "layer-group-minus",
    "layer-minus",
    "chart-pie-simple-circle-currency",
    "circle-e",
    "building-wheat",
    "tachometer-alt-fastest",
    "gauge-max",
    "person-breastfeeding",
    "apostrophe",
    "file-png",
    "fire-hydrant",
    "sign-in-alt",
    "right-to-bracket",
    "video-plus",
    "arrow-alt-square-right",
    "square-right",
    "comment-smile",
    "venus",
    "passport",
    "inbox-arrow-down",
    "inbox-in",
    "heartbeat",
    "heart-pulse",
    "circle-8",
    "clouds-moon",
    "clock-ten-thirty",
    "people-carry",
    "people-carry-box",
    "folder-user",
    "trash-can-xmark",
    "temperature-high",
    "microchip",
    "left-long-to-line",
    "crown",
    "weight-hanging",
    "xmarks-lines",
    "file-prescription",
    "table-cells-lock",
    "calendar-range",
    "flower-daffodil",
    "hand-back-point-up",
    "weight",
    "weight-scale",
    "arrow-up-to-arc",
    "star-exclamation",
    "books",
    "user-friends",
    "user-group",
    "sort-alpha-up",
    "arrow-up-a-z",
    "layer-group-plus",
    "layer-plus",
    "play-pause",
    "block-question",
    "zzz",
    "snooze",
    "scanner-image",
    "tv-retro",
    "square-t",
    "barn-silo",
    "farm",
    "chess-knight",
    "bars-sort",
    "palette-boxes",
    "pallet-alt",
    "pallet-boxes",
    "laugh-squint",
    "face-laugh-squint",
    "code-simple",
    "bolt-slash",
    "panel-fire",
    "binary-circle-check",
    "comment-minus",
    "burrito",
    "violin",
    "objects-column",
    "chevron-square-down",
    "square-chevron-down",
    "comment-plus",
    "triangle-music",
    "triangle-instrument",
    "wheelchair",
    "user-pilot-tie",
    "piano-keyboard",
    "bed-empty",
    "arrow-circle-up",
    "circle-arrow-up",
    "toggle-on",
    "rectangle-portrait",
    "rectangle-vertical",
    "walking",
    "person-walking",
    "l",
    "signal-stream",
    "down-to-bracket",
    "circle-z",
    "stars",
    "fire",
    "procedures",
    "bed-pulse",
    "house-day",
    "space-shuttle",
    "shuttle-space",
    "shirt-long-sleeve",
    "chart-pie-alt",
    "chart-pie-simple",
    "laugh",
    "face-laugh",
    "folder-open",
    "album-collection-circle-user",
    "candy",
    "soup",
    "bowl-hot",
    "flatbread",
    "heart-circle-plus",
    "code-fork",
    "city",
    "signal-alt-1",
    "signal-bars-weak",
    "microphone-alt",
    "microphone-lines",
    "clock-twelve",
    "pepper-hot",
    "citrus-slice",
    "sheep",
    "unlock",
    "colon-sign",
    "headset",
    "badger-honey",
    "h4",
    "store-slash",
    "road-circle-xmark",
    "signal-slash",
    "user-minus",
    "mars-stroke-v",
    "mars-stroke-up",
    "glass-cheers",
    "champagne-glasses",
    "taco",
    "plus-hexagon",
    "hexagon-plus",
    "clipboard",
    "house-circle-exclamation",
    "file-upload",
    "file-arrow-up",
    "wifi-3",
    "wifi-strong",
    "wifi",
    "comments-alt",
    "messages",
    "bathtub",
    "bath",
    "umbrella-alt",
    "umbrella-simple",
    "rectangle-history-circle-plus",
    "underline",
    "prescription-bottle-pill",
    "user-edit",
    "user-pen",
    "binary-slash",
    "square-o",
    "caduceus",
    "signature",
    "stroopwafel",
    "bold",
    "anchor-lock",
    "building-ngo",
    "transporter-3",
    "engine-exclamation",
    "engine-warning",
    "circle-down-right",
    "square-k",
    "manat-sign",
    "money-check-edit",
    "money-check-pen",
    "not-equal",
    "border-style",
    "border-top-left",
    "map-marked-alt",
    "map-location-dot",
    "tilde",
    "jedi",
    "poll",
    "square-poll-vertical",
    "sort-shapes-down-alt",
    "arrow-down-square-triangle",
    "mug-hot",
    "dog-leashed",
    "battery-car",
    "car-battery",
    "face-downcast-sweat",
    "mailbox-flag-up",
    "memo-circle-info",
    "gift",
    "dice-two",
    "volume-medium",
    "volume",
    "transporter-5",
    "gauge-circle-bolt",
    "coin-front",
    "file-slash",
    "message-arrow-up-right",
    "treasure-chest",
    "chess-queen",
    "paint-brush-alt",
    "paint-brush-fine",
    "paintbrush-alt",
    "paintbrush-fine",
    "glasses",
    "hood-cloak",
    "square-quote",
    "up-left",
    "bring-front",
    "chess-board",
    "cheeseburger",
    "burger-cheese",
    "building-circle-check",
    "repeat-1",
    "arrow-to-bottom",
    "arrow-down-to-line",
    "grid-5",
    "swap-arrows",
    "right-long-to-line",
    "person-chalkboard",
    "mars-stroke-h",
    "mars-stroke-right",
    "hand-rock",
    "hand-back-fist",
    "grid-round-5",
    "tally-5",
    "tally",
    "caret-square-up",
    "square-caret-up",
    "cloud-showers-water",
    "bar-chart",
    "chart-bar",
    "hands-wash",
    "hands-bubbles",
    "less-than-equal",
    "train",
    "up-from-dotted-line",
    "low-vision",
    "eye-low-vision",
    "traffic-light-go",
    "face-exhaling",
    "sensor-fire",
    "user-unlock",
    "hexagon-divide",
    "00",
    "crow",
    "betamax",
    "cassette-betamax",
    "sailboat",
    "window-restore",
    "nfc-magnifying-glass",
    "file-binary",
    "circle-v",
    "plus-square",
    "square-plus",
    "bowl-scoops",
    "mistletoe",
    "custard",
    "lacrosse-stick",
    "hockey-mask",
    "sunrise",
    "subtitles",
    "panel-ews",
    "torii-gate",
    "cloud-exclamation",
    "comment-alt-lines",
    "message-lines",
    "frog",
    "bucket",
    "floppy-disk-pen",
    "image",
    "window-frame",
    "microphone",
    "cow",
    "file-zip",
    "square-ring",
    "arrow-alt-from-top",
    "down-from-line",
    "caret-up",
    "shield-times",
    "shield-xmark",
    "screwdriver",
    "sort-circle-down",
    "circle-sort-down",
    "folder-closed",
    "house-tsunami",
    "square-nfi",
    "forklift",
    "arrow-up-from-ground-water",
    "bracket-square-right",
    "glass-martini-alt",
    "martini-glass",
    "rotate-back",
    "rotate-backward",
    "undo-alt",
    "rotate-left",
    "columns",
    "table-columns",
    "square-a",
    "tick",
    "lemon",
    "head-side-mask",
    "handshake",
    "gem",
    "dolly-box",
    "dolly",
    "smoking",
    "compress-arrows-alt",
    "minimize",
    "refrigerator",
    "monument",
    "times-octagon",
    "xmark-octagon",
    "octagon-xmark",
    "align-slash",
    "snowplow",
    "angle-double-right",
    "angles-right",
    "truck-couch",
    "truck-ramp-couch",
    "cannabis",
    "play-circle",
    "circle-play",
    "arrow-up-right-and-arrow-down-left-from-center",
    "location-arrow-up",
    "tablets",
    "360-degrees",
    "ethernet",
    "eur",
    "euro",
    "euro-sign",
    "chair",
    "check-circle",
    "circle-check",
    "square-dashed-circle-plus",
    "hand-holding-circle-dollar",
    "money-simple-from-bracket",
    "bat",
    "stop-circle",
    "circle-stop",
    "head-side-headphones",
    "phone-rotary",
    "arrow-up-to-bracket",
    "drafting-compass",
    "compass-drafting",
    "plate-wheat",
    "calendar-circle-minus",
    "chopsticks",
    "car-mechanic",
    "car-wrench",
    "icicles",
    "person-shelter",
    "neuter",
    "id-badge",
    "kazoo",
    "marker",
    "bin-bottles",
    "laugh-beam",
    "face-laugh-beam",
    "square-arrow-down-left",
    "battery-bolt",
    "tree-large",
    "helicopter-symbol",
    "aperture",
    "universal-access",
    "gear-complex",
    "file-search",
    "file-magnifying-glass",
    "up-right",
    "chevron-circle-up",
    "circle-chevron-up",
    "user-police",
    "lari-sign",
    "volcano",
    "teddy-bear",
    "stocking",
    "person-walking-dashed-line-arrow-right",
    "image-slash",
    "mask-snorkel",
    "smoke",
    "gbp",
    "pound-sign",
    "sterling-sign",
    "battery-exclamation",
    "viruses",
    "square-person-confined",
    "user-tie",
    "up-to-bracket",
    "long-arrow-down",
    "arrow-down-long",
    "tent-arrow-down-to-line",
    "certificate",
    "crystal-ball",
    "mail-reply-all",
    "reply-all",
    "suitcase",
    "skating",
    "person-skating",
    "star-shooting",
    "binary-lock",
    "funnel-dollar",
    "filter-circle-dollar",
    "camera-retro",
    "arrow-circle-down",
    "circle-arrow-down",
    "comment-edit",
    "comment-pen",
    "arrow-right-to-file",
    "file-import",
    "banjo",
    "external-link-square",
    "square-arrow-up-right",
    "light-emergency-on",
    "kerning",
    "box-open",
    "square-f",
    "scroll",
    "spa",
    "arrow-from-right",
    "arrow-left-from-line",
    "strawberry",
    "location-pin-lock",
    "pause",
    "clock-eight-thirty",
    "plane-alt",
    "plane-engines",
    "hill-avalanche",
    "temperature-0",
    "thermometer-0",
    "thermometer-empty",
    "temperature-empty",
    "bomb",
    "tachometer-alt-slow",
    "gauge-low",
    "registered",
    "trash-can-plus",
    "contact-card",
    "vcard",
    "address-card",
    "balance-scale-right",
    "scale-unbalanced-flip",
    "globe-snow",
    "subscript",
    "directions",
    "diamond-turn-right",
    "integral",
    "burst",
    "laptop-house",
    "house-laptop",
    "tired",
    "face-tired",
    "money-bills",
    "blinds-raised",
    "smog",
    "ufo-beam",
    "caret-circle-up",
    "circle-caret-up",
    "user-vneck-hair-long",
    "square-a-lock",
    "crutch",
    "gas-pump-slash",
    "font-awesome-flag",
    "font-awesome-logo-full",
    "font-awesome",
    "cloud-upload",
    "cloud-upload-alt",
    "cloud-arrow-up",
    "palette",
    "transporter-4",
    "chart-mixed-up-circle-currency",
    "objects-align-right",
    "arrows-turn-right",
    "vest",
    "pig",
    "inbox-full",
    "envelope-circle",
    "circle-envelope",
    "construction",
    "triangle-person-digging",
    "ferry",
    "bullseye-arrow",
    "arrows-down-to-people",
    "sprout",
    "seedling",
    "clock-seven",
    "arrows-alt-h",
    "left-right",
    "boxes-packing",
    "arrow-circle-left",
    "circle-arrow-left",
    "flashlight",
    "file-jpg",
    "group-arrows-rotate",
    "bowl-food",
    "square-9",
    "candy-cane",
    "sort-amount-asc",
    "sort-amount-down",
    "arrow-down-wide-short",
    "dollar-square",
    "usd-square",
    "square-dollar",
    "phone-arrow-right",
    "hand-holding-seedling",
    "comment-alt-check",
    "message-check",
    "thunderstorm",
    "cloud-bolt",
    "chart-line-up-down",
    "remove-format",
    "text-slash",
    "watch",
    "circle-down-left",
    "text",
    "projector",
    "smile-wink",
    "face-smile-wink",
    "tombstone-alt",
    "tombstone-blank",
    "chess-king-alt",
    "chess-king-piece",
    "circle-6",
    "waves-sine",
    "arrow-alt-left",
    "left",
    "file-word",
    "file-powerpoint",
    "arrow-alt-square-down",
    "square-down",
    "objects-align-center-vertical",
    "arrows-h",
    "arrows-left-right",
    "house-lock",
    "cloud-download",
    "cloud-download-alt",
    "cloud-arrow-down",
    "wreath",
    "children",
    "meter-droplet",
    "blackboard",
    "chalkboard",
    "user-alt-slash",
    "user-large-slash",
    "signal-4",
    "signal-strong",
    "lollypop",
    "lollipop",
    "list-tree",
    "envelope-open",
    "draw-circle",
    "cat-space",
    "handshake-alt-slash",
    "handshake-simple-slash",
    "rabbit-fast",
    "rabbit-running",
    "memo-pad",
    "mattress-pillow",
    "alarm-plus",
    "alicorn",
    "comment-question",
    "gingerbread-man",
    "guarani-sign",
    "burger-fries",
    "mug-tea",
    "border-top",
    "refresh",
    "sync",
    "arrows-rotate",
    "book-circle",
    "circle-book-open",
    "arrows-to-dotted-line",
    "fire-extinguisher",
    "magnifying-glass-arrows-rotate",
    "garage-open",
    "shelves-empty",
    "cruzeiro-sign",
    "watch-apple",
    "watch-calculator",
    "list-dropdown",
    "cabinet-filing",
    "burger-soda",
    "arrow-square-up",
    "square-arrow-up",
    "greater-than-equal",
    "pallet-box",
    "face-confounded",
    "shield-alt",
    "shield-halved",
    "truck-plow",
    "atlas",
    "book-atlas",
    "virus",
    "grid-round-2",
    "comment-middle-top",
    "wave",
    "envelope-circle-check",
    "layer-group",
    "restroom-simple",
    "arrows-to-dot",
    "border-outer",
    "hashtag-lock",
    "clock-two-thirty",
    "archway",
    "heart-circle-check",
    "house-damage",
    "house-chimney-crack",
    "file-archive",
    "file-zipper",
    "ticket-perforated",
    "heart-half",
    "comment-check",
    "square",
    "memo",
    "glass-martini",
    "martini-glass-empty",
    "couch",
    "cedi-sign",
    "italic",
    "glass-citrus",
    "calendar-lines-pen",
    "table-cells-column-lock",
    "church",
    "snowmobile",
    "person-snowmobiling",
    "face-hushed",
    "comments-dollar",
    "tickets-simple",
    "pickaxe",
    "link-simple-slash",
    "democrat",
    "face-confused",
    "pinball",
    "z",
    "skiing",
    "person-skiing",
    "deer",
    "input-pipe",
    "road-lock",
    "a",
    "bookmark-slash",
    "temperature-down",
    "temperature-arrow-down",
    "mace",
    "feather-alt",
    "feather-pointed",
    "sausage",
    "trash-can-clock",
    "p",
    "broom-wide",
    "snowflake",
    "stomach",
    "newspaper",
    "ad",
    "rectangle-ad",
    "guitar-electric",
    "arrow-turn-down-right",
    "moon-cloud",
    "bread-slice-butter",
    "arrow-circle-right",
    "circle-arrow-right",
    "users-crown",
    "user-group-crown",
    "circle-i",
    "toilet-paper-check",
    "filter-circle-xmark",
    "locust",
    "unsorted",
    "sort",
    "list-1-2",
    "list-numeric",
    "list-ol",
    "chart-waterfall",
    "sparkle",
    "face-party",
    "kidneys",
    "wifi-exclamation",
    "chart-network",
    "person-dress-burst",
    "dice-d4",
    "money-check-alt",
    "money-check-dollar",
    "vector-square",
    "bread-slice",
    "language",
    "wheat-awn-slash",
    "kiss-wink-heart",
    "face-kiss-wink-heart",
    "dagger",
    "podium",
    "memo-circle-check",
    "route-highway",
    "arrow-alt-to-bottom",
    "down-to-line",
    "filter",
    "square-g",
    "phone-circle",
    "circle-phone",
    "clipboard-prescription",
    "user-nurse-hair",
    "question",
    "file-signature",
    "toggle-large-on",
    "arrows-alt",
    "up-down-left-right",
    "dryer-alt",
    "dryer-heat",
    "house-chimney-user",
    "hand-holding-heart",
    "sort-size-up-alt",
    "arrow-up-small-big",
    "train-track",
    "puzzle-piece",
    "money-check",
    "star-half-alt",
    "star-half-stroke",
    "file-exclamation",
    "code",
    "glass-whiskey",
    "whiskey-glass",
    "moon-stars",
    "building-circle-exclamation",
    "clothes-hanger",
    "mobile-iphone",
    "mobile-notch",
    "magnifying-glass-chart",
    "external-link",
    "arrow-up-right-from-square",
    "cubes-stacked",
    "images-user",
    "krw",
    "won",
    "won-sign",
    "image-polaroid-user",
    "virus-covid",
    "square-ellipsis",
    "pie",
    "chess-knight-alt",
    "chess-knight-piece",
    "austral-sign",
    "cloud-plus",
    "f",
    "leaf",
    "bed-bunk",
    "road",
    "cab",
    "taxi",
    "person-circle-plus",
    "pie-chart",
    "chart-pie",
    "bolt-lightning",
    "clock-eight",
    "sack-xmark",
    "file-xls",
    "file-excel",
    "file-contract",
    "fish-fins",
    "circle-q",
    "building-flag",
    "grin-beam",
    "face-grin-beam",
    "object-ungroup",
    "face-disguise",
    "circle-arrow-down-right",
    "alien-monster",
    "alien-8bit",
    "hand-point-ribbon",
    "poop",
    "object-exclude",
    "telescope",
    "map-marker",
    "location-pin",
    "square-list",
    "kaaba",
    "toilet-paper",
    "hard-hat",
    "hat-hard",
    "helmet-safety",
    "comment-code",
    "sim-cards",
    "starship",
    "eject",
    "arrow-alt-circle-right",
    "circle-right",
    "plane-circle-check",
    "seal",
    "user-cowboy",
    "hexagon-vertical-nft",
    "meh-rolling-eyes",
    "face-rolling-eyes",
    "bread-loaf",
    "rings-wedding",
    "object-group",
    "french-fries",
    "line-chart",
    "chart-line",
    "calendar-download",
    "calendar-arrow-down",
    "send-back",
    "mask-ventilator",
    "tickets",
    "signature-lock",
    "arrow-right",
    "map-signs",
    "signs-post",
    "plus-octagon",
    "octagon-plus",
    "cash-register",
    "person-circle-question",
    "melon-slice",
    "space-station-moon",
    "comment-alt-smile",
    "message-smile",
    "cup-straw",
    "arrow-alt-from-right",
    "left-from-line",
    "h",
    "shopping-basket-alt",
    "basket-shopping-simple",
    "hands-heart",
    "hands-holding-heart",
    "clock-nine",
    "hammer-brush",
    "tarp",
    "face-sleepy",
    "hand-horns",
    "tools",
    "screwdriver-wrench",
    "arrows-to-eye",
    "circle-three-quarters",
    "trophy-alt",
    "trophy-star",
    "plug-circle-bolt",
    "face-thermometer",
    "grid-round-4",
    "sign-posts-wrench",
    "shirt-running",
    "book-circle-arrow-up",
    "face-nauseated",
    "heart",
    "file-chart-pie",
    "mars-and-venus",
    "home-user",
    "house-user",
    "circle-arrow-down-left",
    "dumpster-fire",
    "minus-hexagon",
    "hexagon-minus",
    "arrow-alt-to-left",
    "left-to-line",
    "house-crack",
    "paw-alt",
    "paw-simple",
    "arrow-left-long-to-line",
    "parentheses",
    "brackets-round",
    "cocktail",
    "martini-glass-citrus",
    "user-shakespeare",
    "arrow-right-to-arc",
    "surprise",
    "face-surprise",
    "bottle-water",
    "pause-circle",
    "circle-pause",
    "gauge-circle-plus",
    "folders",
    "angel",
    "value-absolute",
    "rabbit",
    "toilet-paper-slash",
    "circle-euro",
    "apple-alt",
    "apple-whole",
    "kitchen-set",
    "diamond-half",
    "lock-alt",
    "lock-keyhole",
    "r",
    "temperature-1",
    "thermometer-1",
    "thermometer-quarter",
    "temperature-quarter",
    "info-square",
    "square-info",
    "wifi-slash",
    "toilet-paper-xmark",
    "hands-usd",
    "hands-holding-dollar",
    "cube",
    "sort-shapes-down",
    "arrow-down-triangle-square",
    "bitcoin-sign",
    "shutters",
    "shield-dog",
    "solar-panel",
    "lock-open",
    "table-tree",
    "house-chimney-heart",
    "tally-3",
    "elevator",
    "money-bill-transfer",
    "money-bill-trend-up",
    "house-flood-water-circle-arrow-right",
    "poll-h",
    "square-poll-horizontal",
    "circle",
    "left-to-bracket",
    "cart-circle-exclamation",
    "sword",
    "fast-backward",
    "backward-fast",
    "recycle",
    "user-astronaut",
    "interrobang",
    "plane-slash",
    "circle-dashed",
    "trademark",
    "basketball-ball",
    "basketball",
    "utensils-alt",
    "fork-knife",
    "satellite-dish",
    "badge-check",
    "arrow-alt-circle-up",
    "circle-up",
    "slider",
    "mobile-alt",
    "mobile-screen-button",
    "clock-one-thirty",
    "inbox-arrow-up",
    "inbox-out",
    "cloud-slash",
    "volume-up",
    "volume-high",
    "users-rays",
    "wallet",
    "octagon-check",
    "flatbread-stuffed",
    "clipboard-check",
    "cart-circle-plus",
    "shipping-timed",
    "truck-clock",
    "pool-8-ball",
    "file-audio",
    "turn-down-left",
    "lock-hashtag",
    "chart-radar",
    "staff",
    "hamburger",
    "burger",
    "utility-pole",
    "transporter-6",
    "arrow-turn-left",
    "wrench",
    "bugs",
    "vector-polygon",
    "diagram-nested",
    "rupee",
    "rupee-sign",
    "file-image",
    "question-circle",
    "circle-question",
    "tickets-perforated",
    "image-user",
    "buoy",
    "plane-departure",
    "handshake-slash",
    "book-bookmark",
    "border-center-h",
    "can-food",
    "typewriter",
    "arrow-right-from-arc",
    "circle-k",
    "face-hand-over-mouth",
    "popcorn",
    "house-flood",
    "house-water",
    "object-subtract",
    "code-branch",
    "warehouse-alt",
    "warehouse-full",
    "hat-cowboy",
    "bridge",
    "phone-alt",
    "phone-flip",
    "arrow-down-from-dotted-line",
    "file-doc",
    "square-quarters",
    "truck-front",
    "cat",
    "trash-xmark",
    "caret-circle-left",
    "circle-caret-left",
    "files",
    "anchor-circle-exclamation",
    "face-clouds",
    "user-crown",
    "basket-shopping-plus",
    "truck-field",
    "route",
    "cart-circle-check",
    "clipboard-question",
    "panorama",
    "comment-medical",
    "teeth-open",
    "user-tie-hair-long",
    "file-circle-minus",
    "head-side-medical",
    "arrow-turn-right",
    "tags",
    "wine-glass",
    "fast-forward",
    "forward-fast",
    "meh-blank",
    "face-meh-blank",
    "user-robot",
    "parking",
    "square-parking",
    "card-diamond",
    "face-zipper",
    "face-raised-eyebrow",
    "house-signal",
    "chevron-square-up",
    "square-chevron-up",
    "nfc-symbol",
    "tasks-alt",
    "bars-progress",
    "faucet-drip",
    "arrows-to-line",
    "dolphin",
    "arrow-up-right",
    "circle-r",
    "dolly-flatbed",
    "cart-flatbed",
    "smoking-ban",
    "ban-smoking",
    "sort-circle-up",
    "circle-sort-up",
    "terminal",
    "mobile-button",
    "house-medical-flag",
    "shopping-basket",
    "basket-shopping",
    "tape",
    "chestnut",
    "bus-alt",
    "bus-simple",
    "eye",
    "sad-cry",
    "face-sad-cry",
    "heat",
    "ticket-perforated-plane",
    "ticket-plane",
    "ticket-airline",
    "boot-heeled",
    "compress-arrows",
    "arrows-minimize",
    "audio-description",
    "person-military-to-person",
    "file-shield",
    "hexagon",
    "manhole",
    "user-slash",
    "pen",
    "tower-observation",
    "floppy-disks",
    "toilet-paper-reverse-alt",
    "toilet-paper-blank-under",
    "file-code",
    "signal-5",
    "signal-perfect",
    "signal",
    "pump",
    "bus",
    "heart-circle-xmark",
    "arrow-up-left-from-circle",
    "home-lg",
    "house-chimney",
    "window-maximize",
    "dryer",
    "frown",
    "face-frown",
    "chess-bishop-alt",
    "chess-bishop-piece",
    "shirt-tank-top",
    "scroll-ribbon",
    "diploma",
    "screencast",
    "walker",
    "prescription",
    "store-alt",
    "shop",
    "save",
    "floppy-disk",
    "vihara",
    "face-kiss-closed-eyes",
    "balance-scale-left",
    "scale-unbalanced",
    "file-user",
    "user-police-tie",
    "face-tongue-money",
    "tennis-ball",
    "square-l",
    "sort-asc",
    "sort-up",
    "calendar-upload",
    "calendar-arrow-up",
    "commenting",
    "comment-dots",
    "plant-wilt",
    "scarf",
    "album-circle-plus",
    "user-nurse-hair-long",
    "diamond",
    "arrow-alt-square-left",
    "square-left",
    "grin-squint",
    "face-grin-squint",
    "circle-ellipsis-vertical",
    "hand-holding-usd",
    "hand-holding-dollar",
    "grid-dividers",
    "bacterium",
    "hand-pointer",
    "drum-steelpan",
    "hand-scissors",
    "praying-hands",
    "hands-praying",
    "face-pensive",
    "user-music",
    "arrow-right-rotate",
    "arrow-rotate-forward",
    "redo",
    "arrow-rotate-right",
    "comments-alt-dollar",
    "messages-dollar",
    "sensor-on",
    "balloon",
    "web-awesome",
    "biohazard",
    "chess-queen-alt",
    "chess-queen-piece",
    "location",
    "location-crosshairs",
    "mars-double",
    "left-from-bracket",
    "house-leave",
    "house-person-depart",
    "house-person-leave",
    "ruler-triangle",
    "card-club",
    "child-dress",
    "users-between-lines",
    "lungs-virus",
    "spinner-third",
    "grin-tears",
    "face-grin-tears",
    "phone",
    "mouse-alt",
    "computer-mouse-scrollwheel",
    "calendar-times",
    "calendar-xmark",
    "child-reaching",
    "table-layout",
    "narwhal",
    "ramp-loading",
    "calendar-circle-plus",
    "toothbrush",
    "border-inner",
    "paw-claws",
    "kiwi-fruit",
    "traffic-light-slow",
    "rectangle-code",
    "head-side-virus",
    "keyboard-brightness",
    "books-medical",
    "lightbulb-slash",
    "home-blank",
    "house-blank",
    "square-5",
    "heart-square",
    "square-heart",
    "puzzle",
    "user-cog",
    "user-gear",
    "pipe-circle-check",
    "sort-numeric-up",
    "arrow-up-1-9",
    "octagon-exclamation",
    "dial-low",
    "door-closed",
    "phone-laptop",
    "laptop-mobile",
    "conveyor-belt-alt",
    "conveyor-belt-boxes",
    "shield-virus",
    "starfighter-alt-advanced",
    "starfighter-twin-ion-engine-advanced",
    "dice-six",
    "starfighter-alt",
    "starfighter-twin-ion-engine",
    "rocket-launch",
    "mosquito-net",
    "vent-damper",
    "bridge-water",
    "debug",
    "ban-bug",
    "person-booth",
    "text-width",
    "garage-car",
    "square-kanban",
    "hat-wizard",
    "chart-kanban",
    "pen-fancy",
    "coffee-pot",
    "mouse-field",
    "digging",
    "person-digging",
    "shower-alt",
    "shower-down",
    "box-circle-check",
    "brightness",
    "car-side-bolt",
    "file-xml",
    "ornament",
    "phone-arrow-down",
    "phone-incoming",
    "phone-arrow-down-left",
    "cloud-word",
    "hand-fingers-crossed",
    "trash",
    "gauge-simple-med",
    "tachometer-average",
    "gauge-simple",
    "sort-size-down-alt",
    "arrow-down-small-big",
    "book-medical",
    "face-melting",
    "poo",
    "pen-alt-slash",
    "pen-clip-slash",
    "quote-right-alt",
    "quote-right",
    "scroll-old",
    "guitars",
    "phone-xmark",
    "hose",
    "clock-six",
    "t-shirt",
    "tshirt",
    "shirt",
    "billboard",
    "square-r",
    "cubes",
    "envelope-open-dollar",
    "divide",
    "sun-cloud",
    "lamp-floor",
    "square-7",
    "tenge",
    "tenge-sign",
    "headphones",
    "hands-holding",
    "campfire",
    "circle-ampersand",
    "snowflakes",
    "hands-clapping",
    "republican",
    "leaf-maple",
    "arrow-left",
    "person-circle-xmark",
    "ruler",
    "arrow-left-from-bracket",
    "cup-straw-swoosh",
    "temperature-hot",
    "temperature-sun",
    "align-left",
    "dice-d6",
    "restroom",
    "rectangle-hd",
    "high-definition",
    "j",
    "galaxy",
    "users-viewfinder",
    "file-video",
    "cherries",
    "external-link-alt",
    "up-right-from-square",
    "sort-circle",
    "circle-sort",
    "th",
    "table-cells",
    "bag-shopping-minus",
    "file-pdf",
    "siren",
    "arrow-up-to-dotted-line",
    "landscape",
    "image-landscape",
    "tank-water",
    "curling",
    "curling-stone",
    "gamepad-alt",
    "gamepad-modern",
    "messages-question",
    "bible",
    "book-bible",
    "o",
    "medkit",
    "suitcase-medical",
    "briefcase-arrow-right",
    "expand-wide",
    "clock-eleven-thirty",
    "rv",
    "user-secret",
    "otter",
    "dreidel",
    "female",
    "person-dress",
    "comment-dollar",
    "briefcase-clock",
    "business-time",
    "flower-tulip",
    "people-pants-simple",
    "cloud-drizzle",
    "th-large",
    "table-cells-large",
    "tanakh",
    "book-tanakh",
    "solar-system",
    "seal-question",
    "volume-control-phone",
    "phone-volume",
    "disc-drive",
    "hat-cowboy-side",
    "rows",
    "table-rows",
    "map-marker-exclamation",
    "location-exclamation",
    "face-fearful",
    "clipboard-user",
    "bus-school",
    "film-slash",
    "square-arrow-down-right",
    "book-spells",
    "book-sparkles",
    "washer",
    "washing-machine",
    "child",
    "lira-sign",
    "user-visor",
    "file-plus-minus",
    "chess-clock-alt",
    "chess-clock-flip",
    "satellite",
    "truck-fire",
    "plane-lock",
    "steering-wheel",
    "tag",
    "stretcher",
    "book-law",
    "book-section",
    "inboxes",
    "coffee-bean",
    "circle-yen",
    "brackets-curly",
    "ellipsis-v-alt",
    "ellipsis-stroke-vertical",
    "comment",
    "square-1",
    "birthday-cake",
    "cake",
    "cake-candles",
    "head-side",
    "truck-ladder",
    "envelope",
    "dolly-empty",
    "face-tissue",
    "angle-double-up",
    "angles-up",
    "bin-recycle",
    "paperclip",
    "chart-line-down",
    "arrow-right-to-city",
    "lock-a",
    "ribbon",
    "lungs",
    "person-pinball",
    "sort-numeric-up-alt",
    "arrow-up-9-1",
    "apple-core",
    "circle-y",
    "h6",
    "litecoin-sign",
    "bottle-baby",
    "circle-small",
    "border-none",
    "arrow-turn-down-left",
    "circle-wifi-group",
    "circle-wifi-circle-wifi",
    "circle-nodes",
    "parachute-box",
    "reflect-horizontal",
    "comment-alt-medical",
    "message-medical",
    "rugby-ball",
    "comment-music",
    "indent",
    "tree-alt",
    "tree-deciduous",
    "puzzle-piece-alt",
    "puzzle-piece-simple",
    "truck-field-un",
    "nfc-trash",
    "hourglass-empty",
    "hourglass",
    "mountain",
    "file-times",
    "file-xmark",
    "home-heart",
    "house-heart",
    "house-chimney-blank",
    "meter-bolt",
    "user-md",
    "user-doctor",
    "slash-back",
    "info-circle",
    "circle-info",
    "fishing-rod",
    "hammer-crash",
    "message-heart",
    "cloud-meatball",
    "camera-polaroid",
    "camera-alt",
    "camera",
    "square-virus",
    "cart-arrow-up",
    "meteor",
    "car-on",
    "sleigh",
    "sort-numeric-asc",
    "sort-numeric-down",
    "arrow-down-1-9",
    "buoy-mooring",
    "square-4",
    "hand-holding-water",
    "hand-holding-droplet",
    "file-eps",
    "tricycle-adult",
    "waveform",
    "water",
    "star-sharp-half-alt",
    "star-sharp-half-stroke",
    "nfc-signal",
    "plane-prop",
    "calendar-check",
    "clock-desk",
    "calendar-time",
    "calendar-clock",
    "braille",
    "prescription-bottle-alt",
    "prescription-bottle-medical",
    "plate-utensils",
    "family-pants",
    "hose-reel",
    "house-window",
    "landmark",
    "truck",
    "music-magnifying-glass",
    "crosshairs",
    "cloud-rainbow",
    "person-cane",
    "alien",
    "tent",
    "laptop-binary",
    "vest-patches",
    "people-dress-simple",
    "check-double",
    "sort-alpha-asc",
    "sort-alpha-down",
    "arrow-down-a-z",
    "bowling-ball-pin",
    "bell-school-slash",
    "plus-large",
    "money-bill-wheat",
    "screenshot",
    "camera-viewfinder",
    "comment-alt-music",
    "message-music",
    "car-building",
    "border-style-alt",
    "border-bottom-right",
    "octagon",
    "comment-arrow-up-right",
    "octagon-divide",
    "cookie",
    "arrow-left-rotate",
    "arrow-rotate-back",
    "arrow-rotate-backward",
    "undo",
    "arrow-rotate-left",
    "tv-music",
    "hdd",
    "hard-drive",
    "reel",
    "grin-squint-tears",
    "face-grin-squint-tears",
    "dumbbell",
    "list-alt",
    "rectangle-list",
    "tarp-droplet",
    "alarm-exclamation",
    "house-medical-circle-check",
    "traffic-cone",
    "grate",
    "arrow-down-right",
    "skiing-nordic",
    "person-skiing-nordic",
    "calendar-plus",
    "portal-exit",
    "person-from-portal",
    "plane-arrival",
    "cowbell-more",
    "cowbell-circle-plus",
    "arrow-alt-circle-left",
    "circle-left",
    "distribute-spacing-vertical",
    "signal-alt-2",
    "signal-bars-fair",
    "sportsball",
    "game-console-handheld-crank",
    "subway",
    "train-subway",
    "chart-gantt",
    "face-smile-upside-down",
    "ball-pile",
    "badge-dollar",
    "money-bills-alt",
    "money-bills-simple",
    "list-timeline",
    "indian-rupee",
    "inr",
    "indian-rupee-sign",
    "crop-alt",
    "crop-simple",
    "money-bill-alt",
    "money-bill-1",
    "long-arrow-alt-left",
    "left-long",
    "keyboard-down",
    "circle-up-right",
    "thunderstorm-moon",
    "cloud-bolt-moon",
    "turn-left-up",
    "dna",
    "virus-slash",
    "bracket-round-right",
    "circle-sterling",
    "circle-5",
    "subtract",
    "minus",
    "flame",
    "fire-flame",
    "arrow-alt-to-right",
    "right-to-line",
    "gif",
    "chess",
    "trash-slash",
    "long-arrow-left",
    "arrow-left-long",
    "plug-circle-check",
    "font-case",
    "street-view",
    "arrow-down-left",
    "franc-sign",
    "flask-poison",
    "flask-round-poison",
    "volume-off",
    "book-circle-arrow-right",
    "user-chart",
    "chart-user",
    "american-sign-language-interpreting",
    "asl-interpreting",
    "hands-american-sign-language-interpreting",
    "hands-asl-interpreting",
    "presentation",
    "presentation-screen",
    "circle-bolt",
    "face-smile-halo",
    "cart-circle-arrow-down",
    "house-person-arrive",
    "house-return",
    "house-person-return",
    "comment-alt-times",
    "message-times",
    "message-xmark",
    "file-award",
    "file-certificate",
    "user-doctor-hair-long",
    "camera-home",
    "camera-security",
    "cog",
    "gear",
    "tint-slash",
    "droplet-slash",
    "book-heart",
    "mosque",
    "duck",
    "mosquito",
    "star-of-david",
    "flag-alt",
    "flag-swallowtail",
    "person-military-rifle",
    "car-garage",
    "shopping-cart",
    "cart-shopping",
    "book-font",
    "shield-plus",
    "vials",
    "eye-dropper-full",
    "distribute-spacing-horizontal",
    "tablet-rugged",
    "temperature-frigid",
    "temperature-snow",
    "moped",
    "smile-plus",
    "face-smile-plus",
    "radio-alt",
    "radio-tuner",
    "face-swear",
    "water-lower",
    "water-arrow-down",
    "scanner-touchscreen",
    "circle-7",
    "plug-circle-plus",
    "ski-jump",
    "person-ski-jumping",
    "place-of-worship",
    "water-rise",
    "water-arrow-up",
    "waveform-path",
    "waveform-lines",
    "split",
    "film-cannister",
    "film-canister",
    "folder-times",
    "folder-xmark",
    "toilet-paper-alt",
    "toilet-paper-blank",
    "tablet-android-alt",
    "tablet-screen",
    "hexagon-vertical-nft-slanted",
    "folder-music",
    "desktop-medical",
    "display-medical",
    "share-all",
    "peapod",
    "chess-clock",
    "axe",
    "square-d",
    "grip-vertical",
    "mobile-signal-out",
    "level-up",
    "arrow-turn-up",
    "u",
    "arrow-up-from-dotted-line",
    "square-root-alt",
    "square-root-variable",
    "light-switch-on",
    "sort-alt",
    "arrow-down-arrow-up",
    "raindrops",
    "minus-large",
    "dash",
    "clock-four",
    "clock",
    "input-numeric",
    "truck-tow",
    "step-backward",
    "backward-step",
    "pallet",
    "car-bolt",
    "expand-arrows",
    "arrows-maximize",
    "faucet",
    "cloud-sleet",
    "lamp-street",
    "list-radio",
    "pen-nib-slash",
    "baseball-bat-ball",
    "square-up-left",
    "overline",
    "s",
    "timeline",
    "keyboard",
    "arrows-from-dotted-line",
    "usb-drive",
    "ballot",
    "caret-down",
    "map-marker-alt-slash",
    "location-dot-slash",
    "cards",
    "clinic-medical",
    "house-chimney-medical",
    "glove-boxing",
    "boxing-glove",
    "temperature-3",
    "thermometer-3",
    "thermometer-three-quarters",
    "temperature-three-quarters",
    "bell-school",
    "mobile-android-alt",
    "mobile-screen",
    "plane-up",
    "folder-heart",
    "location-circle",
    "circle-location-arrow",
    "face-head-bandage",
    "maki-roll",
    "makizushi",
    "sushi-roll",
    "car-bump",
    "piggy-bank",
    "racquet",
    "car-mirrors",
    "industry-alt",
    "industry-windows",
    "bolt-auto",
    "battery-3",
    "battery-half",
    "flux-capacitor",
    "mountain-city",
    "coins",
    "honey-pot",
    "olive",
    "khanda",
    "filter-list",
    "outlet",
    "sliders-h",
    "sliders",
    "cauldron",
    "people",
    "folder-tree",
    "network-wired",
    "croissant",
    "map-pin",
    "hamsa",
    "cent-sign",
    "swords-laser",
    "flask",
    "person-pregnant",
    "square-u",
    "wand-sparkles",
    "router",
    "ellipsis-v",
    "ellipsis-vertical",
    "sword-laser-alt",
    "ticket",
    "power-off",
    "coin",
    "laptop-slash",
    "long-arrow-alt-right",
    "right-long",
    "circle-b",
    "person-dress-simple",
    "pipe-collar",
    "lights-holiday",
    "citrus",
    "flag-usa",
    "laptop-file",
    "teletype",
    "tty",
    "chart-tree-map",
    "diagram-next",
    "person-rifle",
    "clock-five-thirty",
    "pipe-valve",
    "arrow-up-from-arc",
    "face-spiral-eyes",
    "compress-wide",
    "phone-circle-down",
    "circle-phone-hangup",
    "gear-complex-code",
    "house-medical-circle-exclamation",
    "badminton",
    "closed-captioning",
    "hiking",
    "person-hiking",
    "arrow-alt-from-left",
    "right-from-line",
    "venus-double",
    "images",
    "calculator",
    "shuttlecock",
    "user-hair",
    "eye-evil",
    "people-pulling",
    "n",
    "swap",
    "garage",
    "tram",
    "cable-car",
    "shovel-snow",
    "cloud-rain",
    "face-lying",
    "sprinkler",
    "building-circle-xmark",
    "sledding",
    "person-sledding",
    "game-console-handheld",
    "ship",
    "clock-six-thirty",
    "battery-slash",
    "tugrik-sign",
    "arrows-down-to-line",
    "download",
    "angles-up-down",
    "inventory",
    "shelves",
    "cloud-snow",
    "grin",
    "face-grin",
    "backspace",
    "delete-left",
    "oven",
    "cloud-binary",
    "eye-dropper-empty",
    "eyedropper",
    "eye-dropper",
    "comment-captions",
    "comments-question",
    "scribble",
    "rotate-exclamation",
    "file-circle-check",
    "glass",
    "loader",
    "forward",
    "user-pilot",
    "mobile-android",
    "mobile-phone",
    "mobile",
    "code-pull-request-closed",
    "meh",
    "face-meh",
    "align-center",
    "book-dead",
    "book-skull",
    "drivers-license",
    "id-card",
    "face-dotted",
    "face-worried",
    "dedent",
    "outdent",
    "court-sport",
    "heart-circle-exclamation",
    "home",
    "home-alt",
    "home-lg-alt",
    "house",
    "vector-circle",
    "car-circle-bolt",
    "calendar-week",
    "flying-disc",
    "laptop-medical",
    "square-down-right",
    "b",
    "seat-airline",
    "eclipse-alt",
    "moon-over-sun",
    "pipe",
    "file-medical",
    "potato",
    "dice-one",
    "circle-a",
    "helmet-battle",
    "butter",
    "blanket-fire",
    "kiwi-bird",
    "castle",
    "golf-club",
    "exchange",
    "arrow-right-arrow-left",
    "redo-alt",
    "rotate-forward",
    "rotate-right",
    "cutlery",
    "utensils",
    "sort-amount-up",
    "arrow-up-wide-short",
    "chart-pie-simple-circle-dollar",
    "balloons",
    "mill-sign",
    "bowl-rice",
    "timeline-arrow",
    "skull",
    "game-board-alt",
    "game-board-simple",
    "video-circle",
    "circle-video",
    "chart-scatter-bubble",
    "house-turret",
    "banana",
    "hand-holding-skull",
    "people-dress",
    "couch-small",
    "loveseat",
    "broadcast-tower",
    "tower-broadcast",
    "truck-pickup",
    "block-quote",
    "long-arrow-alt-up",
    "up-long",
    "stop",
    "code-merge",
    "money-check-edit-alt",
    "money-check-dollar-pen",
    "arrow-alt-from-bottom",
    "up-from-line",
    "upload",
    "hurricane",
    "grid-round-2-plus",
    "people-pants",
    "mound",
    "windsock",
    "circle-half",
    "brake-warning",
    "toilet-portable",
    "compact-disc",
    "file-download",
    "file-arrow-down",
    "sax-hot",
    "saxophone-fire",
    "webcam-slash",
    "camera-web-slash",
    "folder-medical",
    "folder-cog",
    "folder-gear",
    "hand-wave",
    "sort-up-down",
    "arrow-up-arrow-down",
    "caravan",
    "shield-cat",
    "comment-alt-slash",
    "message-slash",
    "zap",
    "bolt",
    "trash-can-check",
    "glass-water",
    "oil-well",
    "person-simple",
    "arrow-turn-left-up",
    "vault",
    "mars",
    "toilet",
    "plane-circle-xmark",
    "cny",
    "jpy",
    "rmb",
    "yen",
    "yen-sign",
    "gear-code",
    "notes",
    "rouble",
    "rub",
    "ruble",
    "ruble-sign",
    "trash-arrow-turn-left",
    "trash-undo",
    "glass-champagne",
    "champagne-glass",
    "objects-align-center-horizontal",
    "sun",
    "trash-alt-slash",
    "trash-can-slash",
    "users-class",
    "screen-users",
    "guitar",
    "arrow-square-left",
    "square-arrow-left",
    "square-8",
    "face-smile-hearts",
    "brackets",
    "brackets-square",
    "laptop-arrow-down",
    "hockey-stick-puck",
    "house-tree",
    "signal-2",
    "signal-fair",
    "laugh-wink",
    "face-laugh-wink",
    "dollar-circle",
    "usd-circle",
    "circle-dollar",
    "horse-head",
    "repeat-alt",
    "arrows-repeat",
    "bore-hole",
    "industry",
    "image-polaroid",
    "wave-triangle",
    "turn-left-down",
    "person-running-fast",
    "arrow-alt-circle-down",
    "circle-down",
    "grill",
    "arrows-turn-to-dots",
    "analytics",
    "chart-mixed",
    "florin-sign",
    "sort-amount-desc",
    "sort-amount-down-alt",
    "arrow-down-short-wide",
    "less-than",
    "desktop-code",
    "display-code",
    "face-drooling",
    "oil-temp",
    "oil-temperature",
    "question-square",
    "square-question",
    "air-conditioner",
    "angle-down",
    "mountains",
    "omega",
    "car-tunnel",
    "person-dolly-empty",
    "pan-food",
    "head-side-cough",
    "grip-lines",
    "thumbs-down",
    "user-lock",
    "long-arrow-right",
    "arrow-right-long",
    "tickets-perforated-plane",
    "tickets-plane",
    "tickets-airline",
    "tent-double-peak",
    "anchor-circle-xmark",
    "ellipsis-h",
    "ellipsis",
    "nfc-slash",
    "chess-pawn",
    "first-aid",
    "kit-medical",
    "grid-2-plus",
    "bells",
    "person-through-window",
    "toolbox",
    "envelope-badge",
    "envelope-dot",
    "magnifying-glass-waveform",
    "hands-holding-circle",
    "bug",
    "bowl-chopsticks",
    "credit-card-alt",
    "credit-card",
    "circle-s",
    "box-ballot",
    "automobile",
    "car",
    "hand-holding-hand",
    "user-tie-hair",
    "podium-star",
    "business-front",
    "party-back",
    "trian-balbot",
    "user-hair-mullet",
    "microphone-stand",
    "book-reader",
    "book-open-reader",
    "family-dress",
    "circle-x",
    "cabin",
    "mountain-sun",
    "chart-simple-horizontal",
    "bluetooth",
    "arrows-left-right-to-line",
    "hand-back-point-left",
    "comment-alt-dots",
    "messaging",
    "message-dots",
    "file-heart",
    "beer-foam",
    "beer-mug",
    "dice-d20",
    "drone",
    "truck-droplet",
    "file-circle-xmark",
    "temperature-up",
    "temperature-arrow-up",
    "medal",
    "person-fairy",
    "bed",
    "book-copy",
    "h-square",
    "square-h",
    "square-c",
    "clock-two",
    "square-ellipsis-vertical",
    "calendar-users",
    "podcast",
    "bee",
    "temperature-4",
    "thermometer-4",
    "thermometer-full",
    "temperature-full",
    "bell",
    "chocolate-bar",
    "candy-bar",
    "xmark-large",
    "pinata",
    "file-ppt",
    "arrows-from-line",
    "superscript",
    "bowl-spoon",
    "hexagon-check",
    "plug-circle-xmark",
    "star-of-life",
    "phone-slash",
    "traffic-light-stop",
    "paint-roller",
    "accent-grave",
    "hands-helping",
    "handshake-angle",
    "circle-0",
    "dial-med-low",
    "map-marker-alt",
    "location-dot",
    "crab",
    "box-full",
    "box-open-full",
    "file",
    "greater-than",
    "quotes",
    "pretzel",
    "t-rex",
    "swimmer",
    "person-swimming",
    "arrow-down",
    "user-robot-xmarks",
    "comment-alt-quote",
    "message-quote",
    "candy-corn",
    "folder-search",
    "folder-magnifying-glass",
    "notebook",
    "circle-wifi",
    "tint",
    "droplet",
    "bullseye-pointer",
    "eraser",
    "hexagon-image",
    "earth",
    "earth-america",
    "globe-americas",
    "earth-americas",
    "file-svg",
    "apple-crate",
    "crate-apple",
    "person-burst",
    "game-board",
    "hat-chef",
    "hand-back-point-right",
    "dove",
    "snowflake-droplets",
    "battery-0",
    "battery-empty",
    "grid-4",
    "socks",
    "face-sunglasses",
    "inbox",
    "square-0",
    "section",
    "box-up",
    "square-this-way-up",
    "tachometer-alt",
    "tachometer-alt-fast",
    "gauge-high",
    "square-ampersand",
    "envelope-open-text",
    "lamp-desk",
    "hospital-alt",
    "hospital-wide",
    "hospital",
    "poll-people",
    "glass-whiskey-rocks",
    "whiskey-glass-ice",
    "wine-bottle",
    "chess-rook",
    "user-bounty-hunter",
    "reorder",
    "stream",
    "bars-staggered",
    "diagram-sankey",
    "cloud-hail-mixed",
    "circle-up-left",
    "dharmachakra",
    "objects-align-left",
    "oil-can-drip",
    "face-smiling-hands",
    "broccoli",
    "route-interstate",
    "ear-muffs",
    "hotdog",
    "transporter-empty",
    "blind",
    "person-walking-with-cane",
    "angle-90",
    "rectangle-terminal",
    "kite",
    "drum",
    "scrubber",
    "ice-cream",
    "heart-circle-bolt",
    "fish-bones",
    "deer-rudolph",
    "fax",
    "paragraph",
    "head-side-heart",
    "square-e",
    "meter-fire",
    "cloud-hail",
    "vote-yea",
    "check-to-slot",
    "money-from-bracket",
    "star-half",
    "car-bus",
    "speaker",
    "timer",
    "boxes",
    "boxes-alt",
    "boxes-stacked",
    "landmark-magnifying-glass",
    "grill-hot",
    "ballot-check",
    "chain",
    "link",
    "assistive-listening-systems",
    "ear-listen",
    "file-minus",
    "tree-city",
    "play",
    "font",
    "coffee-togo",
    "cup-togo",
    "square-down-left",
    "burger-lettuce",
    "table-cells-row-lock",
    "rupiah-sign",
    "search",
    "magnifying-glass",
    "ping-pong-paddle-ball",
    "table-tennis",
    "table-tennis-paddle-ball",
    "diagnoses",
    "person-dots-from-line",
    "chevron-double-down",
    "chevrons-down",
    "trash-restore-alt",
    "trash-can-arrow-up",
    "signal-3",
    "signal-good",
    "map-marker-question",
    "location-question",
    "floppy-disk-times",
    "save-circle-xmark",
    "save-times",
    "floppy-disk-circle-xmark",
    "naira-sign",
    "peach",
    "taxi-bus",
    "bracket-curly-left",
    "bracket-curly",
    "lobster",
    "dolly-flatbed-empty",
    "cart-flatbed-empty",
    "colon",
    "cart-arrow-down",
    "wand",
    "walkie-talkie",
    "file-edit",
    "file-pen",
    "receipt",
    "table-picnic",
    "pen-square",
    "pencil-square",
    "square-pen",
    "microphone-circle-alt",
    "circle-microphone-lines",
    "desktop-slash",
    "display-slash",
    "suitcase-rolling",
    "person-circle-exclamation",
    "transporter-2",
    "hand-receiving",
    "hands-holding-diamond",
    "money-bill-simple-wave",
    "chevron-down",
    "battery",
    "battery-5",
    "battery-full",
    "bell-plus",
    "book-arrow-right",
    "hospitals",
    "club",
    "skull-crossbones",
    "dewpoint",
    "droplet-degree",
    "code-compare",
    "list-dots",
    "list-ul",
    "hand-holding-magic",
    "watermelon-slice",
    "circle-ellipsis",
    "school-lock",
    "tower-cell",
    "sd-cards",
    "jug-bottle",
    "long-arrow-alt-down",
    "down-long",
    "envelopes",
    "phone-office",
    "ranking-star",
    "chess-king",
    "nfc-pen",
    "person-harassing",
    "magnifying-glass-play",
    "hat-winter",
    "brazilian-real-sign",
    "landmark-alt",
    "landmark-dome",
    "bone-break",
    "arrow-up",
    "down-from-dotted-line",
    "television",
    "tv-alt",
    "tv",
    "border-left",
    "circle-divide",
    "shrimp",
    "tasks",
    "list-check",
    "diagram-subtask",
    "jug-detergent",
    "user-circle",
    "circle-user",
    "square-y",
    "user-doctor-hair",
    "planet-ringed",
    "mushroom",
    "user-shield",
    "megaphone",
    "wreath-laurel",
    "circle-exclamation-check",
    "wind",
    "box-usd",
    "box-dollar",
    "car-crash",
    "car-burst",
    "y",
    "user-headset",
    "retweet-alt",
    "arrows-retweet",
    "snowboarding",
    "person-snowboarding",
    "chevron-square-right",
    "square-chevron-right",
    "lacrosse-stick-ball",
    "shipping-fast",
    "truck-fast",
    "user-magnifying-glass",
    "star-sharp",
    "comment-heart",
    "circle-1",
    "star-circle",
    "circle-star",
    "fish",
    "fog",
    "cloud-fog",
    "waffle",
    "music-alt",
    "music-note",
    "hexagon-exclamation",
    "cart-shopping-fast",
    "object-union",
    "user-graduate",
    "starfighter",
    "adjust",
    "circle-half-stroke",
    "arrow-right-long-to-line",
    "arrow-square-down",
    "square-arrow-down",
    "diamond-half-stroke",
    "clapperboard",
    "chevron-square-left",
    "square-chevron-left",
    "phone-intercom",
    "chain-horizontal",
    "link-horizontal",
    "mango",
    "music-alt-slash",
    "music-note-slash",
    "radiation-alt",
    "circle-radiation",
    "face-tongue-sweat",
    "globe-stand",
    "baseball-ball",
    "baseball",
    "circle-p",
    "award-simple",
    "jet-fighter-up",
    "project-diagram",
    "diagram-project",
    "pedestal",
    "chart-pyramid",
    "sidebar",
    "frosty-head",
    "snowman-head",
    "copy",
    "burger-glass",
    "volume-mute",
    "volume-times",
    "volume-xmark",
    "hand-sparkles",
    "bars-filter",
    "paintbrush-pencil",
    "party-bell",
    "user-vneck-hair",
    "jack-o-lantern",
    "grip-horizontal",
    "grip",
    "share-square",
    "share-from-square",
    "keynote",
    "child-rifle",
    "child-combatant",
    "gun",
    "phone-square",
    "square-phone",
    "hat-beach",
    "add",
    "plus",
    "expand",
    "computer",
    "fort",
    "cloud-check",
    "close",
    "multiply",
    "remove",
    "times",
    "xmark",
    "face-smirking",
    "arrows",
    "arrows-up-down-left-right",
    "chalkboard-teacher",
    "chalkboard-user",
    "rhombus",
    "claw-marks",
    "peso-sign",
    "face-smile-tongue",
    "cart-circle-xmark",
    "building-shield",
    "phone-circle-alt",
    "circle-phone-flip",
    "baby",
    "users-line",
    "quote-left-alt",
    "quote-left",
    "tractor",
    "down-from-bracket",
    "key-skeleton",
    "trash-restore",
    "trash-arrow-up",
    "arrow-down-up-lock",
    "arrow-down-to-bracket",
    "lines-leaning",
    "square-q",
    "ruler-combined",
    "icons-alt",
    "symbols",
    "copyright",
    "flask-gear",
    "highlighter-line",
    "bracket",
    "bracket-left",
    "bracket-square",
    "island-tree-palm",
    "island-tropical",
    "arrow-from-left",
    "arrow-right-from-line",
    "h2",
    "equals",
    "shortcake",
    "cake-slice",
    "building-magnifying-glass",
    "peanut",
    "wrench-simple",
    "blender",
    "teeth",
    "tally-2",
    "ils",
    "shekel",
    "sheqel",
    "sheqel-sign",
    "shekel-sign",
    "cars",
    "axe-battle",
    "user-hair-long",
    "map",
    "arrow-left-from-arc",
    "file-circle-info",
    "face-disappointed",
    "lasso-sparkles",
    "clock-eleven",
    "rocket",
    "siren-on",
    "clock-ten",
    "candle-holder",
    "video-arrow-down-left",
    "photo-video",
    "photo-film",
    "save-circle-arrow-right",
    "floppy-disk-circle-arrow-right",
    "folder-minus",
    "planet-moon",
    "face-eyes-xmarks",
    "chart-scatter",
    "circle-gf",
    "display-arrow-down",
    "store",
    "arrow-trend-up",
    "plug-circle-minus",
    "olive-branch",
    "angle",
    "vacuum-robot",
    "sign",
    "sign-hanging",
    "square-divide",
    "folder-check",
    "signal-stream-slash",
    "bezier-curve",
    "eye-dropper-half",
    "store-lock",
    "bell-slash",
    "thunderstorm-sun",
    "cloud-bolt-sun",
    "camera-slash",
    "comment-quote",
    "tablet-android",
    "tablet",
    "school-flag",
    "message-code",
    "glass-half-empty",
    "glass-half-full",
    "glass-half",
    "fill",
    "comment-alt-minus",
    "message-minus",
    "angle-up",
    "dinosaur",
    "drumstick-bite",
    "chain-horizontal-slash",
    "link-horizontal-slash",
    "holly-berry",
    "nose",
    "arrow-left-to-arc",
    "chevron-left",
    "bacteria",
    "clouds",
    "money-bill-simple",
    "hand-lizard",
    "table-pivot",
    "filter-slash",
    "trash-can-arrow-turn-left",
    "trash-undo-alt",
    "trash-can-undo",
    "notdef",
    "disease",
    "person-to-door",
    "turntable",
    "briefcase-medical",
    "genderless",
    "chevron-right",
    "signal-1",
    "signal-weak",
    "clock-five",
    "retweet",
    "car-alt",
    "car-rear",
    "pump-soap",
    "computer-classic",
    "frame",
    "video-slash",
    "battery-2",
    "battery-quarter",
    "ellipsis-h-alt",
    "ellipsis-stroke",
    "radio",
    "carriage-baby",
    "baby-carriage",
    "face-expressionless",
    "down-to-dotted-line",
    "cloud-music",
    "traffic-light",
    "cloud-minus",
    "thermometer",
    "shield-minus",
    "vr-cardboard",
    "car-tilt",
    "gauge-circle-minus",
    "brightness-low",
    "hand-middle-finger",
    "percentage",
    "percent",
    "truck-moving",
    "glass-water-droplet",
    "conveyor-belt",
    "map-marker-check",
    "location-check",
    "coin-vertical",
    "display",
    "person-sign",
    "smile",
    "face-smile",
    "phone-hangup",
    "signature-slash",
    "thumb-tack",
    "thumbtack",
    "wheat-slash",
    "trophy",
    "clouds-sun",
    "pray",
    "person-praying",
    "hammer",
    "face-vomit",
    "speakers",
    "teletype-answer",
    "tty-answer",
    "mug-tea-saucer",
    "diagram-lean-canvas",
    "alt",
    "dial-med-high",
    "dial",
    "hand-peace",
    "trash-circle",
    "circle-trash",
    "sync-alt",
    "rotate",
    "circle-quarters",
    "spinner",
    "tower-control",
    "sort-shapes-up",
    "arrow-up-triangle-square",
    "whale",
    "robot",
    "peace",
    "party-horn",
    "cogs",
    "gears",
    "sun-alt",
    "sun-bright",
    "warehouse",
    "conveyor-belt-arm",
    "lock-open-alt",
    "lock-keyhole-open",
    "box-fragile",
    "square-wine-glass-crack",
    "square-fragile",
    "arrow-up-right-dots",
    "square-n",
    "splotch",
    "grin-hearts",
    "face-grin-hearts",
    "meter",
    "mandolin",
    "dice-four",
    "sim-card",
    "transgender-alt",
    "transgender",
    "mercury",
    "up-from-bracket",
    "knife-kitchen",
    "border-right",
    "level-down",
    "arrow-turn-down",
    "spade",
    "card-spade",
    "line-columns",
    "ant",
    "arrow-to-right",
    "arrow-right-to-line",
    "person-falling-burst",
    "pennant",
    "flag-pennant",
    "conveyor-belt-empty",
    "user-group-simple",
    "award",
    "ticket-alt",
    "ticket-simple",
    "building",
    "angle-double-left",
    "angles-left",
    "video-handheld",
    "camcorder",
    "pancakes",
    "album-circle-user",
    "subtitles-slash",
    "qrcode",
    "dice-d10",
    "fireplace",
    "browser",
    "pencil-paintbrush",
    "pen-paintbrush",
    "fish-cooked",
    "chair-office",
    "magnifying-glass-music",
    "nesting-dolls",
    "history",
    "clock-rotate-left",
    "trumpet",
    "grin-beam-sweat",
    "face-grin-beam-sweat",
    "fire-smoke",
    "phone-missed",
    "arrow-right-from-file",
    "file-export",
    "shield-blank",
    "shield",
    "sort-amount-up-alt",
    "arrow-up-short-wide",
    "repeat-1-alt",
    "arrows-repeat-1",
    "gun-slash",
    "avocado",
    "binary",
    "glasses-alt",
    "glasses-round",
    "phone-plus",
    "ditto",
    "person-seat",
    "house-medical",
    "golf-ball",
    "golf-ball-tee",
    "chevron-circle-left",
    "circle-chevron-left",
    "house-chimney-window",
    "scythe",
    "pen-nib",
    "parking-circle-slash",
    "ban-parking",
    "tent-arrow-turn-left",
    "face-diagonal-mouth",
    "diagram-cells",
    "cricket",
    "cricket-bat-ball",
    "tents",
    "magic",
    "wand-magic",
    "dog",
    "pen-line",
    "atom-alt",
    "atom-simple",
    "ampersand",
    "carrot",
    "arrow-from-bottom",
    "arrow-up-from-line",
    "moon",
    "pen-slash",
    "wine-glass-alt",
    "wine-glass-empty",
    "square-star",
    "cheese",
    "send-backward",
    "yin-yang",
    "music",
    "compass-slash",
    "clock-one",
    "file-music",
    "code-commit",
    "temperature-low",
    "biking",
    "person-biking",
    "display-chart-up-circle-currency",
    "skeleton",
    "circle-g",
    "circle-arrow-up-left",
    "coin-blank",
    "broom",
    "vacuum",
    "shield-heart",
    "card-heart",
    "lightbulb-cfl-on",
    "melon",
    "gopuram",
    "globe-oceania",
    "earth-oceania",
    "container-storage",
    "face-pouting",
    "times-square",
    "xmark-square",
    "square-xmark",
    "exploding-head",
    "face-explode",
    "hashtag",
    "expand-alt",
    "up-right-and-down-left-from-center",
    "oil-can",
    "t",
    "transformer-bolt",
    "hippo",
    "chart-column",
    "vhs",
    "cassette-vhs",
    "infinity",
    "vial-circle-check",
    "chimney",
    "object-intersect",
    "person-arrow-down-to-line",
    "voicemail",
    "wall-brick",
    "block-brick",
    "fan",
    "bags-shopping",
    "paragraph-rtl",
    "paragraph-left",
    "person-walking-luggage",
    "caravan-alt",
    "caravan-simple",
    "turtle",
    "pencil-mechanical",
    "arrows-alt-v",
    "up-down",
    "cloud-moon-rain",
    "booth-curtain",
    "calendar",
    "box-heart",
    "trailer",
    "user-md-chat",
    "user-doctor-message",
    "haykal",
    "bahai",
    "lighthouse",
    "amp-guitar",
    "sd-card",
    "volume-slash",
    "border-bottom",
    "wifi-1",
    "wifi-weak",
    "dragon",
    "shoe-prints",
    "plus-circle",
    "circle-plus",
    "grin-tongue-wink",
    "face-grin-tongue-wink",
    "hand-holding",
    "plug-circle-exclamation",
    "chain-broken",
    "chain-slash",
    "unlink",
    "link-slash",
    "clone",
    "person-walking-arrow-loop-left",
    "sort-alpha-up-alt",
    "arrow-up-z-a",
    "fire-alt",
    "fire-flame-curved",
    "tornado",
    "file-circle-plus",
    "delete-right",
    "quran",
    "book-quran",
    "circle-quarter",
    "anchor",
    "border-all",
    "function",
    "angry",
    "face-angry",
    "people-simple",
    "cookie-bite",
    "arrow-trend-down",
    "feed",
    "rss",
    "face-monocle",
    "draw-polygon",
    "balance-scale",
    "scale-balanced",
    "calendar-note",
    "calendar-lines",
    "sort-size-down",
    "arrow-down-big-small",
    "tachometer",
    "tachometer-fast",
    "gauge-simple-high",
    "do-not-enter",
    "shower",
    "dice-d8",
    "desktop-alt",
    "desktop",
    "m",
    "spinner-scale",
    "grip-dots-vertical",
    "face-viewfinder",
    "creemee",
    "soft-serve",
    "h5",
    "hand-back-point-down",
    "th-list",
    "table-list",
    "basket-shopping-minus",
    "sms",
    "comment-sms",
    "rectangle-landscape",
    "rectangle",
    "clipboard-list-check",
    "turkey",
    "book",
    "user-plus",
    "ice-skate",
    "check",
    "battery-4",
    "battery-three-quarters",
    "tomato",
    "sword-laser",
    "house-circle-check",
    "buildings",
    "angle-left",
    "dolly-flatbed-alt",
    "cart-flatbed-boxes",
    "diagram-successor",
    "truck-arrow-right",
    "square-w",
    "arrows-split-up-and-left",
    "lamp",
    "airplay",
    "fist-raised",
    "hand-fist",
    "shield-quartered",
    "slash-forward",
    "map-marker-edit",
    "location-pen",
    "cloud-moon",
    "pot-food",
    "briefcase",
    "person-falling",
    "portrait",
    "image-portrait",
    "user-tag",
    "rug",
    "print-slash",
    "globe-europe",
    "earth-europe",
    "luggage-cart",
    "cart-flatbed-suitcase",
    "hand-back-point-ribbon",
    "rectangle-times",
    "times-rectangle",
    "window-close",
    "rectangle-xmark",
    "tire-rugged",
    "lightbulb-dollar",
    "cowbell",
    "baht-sign",
    "corner",
    "chevron-double-right",
    "chevrons-right",
    "book-open",
    "journal-whills",
    "book-journal-whills",
    "inhaler",
    "handcuffs",
    "snake",
    "exclamation-triangle",
    "warning",
    "triangle-exclamation",
    "note-medical",
    "database",
    "down-left",
    "mail-forward",
    "share",
    "face-thinking",
    "turn-down-right",
    "bottle-droplet",
    "mask-face",
    "hill-rockslide",
    "scanner-keyboard",
    "circle-o",
    "grid-horizontal",
    "comment-alt-dollar",
    "message-dollar",
    "exchange-alt",
    "right-left",
    "columns-3",
    "paper-plane",
    "road-circle-exclamation",
    "dungeon",
    "hand-holding-box",
    "input-text",
    "window-alt",
    "window-flip",
    "align-right",
    "scanner",
    "scanner-gun",
    "tire",
    "engine",
    "money-bill-wave-alt",
    "money-bill-1-wave",
    "life-ring",
    "sign-language",
    "signing",
    "hands",
    "caret-circle-right",
    "circle-caret-right",
    "turn-left",
    "wheat",
    "file-spreadsheet",
    "audio-description-slash",
    "bell-ring",
    "calendar-day",
    "ladder-water",
    "swimming-pool",
    "water-ladder",
    "arrows-v",
    "arrows-up-down",
    "chess-pawn-alt",
    "chess-pawn-piece",
    "grimace",
    "face-grimace",
    "wheelchair-alt",
    "wheelchair-move",
    "level-down-alt",
    "turn-down",
    "square-s",
    "barcode-alt",
    "rectangle-barcode",
    "person-walking-arrow-right",
    "envelope-square",
    "square-envelope",
    "dice",
    "unicorn",
    "bowling-ball",
    "pompebled",
    "brain",
    "watch-smart",
    "book-user",
    "sensor-smoke",
    "sensor-cloud",
    "clapperboard-play",
    "band-aid",
    "bandage",
    "calendar-minus",
    "times-circle",
    "xmark-circle",
    "circle-xmark",
    "circle-4",
    "gifts",
    "album-collection",
    "hotel",
    "globe-asia",
    "earth-asia",
    "id-card-alt",
    "id-card-clip",
    "search-plus",
    "magnifying-glass-plus",
    "thumbs-up",
    "cloud-showers",
    "user-clock",
    "onion",
    "clock-twelve-thirty",
    "arrow-down-to-dotted-line",
    "allergies",
    "hand-dots",
    "file-invoice",
    "window-minimize",
    "rectangle-wide",
    "comment-arrow-up",
    "garlic",
    "coffee",
    "mug-saucer",
    "brush",
    "tree-decorated",
    "mask",
    "calendar-heart",
    "search-minus",
    "magnifying-glass-minus",
    "flower",
    "arrow-down-from-arc",
    "right-left-large",
    "ruler-vertical",
    "circles-overlap",
    "user-alt",
    "user-large",
    "starship-freighter",
    "train-tram",
    "bridge-suspension",
    "trash-check",
    "user-nurse",
    "boombox",
    "syringe",
    "cloud-sun",
    "shield-exclamation",
    "stopwatch-20",
    "square-full",
    "grip-dots",
    "comment-exclamation",
    "pen-swirl",
    "falafel",
    "circle-2",
    "magnet",
    "jar",
    "gramophone",
    "dice-d12",
    "sticky-note",
    "note-sticky",
    "arrow-alt-down",
    "down",
    "100",
    "hundred-points",
    "paperclip-vertical",
    "wind-circle-exclamation",
    "wind-warning",
    "map-marker-slash",
    "location-pin-slash",
    "face-sad-sweat",
    "bug-slash",
    "cupcake",
    "light-switch-off",
    "toggle-large-off",
    "pen-fancy-slash",
    "truck-container",
    "boot",
    "arrow-up-from-water-pump",
    "file-check",
    "bone",
    "cards-blank",
    "circle-3",
    "bench-tree",
    "keyboard-brightness-low",
    "ski-boot-ski",
    "brain-circuit",
    "user-injured",
    "firewall",
    "block-brick-fire",
    "sad-tear",
    "face-sad-tear",
    "plane",
    "tent-arrows-down",
    "exclamation",
    "arrows-spin",
    "face-smile-relaxed",
    "comment-times",
    "comment-xmark",
    "print",
    "try",
    "turkish-lira",
    "turkish-lira-sign",
    "face-nose-steam",
    "waveform-circle",
    "circle-waveform-lines",
    "dollar",
    "usd",
    "dollar-sign",
    "ferris-wheel",
    "computer-speaker",
    "skull-cow",
    "x",
    "search-dollar",
    "magnifying-glass-dollar",
    "users-cog",
    "users-gear",
    "person-military-pointing",
    "bank",
    "institution",
    "museum",
    "university",
    "building-columns",
    "circle-t",
    "sack",
    "grid-2",
    "cctv",
    "camera-cctv",
    "umbrella",
    "trowel",
    "horizontal-rule",
    "bed-alt",
    "bed-front",
    "d",
    "stapler",
    "theater-masks",
    "masks-theater",
    "file-gif",
    "kip-sign",
    "face-woozy",
    "cloud-question",
    "pineapple",
    "hand-point-left",
    "gallery-thumbnails",
    "circle-j",
    "eyes",
    "handshake-alt",
    "handshake-simple",
    "file-caret-up",
    "page-caret-up",
    "fighter-jet",
    "jet-fighter",
    "comet",
    "share-alt-square",
    "square-share-nodes",
    "reflect-vertical",
    "shield-keyhole",
    "file-mp4",
    "barcode",
    "bulldozer",
    "plus-minus",
    "sliders-v-square",
    "square-sliders-vertical",
    "video-camera",
    "video",
    "comment-middle-alt",
    "message-middle",
    "mortar-board",
    "graduation-cap",
    "hand-holding-medical",
    "person-circle-check",
    "square-z",
    "comment-alt-text",
    "message-text",
    "level-up-alt",
    "turn-up"
  ],
  "fad": [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "fill-drip",
    "arrows-to-circle",
    "chevron-circle-right",
    "circle-chevron-right",
    "wagon-covered",
    "line-height",
    "bagel",
    "transporter-7",
    "at",
    "rectangles-mixed",
    "phone-arrow-up",
    "phone-outgoing",
    "phone-arrow-up-right",
    "trash-alt",
    "trash-can",
    "circle-l",
    "head-vr",
    "head-side-goggles",
    "text-height",
    "user-times",
    "user-xmark",
    "face-hand-yawn",
    "tachometer-slowest",
    "gauge-simple-min",
    "stethoscope",
    "coffin",
    "comment-alt",
    "message",
    "bowl-salad",
    "salad",
    "info",
    "robot-astromech",
    "ring-diamond",
    "fondue-pot",
    "theta",
    "face-hand-peeking",
    "square-user",
    "compress-alt",
    "down-left-and-up-right-to-center",
    "explosion",
    "file-alt",
    "file-text",
    "file-lines",
    "wave-square",
    "ring",
    "building-un",
    "dice-three",
    "tire-pressure-warning",
    "wifi-2",
    "wifi-fair",
    "calendar-alt",
    "calendar-days",
    "mp3-player",
    "anchor-circle-check",
    "tally-4",
    "rectangle-history",
    "building-circle-arrow-right",
    "volleyball-ball",
    "volleyball",
    "sun-haze",
    "text-size",
    "ufo",
    "utensil-fork",
    "fork",
    "arrows-up-to-line",
    "mobile-signal",
    "barcode-scan",
    "sort-desc",
    "sort-down",
    "folder-download",
    "folder-arrow-down",
    "minus-circle",
    "circle-minus",
    "face-icicles",
    "shovel",
    "door-open",
    "films",
    "sign-out-alt",
    "right-from-bracket",
    "face-glasses",
    "nfc",
    "atom",
    "soap",
    "heart-music-camera-bolt",
    "icons",
    "microphone-alt-slash",
    "microphone-lines-slash",
    "closed-captioning-slash",
    "calculator-alt",
    "calculator-simple",
    "bridge-circle-check",
    "sliders-v",
    "sliders-up",
    "map-marker-minus",
    "location-minus",
    "pump-medical",
    "fingerprint",
    "ski-boot",
    "rectangle-sd",
    "standard-definition",
    "h1",
    "hand-point-right",
    "search-location",
    "magnifying-glass-location",
    "message-bot",
    "step-forward",
    "forward-step",
    "smile-beam",
    "face-smile-beam",
    "light-ceiling",
    "comment-alt-exclamation",
    "message-exclamation",
    "bowl-shaved-ice",
    "bowl-scoop",
    "square-x",
    "building-memo",
    "utility-pole-double",
    "flag-checkered",
    "chevron-double-up",
    "chevrons-up",
    "football-ball",
    "football",
    "user-vneck",
    "school-circle-exclamation",
    "crop",
    "angle-double-down",
    "angles-down",
    "users-rectangle",
    "people-roof",
    "arrow-square-right",
    "square-arrow-right",
    "map-marker-plus",
    "location-plus",
    "lightbulb-exclamation-on",
    "people-line",
    "beer",
    "beer-mug-empty",
    "crate-empty",
    "diagram-predecessor",
    "transporter",
    "calendar-circle-user",
    "long-arrow-up",
    "arrow-up-long",
    "person-carry",
    "person-carry-box",
    "burn",
    "fire-flame-simple",
    "male",
    "person",
    "laptop",
    "file-csv",
    "menorah",
    "union",
    "chevron-double-left",
    "chevrons-left",
    "heart-circle",
    "circle-heart",
    "truck-plane",
    "record-vinyl",
    "bring-forward",
    "square-p",
    "grin-stars",
    "face-grin-stars",
    "sigma",
    "camera-movie",
    "bong",
    "clarinet",
    "truck-flatbed",
    "pastafarianism",
    "spaghetti-monster-flying",
    "arrow-down-up-across-line",
    "arrows-rotate-reverse",
    "leaf-heart",
    "house-building",
    "cheese-swiss",
    "utensil-spoon",
    "spoon",
    "jar-wheat",
    "mail-bulk",
    "envelopes-bulk",
    "file-circle-exclamation",
    "bow-arrow",
    "cart-xmark",
    "times-hexagon",
    "xmark-hexagon",
    "hexagon-xmark",
    "hospital-symbol",
    "circle-h",
    "merge",
    "pager",
    "cart-minus",
    "contact-book",
    "address-book",
    "pan-frying",
    "grid-3",
    "grid",
    "football-helmet",
    "hand-love",
    "trees",
    "strikethrough",
    "page",
    "k",
    "diagram-previous",
    "tachometer-alt-slowest",
    "gauge-min",
    "folder-grid",
    "eggplant",
    "excavator",
    "ram",
    "landmark-flag",
    "lips",
    "pencil-alt",
    "pencil",
    "backward",
    "caret-right",
    "comments",
    "file-clipboard",
    "paste",
    "desktop-arrow-down",
    "code-pull-request",
    "pumpkin",
    "clipboard-list",
    "pen-field",
    "blueberries",
    "truck-loading",
    "truck-ramp-box",
    "note",
    "arrow-down-to-square",
    "user-check",
    "cloud-xmark",
    "vial-virus",
    "book-alt",
    "book-blank",
    "golf-flag-hole",
    "comment-alt-arrow-down",
    "message-arrow-down",
    "face-unamused",
    "sheet-plastic",
    "circle-9",
    "blog",
    "user-ninja",
    "pencil-slash",
    "bowling-pins",
    "person-arrow-up-from-line",
    "down-right",
    "torah",
    "scroll-torah",
    "webhook",
    "blinds-open",
    "fence",
    "arrow-alt-up",
    "up",
    "quidditch",
    "quidditch-broom-ball",
    "broom-ball",
    "drumstick",
    "square-v",
    "gave-dandy",
    "face-awesome",
    "dial-off",
    "toggle-off",
    "face-smile-horns",
    "archive",
    "box-archive",
    "grapes",
    "person-drowning",
    "dial-max",
    "circle-m",
    "calendar-image",
    "caret-circle-down",
    "circle-caret-down",
    "sort-numeric-desc",
    "sort-numeric-down-alt",
    "arrow-down-9-1",
    "grin-tongue-squint",
    "face-grin-tongue-squint",
    "shish-kebab",
    "spray-can",
    "alarm-snooze",
    "scarecrow",
    "truck-monster",
    "gift-card",
    "w",
    "code-pull-request-draft",
    "square-b",
    "elephant",
    "globe-africa",
    "earth-africa",
    "rainbow",
    "circle-notch",
    "tablet-alt",
    "tablet-screen-button",
    "paw",
    "message-question",
    "cloud",
    "trowel-bricks",
    "square-3",
    "flushed",
    "face-flushed",
    "hospital-user",
    "microwave",
    "chf-sign",
    "tent-arrow-left-right",
    "cart-circle-arrow-up",
    "trash-clock",
    "reflect-both",
    "legal",
    "gavel",
    "sprinkler-ceiling",
    "browsers",
    "trillium",
    "music-slash",
    "truck-ramp",
    "binoculars",
    "microphone-slash",
    "box-tissue",
    "circle-c",
    "star-christmas",
    "chart-bullet",
    "motorcycle",
    "tree-christmas",
    "tire-flat",
    "sunglasses",
    "badge",
    "comment-alt-edit",
    "message-edit",
    "message-pen",
    "concierge-bell",
    "bell-concierge",
    "pencil-ruler",
    "pen-ruler",
    "file-mp3",
    "arrow-progress",
    "chess-rook-alt",
    "chess-rook-piece",
    "square-root",
    "album-collection-circle-plus",
    "people-arrows-left-right",
    "people-arrows",
    "sign-post",
    "face-angry-horns",
    "mars-and-venus-burst",
    "tombstone",
    "caret-square-right",
    "square-caret-right",
    "cut",
    "scissors",
    "list-music",
    "sun-plant-wilt",
    "toilets-portable",
    "hockey-puck",
    "mustache",
    "hyphen",
    "table",
    "user-chef",
    "comment-alt-image",
    "message-image",
    "users-medical",
    "sensor-alert",
    "sensor-triangle-exclamation",
    "magnifying-glass-arrow-right",
    "digital-tachograph",
    "tachograph-digital",
    "face-mask",
    "pickleball",
    "star-sharp-half",
    "users-slash",
    "clover",
    "meat",
    "mail-reply",
    "reply",
    "star-and-crescent",
    "empty-set",
    "house-fire",
    "minus-square",
    "square-minus",
    "helicopter",
    "bird",
    "compass",
    "caret-square-down",
    "square-caret-down",
    "heart-half-alt",
    "heart-half-stroke",
    "file-circle-question",
    "truck-utensils",
    "laptop-code",
    "joystick",
    "grill-fire",
    "rectangle-vertical-history",
    "swatchbook",
    "prescription-bottle",
    "navicon",
    "bars",
    "keyboard-left",
    "people-group",
    "hourglass-3",
    "hourglass-end",
    "heart-broken",
    "heart-crack",
    "face-beam-hand-over-mouth",
    "humidity",
    "droplet-percent",
    "external-link-square-alt",
    "square-up-right",
    "kiss-beam",
    "face-kiss-beam",
    "corn",
    "roller-coaster",
    "photo-film-music",
    "radar",
    "sickle",
    "film",
    "coconut",
    "ruler-horizontal",
    "shield-cross",
    "cassette-tape",
    "square-terminal",
    "people-robbery",
    "lightbulb",
    "caret-left",
    "comment-middle",
    "trash-can-list",
    "block",
    "exclamation-circle",
    "circle-exclamation",
    "school-circle-xmark",
    "sign-out",
    "arrow-right-from-bracket",
    "face-frown-slight",
    "chevron-circle-down",
    "circle-chevron-down",
    "sidebar-flip",
    "unlock-alt",
    "unlock-keyhole",
    "temperature-list",
    "cloud-showers-heavy",
    "headphones-alt",
    "headphones-simple",
    "sitemap",
    "pipe-section",
    "space-station-moon-alt",
    "space-station-moon-construction",
    "donate",
    "circle-dollar-to-slot",
    "memory",
    "face-sleeping",
    "road-spikes",
    "fire-burner",
    "squirrel",
    "arrow-to-top",
    "arrow-up-to-line",
    "flag",
    "face-cowboy-hat",
    "hanukiah",
    "chart-scatter-3d",
    "display-chart-up",
    "square-code",
    "feather",
    "volume-down",
    "volume-low",
    "times-to-slot",
    "vote-nay",
    "xmark-to-slot",
    "box-alt",
    "box-taped",
    "comment-slash",
    "swords",
    "cloud-sun-rain",
    "album",
    "circle-n",
    "compress",
    "wheat-alt",
    "wheat-awn",
    "ankh",
    "hands-holding-child",
    "asterisk",
    "key-skeleton-left-right",
    "comment-lines",
    "luchador",
    "mask-luchador",
    "luchador-mask",
    "check-square",
    "square-check",
    "shredder",
    "book-open-alt",
    "book-open-cover",
    "sandwich",
    "peseta-sign",
    "parking-slash",
    "square-parking-slash",
    "train-tunnel",
    "header",
    "heading",
    "ghost",
    "face-anguished",
    "hockey-sticks",
    "abacus",
    "film-alt",
    "film-simple",
    "list-squares",
    "list",
    "tree-palm",
    "phone-square-alt",
    "square-phone-flip",
    "cart-plus",
    "gamepad",
    "border-center-v",
    "dot-circle",
    "circle-dot",
    "clipboard-medical",
    "dizzy",
    "face-dizzy",
    "egg",
    "arrow-alt-to-top",
    "up-to-line",
    "house-medical-circle-xmark",
    "watch-fitness",
    "clock-nine-thirty",
    "campground",
    "folder-plus",
    "jug",
    "futbol-ball",
    "soccer-ball",
    "futbol",
    "snow-blowing",
    "paint-brush",
    "paintbrush",
    "lock",
    "arrow-from-top",
    "arrow-down-from-line",
    "gas-pump",
    "signal-alt-slash",
    "signal-bars-slash",
    "monkey",
    "pro",
    "rectangle-pro",
    "house-night",
    "hot-tub",
    "hot-tub-person",
    "globe-pointer",
    "blanket",
    "map-marked",
    "map-location",
    "house-flood-water",
    "comments-question-check",
    "tree",
    "arrows-cross",
    "backpack",
    "square-small",
    "folder-upload",
    "folder-arrow-up",
    "bridge-lock",
    "crosshairs-simple",
    "sack-dollar",
    "edit",
    "pen-to-square",
    "sliders-h-square",
    "square-sliders",
    "car-side",
    "comment-middle-top-alt",
    "message-middle-top",
    "lightbulb-on",
    "utensil-knife",
    "knife",
    "share-alt",
    "share-nodes",
    "display-chart-up-circle-dollar",
    "wave-sine",
    "heart-circle-minus",
    "circle-w",
    "calendar-circle",
    "circle-calendar",
    "hourglass-2",
    "hourglass-half",
    "microscope",
    "sunset",
    "sink",
    "calendar-exclamation",
    "truck-container-empty",
    "hand-heart",
    "shopping-bag",
    "bag-shopping",
    "sort-alpha-desc",
    "sort-alpha-down-alt",
    "arrow-down-z-a",
    "mitten",
    "reply-time",
    "reply-clock",
    "person-rays",
    "arrow-alt-right",
    "right",
    "circle-f",
    "users",
    "face-pleading",
    "eye-slash",
    "flask-vial",
    "police-box",
    "cucumber",
    "head-side-brain",
    "hand-paper",
    "hand",
    "biking-mountain",
    "person-biking-mountain",
    "utensils-slash",
    "print-search",
    "print-magnifying-glass",
    "turn-right",
    "folder-bookmark",
    "arrow-turn-left-down",
    "om",
    "pi",
    "flask-potion",
    "flask-round-potion",
    "face-shush",
    "worm",
    "house-circle-xmark",
    "plug",
    "calendar-circle-exclamation",
    "square-i",
    "chevron-up",
    "face-saluting",
    "tachometer-slow",
    "gauge-simple-low",
    "face-persevering",
    "camera-circle",
    "circle-camera",
    "hand-spock",
    "spider-web",
    "microphone-circle",
    "circle-microphone",
    "book-arrow-up",
    "popsicle",
    "command",
    "blinds",
    "stopwatch",
    "saxophone",
    "square-2",
    "field-hockey",
    "field-hockey-stick-ball",
    "sort-shapes-up-alt",
    "arrow-up-square-triangle",
    "face-scream",
    "square-m",
    "webcam",
    "camera-web",
    "comment-arrow-down",
    "lightbulb-cfl",
    "window-frame-open",
    "kiss",
    "face-kiss",
    "bridge-circle-xmark",
    "period",
    "grin-tongue",
    "face-grin-tongue",
    "up-to-dotted-line",
    "thought-bubble",
    "skeleton-ribs",
    "raygun",
    "flute",
    "acorn",
    "video-arrow-up-right",
    "grate-droplet",
    "seal-exclamation",
    "chess-bishop",
    "message-sms",
    "coffee-beans",
    "hat-witch",
    "grin-wink",
    "face-grin-wink",
    "clock-three-thirty",
    "deaf",
    "deafness",
    "hard-of-hearing",
    "ear-deaf",
    "alarm-clock",
    "eclipse",
    "face-relieved",
    "road-circle-check",
    "dice-five",
    "minus-octagon",
    "octagon-minus",
    "rss-square",
    "square-rss",
    "face-zany",
    "tricycle",
    "land-mine-on",
    "square-arrow-up-left",
    "i-cursor",
    "chart-mixed-up-circle-dollar",
    "salt-shaker",
    "stamp",
    "file-plus",
    "draw-square",
    "toilet-paper-reverse-slash",
    "toilet-paper-under-slash",
    "stairs",
    "drone-alt",
    "drone-front",
    "glass-empty",
    "dial-high",
    "user-construction",
    "user-hard-hat",
    "user-helmet-safety",
    "i",
    "hryvnia",
    "hryvnia-sign",
    "arrow-down-left-and-arrow-up-right-to-center",
    "pills",
    "grin-alt",
    "face-grin-wide",
    "tooth",
    "basketball-hoop",
    "objects-align-bottom",
    "v",
    "sparkles",
    "squid",
    "leafy-green",
    "circle-arrow-up-right",
    "calendars",
    "bangladeshi-taka-sign",
    "bicycle",
    "hammer-war",
    "circle-d",
    "spider-black-widow",
    "rod-asclepius",
    "rod-snake",
    "staff-aesculapius",
    "staff-snake",
    "pear",
    "head-side-cough-slash",
    "file-mov",
    "triangle",
    "apartment",
    "ambulance",
    "truck-medical",
    "pepper",
    "piano",
    "gun-squirt",
    "wheat-awn-circle-exclamation",
    "snowman",
    "user-alien",
    "shield-check",
    "mortar-pestle",
    "road-barrier",
    "chart-candlestick",
    "briefcase-blank",
    "school",
    "igloo",
    "parenthesis",
    "bracket-round",
    "joint",
    "horse-saddle",
    "mug-marshmallows",
    "filters",
    "bell-on",
    "angle-right",
    "dial-med",
    "horse",
    "q",
    "monitor-heart-rate",
    "monitor-waveform",
    "link-simple",
    "whistle",
    "g",
    "fragile",
    "wine-glass-crack",
    "slot-machine",
    "notes-medical",
    "car-wash",
    "escalator",
    "comment-image",
    "temperature-2",
    "thermometer-2",
    "thermometer-half",
    "temperature-half",
    "dong-sign",
    "doughnut",
    "donut",
    "capsules",
    "poo-bolt",
    "poo-storm",
    "tally-1",
    "file-vector",
    "frown-open",
    "face-frown-open",
    "square-dashed",
    "bag-shopping-plus",
    "square-j",
    "hand-point-up",
    "money-bill",
    "sort-size-up",
    "arrow-up-big-small",
    "barcode-read",
    "baguette",
    "bowl-soft-serve",
    "face-holding-back-tears",
    "arrow-alt-square-up",
    "square-up",
    "subway-tunnel",
    "train-subway-tunnel",
    "exclamation-square",
    "square-exclamation",
    "semicolon",
    "bookmark",
    "fan-table",
    "align-justify",
    "battery-1",
    "battery-low",
    "credit-card-front",
    "mind-share",
    "brain-arrow-curved-right",
    "umbrella-beach",
    "helmet-un",
    "map-marker-smile",
    "location-smile",
    "arrow-to-left",
    "arrow-left-to-line",
    "bullseye",
    "nigiri",
    "sushi",
    "comment-alt-captions",
    "message-captions",
    "trash-list",
    "bacon",
    "option",
    "raccoon",
    "hand-point-down",
    "arrow-up-from-bracket",
    "head-side-gear",
    "trash-plus",
    "file-cad",
    "objects-align-top",
    "folder-blank",
    "folder",
    "face-anxious-sweat",
    "credit-card-blank",
    "file-medical-alt",
    "file-waveform",
    "microchip-ai",
    "mug",
    "plane-up-slash",
    "radiation",
    "pen-circle",
    "bag-seedling",
    "chart-simple",
    "crutches",
    "parking-circle",
    "circle-parking",
    "mars-stroke",
    "leaf-oak",
    "square-bolt",
    "vial",
    "dashboard",
    "gauge-med",
    "tachometer-alt-average",
    "gauge",
    "magic-wand-sparkles",
    "wand-magic-sparkles",
    "lambda",
    "e",
    "pizza",
    "bowl-chopsticks-noodles",
    "h3",
    "pen-alt",
    "pen-clip",
    "bridge-circle-exclamation",
    "badge-percent",
    "rotate-reverse",
    "user",
    "sensor",
    "comma",
    "school-circle-check",
    "toilet-paper-reverse",
    "toilet-paper-under",
    "light-emergency",
    "arrow-down-to-arc",
    "dumpster",
    "shuttle-van",
    "van-shuttle",
    "building-user",
    "light-switch",
    "caret-square-left",
    "square-caret-left",
    "highlighter",
    "heart-rate",
    "wave-pulse",
    "key",
    "arrow-left-to-bracket",
    "hat-santa",
    "tamale",
    "box-check",
    "bullhorn",
    "steak",
    "location-slash",
    "location-crosshairs-slash",
    "person-dolly",
    "globe",
    "synagogue",
    "file-chart-line",
    "file-chart-column",
    "person-half-dress",
    "folder-image",
    "calendar-edit",
    "calendar-pen",
    "road-bridge",
    "face-smile-tear",
    "comment-alt-plus",
    "message-plus",
    "location-arrow",
    "c",
    "tablet-button",
    "person-dress-fairy",
    "rectangle-history-circle-user",
    "building-lock",
    "chart-line-up",
    "mailbox",
    "sign-posts",
    "truck-bolt",
    "pizza-slice",
    "money-bill-wave",
    "area-chart",
    "chart-area",
    "house-flag",
    "circle-three-quarters-stroke",
    "person-circle-minus",
    "scalpel",
    "cancel",
    "ban",
    "bell-exclamation",
    "bookmark-circle",
    "circle-bookmark",
    "egg-fried",
    "face-weary",
    "uniform-martial-arts",
    "camera-rotate",
    "sun-dust",
    "comment-text",
    "air-freshener",
    "spray-can-sparkles",
    "signal-alt",
    "signal-alt-4",
    "signal-bars-strong",
    "signal-bars",
    "diamond-exclamation",
    "star",
    "dial-min",
    "repeat",
    "cross",
    "file-caret-down",
    "page-caret-down",
    "box",
    "venus-mars",
    "clock-seven-thirty",
    "mouse-pointer",
    "arrow-pointer",
    "clock-four-thirty",
    "signal-alt-3",
    "signal-bars-good",
    "cactus",
    "lightbulb-gear",
    "expand-arrows-alt",
    "maximize",
    "charging-station",
    "triangle-circle-square",
    "shapes",
    "plane-tail",
    "tachometer-fastest",
    "gauge-simple-max",
    "circle-u",
    "shield-slash",
    "phone-square-down",
    "square-phone-hangup",
    "arrow-up-left",
    "transporter-1",
    "peanuts",
    "random",
    "shuffle",
    "running",
    "person-running",
    "mobile-retro",
    "grip-lines-vertical",
    "bin-bottles-recycle",
    "arrow-up-from-square",
    "page-break",
    "file-dashed-line",
    "bracket-curly-right",
    "spider",
    "clock-three",
    "hands-bound",
    "scalpel-path",
    "scalpel-line-dashed",
    "file-invoice-dollar",
    "pipe-smoking",
    "face-astonished",
    "window",
    "plane-circle-exclamation",
    "ear",
    "file-lock",
    "diagram-venn",
    "arrow-down-from-bracket",
    "x-ray",
    "goal-net",
    "coffin-cross",
    "spell-check",
    "map-marker-times",
    "map-marker-xmark",
    "location-xmark",
    "circle-quarter-stroke",
    "lasso",
    "slash",
    "portal-enter",
    "person-to-portal",
    "calendar-star",
    "mouse",
    "computer-mouse",
    "sign-in",
    "arrow-right-to-bracket",
    "pegasus",
    "files-medical",
    "cannon",
    "nfc-lock",
    "ski-lift",
    "person-ski-lift",
    "square-6",
    "store-alt-slash",
    "shop-slash",
    "wind-turbine",
    "sliders-simple",
    "grid-round",
    "badge-sheriff",
    "server",
    "virus-covid-slash",
    "intersection",
    "shop-lock",
    "family",
    "hourglass-1",
    "hourglass-start",
    "user-hair-buns",
    "blender-phone",
    "hourglass-clock",
    "person-seat-reclined",
    "paper-plane-alt",
    "send",
    "paper-plane-top",
    "comment-alt-arrow-up",
    "message-arrow-up",
    "lightbulb-exclamation",
    "layer-group-minus",
    "layer-minus",
    "chart-pie-simple-circle-currency",
    "circle-e",
    "building-wheat",
    "tachometer-alt-fastest",
    "gauge-max",
    "person-breastfeeding",
    "apostrophe",
    "file-png",
    "fire-hydrant",
    "sign-in-alt",
    "right-to-bracket",
    "video-plus",
    "arrow-alt-square-right",
    "square-right",
    "comment-smile",
    "venus",
    "passport",
    "inbox-arrow-down",
    "inbox-in",
    "heartbeat",
    "heart-pulse",
    "circle-8",
    "clouds-moon",
    "clock-ten-thirty",
    "people-carry",
    "people-carry-box",
    "folder-user",
    "trash-can-xmark",
    "temperature-high",
    "microchip",
    "left-long-to-line",
    "crown",
    "weight-hanging",
    "xmarks-lines",
    "file-prescription",
    "table-cells-lock",
    "calendar-range",
    "flower-daffodil",
    "hand-back-point-up",
    "weight",
    "weight-scale",
    "arrow-up-to-arc",
    "star-exclamation",
    "books",
    "user-friends",
    "user-group",
    "sort-alpha-up",
    "arrow-up-a-z",
    "layer-group-plus",
    "layer-plus",
    "play-pause",
    "block-question",
    "zzz",
    "snooze",
    "scanner-image",
    "tv-retro",
    "square-t",
    "barn-silo",
    "farm",
    "chess-knight",
    "bars-sort",
    "palette-boxes",
    "pallet-alt",
    "pallet-boxes",
    "laugh-squint",
    "face-laugh-squint",
    "code-simple",
    "bolt-slash",
    "panel-fire",
    "binary-circle-check",
    "comment-minus",
    "burrito",
    "violin",
    "objects-column",
    "chevron-square-down",
    "square-chevron-down",
    "comment-plus",
    "triangle-music",
    "triangle-instrument",
    "wheelchair",
    "user-pilot-tie",
    "piano-keyboard",
    "bed-empty",
    "arrow-circle-up",
    "circle-arrow-up",
    "toggle-on",
    "rectangle-portrait",
    "rectangle-vertical",
    "walking",
    "person-walking",
    "l",
    "signal-stream",
    "down-to-bracket",
    "circle-z",
    "stars",
    "fire",
    "procedures",
    "bed-pulse",
    "house-day",
    "space-shuttle",
    "shuttle-space",
    "shirt-long-sleeve",
    "chart-pie-alt",
    "chart-pie-simple",
    "laugh",
    "face-laugh",
    "folder-open",
    "album-collection-circle-user",
    "candy",
    "soup",
    "bowl-hot",
    "flatbread",
    "heart-circle-plus",
    "code-fork",
    "city",
    "signal-alt-1",
    "signal-bars-weak",
    "microphone-alt",
    "microphone-lines",
    "clock-twelve",
    "pepper-hot",
    "citrus-slice",
    "sheep",
    "unlock",
    "colon-sign",
    "headset",
    "badger-honey",
    "h4",
    "store-slash",
    "road-circle-xmark",
    "signal-slash",
    "user-minus",
    "mars-stroke-v",
    "mars-stroke-up",
    "glass-cheers",
    "champagne-glasses",
    "taco",
    "plus-hexagon",
    "hexagon-plus",
    "clipboard",
    "house-circle-exclamation",
    "file-upload",
    "file-arrow-up",
    "wifi-3",
    "wifi-strong",
    "wifi",
    "comments-alt",
    "messages",
    "bathtub",
    "bath",
    "umbrella-alt",
    "umbrella-simple",
    "rectangle-history-circle-plus",
    "underline",
    "prescription-bottle-pill",
    "user-edit",
    "user-pen",
    "binary-slash",
    "square-o",
    "caduceus",
    "signature",
    "stroopwafel",
    "bold",
    "anchor-lock",
    "building-ngo",
    "transporter-3",
    "engine-exclamation",
    "engine-warning",
    "circle-down-right",
    "square-k",
    "manat-sign",
    "money-check-edit",
    "money-check-pen",
    "not-equal",
    "border-style",
    "border-top-left",
    "map-marked-alt",
    "map-location-dot",
    "tilde",
    "jedi",
    "poll",
    "square-poll-vertical",
    "sort-shapes-down-alt",
    "arrow-down-square-triangle",
    "mug-hot",
    "dog-leashed",
    "battery-car",
    "car-battery",
    "face-downcast-sweat",
    "mailbox-flag-up",
    "memo-circle-info",
    "gift",
    "dice-two",
    "volume-medium",
    "volume",
    "transporter-5",
    "gauge-circle-bolt",
    "coin-front",
    "file-slash",
    "message-arrow-up-right",
    "treasure-chest",
    "chess-queen",
    "paint-brush-alt",
    "paint-brush-fine",
    "paintbrush-alt",
    "paintbrush-fine",
    "glasses",
    "hood-cloak",
    "square-quote",
    "up-left",
    "bring-front",
    "chess-board",
    "cheeseburger",
    "burger-cheese",
    "building-circle-check",
    "repeat-1",
    "arrow-to-bottom",
    "arrow-down-to-line",
    "grid-5",
    "swap-arrows",
    "right-long-to-line",
    "person-chalkboard",
    "mars-stroke-h",
    "mars-stroke-right",
    "hand-rock",
    "hand-back-fist",
    "grid-round-5",
    "tally-5",
    "tally",
    "caret-square-up",
    "square-caret-up",
    "cloud-showers-water",
    "bar-chart",
    "chart-bar",
    "hands-wash",
    "hands-bubbles",
    "less-than-equal",
    "train",
    "up-from-dotted-line",
    "low-vision",
    "eye-low-vision",
    "traffic-light-go",
    "face-exhaling",
    "sensor-fire",
    "user-unlock",
    "hexagon-divide",
    "00",
    "crow",
    "betamax",
    "cassette-betamax",
    "sailboat",
    "window-restore",
    "nfc-magnifying-glass",
    "file-binary",
    "circle-v",
    "plus-square",
    "square-plus",
    "bowl-scoops",
    "mistletoe",
    "custard",
    "lacrosse-stick",
    "hockey-mask",
    "sunrise",
    "subtitles",
    "panel-ews",
    "torii-gate",
    "cloud-exclamation",
    "comment-alt-lines",
    "message-lines",
    "frog",
    "bucket",
    "floppy-disk-pen",
    "image",
    "window-frame",
    "microphone",
    "cow",
    "file-zip",
    "square-ring",
    "arrow-alt-from-top",
    "down-from-line",
    "caret-up",
    "shield-times",
    "shield-xmark",
    "screwdriver",
    "sort-circle-down",
    "circle-sort-down",
    "folder-closed",
    "house-tsunami",
    "square-nfi",
    "forklift",
    "arrow-up-from-ground-water",
    "bracket-square-right",
    "glass-martini-alt",
    "martini-glass",
    "rotate-back",
    "rotate-backward",
    "undo-alt",
    "rotate-left",
    "columns",
    "table-columns",
    "square-a",
    "tick",
    "lemon",
    "head-side-mask",
    "handshake",
    "gem",
    "dolly-box",
    "dolly",
    "smoking",
    "compress-arrows-alt",
    "minimize",
    "refrigerator",
    "monument",
    "times-octagon",
    "xmark-octagon",
    "octagon-xmark",
    "align-slash",
    "snowplow",
    "angle-double-right",
    "angles-right",
    "truck-couch",
    "truck-ramp-couch",
    "cannabis",
    "play-circle",
    "circle-play",
    "arrow-up-right-and-arrow-down-left-from-center",
    "location-arrow-up",
    "tablets",
    "360-degrees",
    "ethernet",
    "eur",
    "euro",
    "euro-sign",
    "chair",
    "check-circle",
    "circle-check",
    "square-dashed-circle-plus",
    "hand-holding-circle-dollar",
    "money-simple-from-bracket",
    "bat",
    "stop-circle",
    "circle-stop",
    "head-side-headphones",
    "phone-rotary",
    "arrow-up-to-bracket",
    "drafting-compass",
    "compass-drafting",
    "plate-wheat",
    "calendar-circle-minus",
    "chopsticks",
    "car-mechanic",
    "car-wrench",
    "icicles",
    "person-shelter",
    "neuter",
    "id-badge",
    "kazoo",
    "marker",
    "bin-bottles",
    "laugh-beam",
    "face-laugh-beam",
    "square-arrow-down-left",
    "battery-bolt",
    "tree-large",
    "helicopter-symbol",
    "aperture",
    "universal-access",
    "gear-complex",
    "file-search",
    "file-magnifying-glass",
    "up-right",
    "chevron-circle-up",
    "circle-chevron-up",
    "user-police",
    "lari-sign",
    "volcano",
    "teddy-bear",
    "stocking",
    "person-walking-dashed-line-arrow-right",
    "image-slash",
    "mask-snorkel",
    "smoke",
    "gbp",
    "pound-sign",
    "sterling-sign",
    "battery-exclamation",
    "viruses",
    "square-person-confined",
    "user-tie",
    "up-to-bracket",
    "long-arrow-down",
    "arrow-down-long",
    "tent-arrow-down-to-line",
    "certificate",
    "crystal-ball",
    "mail-reply-all",
    "reply-all",
    "suitcase",
    "skating",
    "person-skating",
    "star-shooting",
    "binary-lock",
    "funnel-dollar",
    "filter-circle-dollar",
    "camera-retro",
    "arrow-circle-down",
    "circle-arrow-down",
    "comment-edit",
    "comment-pen",
    "arrow-right-to-file",
    "file-import",
    "banjo",
    "external-link-square",
    "square-arrow-up-right",
    "light-emergency-on",
    "kerning",
    "box-open",
    "square-f",
    "scroll",
    "spa",
    "arrow-from-right",
    "arrow-left-from-line",
    "strawberry",
    "location-pin-lock",
    "pause",
    "clock-eight-thirty",
    "plane-alt",
    "plane-engines",
    "hill-avalanche",
    "temperature-0",
    "thermometer-0",
    "thermometer-empty",
    "temperature-empty",
    "bomb",
    "tachometer-alt-slow",
    "gauge-low",
    "registered",
    "trash-can-plus",
    "contact-card",
    "vcard",
    "address-card",
    "balance-scale-right",
    "scale-unbalanced-flip",
    "globe-snow",
    "subscript",
    "directions",
    "diamond-turn-right",
    "integral",
    "burst",
    "laptop-house",
    "house-laptop",
    "tired",
    "face-tired",
    "money-bills",
    "blinds-raised",
    "smog",
    "ufo-beam",
    "caret-circle-up",
    "circle-caret-up",
    "user-vneck-hair-long",
    "square-a-lock",
    "crutch",
    "gas-pump-slash",
    "font-awesome-flag",
    "font-awesome-logo-full",
    "font-awesome",
    "cloud-upload",
    "cloud-upload-alt",
    "cloud-arrow-up",
    "palette",
    "transporter-4",
    "chart-mixed-up-circle-currency",
    "objects-align-right",
    "arrows-turn-right",
    "vest",
    "pig",
    "inbox-full",
    "envelope-circle",
    "circle-envelope",
    "construction",
    "triangle-person-digging",
    "ferry",
    "bullseye-arrow",
    "arrows-down-to-people",
    "sprout",
    "seedling",
    "clock-seven",
    "arrows-alt-h",
    "left-right",
    "boxes-packing",
    "arrow-circle-left",
    "circle-arrow-left",
    "flashlight",
    "file-jpg",
    "group-arrows-rotate",
    "bowl-food",
    "square-9",
    "candy-cane",
    "sort-amount-asc",
    "sort-amount-down",
    "arrow-down-wide-short",
    "dollar-square",
    "usd-square",
    "square-dollar",
    "phone-arrow-right",
    "hand-holding-seedling",
    "comment-alt-check",
    "message-check",
    "thunderstorm",
    "cloud-bolt",
    "chart-line-up-down",
    "remove-format",
    "text-slash",
    "watch",
    "circle-down-left",
    "text",
    "projector",
    "smile-wink",
    "face-smile-wink",
    "tombstone-alt",
    "tombstone-blank",
    "chess-king-alt",
    "chess-king-piece",
    "circle-6",
    "waves-sine",
    "arrow-alt-left",
    "left",
    "file-word",
    "file-powerpoint",
    "arrow-alt-square-down",
    "square-down",
    "objects-align-center-vertical",
    "arrows-h",
    "arrows-left-right",
    "house-lock",
    "cloud-download",
    "cloud-download-alt",
    "cloud-arrow-down",
    "wreath",
    "children",
    "meter-droplet",
    "blackboard",
    "chalkboard",
    "user-alt-slash",
    "user-large-slash",
    "signal-4",
    "signal-strong",
    "lollypop",
    "lollipop",
    "list-tree",
    "envelope-open",
    "draw-circle",
    "cat-space",
    "handshake-alt-slash",
    "handshake-simple-slash",
    "rabbit-fast",
    "rabbit-running",
    "memo-pad",
    "mattress-pillow",
    "alarm-plus",
    "alicorn",
    "comment-question",
    "gingerbread-man",
    "guarani-sign",
    "burger-fries",
    "mug-tea",
    "border-top",
    "refresh",
    "sync",
    "arrows-rotate",
    "book-circle",
    "circle-book-open",
    "arrows-to-dotted-line",
    "fire-extinguisher",
    "magnifying-glass-arrows-rotate",
    "garage-open",
    "shelves-empty",
    "cruzeiro-sign",
    "watch-apple",
    "watch-calculator",
    "list-dropdown",
    "cabinet-filing",
    "burger-soda",
    "arrow-square-up",
    "square-arrow-up",
    "greater-than-equal",
    "pallet-box",
    "face-confounded",
    "shield-alt",
    "shield-halved",
    "truck-plow",
    "atlas",
    "book-atlas",
    "virus",
    "grid-round-2",
    "comment-middle-top",
    "wave",
    "envelope-circle-check",
    "layer-group",
    "restroom-simple",
    "arrows-to-dot",
    "border-outer",
    "hashtag-lock",
    "clock-two-thirty",
    "archway",
    "heart-circle-check",
    "house-damage",
    "house-chimney-crack",
    "file-archive",
    "file-zipper",
    "ticket-perforated",
    "heart-half",
    "comment-check",
    "square",
    "memo",
    "glass-martini",
    "martini-glass-empty",
    "couch",
    "cedi-sign",
    "italic",
    "glass-citrus",
    "calendar-lines-pen",
    "table-cells-column-lock",
    "church",
    "snowmobile",
    "person-snowmobiling",
    "face-hushed",
    "comments-dollar",
    "tickets-simple",
    "pickaxe",
    "link-simple-slash",
    "democrat",
    "face-confused",
    "pinball",
    "z",
    "skiing",
    "person-skiing",
    "deer",
    "input-pipe",
    "road-lock",
    "a",
    "bookmark-slash",
    "temperature-down",
    "temperature-arrow-down",
    "mace",
    "feather-alt",
    "feather-pointed",
    "sausage",
    "trash-can-clock",
    "p",
    "broom-wide",
    "snowflake",
    "stomach",
    "newspaper",
    "ad",
    "rectangle-ad",
    "guitar-electric",
    "arrow-turn-down-right",
    "moon-cloud",
    "bread-slice-butter",
    "arrow-circle-right",
    "circle-arrow-right",
    "users-crown",
    "user-group-crown",
    "circle-i",
    "toilet-paper-check",
    "filter-circle-xmark",
    "locust",
    "unsorted",
    "sort",
    "list-1-2",
    "list-numeric",
    "list-ol",
    "chart-waterfall",
    "sparkle",
    "face-party",
    "kidneys",
    "wifi-exclamation",
    "chart-network",
    "person-dress-burst",
    "dice-d4",
    "money-check-alt",
    "money-check-dollar",
    "vector-square",
    "bread-slice",
    "language",
    "wheat-awn-slash",
    "kiss-wink-heart",
    "face-kiss-wink-heart",
    "dagger",
    "podium",
    "memo-circle-check",
    "route-highway",
    "arrow-alt-to-bottom",
    "down-to-line",
    "filter",
    "square-g",
    "phone-circle",
    "circle-phone",
    "clipboard-prescription",
    "user-nurse-hair",
    "question",
    "file-signature",
    "toggle-large-on",
    "arrows-alt",
    "up-down-left-right",
    "dryer-alt",
    "dryer-heat",
    "house-chimney-user",
    "hand-holding-heart",
    "sort-size-up-alt",
    "arrow-up-small-big",
    "train-track",
    "puzzle-piece",
    "money-check",
    "star-half-alt",
    "star-half-stroke",
    "file-exclamation",
    "code",
    "glass-whiskey",
    "whiskey-glass",
    "moon-stars",
    "building-circle-exclamation",
    "clothes-hanger",
    "mobile-iphone",
    "mobile-notch",
    "magnifying-glass-chart",
    "external-link",
    "arrow-up-right-from-square",
    "cubes-stacked",
    "images-user",
    "krw",
    "won",
    "won-sign",
    "image-polaroid-user",
    "virus-covid",
    "square-ellipsis",
    "pie",
    "chess-knight-alt",
    "chess-knight-piece",
    "austral-sign",
    "cloud-plus",
    "f",
    "leaf",
    "bed-bunk",
    "road",
    "cab",
    "taxi",
    "person-circle-plus",
    "pie-chart",
    "chart-pie",
    "bolt-lightning",
    "clock-eight",
    "sack-xmark",
    "file-xls",
    "file-excel",
    "file-contract",
    "fish-fins",
    "circle-q",
    "building-flag",
    "grin-beam",
    "face-grin-beam",
    "object-ungroup",
    "face-disguise",
    "circle-arrow-down-right",
    "alien-monster",
    "alien-8bit",
    "hand-point-ribbon",
    "poop",
    "object-exclude",
    "telescope",
    "map-marker",
    "location-pin",
    "square-list",
    "kaaba",
    "toilet-paper",
    "hard-hat",
    "hat-hard",
    "helmet-safety",
    "comment-code",
    "sim-cards",
    "starship",
    "eject",
    "arrow-alt-circle-right",
    "circle-right",
    "plane-circle-check",
    "seal",
    "user-cowboy",
    "hexagon-vertical-nft",
    "meh-rolling-eyes",
    "face-rolling-eyes",
    "bread-loaf",
    "rings-wedding",
    "object-group",
    "french-fries",
    "line-chart",
    "chart-line",
    "calendar-download",
    "calendar-arrow-down",
    "send-back",
    "mask-ventilator",
    "tickets",
    "signature-lock",
    "arrow-right",
    "map-signs",
    "signs-post",
    "plus-octagon",
    "octagon-plus",
    "cash-register",
    "person-circle-question",
    "melon-slice",
    "space-station-moon",
    "comment-alt-smile",
    "message-smile",
    "cup-straw",
    "arrow-alt-from-right",
    "left-from-line",
    "h",
    "shopping-basket-alt",
    "basket-shopping-simple",
    "hands-heart",
    "hands-holding-heart",
    "clock-nine",
    "hammer-brush",
    "tarp",
    "face-sleepy",
    "hand-horns",
    "tools",
    "screwdriver-wrench",
    "arrows-to-eye",
    "circle-three-quarters",
    "trophy-alt",
    "trophy-star",
    "plug-circle-bolt",
    "face-thermometer",
    "grid-round-4",
    "sign-posts-wrench",
    "shirt-running",
    "book-circle-arrow-up",
    "face-nauseated",
    "heart",
    "file-chart-pie",
    "mars-and-venus",
    "home-user",
    "house-user",
    "circle-arrow-down-left",
    "dumpster-fire",
    "minus-hexagon",
    "hexagon-minus",
    "arrow-alt-to-left",
    "left-to-line",
    "house-crack",
    "paw-alt",
    "paw-simple",
    "arrow-left-long-to-line",
    "parentheses",
    "brackets-round",
    "cocktail",
    "martini-glass-citrus",
    "user-shakespeare",
    "arrow-right-to-arc",
    "surprise",
    "face-surprise",
    "bottle-water",
    "pause-circle",
    "circle-pause",
    "gauge-circle-plus",
    "folders",
    "angel",
    "value-absolute",
    "rabbit",
    "toilet-paper-slash",
    "circle-euro",
    "apple-alt",
    "apple-whole",
    "kitchen-set",
    "diamond-half",
    "lock-alt",
    "lock-keyhole",
    "r",
    "temperature-1",
    "thermometer-1",
    "thermometer-quarter",
    "temperature-quarter",
    "info-square",
    "square-info",
    "wifi-slash",
    "toilet-paper-xmark",
    "hands-usd",
    "hands-holding-dollar",
    "cube",
    "sort-shapes-down",
    "arrow-down-triangle-square",
    "bitcoin-sign",
    "shutters",
    "shield-dog",
    "solar-panel",
    "lock-open",
    "table-tree",
    "house-chimney-heart",
    "tally-3",
    "elevator",
    "money-bill-transfer",
    "money-bill-trend-up",
    "house-flood-water-circle-arrow-right",
    "poll-h",
    "square-poll-horizontal",
    "circle",
    "left-to-bracket",
    "cart-circle-exclamation",
    "sword",
    "fast-backward",
    "backward-fast",
    "recycle",
    "user-astronaut",
    "interrobang",
    "plane-slash",
    "circle-dashed",
    "trademark",
    "basketball-ball",
    "basketball",
    "utensils-alt",
    "fork-knife",
    "satellite-dish",
    "badge-check",
    "arrow-alt-circle-up",
    "circle-up",
    "slider",
    "mobile-alt",
    "mobile-screen-button",
    "clock-one-thirty",
    "inbox-arrow-up",
    "inbox-out",
    "cloud-slash",
    "volume-up",
    "volume-high",
    "users-rays",
    "wallet",
    "octagon-check",
    "flatbread-stuffed",
    "clipboard-check",
    "cart-circle-plus",
    "shipping-timed",
    "truck-clock",
    "pool-8-ball",
    "file-audio",
    "turn-down-left",
    "lock-hashtag",
    "chart-radar",
    "staff",
    "hamburger",
    "burger",
    "utility-pole",
    "transporter-6",
    "arrow-turn-left",
    "wrench",
    "bugs",
    "vector-polygon",
    "diagram-nested",
    "rupee",
    "rupee-sign",
    "file-image",
    "question-circle",
    "circle-question",
    "tickets-perforated",
    "image-user",
    "buoy",
    "plane-departure",
    "handshake-slash",
    "book-bookmark",
    "border-center-h",
    "can-food",
    "typewriter",
    "arrow-right-from-arc",
    "circle-k",
    "face-hand-over-mouth",
    "popcorn",
    "house-flood",
    "house-water",
    "object-subtract",
    "code-branch",
    "warehouse-alt",
    "warehouse-full",
    "hat-cowboy",
    "bridge",
    "phone-alt",
    "phone-flip",
    "arrow-down-from-dotted-line",
    "file-doc",
    "square-quarters",
    "truck-front",
    "cat",
    "trash-xmark",
    "caret-circle-left",
    "circle-caret-left",
    "files",
    "anchor-circle-exclamation",
    "face-clouds",
    "user-crown",
    "basket-shopping-plus",
    "truck-field",
    "route",
    "cart-circle-check",
    "clipboard-question",
    "panorama",
    "comment-medical",
    "teeth-open",
    "user-tie-hair-long",
    "file-circle-minus",
    "head-side-medical",
    "arrow-turn-right",
    "tags",
    "wine-glass",
    "fast-forward",
    "forward-fast",
    "meh-blank",
    "face-meh-blank",
    "user-robot",
    "parking",
    "square-parking",
    "card-diamond",
    "face-zipper",
    "face-raised-eyebrow",
    "house-signal",
    "chevron-square-up",
    "square-chevron-up",
    "nfc-symbol",
    "tasks-alt",
    "bars-progress",
    "faucet-drip",
    "arrows-to-line",
    "dolphin",
    "arrow-up-right",
    "circle-r",
    "dolly-flatbed",
    "cart-flatbed",
    "smoking-ban",
    "ban-smoking",
    "sort-circle-up",
    "circle-sort-up",
    "terminal",
    "mobile-button",
    "house-medical-flag",
    "shopping-basket",
    "basket-shopping",
    "tape",
    "chestnut",
    "bus-alt",
    "bus-simple",
    "eye",
    "sad-cry",
    "face-sad-cry",
    "heat",
    "ticket-perforated-plane",
    "ticket-plane",
    "ticket-airline",
    "boot-heeled",
    "compress-arrows",
    "arrows-minimize",
    "audio-description",
    "person-military-to-person",
    "file-shield",
    "hexagon",
    "manhole",
    "user-slash",
    "pen",
    "tower-observation",
    "floppy-disks",
    "toilet-paper-reverse-alt",
    "toilet-paper-blank-under",
    "file-code",
    "signal-5",
    "signal-perfect",
    "signal",
    "pump",
    "bus",
    "heart-circle-xmark",
    "arrow-up-left-from-circle",
    "home-lg",
    "house-chimney",
    "window-maximize",
    "dryer",
    "frown",
    "face-frown",
    "chess-bishop-alt",
    "chess-bishop-piece",
    "shirt-tank-top",
    "scroll-ribbon",
    "diploma",
    "screencast",
    "walker",
    "prescription",
    "store-alt",
    "shop",
    "save",
    "floppy-disk",
    "vihara",
    "face-kiss-closed-eyes",
    "balance-scale-left",
    "scale-unbalanced",
    "file-user",
    "user-police-tie",
    "face-tongue-money",
    "tennis-ball",
    "square-l",
    "sort-asc",
    "sort-up",
    "calendar-upload",
    "calendar-arrow-up",
    "commenting",
    "comment-dots",
    "plant-wilt",
    "scarf",
    "album-circle-plus",
    "user-nurse-hair-long",
    "diamond",
    "arrow-alt-square-left",
    "square-left",
    "grin-squint",
    "face-grin-squint",
    "circle-ellipsis-vertical",
    "hand-holding-usd",
    "hand-holding-dollar",
    "grid-dividers",
    "bacterium",
    "hand-pointer",
    "drum-steelpan",
    "hand-scissors",
    "praying-hands",
    "hands-praying",
    "face-pensive",
    "user-music",
    "arrow-right-rotate",
    "arrow-rotate-forward",
    "redo",
    "arrow-rotate-right",
    "comments-alt-dollar",
    "messages-dollar",
    "sensor-on",
    "balloon",
    "web-awesome",
    "biohazard",
    "chess-queen-alt",
    "chess-queen-piece",
    "location",
    "location-crosshairs",
    "mars-double",
    "left-from-bracket",
    "house-leave",
    "house-person-depart",
    "house-person-leave",
    "ruler-triangle",
    "card-club",
    "child-dress",
    "users-between-lines",
    "lungs-virus",
    "spinner-third",
    "grin-tears",
    "face-grin-tears",
    "phone",
    "mouse-alt",
    "computer-mouse-scrollwheel",
    "calendar-times",
    "calendar-xmark",
    "child-reaching",
    "table-layout",
    "narwhal",
    "ramp-loading",
    "calendar-circle-plus",
    "toothbrush",
    "border-inner",
    "paw-claws",
    "kiwi-fruit",
    "traffic-light-slow",
    "rectangle-code",
    "head-side-virus",
    "keyboard-brightness",
    "books-medical",
    "lightbulb-slash",
    "home-blank",
    "house-blank",
    "square-5",
    "heart-square",
    "square-heart",
    "puzzle",
    "user-cog",
    "user-gear",
    "pipe-circle-check",
    "sort-numeric-up",
    "arrow-up-1-9",
    "octagon-exclamation",
    "dial-low",
    "door-closed",
    "phone-laptop",
    "laptop-mobile",
    "conveyor-belt-alt",
    "conveyor-belt-boxes",
    "shield-virus",
    "starfighter-alt-advanced",
    "starfighter-twin-ion-engine-advanced",
    "dice-six",
    "starfighter-alt",
    "starfighter-twin-ion-engine",
    "rocket-launch",
    "mosquito-net",
    "vent-damper",
    "bridge-water",
    "debug",
    "ban-bug",
    "person-booth",
    "text-width",
    "garage-car",
    "square-kanban",
    "hat-wizard",
    "chart-kanban",
    "pen-fancy",
    "coffee-pot",
    "mouse-field",
    "digging",
    "person-digging",
    "shower-alt",
    "shower-down",
    "box-circle-check",
    "brightness",
    "car-side-bolt",
    "file-xml",
    "ornament",
    "phone-arrow-down",
    "phone-incoming",
    "phone-arrow-down-left",
    "cloud-word",
    "hand-fingers-crossed",
    "trash",
    "gauge-simple-med",
    "tachometer-average",
    "gauge-simple",
    "sort-size-down-alt",
    "arrow-down-small-big",
    "book-medical",
    "face-melting",
    "poo",
    "pen-alt-slash",
    "pen-clip-slash",
    "quote-right-alt",
    "quote-right",
    "scroll-old",
    "guitars",
    "phone-xmark",
    "hose",
    "clock-six",
    "t-shirt",
    "tshirt",
    "shirt",
    "billboard",
    "square-r",
    "cubes",
    "envelope-open-dollar",
    "divide",
    "sun-cloud",
    "lamp-floor",
    "square-7",
    "tenge",
    "tenge-sign",
    "headphones",
    "hands-holding",
    "campfire",
    "circle-ampersand",
    "snowflakes",
    "hands-clapping",
    "republican",
    "leaf-maple",
    "arrow-left",
    "person-circle-xmark",
    "ruler",
    "arrow-left-from-bracket",
    "cup-straw-swoosh",
    "temperature-hot",
    "temperature-sun",
    "align-left",
    "dice-d6",
    "restroom",
    "rectangle-hd",
    "high-definition",
    "j",
    "galaxy",
    "users-viewfinder",
    "file-video",
    "cherries",
    "external-link-alt",
    "up-right-from-square",
    "sort-circle",
    "circle-sort",
    "th",
    "table-cells",
    "bag-shopping-minus",
    "file-pdf",
    "siren",
    "arrow-up-to-dotted-line",
    "landscape",
    "image-landscape",
    "tank-water",
    "curling",
    "curling-stone",
    "gamepad-alt",
    "gamepad-modern",
    "messages-question",
    "bible",
    "book-bible",
    "o",
    "medkit",
    "suitcase-medical",
    "briefcase-arrow-right",
    "expand-wide",
    "clock-eleven-thirty",
    "rv",
    "user-secret",
    "otter",
    "dreidel",
    "female",
    "person-dress",
    "comment-dollar",
    "briefcase-clock",
    "business-time",
    "flower-tulip",
    "people-pants-simple",
    "cloud-drizzle",
    "th-large",
    "table-cells-large",
    "tanakh",
    "book-tanakh",
    "solar-system",
    "seal-question",
    "volume-control-phone",
    "phone-volume",
    "disc-drive",
    "hat-cowboy-side",
    "rows",
    "table-rows",
    "map-marker-exclamation",
    "location-exclamation",
    "face-fearful",
    "clipboard-user",
    "bus-school",
    "film-slash",
    "square-arrow-down-right",
    "book-spells",
    "book-sparkles",
    "washer",
    "washing-machine",
    "child",
    "lira-sign",
    "user-visor",
    "file-plus-minus",
    "chess-clock-alt",
    "chess-clock-flip",
    "satellite",
    "truck-fire",
    "plane-lock",
    "steering-wheel",
    "tag",
    "stretcher",
    "book-law",
    "book-section",
    "inboxes",
    "coffee-bean",
    "circle-yen",
    "brackets-curly",
    "ellipsis-v-alt",
    "ellipsis-stroke-vertical",
    "comment",
    "square-1",
    "birthday-cake",
    "cake",
    "cake-candles",
    "head-side",
    "truck-ladder",
    "envelope",
    "dolly-empty",
    "face-tissue",
    "angle-double-up",
    "angles-up",
    "bin-recycle",
    "paperclip",
    "chart-line-down",
    "arrow-right-to-city",
    "lock-a",
    "ribbon",
    "lungs",
    "person-pinball",
    "sort-numeric-up-alt",
    "arrow-up-9-1",
    "apple-core",
    "circle-y",
    "h6",
    "litecoin-sign",
    "bottle-baby",
    "circle-small",
    "border-none",
    "arrow-turn-down-left",
    "circle-wifi-group",
    "circle-wifi-circle-wifi",
    "circle-nodes",
    "parachute-box",
    "reflect-horizontal",
    "comment-alt-medical",
    "message-medical",
    "rugby-ball",
    "comment-music",
    "indent",
    "tree-alt",
    "tree-deciduous",
    "puzzle-piece-alt",
    "puzzle-piece-simple",
    "truck-field-un",
    "nfc-trash",
    "hourglass-empty",
    "hourglass",
    "mountain",
    "file-times",
    "file-xmark",
    "home-heart",
    "house-heart",
    "house-chimney-blank",
    "meter-bolt",
    "user-md",
    "user-doctor",
    "slash-back",
    "info-circle",
    "circle-info",
    "fishing-rod",
    "hammer-crash",
    "message-heart",
    "cloud-meatball",
    "camera-polaroid",
    "camera-alt",
    "camera",
    "square-virus",
    "cart-arrow-up",
    "meteor",
    "car-on",
    "sleigh",
    "sort-numeric-asc",
    "sort-numeric-down",
    "arrow-down-1-9",
    "buoy-mooring",
    "square-4",
    "hand-holding-water",
    "hand-holding-droplet",
    "file-eps",
    "tricycle-adult",
    "waveform",
    "water",
    "star-sharp-half-alt",
    "star-sharp-half-stroke",
    "nfc-signal",
    "plane-prop",
    "calendar-check",
    "clock-desk",
    "calendar-time",
    "calendar-clock",
    "braille",
    "prescription-bottle-alt",
    "prescription-bottle-medical",
    "plate-utensils",
    "family-pants",
    "hose-reel",
    "house-window",
    "landmark",
    "truck",
    "music-magnifying-glass",
    "crosshairs",
    "cloud-rainbow",
    "person-cane",
    "alien",
    "tent",
    "laptop-binary",
    "vest-patches",
    "people-dress-simple",
    "check-double",
    "sort-alpha-asc",
    "sort-alpha-down",
    "arrow-down-a-z",
    "bowling-ball-pin",
    "bell-school-slash",
    "plus-large",
    "money-bill-wheat",
    "screenshot",
    "camera-viewfinder",
    "comment-alt-music",
    "message-music",
    "car-building",
    "border-style-alt",
    "border-bottom-right",
    "octagon",
    "comment-arrow-up-right",
    "octagon-divide",
    "cookie",
    "arrow-left-rotate",
    "arrow-rotate-back",
    "arrow-rotate-backward",
    "undo",
    "arrow-rotate-left",
    "tv-music",
    "hdd",
    "hard-drive",
    "reel",
    "grin-squint-tears",
    "face-grin-squint-tears",
    "dumbbell",
    "list-alt",
    "rectangle-list",
    "tarp-droplet",
    "alarm-exclamation",
    "house-medical-circle-check",
    "traffic-cone",
    "grate",
    "arrow-down-right",
    "skiing-nordic",
    "person-skiing-nordic",
    "calendar-plus",
    "portal-exit",
    "person-from-portal",
    "plane-arrival",
    "cowbell-more",
    "cowbell-circle-plus",
    "arrow-alt-circle-left",
    "circle-left",
    "distribute-spacing-vertical",
    "signal-alt-2",
    "signal-bars-fair",
    "sportsball",
    "game-console-handheld-crank",
    "subway",
    "train-subway",
    "chart-gantt",
    "face-smile-upside-down",
    "ball-pile",
    "badge-dollar",
    "money-bills-alt",
    "money-bills-simple",
    "list-timeline",
    "indian-rupee",
    "inr",
    "indian-rupee-sign",
    "crop-alt",
    "crop-simple",
    "money-bill-alt",
    "money-bill-1",
    "long-arrow-alt-left",
    "left-long",
    "keyboard-down",
    "circle-up-right",
    "thunderstorm-moon",
    "cloud-bolt-moon",
    "turn-left-up",
    "dna",
    "virus-slash",
    "bracket-round-right",
    "circle-sterling",
    "circle-5",
    "subtract",
    "minus",
    "flame",
    "fire-flame",
    "arrow-alt-to-right",
    "right-to-line",
    "gif",
    "chess",
    "trash-slash",
    "long-arrow-left",
    "arrow-left-long",
    "plug-circle-check",
    "font-case",
    "street-view",
    "arrow-down-left",
    "franc-sign",
    "flask-poison",
    "flask-round-poison",
    "volume-off",
    "book-circle-arrow-right",
    "user-chart",
    "chart-user",
    "american-sign-language-interpreting",
    "asl-interpreting",
    "hands-american-sign-language-interpreting",
    "hands-asl-interpreting",
    "presentation",
    "presentation-screen",
    "circle-bolt",
    "face-smile-halo",
    "cart-circle-arrow-down",
    "house-person-arrive",
    "house-return",
    "house-person-return",
    "comment-alt-times",
    "message-times",
    "message-xmark",
    "file-award",
    "file-certificate",
    "user-doctor-hair-long",
    "camera-home",
    "camera-security",
    "cog",
    "gear",
    "tint-slash",
    "droplet-slash",
    "book-heart",
    "mosque",
    "duck",
    "mosquito",
    "star-of-david",
    "flag-alt",
    "flag-swallowtail",
    "person-military-rifle",
    "car-garage",
    "shopping-cart",
    "cart-shopping",
    "book-font",
    "shield-plus",
    "vials",
    "eye-dropper-full",
    "distribute-spacing-horizontal",
    "tablet-rugged",
    "temperature-frigid",
    "temperature-snow",
    "moped",
    "smile-plus",
    "face-smile-plus",
    "radio-alt",
    "radio-tuner",
    "face-swear",
    "water-lower",
    "water-arrow-down",
    "scanner-touchscreen",
    "circle-7",
    "plug-circle-plus",
    "ski-jump",
    "person-ski-jumping",
    "place-of-worship",
    "water-rise",
    "water-arrow-up",
    "waveform-path",
    "waveform-lines",
    "split",
    "film-cannister",
    "film-canister",
    "folder-times",
    "folder-xmark",
    "toilet-paper-alt",
    "toilet-paper-blank",
    "tablet-android-alt",
    "tablet-screen",
    "hexagon-vertical-nft-slanted",
    "folder-music",
    "desktop-medical",
    "display-medical",
    "share-all",
    "peapod",
    "chess-clock",
    "axe",
    "square-d",
    "grip-vertical",
    "mobile-signal-out",
    "level-up",
    "arrow-turn-up",
    "u",
    "arrow-up-from-dotted-line",
    "square-root-alt",
    "square-root-variable",
    "light-switch-on",
    "sort-alt",
    "arrow-down-arrow-up",
    "raindrops",
    "minus-large",
    "dash",
    "clock-four",
    "clock",
    "input-numeric",
    "truck-tow",
    "step-backward",
    "backward-step",
    "pallet",
    "car-bolt",
    "expand-arrows",
    "arrows-maximize",
    "faucet",
    "cloud-sleet",
    "lamp-street",
    "list-radio",
    "pen-nib-slash",
    "baseball-bat-ball",
    "square-up-left",
    "overline",
    "s",
    "timeline",
    "keyboard",
    "arrows-from-dotted-line",
    "usb-drive",
    "ballot",
    "caret-down",
    "map-marker-alt-slash",
    "location-dot-slash",
    "cards",
    "clinic-medical",
    "house-chimney-medical",
    "glove-boxing",
    "boxing-glove",
    "temperature-3",
    "thermometer-3",
    "thermometer-three-quarters",
    "temperature-three-quarters",
    "bell-school",
    "mobile-android-alt",
    "mobile-screen",
    "plane-up",
    "folder-heart",
    "location-circle",
    "circle-location-arrow",
    "face-head-bandage",
    "maki-roll",
    "makizushi",
    "sushi-roll",
    "car-bump",
    "piggy-bank",
    "racquet",
    "car-mirrors",
    "industry-alt",
    "industry-windows",
    "bolt-auto",
    "battery-3",
    "battery-half",
    "flux-capacitor",
    "mountain-city",
    "coins",
    "honey-pot",
    "olive",
    "khanda",
    "filter-list",
    "outlet",
    "sliders-h",
    "sliders",
    "cauldron",
    "people",
    "folder-tree",
    "network-wired",
    "croissant",
    "map-pin",
    "hamsa",
    "cent-sign",
    "swords-laser",
    "flask",
    "person-pregnant",
    "square-u",
    "wand-sparkles",
    "router",
    "ellipsis-v",
    "ellipsis-vertical",
    "sword-laser-alt",
    "ticket",
    "power-off",
    "coin",
    "laptop-slash",
    "long-arrow-alt-right",
    "right-long",
    "circle-b",
    "person-dress-simple",
    "pipe-collar",
    "lights-holiday",
    "citrus",
    "flag-usa",
    "laptop-file",
    "teletype",
    "tty",
    "chart-tree-map",
    "diagram-next",
    "person-rifle",
    "clock-five-thirty",
    "pipe-valve",
    "arrow-up-from-arc",
    "face-spiral-eyes",
    "compress-wide",
    "phone-circle-down",
    "circle-phone-hangup",
    "gear-complex-code",
    "house-medical-circle-exclamation",
    "badminton",
    "closed-captioning",
    "hiking",
    "person-hiking",
    "arrow-alt-from-left",
    "right-from-line",
    "venus-double",
    "images",
    "calculator",
    "shuttlecock",
    "user-hair",
    "eye-evil",
    "people-pulling",
    "n",
    "swap",
    "garage",
    "tram",
    "cable-car",
    "shovel-snow",
    "cloud-rain",
    "face-lying",
    "sprinkler",
    "building-circle-xmark",
    "sledding",
    "person-sledding",
    "game-console-handheld",
    "ship",
    "clock-six-thirty",
    "battery-slash",
    "tugrik-sign",
    "arrows-down-to-line",
    "download",
    "angles-up-down",
    "inventory",
    "shelves",
    "cloud-snow",
    "grin",
    "face-grin",
    "backspace",
    "delete-left",
    "oven",
    "cloud-binary",
    "eye-dropper-empty",
    "eyedropper",
    "eye-dropper",
    "comment-captions",
    "comments-question",
    "scribble",
    "rotate-exclamation",
    "file-circle-check",
    "glass",
    "loader",
    "forward",
    "user-pilot",
    "mobile-android",
    "mobile-phone",
    "mobile",
    "code-pull-request-closed",
    "meh",
    "face-meh",
    "align-center",
    "book-dead",
    "book-skull",
    "drivers-license",
    "id-card",
    "face-dotted",
    "face-worried",
    "dedent",
    "outdent",
    "court-sport",
    "heart-circle-exclamation",
    "home",
    "home-alt",
    "home-lg-alt",
    "house",
    "vector-circle",
    "car-circle-bolt",
    "calendar-week",
    "flying-disc",
    "laptop-medical",
    "square-down-right",
    "b",
    "seat-airline",
    "eclipse-alt",
    "moon-over-sun",
    "pipe",
    "file-medical",
    "potato",
    "dice-one",
    "circle-a",
    "helmet-battle",
    "butter",
    "blanket-fire",
    "kiwi-bird",
    "castle",
    "golf-club",
    "exchange",
    "arrow-right-arrow-left",
    "redo-alt",
    "rotate-forward",
    "rotate-right",
    "cutlery",
    "utensils",
    "sort-amount-up",
    "arrow-up-wide-short",
    "chart-pie-simple-circle-dollar",
    "balloons",
    "mill-sign",
    "bowl-rice",
    "timeline-arrow",
    "skull",
    "game-board-alt",
    "game-board-simple",
    "video-circle",
    "circle-video",
    "chart-scatter-bubble",
    "house-turret",
    "banana",
    "hand-holding-skull",
    "people-dress",
    "couch-small",
    "loveseat",
    "broadcast-tower",
    "tower-broadcast",
    "truck-pickup",
    "block-quote",
    "long-arrow-alt-up",
    "up-long",
    "stop",
    "code-merge",
    "money-check-edit-alt",
    "money-check-dollar-pen",
    "arrow-alt-from-bottom",
    "up-from-line",
    "upload",
    "hurricane",
    "grid-round-2-plus",
    "people-pants",
    "mound",
    "windsock",
    "circle-half",
    "brake-warning",
    "toilet-portable",
    "compact-disc",
    "file-download",
    "file-arrow-down",
    "sax-hot",
    "saxophone-fire",
    "webcam-slash",
    "camera-web-slash",
    "folder-medical",
    "folder-cog",
    "folder-gear",
    "hand-wave",
    "sort-up-down",
    "arrow-up-arrow-down",
    "caravan",
    "shield-cat",
    "comment-alt-slash",
    "message-slash",
    "zap",
    "bolt",
    "trash-can-check",
    "glass-water",
    "oil-well",
    "person-simple",
    "arrow-turn-left-up",
    "vault",
    "mars",
    "toilet",
    "plane-circle-xmark",
    "cny",
    "jpy",
    "rmb",
    "yen",
    "yen-sign",
    "gear-code",
    "notes",
    "rouble",
    "rub",
    "ruble",
    "ruble-sign",
    "trash-arrow-turn-left",
    "trash-undo",
    "glass-champagne",
    "champagne-glass",
    "objects-align-center-horizontal",
    "sun",
    "trash-alt-slash",
    "trash-can-slash",
    "users-class",
    "screen-users",
    "guitar",
    "arrow-square-left",
    "square-arrow-left",
    "square-8",
    "face-smile-hearts",
    "brackets",
    "brackets-square",
    "laptop-arrow-down",
    "hockey-stick-puck",
    "house-tree",
    "signal-2",
    "signal-fair",
    "laugh-wink",
    "face-laugh-wink",
    "dollar-circle",
    "usd-circle",
    "circle-dollar",
    "horse-head",
    "repeat-alt",
    "arrows-repeat",
    "bore-hole",
    "industry",
    "image-polaroid",
    "wave-triangle",
    "turn-left-down",
    "person-running-fast",
    "arrow-alt-circle-down",
    "circle-down",
    "grill",
    "arrows-turn-to-dots",
    "analytics",
    "chart-mixed",
    "florin-sign",
    "sort-amount-desc",
    "sort-amount-down-alt",
    "arrow-down-short-wide",
    "less-than",
    "desktop-code",
    "display-code",
    "face-drooling",
    "oil-temp",
    "oil-temperature",
    "question-square",
    "square-question",
    "air-conditioner",
    "angle-down",
    "mountains",
    "omega",
    "car-tunnel",
    "person-dolly-empty",
    "pan-food",
    "head-side-cough",
    "grip-lines",
    "thumbs-down",
    "user-lock",
    "long-arrow-right",
    "arrow-right-long",
    "tickets-perforated-plane",
    "tickets-plane",
    "tickets-airline",
    "tent-double-peak",
    "anchor-circle-xmark",
    "ellipsis-h",
    "ellipsis",
    "nfc-slash",
    "chess-pawn",
    "first-aid",
    "kit-medical",
    "grid-2-plus",
    "bells",
    "person-through-window",
    "toolbox",
    "envelope-badge",
    "envelope-dot",
    "magnifying-glass-waveform",
    "hands-holding-circle",
    "bug",
    "bowl-chopsticks",
    "credit-card-alt",
    "credit-card",
    "circle-s",
    "box-ballot",
    "automobile",
    "car",
    "hand-holding-hand",
    "user-tie-hair",
    "podium-star",
    "business-front",
    "party-back",
    "trian-balbot",
    "user-hair-mullet",
    "microphone-stand",
    "book-reader",
    "book-open-reader",
    "family-dress",
    "circle-x",
    "cabin",
    "mountain-sun",
    "chart-simple-horizontal",
    "bluetooth",
    "arrows-left-right-to-line",
    "hand-back-point-left",
    "comment-alt-dots",
    "messaging",
    "message-dots",
    "file-heart",
    "beer-foam",
    "beer-mug",
    "dice-d20",
    "drone",
    "truck-droplet",
    "file-circle-xmark",
    "temperature-up",
    "temperature-arrow-up",
    "medal",
    "person-fairy",
    "bed",
    "book-copy",
    "h-square",
    "square-h",
    "square-c",
    "clock-two",
    "square-ellipsis-vertical",
    "calendar-users",
    "podcast",
    "bee",
    "temperature-4",
    "thermometer-4",
    "thermometer-full",
    "temperature-full",
    "bell",
    "chocolate-bar",
    "candy-bar",
    "xmark-large",
    "pinata",
    "file-ppt",
    "arrows-from-line",
    "superscript",
    "bowl-spoon",
    "hexagon-check",
    "plug-circle-xmark",
    "star-of-life",
    "phone-slash",
    "traffic-light-stop",
    "paint-roller",
    "accent-grave",
    "hands-helping",
    "handshake-angle",
    "circle-0",
    "dial-med-low",
    "map-marker-alt",
    "location-dot",
    "crab",
    "box-full",
    "box-open-full",
    "file",
    "greater-than",
    "quotes",
    "pretzel",
    "t-rex",
    "swimmer",
    "person-swimming",
    "arrow-down",
    "user-robot-xmarks",
    "comment-alt-quote",
    "message-quote",
    "candy-corn",
    "folder-search",
    "folder-magnifying-glass",
    "notebook",
    "circle-wifi",
    "tint",
    "droplet",
    "bullseye-pointer",
    "eraser",
    "hexagon-image",
    "earth",
    "earth-america",
    "globe-americas",
    "earth-americas",
    "file-svg",
    "apple-crate",
    "crate-apple",
    "person-burst",
    "game-board",
    "hat-chef",
    "hand-back-point-right",
    "dove",
    "snowflake-droplets",
    "battery-0",
    "battery-empty",
    "grid-4",
    "socks",
    "face-sunglasses",
    "inbox",
    "square-0",
    "section",
    "box-up",
    "square-this-way-up",
    "tachometer-alt",
    "tachometer-alt-fast",
    "gauge-high",
    "square-ampersand",
    "envelope-open-text",
    "lamp-desk",
    "hospital-alt",
    "hospital-wide",
    "hospital",
    "poll-people",
    "glass-whiskey-rocks",
    "whiskey-glass-ice",
    "wine-bottle",
    "chess-rook",
    "user-bounty-hunter",
    "reorder",
    "stream",
    "bars-staggered",
    "diagram-sankey",
    "cloud-hail-mixed",
    "circle-up-left",
    "dharmachakra",
    "objects-align-left",
    "oil-can-drip",
    "face-smiling-hands",
    "broccoli",
    "route-interstate",
    "ear-muffs",
    "hotdog",
    "transporter-empty",
    "blind",
    "person-walking-with-cane",
    "angle-90",
    "rectangle-terminal",
    "kite",
    "drum",
    "scrubber",
    "ice-cream",
    "heart-circle-bolt",
    "fish-bones",
    "deer-rudolph",
    "fax",
    "paragraph",
    "head-side-heart",
    "square-e",
    "meter-fire",
    "cloud-hail",
    "vote-yea",
    "check-to-slot",
    "money-from-bracket",
    "star-half",
    "car-bus",
    "speaker",
    "timer",
    "boxes",
    "boxes-alt",
    "boxes-stacked",
    "landmark-magnifying-glass",
    "grill-hot",
    "ballot-check",
    "chain",
    "link",
    "assistive-listening-systems",
    "ear-listen",
    "file-minus",
    "tree-city",
    "play",
    "font",
    "coffee-togo",
    "cup-togo",
    "square-down-left",
    "burger-lettuce",
    "table-cells-row-lock",
    "rupiah-sign",
    "search",
    "magnifying-glass",
    "ping-pong-paddle-ball",
    "table-tennis",
    "table-tennis-paddle-ball",
    "diagnoses",
    "person-dots-from-line",
    "chevron-double-down",
    "chevrons-down",
    "trash-restore-alt",
    "trash-can-arrow-up",
    "signal-3",
    "signal-good",
    "map-marker-question",
    "location-question",
    "floppy-disk-times",
    "save-circle-xmark",
    "save-times",
    "floppy-disk-circle-xmark",
    "naira-sign",
    "peach",
    "taxi-bus",
    "bracket-curly-left",
    "bracket-curly",
    "lobster",
    "dolly-flatbed-empty",
    "cart-flatbed-empty",
    "colon",
    "cart-arrow-down",
    "wand",
    "walkie-talkie",
    "file-edit",
    "file-pen",
    "receipt",
    "table-picnic",
    "pen-square",
    "pencil-square",
    "square-pen",
    "microphone-circle-alt",
    "circle-microphone-lines",
    "desktop-slash",
    "display-slash",
    "suitcase-rolling",
    "person-circle-exclamation",
    "transporter-2",
    "hand-receiving",
    "hands-holding-diamond",
    "money-bill-simple-wave",
    "chevron-down",
    "battery",
    "battery-5",
    "battery-full",
    "bell-plus",
    "book-arrow-right",
    "hospitals",
    "club",
    "skull-crossbones",
    "dewpoint",
    "droplet-degree",
    "code-compare",
    "list-dots",
    "list-ul",
    "hand-holding-magic",
    "watermelon-slice",
    "circle-ellipsis",
    "school-lock",
    "tower-cell",
    "sd-cards",
    "jug-bottle",
    "long-arrow-alt-down",
    "down-long",
    "envelopes",
    "phone-office",
    "ranking-star",
    "chess-king",
    "nfc-pen",
    "person-harassing",
    "magnifying-glass-play",
    "hat-winter",
    "brazilian-real-sign",
    "landmark-alt",
    "landmark-dome",
    "bone-break",
    "arrow-up",
    "down-from-dotted-line",
    "television",
    "tv-alt",
    "tv",
    "border-left",
    "circle-divide",
    "shrimp",
    "tasks",
    "list-check",
    "diagram-subtask",
    "jug-detergent",
    "user-circle",
    "circle-user",
    "square-y",
    "user-doctor-hair",
    "planet-ringed",
    "mushroom",
    "user-shield",
    "megaphone",
    "wreath-laurel",
    "circle-exclamation-check",
    "wind",
    "box-usd",
    "box-dollar",
    "car-crash",
    "car-burst",
    "y",
    "user-headset",
    "retweet-alt",
    "arrows-retweet",
    "snowboarding",
    "person-snowboarding",
    "chevron-square-right",
    "square-chevron-right",
    "lacrosse-stick-ball",
    "shipping-fast",
    "truck-fast",
    "user-magnifying-glass",
    "star-sharp",
    "comment-heart",
    "circle-1",
    "star-circle",
    "circle-star",
    "fish",
    "fog",
    "cloud-fog",
    "waffle",
    "music-alt",
    "music-note",
    "hexagon-exclamation",
    "cart-shopping-fast",
    "object-union",
    "user-graduate",
    "starfighter",
    "adjust",
    "circle-half-stroke",
    "arrow-right-long-to-line",
    "arrow-square-down",
    "square-arrow-down",
    "diamond-half-stroke",
    "clapperboard",
    "chevron-square-left",
    "square-chevron-left",
    "phone-intercom",
    "chain-horizontal",
    "link-horizontal",
    "mango",
    "music-alt-slash",
    "music-note-slash",
    "radiation-alt",
    "circle-radiation",
    "face-tongue-sweat",
    "globe-stand",
    "baseball-ball",
    "baseball",
    "circle-p",
    "award-simple",
    "jet-fighter-up",
    "project-diagram",
    "diagram-project",
    "pedestal",
    "chart-pyramid",
    "sidebar",
    "frosty-head",
    "snowman-head",
    "copy",
    "burger-glass",
    "volume-mute",
    "volume-times",
    "volume-xmark",
    "hand-sparkles",
    "bars-filter",
    "paintbrush-pencil",
    "party-bell",
    "user-vneck-hair",
    "jack-o-lantern",
    "grip-horizontal",
    "grip",
    "share-square",
    "share-from-square",
    "keynote",
    "child-rifle",
    "child-combatant",
    "gun",
    "phone-square",
    "square-phone",
    "hat-beach",
    "add",
    "plus",
    "expand",
    "computer",
    "fort",
    "cloud-check",
    "close",
    "multiply",
    "remove",
    "times",
    "xmark",
    "face-smirking",
    "arrows",
    "arrows-up-down-left-right",
    "chalkboard-teacher",
    "chalkboard-user",
    "rhombus",
    "claw-marks",
    "peso-sign",
    "face-smile-tongue",
    "cart-circle-xmark",
    "building-shield",
    "phone-circle-alt",
    "circle-phone-flip",
    "baby",
    "users-line",
    "quote-left-alt",
    "quote-left",
    "tractor",
    "down-from-bracket",
    "key-skeleton",
    "trash-restore",
    "trash-arrow-up",
    "arrow-down-up-lock",
    "arrow-down-to-bracket",
    "lines-leaning",
    "square-q",
    "ruler-combined",
    "icons-alt",
    "symbols",
    "copyright",
    "flask-gear",
    "highlighter-line",
    "bracket",
    "bracket-left",
    "bracket-square",
    "island-tree-palm",
    "island-tropical",
    "arrow-from-left",
    "arrow-right-from-line",
    "h2",
    "equals",
    "shortcake",
    "cake-slice",
    "building-magnifying-glass",
    "peanut",
    "wrench-simple",
    "blender",
    "teeth",
    "tally-2",
    "ils",
    "shekel",
    "sheqel",
    "sheqel-sign",
    "shekel-sign",
    "cars",
    "axe-battle",
    "user-hair-long",
    "map",
    "arrow-left-from-arc",
    "file-circle-info",
    "face-disappointed",
    "lasso-sparkles",
    "clock-eleven",
    "rocket",
    "siren-on",
    "clock-ten",
    "candle-holder",
    "video-arrow-down-left",
    "photo-video",
    "photo-film",
    "save-circle-arrow-right",
    "floppy-disk-circle-arrow-right",
    "folder-minus",
    "planet-moon",
    "face-eyes-xmarks",
    "chart-scatter",
    "circle-gf",
    "display-arrow-down",
    "store",
    "arrow-trend-up",
    "plug-circle-minus",
    "olive-branch",
    "angle",
    "vacuum-robot",
    "sign",
    "sign-hanging",
    "square-divide",
    "folder-check",
    "signal-stream-slash",
    "bezier-curve",
    "eye-dropper-half",
    "store-lock",
    "bell-slash",
    "thunderstorm-sun",
    "cloud-bolt-sun",
    "camera-slash",
    "comment-quote",
    "tablet-android",
    "tablet",
    "school-flag",
    "message-code",
    "glass-half-empty",
    "glass-half-full",
    "glass-half",
    "fill",
    "comment-alt-minus",
    "message-minus",
    "angle-up",
    "dinosaur",
    "drumstick-bite",
    "chain-horizontal-slash",
    "link-horizontal-slash",
    "holly-berry",
    "nose",
    "arrow-left-to-arc",
    "chevron-left",
    "bacteria",
    "clouds",
    "money-bill-simple",
    "hand-lizard",
    "table-pivot",
    "filter-slash",
    "trash-can-arrow-turn-left",
    "trash-undo-alt",
    "trash-can-undo",
    "notdef",
    "disease",
    "person-to-door",
    "turntable",
    "briefcase-medical",
    "genderless",
    "chevron-right",
    "signal-1",
    "signal-weak",
    "clock-five",
    "retweet",
    "car-alt",
    "car-rear",
    "pump-soap",
    "computer-classic",
    "frame",
    "video-slash",
    "battery-2",
    "battery-quarter",
    "ellipsis-h-alt",
    "ellipsis-stroke",
    "radio",
    "carriage-baby",
    "baby-carriage",
    "face-expressionless",
    "down-to-dotted-line",
    "cloud-music",
    "traffic-light",
    "cloud-minus",
    "thermometer",
    "shield-minus",
    "vr-cardboard",
    "car-tilt",
    "gauge-circle-minus",
    "brightness-low",
    "hand-middle-finger",
    "percentage",
    "percent",
    "truck-moving",
    "glass-water-droplet",
    "conveyor-belt",
    "map-marker-check",
    "location-check",
    "coin-vertical",
    "display",
    "person-sign",
    "smile",
    "face-smile",
    "phone-hangup",
    "signature-slash",
    "thumb-tack",
    "thumbtack",
    "wheat-slash",
    "trophy",
    "clouds-sun",
    "pray",
    "person-praying",
    "hammer",
    "face-vomit",
    "speakers",
    "teletype-answer",
    "tty-answer",
    "mug-tea-saucer",
    "diagram-lean-canvas",
    "alt",
    "dial-med-high",
    "dial",
    "hand-peace",
    "trash-circle",
    "circle-trash",
    "sync-alt",
    "rotate",
    "circle-quarters",
    "spinner",
    "tower-control",
    "sort-shapes-up",
    "arrow-up-triangle-square",
    "whale",
    "robot",
    "peace",
    "party-horn",
    "cogs",
    "gears",
    "sun-alt",
    "sun-bright",
    "warehouse",
    "conveyor-belt-arm",
    "lock-open-alt",
    "lock-keyhole-open",
    "box-fragile",
    "square-wine-glass-crack",
    "square-fragile",
    "arrow-up-right-dots",
    "square-n",
    "splotch",
    "grin-hearts",
    "face-grin-hearts",
    "meter",
    "mandolin",
    "dice-four",
    "sim-card",
    "transgender-alt",
    "transgender",
    "mercury",
    "up-from-bracket",
    "knife-kitchen",
    "border-right",
    "level-down",
    "arrow-turn-down",
    "spade",
    "card-spade",
    "line-columns",
    "ant",
    "arrow-to-right",
    "arrow-right-to-line",
    "person-falling-burst",
    "pennant",
    "flag-pennant",
    "conveyor-belt-empty",
    "user-group-simple",
    "award",
    "ticket-alt",
    "ticket-simple",
    "building",
    "angle-double-left",
    "angles-left",
    "video-handheld",
    "camcorder",
    "pancakes",
    "album-circle-user",
    "subtitles-slash",
    "qrcode",
    "dice-d10",
    "fireplace",
    "browser",
    "pencil-paintbrush",
    "pen-paintbrush",
    "fish-cooked",
    "chair-office",
    "magnifying-glass-music",
    "nesting-dolls",
    "history",
    "clock-rotate-left",
    "trumpet",
    "grin-beam-sweat",
    "face-grin-beam-sweat",
    "fire-smoke",
    "phone-missed",
    "arrow-right-from-file",
    "file-export",
    "shield-blank",
    "shield",
    "sort-amount-up-alt",
    "arrow-up-short-wide",
    "repeat-1-alt",
    "arrows-repeat-1",
    "gun-slash",
    "avocado",
    "binary",
    "glasses-alt",
    "glasses-round",
    "phone-plus",
    "ditto",
    "person-seat",
    "house-medical",
    "golf-ball",
    "golf-ball-tee",
    "chevron-circle-left",
    "circle-chevron-left",
    "house-chimney-window",
    "scythe",
    "pen-nib",
    "parking-circle-slash",
    "ban-parking",
    "tent-arrow-turn-left",
    "face-diagonal-mouth",
    "diagram-cells",
    "cricket",
    "cricket-bat-ball",
    "tents",
    "magic",
    "wand-magic",
    "dog",
    "pen-line",
    "atom-alt",
    "atom-simple",
    "ampersand",
    "carrot",
    "arrow-from-bottom",
    "arrow-up-from-line",
    "moon",
    "pen-slash",
    "wine-glass-alt",
    "wine-glass-empty",
    "square-star",
    "cheese",
    "send-backward",
    "yin-yang",
    "music",
    "compass-slash",
    "clock-one",
    "file-music",
    "code-commit",
    "temperature-low",
    "biking",
    "person-biking",
    "display-chart-up-circle-currency",
    "skeleton",
    "circle-g",
    "circle-arrow-up-left",
    "coin-blank",
    "broom",
    "vacuum",
    "shield-heart",
    "card-heart",
    "lightbulb-cfl-on",
    "melon",
    "gopuram",
    "globe-oceania",
    "earth-oceania",
    "container-storage",
    "face-pouting",
    "times-square",
    "xmark-square",
    "square-xmark",
    "exploding-head",
    "face-explode",
    "hashtag",
    "expand-alt",
    "up-right-and-down-left-from-center",
    "oil-can",
    "t",
    "transformer-bolt",
    "hippo",
    "chart-column",
    "vhs",
    "cassette-vhs",
    "infinity",
    "vial-circle-check",
    "chimney",
    "object-intersect",
    "person-arrow-down-to-line",
    "voicemail",
    "wall-brick",
    "block-brick",
    "fan",
    "bags-shopping",
    "paragraph-rtl",
    "paragraph-left",
    "person-walking-luggage",
    "caravan-alt",
    "caravan-simple",
    "turtle",
    "pencil-mechanical",
    "arrows-alt-v",
    "up-down",
    "cloud-moon-rain",
    "booth-curtain",
    "calendar",
    "box-heart",
    "trailer",
    "user-md-chat",
    "user-doctor-message",
    "haykal",
    "bahai",
    "lighthouse",
    "amp-guitar",
    "sd-card",
    "volume-slash",
    "border-bottom",
    "wifi-1",
    "wifi-weak",
    "dragon",
    "shoe-prints",
    "plus-circle",
    "circle-plus",
    "grin-tongue-wink",
    "face-grin-tongue-wink",
    "hand-holding",
    "plug-circle-exclamation",
    "chain-broken",
    "chain-slash",
    "unlink",
    "link-slash",
    "clone",
    "person-walking-arrow-loop-left",
    "sort-alpha-up-alt",
    "arrow-up-z-a",
    "fire-alt",
    "fire-flame-curved",
    "tornado",
    "file-circle-plus",
    "delete-right",
    "quran",
    "book-quran",
    "circle-quarter",
    "anchor",
    "border-all",
    "function",
    "angry",
    "face-angry",
    "people-simple",
    "cookie-bite",
    "arrow-trend-down",
    "feed",
    "rss",
    "face-monocle",
    "draw-polygon",
    "balance-scale",
    "scale-balanced",
    "calendar-note",
    "calendar-lines",
    "sort-size-down",
    "arrow-down-big-small",
    "tachometer",
    "tachometer-fast",
    "gauge-simple-high",
    "do-not-enter",
    "shower",
    "dice-d8",
    "desktop-alt",
    "desktop",
    "m",
    "spinner-scale",
    "grip-dots-vertical",
    "face-viewfinder",
    "creemee",
    "soft-serve",
    "h5",
    "hand-back-point-down",
    "th-list",
    "table-list",
    "basket-shopping-minus",
    "sms",
    "comment-sms",
    "rectangle-landscape",
    "rectangle",
    "clipboard-list-check",
    "turkey",
    "book",
    "user-plus",
    "ice-skate",
    "check",
    "battery-4",
    "battery-three-quarters",
    "tomato",
    "sword-laser",
    "house-circle-check",
    "buildings",
    "angle-left",
    "dolly-flatbed-alt",
    "cart-flatbed-boxes",
    "diagram-successor",
    "truck-arrow-right",
    "square-w",
    "arrows-split-up-and-left",
    "lamp",
    "airplay",
    "fist-raised",
    "hand-fist",
    "shield-quartered",
    "slash-forward",
    "map-marker-edit",
    "location-pen",
    "cloud-moon",
    "pot-food",
    "briefcase",
    "person-falling",
    "portrait",
    "image-portrait",
    "user-tag",
    "rug",
    "print-slash",
    "globe-europe",
    "earth-europe",
    "luggage-cart",
    "cart-flatbed-suitcase",
    "hand-back-point-ribbon",
    "rectangle-times",
    "times-rectangle",
    "window-close",
    "rectangle-xmark",
    "tire-rugged",
    "lightbulb-dollar",
    "cowbell",
    "baht-sign",
    "corner",
    "chevron-double-right",
    "chevrons-right",
    "book-open",
    "journal-whills",
    "book-journal-whills",
    "inhaler",
    "handcuffs",
    "snake",
    "exclamation-triangle",
    "warning",
    "triangle-exclamation",
    "note-medical",
    "database",
    "down-left",
    "mail-forward",
    "share",
    "face-thinking",
    "turn-down-right",
    "bottle-droplet",
    "mask-face",
    "hill-rockslide",
    "scanner-keyboard",
    "circle-o",
    "grid-horizontal",
    "comment-alt-dollar",
    "message-dollar",
    "exchange-alt",
    "right-left",
    "columns-3",
    "paper-plane",
    "road-circle-exclamation",
    "dungeon",
    "hand-holding-box",
    "input-text",
    "window-alt",
    "window-flip",
    "align-right",
    "scanner",
    "scanner-gun",
    "tire",
    "engine",
    "money-bill-wave-alt",
    "money-bill-1-wave",
    "life-ring",
    "sign-language",
    "signing",
    "hands",
    "caret-circle-right",
    "circle-caret-right",
    "turn-left",
    "wheat",
    "file-spreadsheet",
    "audio-description-slash",
    "bell-ring",
    "calendar-day",
    "ladder-water",
    "swimming-pool",
    "water-ladder",
    "arrows-v",
    "arrows-up-down",
    "chess-pawn-alt",
    "chess-pawn-piece",
    "grimace",
    "face-grimace",
    "wheelchair-alt",
    "wheelchair-move",
    "level-down-alt",
    "turn-down",
    "square-s",
    "barcode-alt",
    "rectangle-barcode",
    "person-walking-arrow-right",
    "envelope-square",
    "square-envelope",
    "dice",
    "unicorn",
    "bowling-ball",
    "pompebled",
    "brain",
    "watch-smart",
    "book-user",
    "sensor-smoke",
    "sensor-cloud",
    "clapperboard-play",
    "band-aid",
    "bandage",
    "calendar-minus",
    "times-circle",
    "xmark-circle",
    "circle-xmark",
    "circle-4",
    "gifts",
    "album-collection",
    "hotel",
    "globe-asia",
    "earth-asia",
    "id-card-alt",
    "id-card-clip",
    "search-plus",
    "magnifying-glass-plus",
    "thumbs-up",
    "cloud-showers",
    "user-clock",
    "onion",
    "clock-twelve-thirty",
    "arrow-down-to-dotted-line",
    "allergies",
    "hand-dots",
    "file-invoice",
    "window-minimize",
    "rectangle-wide",
    "comment-arrow-up",
    "garlic",
    "coffee",
    "mug-saucer",
    "brush",
    "tree-decorated",
    "mask",
    "calendar-heart",
    "search-minus",
    "magnifying-glass-minus",
    "flower",
    "arrow-down-from-arc",
    "right-left-large",
    "ruler-vertical",
    "circles-overlap",
    "user-alt",
    "user-large",
    "starship-freighter",
    "train-tram",
    "bridge-suspension",
    "trash-check",
    "user-nurse",
    "boombox",
    "syringe",
    "cloud-sun",
    "shield-exclamation",
    "stopwatch-20",
    "square-full",
    "grip-dots",
    "comment-exclamation",
    "pen-swirl",
    "falafel",
    "circle-2",
    "magnet",
    "jar",
    "gramophone",
    "dice-d12",
    "sticky-note",
    "note-sticky",
    "arrow-alt-down",
    "down",
    "100",
    "hundred-points",
    "paperclip-vertical",
    "wind-circle-exclamation",
    "wind-warning",
    "map-marker-slash",
    "location-pin-slash",
    "face-sad-sweat",
    "bug-slash",
    "cupcake",
    "light-switch-off",
    "toggle-large-off",
    "pen-fancy-slash",
    "truck-container",
    "boot",
    "arrow-up-from-water-pump",
    "file-check",
    "bone",
    "cards-blank",
    "circle-3",
    "bench-tree",
    "keyboard-brightness-low",
    "ski-boot-ski",
    "brain-circuit",
    "user-injured",
    "firewall",
    "block-brick-fire",
    "sad-tear",
    "face-sad-tear",
    "plane",
    "tent-arrows-down",
    "exclamation",
    "arrows-spin",
    "face-smile-relaxed",
    "comment-times",
    "comment-xmark",
    "print",
    "try",
    "turkish-lira",
    "turkish-lira-sign",
    "face-nose-steam",
    "waveform-circle",
    "circle-waveform-lines",
    "dollar",
    "usd",
    "dollar-sign",
    "ferris-wheel",
    "computer-speaker",
    "skull-cow",
    "x",
    "search-dollar",
    "magnifying-glass-dollar",
    "users-cog",
    "users-gear",
    "person-military-pointing",
    "bank",
    "institution",
    "museum",
    "university",
    "building-columns",
    "circle-t",
    "sack",
    "grid-2",
    "cctv",
    "camera-cctv",
    "umbrella",
    "trowel",
    "horizontal-rule",
    "bed-alt",
    "bed-front",
    "d",
    "stapler",
    "theater-masks",
    "masks-theater",
    "file-gif",
    "kip-sign",
    "face-woozy",
    "cloud-question",
    "pineapple",
    "hand-point-left",
    "gallery-thumbnails",
    "circle-j",
    "eyes",
    "handshake-alt",
    "handshake-simple",
    "file-caret-up",
    "page-caret-up",
    "fighter-jet",
    "jet-fighter",
    "comet",
    "share-alt-square",
    "square-share-nodes",
    "reflect-vertical",
    "shield-keyhole",
    "file-mp4",
    "barcode",
    "bulldozer",
    "plus-minus",
    "sliders-v-square",
    "square-sliders-vertical",
    "video-camera",
    "video",
    "comment-middle-alt",
    "message-middle",
    "mortar-board",
    "graduation-cap",
    "hand-holding-medical",
    "person-circle-check",
    "square-z",
    "comment-alt-text",
    "message-text",
    "level-up-alt",
    "turn-up"
  ],
  "fat": [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "fill-drip",
    "arrows-to-circle",
    "chevron-circle-right",
    "circle-chevron-right",
    "wagon-covered",
    "line-height",
    "bagel",
    "transporter-7",
    "at",
    "rectangles-mixed",
    "phone-arrow-up",
    "phone-outgoing",
    "phone-arrow-up-right",
    "trash-alt",
    "trash-can",
    "circle-l",
    "head-vr",
    "head-side-goggles",
    "text-height",
    "user-times",
    "user-xmark",
    "face-hand-yawn",
    "tachometer-slowest",
    "gauge-simple-min",
    "stethoscope",
    "coffin",
    "comment-alt",
    "message",
    "bowl-salad",
    "salad",
    "info",
    "robot-astromech",
    "ring-diamond",
    "fondue-pot",
    "theta",
    "face-hand-peeking",
    "square-user",
    "compress-alt",
    "down-left-and-up-right-to-center",
    "explosion",
    "file-alt",
    "file-text",
    "file-lines",
    "wave-square",
    "ring",
    "building-un",
    "dice-three",
    "tire-pressure-warning",
    "wifi-2",
    "wifi-fair",
    "calendar-alt",
    "calendar-days",
    "mp3-player",
    "anchor-circle-check",
    "tally-4",
    "rectangle-history",
    "building-circle-arrow-right",
    "volleyball-ball",
    "volleyball",
    "sun-haze",
    "text-size",
    "ufo",
    "utensil-fork",
    "fork",
    "arrows-up-to-line",
    "mobile-signal",
    "barcode-scan",
    "sort-desc",
    "sort-down",
    "folder-download",
    "folder-arrow-down",
    "minus-circle",
    "circle-minus",
    "face-icicles",
    "shovel",
    "door-open",
    "films",
    "sign-out-alt",
    "right-from-bracket",
    "face-glasses",
    "nfc",
    "atom",
    "soap",
    "heart-music-camera-bolt",
    "icons",
    "microphone-alt-slash",
    "microphone-lines-slash",
    "closed-captioning-slash",
    "calculator-alt",
    "calculator-simple",
    "bridge-circle-check",
    "sliders-v",
    "sliders-up",
    "map-marker-minus",
    "location-minus",
    "pump-medical",
    "fingerprint",
    "ski-boot",
    "rectangle-sd",
    "standard-definition",
    "h1",
    "hand-point-right",
    "search-location",
    "magnifying-glass-location",
    "message-bot",
    "step-forward",
    "forward-step",
    "smile-beam",
    "face-smile-beam",
    "light-ceiling",
    "comment-alt-exclamation",
    "message-exclamation",
    "bowl-shaved-ice",
    "bowl-scoop",
    "square-x",
    "building-memo",
    "utility-pole-double",
    "flag-checkered",
    "chevron-double-up",
    "chevrons-up",
    "football-ball",
    "football",
    "user-vneck",
    "school-circle-exclamation",
    "crop",
    "angle-double-down",
    "angles-down",
    "users-rectangle",
    "people-roof",
    "arrow-square-right",
    "square-arrow-right",
    "map-marker-plus",
    "location-plus",
    "lightbulb-exclamation-on",
    "people-line",
    "beer",
    "beer-mug-empty",
    "crate-empty",
    "diagram-predecessor",
    "transporter",
    "calendar-circle-user",
    "long-arrow-up",
    "arrow-up-long",
    "person-carry",
    "person-carry-box",
    "burn",
    "fire-flame-simple",
    "male",
    "person",
    "laptop",
    "file-csv",
    "menorah",
    "union",
    "chevron-double-left",
    "chevrons-left",
    "heart-circle",
    "circle-heart",
    "truck-plane",
    "record-vinyl",
    "bring-forward",
    "square-p",
    "grin-stars",
    "face-grin-stars",
    "sigma",
    "camera-movie",
    "bong",
    "clarinet",
    "truck-flatbed",
    "pastafarianism",
    "spaghetti-monster-flying",
    "arrow-down-up-across-line",
    "arrows-rotate-reverse",
    "leaf-heart",
    "house-building",
    "cheese-swiss",
    "utensil-spoon",
    "spoon",
    "jar-wheat",
    "mail-bulk",
    "envelopes-bulk",
    "file-circle-exclamation",
    "bow-arrow",
    "cart-xmark",
    "times-hexagon",
    "xmark-hexagon",
    "hexagon-xmark",
    "hospital-symbol",
    "circle-h",
    "merge",
    "pager",
    "cart-minus",
    "contact-book",
    "address-book",
    "pan-frying",
    "grid-3",
    "grid",
    "football-helmet",
    "hand-love",
    "trees",
    "strikethrough",
    "page",
    "k",
    "diagram-previous",
    "tachometer-alt-slowest",
    "gauge-min",
    "folder-grid",
    "eggplant",
    "excavator",
    "ram",
    "landmark-flag",
    "lips",
    "pencil-alt",
    "pencil",
    "backward",
    "caret-right",
    "comments",
    "file-clipboard",
    "paste",
    "desktop-arrow-down",
    "code-pull-request",
    "pumpkin",
    "clipboard-list",
    "pen-field",
    "blueberries",
    "truck-loading",
    "truck-ramp-box",
    "note",
    "arrow-down-to-square",
    "user-check",
    "cloud-xmark",
    "vial-virus",
    "book-alt",
    "book-blank",
    "golf-flag-hole",
    "comment-alt-arrow-down",
    "message-arrow-down",
    "face-unamused",
    "sheet-plastic",
    "circle-9",
    "blog",
    "user-ninja",
    "pencil-slash",
    "bowling-pins",
    "person-arrow-up-from-line",
    "down-right",
    "torah",
    "scroll-torah",
    "webhook",
    "blinds-open",
    "fence",
    "arrow-alt-up",
    "up",
    "quidditch",
    "quidditch-broom-ball",
    "broom-ball",
    "drumstick",
    "square-v",
    "gave-dandy",
    "face-awesome",
    "dial-off",
    "toggle-off",
    "face-smile-horns",
    "archive",
    "box-archive",
    "grapes",
    "person-drowning",
    "dial-max",
    "circle-m",
    "calendar-image",
    "caret-circle-down",
    "circle-caret-down",
    "sort-numeric-desc",
    "sort-numeric-down-alt",
    "arrow-down-9-1",
    "grin-tongue-squint",
    "face-grin-tongue-squint",
    "shish-kebab",
    "spray-can",
    "alarm-snooze",
    "scarecrow",
    "truck-monster",
    "gift-card",
    "w",
    "code-pull-request-draft",
    "square-b",
    "elephant",
    "globe-africa",
    "earth-africa",
    "rainbow",
    "circle-notch",
    "tablet-alt",
    "tablet-screen-button",
    "paw",
    "message-question",
    "cloud",
    "trowel-bricks",
    "square-3",
    "flushed",
    "face-flushed",
    "hospital-user",
    "microwave",
    "chf-sign",
    "tent-arrow-left-right",
    "cart-circle-arrow-up",
    "trash-clock",
    "reflect-both",
    "legal",
    "gavel",
    "sprinkler-ceiling",
    "browsers",
    "trillium",
    "music-slash",
    "truck-ramp",
    "binoculars",
    "microphone-slash",
    "box-tissue",
    "circle-c",
    "star-christmas",
    "chart-bullet",
    "motorcycle",
    "tree-christmas",
    "tire-flat",
    "sunglasses",
    "badge",
    "comment-alt-edit",
    "message-edit",
    "message-pen",
    "concierge-bell",
    "bell-concierge",
    "pencil-ruler",
    "pen-ruler",
    "file-mp3",
    "arrow-progress",
    "chess-rook-alt",
    "chess-rook-piece",
    "square-root",
    "album-collection-circle-plus",
    "people-arrows-left-right",
    "people-arrows",
    "sign-post",
    "face-angry-horns",
    "mars-and-venus-burst",
    "tombstone",
    "caret-square-right",
    "square-caret-right",
    "cut",
    "scissors",
    "list-music",
    "sun-plant-wilt",
    "toilets-portable",
    "hockey-puck",
    "mustache",
    "hyphen",
    "table",
    "user-chef",
    "comment-alt-image",
    "message-image",
    "users-medical",
    "sensor-alert",
    "sensor-triangle-exclamation",
    "magnifying-glass-arrow-right",
    "digital-tachograph",
    "tachograph-digital",
    "face-mask",
    "pickleball",
    "star-sharp-half",
    "users-slash",
    "clover",
    "meat",
    "mail-reply",
    "reply",
    "star-and-crescent",
    "empty-set",
    "house-fire",
    "minus-square",
    "square-minus",
    "helicopter",
    "bird",
    "compass",
    "caret-square-down",
    "square-caret-down",
    "heart-half-alt",
    "heart-half-stroke",
    "file-circle-question",
    "truck-utensils",
    "laptop-code",
    "joystick",
    "grill-fire",
    "rectangle-vertical-history",
    "swatchbook",
    "prescription-bottle",
    "navicon",
    "bars",
    "keyboard-left",
    "people-group",
    "hourglass-3",
    "hourglass-end",
    "heart-broken",
    "heart-crack",
    "face-beam-hand-over-mouth",
    "humidity",
    "droplet-percent",
    "external-link-square-alt",
    "square-up-right",
    "kiss-beam",
    "face-kiss-beam",
    "corn",
    "roller-coaster",
    "photo-film-music",
    "radar",
    "sickle",
    "film",
    "coconut",
    "ruler-horizontal",
    "shield-cross",
    "cassette-tape",
    "square-terminal",
    "people-robbery",
    "lightbulb",
    "caret-left",
    "comment-middle",
    "trash-can-list",
    "block",
    "exclamation-circle",
    "circle-exclamation",
    "school-circle-xmark",
    "sign-out",
    "arrow-right-from-bracket",
    "face-frown-slight",
    "chevron-circle-down",
    "circle-chevron-down",
    "sidebar-flip",
    "unlock-alt",
    "unlock-keyhole",
    "temperature-list",
    "cloud-showers-heavy",
    "headphones-alt",
    "headphones-simple",
    "sitemap",
    "pipe-section",
    "space-station-moon-alt",
    "space-station-moon-construction",
    "donate",
    "circle-dollar-to-slot",
    "memory",
    "face-sleeping",
    "road-spikes",
    "fire-burner",
    "squirrel",
    "arrow-to-top",
    "arrow-up-to-line",
    "flag",
    "face-cowboy-hat",
    "hanukiah",
    "chart-scatter-3d",
    "display-chart-up",
    "square-code",
    "feather",
    "volume-down",
    "volume-low",
    "times-to-slot",
    "vote-nay",
    "xmark-to-slot",
    "box-alt",
    "box-taped",
    "comment-slash",
    "swords",
    "cloud-sun-rain",
    "album",
    "circle-n",
    "compress",
    "wheat-alt",
    "wheat-awn",
    "ankh",
    "hands-holding-child",
    "asterisk",
    "key-skeleton-left-right",
    "comment-lines",
    "luchador",
    "mask-luchador",
    "luchador-mask",
    "check-square",
    "square-check",
    "shredder",
    "book-open-alt",
    "book-open-cover",
    "sandwich",
    "peseta-sign",
    "parking-slash",
    "square-parking-slash",
    "train-tunnel",
    "header",
    "heading",
    "ghost",
    "face-anguished",
    "hockey-sticks",
    "abacus",
    "film-alt",
    "film-simple",
    "list-squares",
    "list",
    "tree-palm",
    "phone-square-alt",
    "square-phone-flip",
    "cart-plus",
    "gamepad",
    "border-center-v",
    "dot-circle",
    "circle-dot",
    "clipboard-medical",
    "dizzy",
    "face-dizzy",
    "egg",
    "arrow-alt-to-top",
    "up-to-line",
    "house-medical-circle-xmark",
    "watch-fitness",
    "clock-nine-thirty",
    "campground",
    "folder-plus",
    "jug",
    "futbol-ball",
    "soccer-ball",
    "futbol",
    "snow-blowing",
    "paint-brush",
    "paintbrush",
    "lock",
    "arrow-from-top",
    "arrow-down-from-line",
    "gas-pump",
    "signal-alt-slash",
    "signal-bars-slash",
    "monkey",
    "pro",
    "rectangle-pro",
    "house-night",
    "hot-tub",
    "hot-tub-person",
    "globe-pointer",
    "blanket",
    "map-marked",
    "map-location",
    "house-flood-water",
    "comments-question-check",
    "tree",
    "arrows-cross",
    "backpack",
    "square-small",
    "folder-upload",
    "folder-arrow-up",
    "bridge-lock",
    "crosshairs-simple",
    "sack-dollar",
    "edit",
    "pen-to-square",
    "sliders-h-square",
    "square-sliders",
    "car-side",
    "comment-middle-top-alt",
    "message-middle-top",
    "lightbulb-on",
    "utensil-knife",
    "knife",
    "share-alt",
    "share-nodes",
    "display-chart-up-circle-dollar",
    "wave-sine",
    "heart-circle-minus",
    "circle-w",
    "calendar-circle",
    "circle-calendar",
    "hourglass-2",
    "hourglass-half",
    "microscope",
    "sunset",
    "sink",
    "calendar-exclamation",
    "truck-container-empty",
    "hand-heart",
    "shopping-bag",
    "bag-shopping",
    "sort-alpha-desc",
    "sort-alpha-down-alt",
    "arrow-down-z-a",
    "mitten",
    "reply-time",
    "reply-clock",
    "person-rays",
    "arrow-alt-right",
    "right",
    "circle-f",
    "users",
    "face-pleading",
    "eye-slash",
    "flask-vial",
    "police-box",
    "cucumber",
    "head-side-brain",
    "hand-paper",
    "hand",
    "biking-mountain",
    "person-biking-mountain",
    "utensils-slash",
    "print-search",
    "print-magnifying-glass",
    "turn-right",
    "folder-bookmark",
    "arrow-turn-left-down",
    "om",
    "pi",
    "flask-potion",
    "flask-round-potion",
    "face-shush",
    "worm",
    "house-circle-xmark",
    "plug",
    "calendar-circle-exclamation",
    "square-i",
    "chevron-up",
    "face-saluting",
    "tachometer-slow",
    "gauge-simple-low",
    "face-persevering",
    "camera-circle",
    "circle-camera",
    "hand-spock",
    "spider-web",
    "microphone-circle",
    "circle-microphone",
    "book-arrow-up",
    "popsicle",
    "command",
    "blinds",
    "stopwatch",
    "saxophone",
    "square-2",
    "field-hockey",
    "field-hockey-stick-ball",
    "sort-shapes-up-alt",
    "arrow-up-square-triangle",
    "face-scream",
    "square-m",
    "webcam",
    "camera-web",
    "comment-arrow-down",
    "lightbulb-cfl",
    "window-frame-open",
    "kiss",
    "face-kiss",
    "bridge-circle-xmark",
    "period",
    "grin-tongue",
    "face-grin-tongue",
    "up-to-dotted-line",
    "thought-bubble",
    "skeleton-ribs",
    "raygun",
    "flute",
    "acorn",
    "video-arrow-up-right",
    "grate-droplet",
    "seal-exclamation",
    "chess-bishop",
    "message-sms",
    "coffee-beans",
    "hat-witch",
    "grin-wink",
    "face-grin-wink",
    "clock-three-thirty",
    "deaf",
    "deafness",
    "hard-of-hearing",
    "ear-deaf",
    "alarm-clock",
    "eclipse",
    "face-relieved",
    "road-circle-check",
    "dice-five",
    "minus-octagon",
    "octagon-minus",
    "rss-square",
    "square-rss",
    "face-zany",
    "tricycle",
    "land-mine-on",
    "square-arrow-up-left",
    "i-cursor",
    "chart-mixed-up-circle-dollar",
    "salt-shaker",
    "stamp",
    "file-plus",
    "draw-square",
    "toilet-paper-reverse-slash",
    "toilet-paper-under-slash",
    "stairs",
    "drone-alt",
    "drone-front",
    "glass-empty",
    "dial-high",
    "user-construction",
    "user-hard-hat",
    "user-helmet-safety",
    "i",
    "hryvnia",
    "hryvnia-sign",
    "arrow-down-left-and-arrow-up-right-to-center",
    "pills",
    "grin-alt",
    "face-grin-wide",
    "tooth",
    "basketball-hoop",
    "objects-align-bottom",
    "v",
    "sparkles",
    "squid",
    "leafy-green",
    "circle-arrow-up-right",
    "calendars",
    "bangladeshi-taka-sign",
    "bicycle",
    "hammer-war",
    "circle-d",
    "spider-black-widow",
    "rod-asclepius",
    "rod-snake",
    "staff-aesculapius",
    "staff-snake",
    "pear",
    "head-side-cough-slash",
    "file-mov",
    "triangle",
    "apartment",
    "ambulance",
    "truck-medical",
    "pepper",
    "piano",
    "gun-squirt",
    "wheat-awn-circle-exclamation",
    "snowman",
    "user-alien",
    "shield-check",
    "mortar-pestle",
    "road-barrier",
    "chart-candlestick",
    "briefcase-blank",
    "school",
    "igloo",
    "parenthesis",
    "bracket-round",
    "joint",
    "horse-saddle",
    "mug-marshmallows",
    "filters",
    "bell-on",
    "angle-right",
    "dial-med",
    "horse",
    "q",
    "monitor-heart-rate",
    "monitor-waveform",
    "link-simple",
    "whistle",
    "g",
    "fragile",
    "wine-glass-crack",
    "slot-machine",
    "notes-medical",
    "car-wash",
    "escalator",
    "comment-image",
    "temperature-2",
    "thermometer-2",
    "thermometer-half",
    "temperature-half",
    "dong-sign",
    "doughnut",
    "donut",
    "capsules",
    "poo-bolt",
    "poo-storm",
    "tally-1",
    "file-vector",
    "frown-open",
    "face-frown-open",
    "square-dashed",
    "bag-shopping-plus",
    "square-j",
    "hand-point-up",
    "money-bill",
    "sort-size-up",
    "arrow-up-big-small",
    "barcode-read",
    "baguette",
    "bowl-soft-serve",
    "face-holding-back-tears",
    "arrow-alt-square-up",
    "square-up",
    "subway-tunnel",
    "train-subway-tunnel",
    "exclamation-square",
    "square-exclamation",
    "semicolon",
    "bookmark",
    "fan-table",
    "align-justify",
    "battery-1",
    "battery-low",
    "credit-card-front",
    "mind-share",
    "brain-arrow-curved-right",
    "umbrella-beach",
    "helmet-un",
    "map-marker-smile",
    "location-smile",
    "arrow-to-left",
    "arrow-left-to-line",
    "bullseye",
    "nigiri",
    "sushi",
    "comment-alt-captions",
    "message-captions",
    "trash-list",
    "bacon",
    "option",
    "raccoon",
    "hand-point-down",
    "arrow-up-from-bracket",
    "head-side-gear",
    "trash-plus",
    "file-cad",
    "objects-align-top",
    "folder-blank",
    "folder",
    "face-anxious-sweat",
    "credit-card-blank",
    "file-medical-alt",
    "file-waveform",
    "microchip-ai",
    "mug",
    "plane-up-slash",
    "radiation",
    "pen-circle",
    "bag-seedling",
    "chart-simple",
    "crutches",
    "parking-circle",
    "circle-parking",
    "mars-stroke",
    "leaf-oak",
    "square-bolt",
    "vial",
    "dashboard",
    "gauge-med",
    "tachometer-alt-average",
    "gauge",
    "magic-wand-sparkles",
    "wand-magic-sparkles",
    "lambda",
    "e",
    "pizza",
    "bowl-chopsticks-noodles",
    "h3",
    "pen-alt",
    "pen-clip",
    "bridge-circle-exclamation",
    "badge-percent",
    "rotate-reverse",
    "user",
    "sensor",
    "comma",
    "school-circle-check",
    "toilet-paper-reverse",
    "toilet-paper-under",
    "light-emergency",
    "arrow-down-to-arc",
    "dumpster",
    "shuttle-van",
    "van-shuttle",
    "building-user",
    "light-switch",
    "caret-square-left",
    "square-caret-left",
    "highlighter",
    "heart-rate",
    "wave-pulse",
    "key",
    "arrow-left-to-bracket",
    "hat-santa",
    "tamale",
    "box-check",
    "bullhorn",
    "steak",
    "location-slash",
    "location-crosshairs-slash",
    "person-dolly",
    "globe",
    "synagogue",
    "file-chart-line",
    "file-chart-column",
    "person-half-dress",
    "folder-image",
    "calendar-edit",
    "calendar-pen",
    "road-bridge",
    "face-smile-tear",
    "comment-alt-plus",
    "message-plus",
    "location-arrow",
    "c",
    "tablet-button",
    "person-dress-fairy",
    "rectangle-history-circle-user",
    "building-lock",
    "chart-line-up",
    "mailbox",
    "sign-posts",
    "truck-bolt",
    "pizza-slice",
    "money-bill-wave",
    "area-chart",
    "chart-area",
    "house-flag",
    "circle-three-quarters-stroke",
    "person-circle-minus",
    "scalpel",
    "cancel",
    "ban",
    "bell-exclamation",
    "bookmark-circle",
    "circle-bookmark",
    "egg-fried",
    "face-weary",
    "uniform-martial-arts",
    "camera-rotate",
    "sun-dust",
    "comment-text",
    "air-freshener",
    "spray-can-sparkles",
    "signal-alt",
    "signal-alt-4",
    "signal-bars-strong",
    "signal-bars",
    "diamond-exclamation",
    "star",
    "dial-min",
    "repeat",
    "cross",
    "file-caret-down",
    "page-caret-down",
    "box",
    "venus-mars",
    "clock-seven-thirty",
    "mouse-pointer",
    "arrow-pointer",
    "clock-four-thirty",
    "signal-alt-3",
    "signal-bars-good",
    "cactus",
    "lightbulb-gear",
    "expand-arrows-alt",
    "maximize",
    "charging-station",
    "triangle-circle-square",
    "shapes",
    "plane-tail",
    "tachometer-fastest",
    "gauge-simple-max",
    "circle-u",
    "shield-slash",
    "phone-square-down",
    "square-phone-hangup",
    "arrow-up-left",
    "transporter-1",
    "peanuts",
    "random",
    "shuffle",
    "running",
    "person-running",
    "mobile-retro",
    "grip-lines-vertical",
    "bin-bottles-recycle",
    "arrow-up-from-square",
    "page-break",
    "file-dashed-line",
    "bracket-curly-right",
    "spider",
    "clock-three",
    "hands-bound",
    "scalpel-path",
    "scalpel-line-dashed",
    "file-invoice-dollar",
    "pipe-smoking",
    "face-astonished",
    "window",
    "plane-circle-exclamation",
    "ear",
    "file-lock",
    "diagram-venn",
    "arrow-down-from-bracket",
    "x-ray",
    "goal-net",
    "coffin-cross",
    "spell-check",
    "map-marker-times",
    "map-marker-xmark",
    "location-xmark",
    "circle-quarter-stroke",
    "lasso",
    "slash",
    "portal-enter",
    "person-to-portal",
    "calendar-star",
    "mouse",
    "computer-mouse",
    "sign-in",
    "arrow-right-to-bracket",
    "pegasus",
    "files-medical",
    "cannon",
    "nfc-lock",
    "ski-lift",
    "person-ski-lift",
    "square-6",
    "store-alt-slash",
    "shop-slash",
    "wind-turbine",
    "sliders-simple",
    "grid-round",
    "badge-sheriff",
    "server",
    "virus-covid-slash",
    "intersection",
    "shop-lock",
    "family",
    "hourglass-1",
    "hourglass-start",
    "user-hair-buns",
    "blender-phone",
    "hourglass-clock",
    "person-seat-reclined",
    "paper-plane-alt",
    "send",
    "paper-plane-top",
    "comment-alt-arrow-up",
    "message-arrow-up",
    "lightbulb-exclamation",
    "layer-group-minus",
    "layer-minus",
    "chart-pie-simple-circle-currency",
    "circle-e",
    "building-wheat",
    "tachometer-alt-fastest",
    "gauge-max",
    "person-breastfeeding",
    "apostrophe",
    "file-png",
    "fire-hydrant",
    "sign-in-alt",
    "right-to-bracket",
    "video-plus",
    "arrow-alt-square-right",
    "square-right",
    "comment-smile",
    "venus",
    "passport",
    "inbox-arrow-down",
    "inbox-in",
    "heartbeat",
    "heart-pulse",
    "circle-8",
    "clouds-moon",
    "clock-ten-thirty",
    "people-carry",
    "people-carry-box",
    "folder-user",
    "trash-can-xmark",
    "temperature-high",
    "microchip",
    "left-long-to-line",
    "crown",
    "weight-hanging",
    "xmarks-lines",
    "file-prescription",
    "table-cells-lock",
    "calendar-range",
    "flower-daffodil",
    "hand-back-point-up",
    "weight",
    "weight-scale",
    "arrow-up-to-arc",
    "star-exclamation",
    "books",
    "user-friends",
    "user-group",
    "sort-alpha-up",
    "arrow-up-a-z",
    "layer-group-plus",
    "layer-plus",
    "play-pause",
    "block-question",
    "zzz",
    "snooze",
    "scanner-image",
    "tv-retro",
    "square-t",
    "barn-silo",
    "farm",
    "chess-knight",
    "bars-sort",
    "palette-boxes",
    "pallet-alt",
    "pallet-boxes",
    "laugh-squint",
    "face-laugh-squint",
    "code-simple",
    "bolt-slash",
    "panel-fire",
    "binary-circle-check",
    "comment-minus",
    "burrito",
    "violin",
    "objects-column",
    "chevron-square-down",
    "square-chevron-down",
    "comment-plus",
    "triangle-music",
    "triangle-instrument",
    "wheelchair",
    "user-pilot-tie",
    "piano-keyboard",
    "bed-empty",
    "arrow-circle-up",
    "circle-arrow-up",
    "toggle-on",
    "rectangle-portrait",
    "rectangle-vertical",
    "walking",
    "person-walking",
    "l",
    "signal-stream",
    "down-to-bracket",
    "circle-z",
    "stars",
    "fire",
    "procedures",
    "bed-pulse",
    "house-day",
    "space-shuttle",
    "shuttle-space",
    "shirt-long-sleeve",
    "chart-pie-alt",
    "chart-pie-simple",
    "laugh",
    "face-laugh",
    "folder-open",
    "album-collection-circle-user",
    "candy",
    "soup",
    "bowl-hot",
    "flatbread",
    "heart-circle-plus",
    "code-fork",
    "city",
    "signal-alt-1",
    "signal-bars-weak",
    "microphone-alt",
    "microphone-lines",
    "clock-twelve",
    "pepper-hot",
    "citrus-slice",
    "sheep",
    "unlock",
    "colon-sign",
    "headset",
    "badger-honey",
    "h4",
    "store-slash",
    "road-circle-xmark",
    "signal-slash",
    "user-minus",
    "mars-stroke-v",
    "mars-stroke-up",
    "glass-cheers",
    "champagne-glasses",
    "taco",
    "plus-hexagon",
    "hexagon-plus",
    "clipboard",
    "house-circle-exclamation",
    "file-upload",
    "file-arrow-up",
    "wifi-3",
    "wifi-strong",
    "wifi",
    "comments-alt",
    "messages",
    "bathtub",
    "bath",
    "umbrella-alt",
    "umbrella-simple",
    "rectangle-history-circle-plus",
    "underline",
    "prescription-bottle-pill",
    "user-edit",
    "user-pen",
    "binary-slash",
    "square-o",
    "caduceus",
    "signature",
    "stroopwafel",
    "bold",
    "anchor-lock",
    "building-ngo",
    "transporter-3",
    "engine-exclamation",
    "engine-warning",
    "circle-down-right",
    "square-k",
    "manat-sign",
    "money-check-edit",
    "money-check-pen",
    "not-equal",
    "border-style",
    "border-top-left",
    "map-marked-alt",
    "map-location-dot",
    "tilde",
    "jedi",
    "poll",
    "square-poll-vertical",
    "sort-shapes-down-alt",
    "arrow-down-square-triangle",
    "mug-hot",
    "dog-leashed",
    "battery-car",
    "car-battery",
    "face-downcast-sweat",
    "mailbox-flag-up",
    "memo-circle-info",
    "gift",
    "dice-two",
    "volume-medium",
    "volume",
    "transporter-5",
    "gauge-circle-bolt",
    "coin-front",
    "file-slash",
    "message-arrow-up-right",
    "treasure-chest",
    "chess-queen",
    "paint-brush-alt",
    "paint-brush-fine",
    "paintbrush-alt",
    "paintbrush-fine",
    "glasses",
    "hood-cloak",
    "square-quote",
    "up-left",
    "bring-front",
    "chess-board",
    "cheeseburger",
    "burger-cheese",
    "building-circle-check",
    "repeat-1",
    "arrow-to-bottom",
    "arrow-down-to-line",
    "grid-5",
    "swap-arrows",
    "right-long-to-line",
    "person-chalkboard",
    "mars-stroke-h",
    "mars-stroke-right",
    "hand-rock",
    "hand-back-fist",
    "grid-round-5",
    "tally-5",
    "tally",
    "caret-square-up",
    "square-caret-up",
    "cloud-showers-water",
    "bar-chart",
    "chart-bar",
    "hands-wash",
    "hands-bubbles",
    "less-than-equal",
    "train",
    "up-from-dotted-line",
    "low-vision",
    "eye-low-vision",
    "traffic-light-go",
    "face-exhaling",
    "sensor-fire",
    "user-unlock",
    "hexagon-divide",
    "00",
    "crow",
    "betamax",
    "cassette-betamax",
    "sailboat",
    "window-restore",
    "nfc-magnifying-glass",
    "file-binary",
    "circle-v",
    "plus-square",
    "square-plus",
    "bowl-scoops",
    "mistletoe",
    "custard",
    "lacrosse-stick",
    "hockey-mask",
    "sunrise",
    "subtitles",
    "panel-ews",
    "torii-gate",
    "cloud-exclamation",
    "comment-alt-lines",
    "message-lines",
    "frog",
    "bucket",
    "floppy-disk-pen",
    "image",
    "window-frame",
    "microphone",
    "cow",
    "file-zip",
    "square-ring",
    "arrow-alt-from-top",
    "down-from-line",
    "caret-up",
    "shield-times",
    "shield-xmark",
    "screwdriver",
    "sort-circle-down",
    "circle-sort-down",
    "folder-closed",
    "house-tsunami",
    "square-nfi",
    "forklift",
    "arrow-up-from-ground-water",
    "bracket-square-right",
    "glass-martini-alt",
    "martini-glass",
    "rotate-back",
    "rotate-backward",
    "undo-alt",
    "rotate-left",
    "columns",
    "table-columns",
    "square-a",
    "tick",
    "lemon",
    "head-side-mask",
    "handshake",
    "gem",
    "dolly-box",
    "dolly",
    "smoking",
    "compress-arrows-alt",
    "minimize",
    "refrigerator",
    "monument",
    "times-octagon",
    "xmark-octagon",
    "octagon-xmark",
    "align-slash",
    "snowplow",
    "angle-double-right",
    "angles-right",
    "truck-couch",
    "truck-ramp-couch",
    "cannabis",
    "play-circle",
    "circle-play",
    "arrow-up-right-and-arrow-down-left-from-center",
    "location-arrow-up",
    "tablets",
    "360-degrees",
    "ethernet",
    "eur",
    "euro",
    "euro-sign",
    "chair",
    "check-circle",
    "circle-check",
    "square-dashed-circle-plus",
    "hand-holding-circle-dollar",
    "money-simple-from-bracket",
    "bat",
    "stop-circle",
    "circle-stop",
    "head-side-headphones",
    "phone-rotary",
    "arrow-up-to-bracket",
    "drafting-compass",
    "compass-drafting",
    "plate-wheat",
    "calendar-circle-minus",
    "chopsticks",
    "car-mechanic",
    "car-wrench",
    "icicles",
    "person-shelter",
    "neuter",
    "id-badge",
    "kazoo",
    "marker",
    "bin-bottles",
    "laugh-beam",
    "face-laugh-beam",
    "square-arrow-down-left",
    "battery-bolt",
    "tree-large",
    "helicopter-symbol",
    "aperture",
    "universal-access",
    "gear-complex",
    "file-search",
    "file-magnifying-glass",
    "up-right",
    "chevron-circle-up",
    "circle-chevron-up",
    "user-police",
    "lari-sign",
    "volcano",
    "teddy-bear",
    "stocking",
    "person-walking-dashed-line-arrow-right",
    "image-slash",
    "mask-snorkel",
    "smoke",
    "gbp",
    "pound-sign",
    "sterling-sign",
    "battery-exclamation",
    "viruses",
    "square-person-confined",
    "user-tie",
    "up-to-bracket",
    "long-arrow-down",
    "arrow-down-long",
    "tent-arrow-down-to-line",
    "certificate",
    "crystal-ball",
    "mail-reply-all",
    "reply-all",
    "suitcase",
    "skating",
    "person-skating",
    "star-shooting",
    "binary-lock",
    "funnel-dollar",
    "filter-circle-dollar",
    "camera-retro",
    "arrow-circle-down",
    "circle-arrow-down",
    "comment-edit",
    "comment-pen",
    "arrow-right-to-file",
    "file-import",
    "banjo",
    "external-link-square",
    "square-arrow-up-right",
    "light-emergency-on",
    "kerning",
    "box-open",
    "square-f",
    "scroll",
    "spa",
    "arrow-from-right",
    "arrow-left-from-line",
    "strawberry",
    "location-pin-lock",
    "pause",
    "clock-eight-thirty",
    "plane-alt",
    "plane-engines",
    "hill-avalanche",
    "temperature-0",
    "thermometer-0",
    "thermometer-empty",
    "temperature-empty",
    "bomb",
    "tachometer-alt-slow",
    "gauge-low",
    "registered",
    "trash-can-plus",
    "contact-card",
    "vcard",
    "address-card",
    "balance-scale-right",
    "scale-unbalanced-flip",
    "globe-snow",
    "subscript",
    "directions",
    "diamond-turn-right",
    "integral",
    "burst",
    "laptop-house",
    "house-laptop",
    "tired",
    "face-tired",
    "money-bills",
    "blinds-raised",
    "smog",
    "ufo-beam",
    "caret-circle-up",
    "circle-caret-up",
    "user-vneck-hair-long",
    "square-a-lock",
    "crutch",
    "gas-pump-slash",
    "font-awesome-flag",
    "font-awesome-logo-full",
    "font-awesome",
    "cloud-upload",
    "cloud-upload-alt",
    "cloud-arrow-up",
    "palette",
    "transporter-4",
    "chart-mixed-up-circle-currency",
    "objects-align-right",
    "arrows-turn-right",
    "vest",
    "pig",
    "inbox-full",
    "envelope-circle",
    "circle-envelope",
    "construction",
    "triangle-person-digging",
    "ferry",
    "bullseye-arrow",
    "arrows-down-to-people",
    "sprout",
    "seedling",
    "clock-seven",
    "arrows-alt-h",
    "left-right",
    "boxes-packing",
    "arrow-circle-left",
    "circle-arrow-left",
    "flashlight",
    "file-jpg",
    "group-arrows-rotate",
    "bowl-food",
    "square-9",
    "candy-cane",
    "sort-amount-asc",
    "sort-amount-down",
    "arrow-down-wide-short",
    "dollar-square",
    "usd-square",
    "square-dollar",
    "phone-arrow-right",
    "hand-holding-seedling",
    "comment-alt-check",
    "message-check",
    "thunderstorm",
    "cloud-bolt",
    "chart-line-up-down",
    "remove-format",
    "text-slash",
    "watch",
    "circle-down-left",
    "text",
    "projector",
    "smile-wink",
    "face-smile-wink",
    "tombstone-alt",
    "tombstone-blank",
    "chess-king-alt",
    "chess-king-piece",
    "circle-6",
    "waves-sine",
    "arrow-alt-left",
    "left",
    "file-word",
    "file-powerpoint",
    "arrow-alt-square-down",
    "square-down",
    "objects-align-center-vertical",
    "arrows-h",
    "arrows-left-right",
    "house-lock",
    "cloud-download",
    "cloud-download-alt",
    "cloud-arrow-down",
    "wreath",
    "children",
    "meter-droplet",
    "blackboard",
    "chalkboard",
    "user-alt-slash",
    "user-large-slash",
    "signal-4",
    "signal-strong",
    "lollypop",
    "lollipop",
    "list-tree",
    "envelope-open",
    "draw-circle",
    "cat-space",
    "handshake-alt-slash",
    "handshake-simple-slash",
    "rabbit-fast",
    "rabbit-running",
    "memo-pad",
    "mattress-pillow",
    "alarm-plus",
    "alicorn",
    "comment-question",
    "gingerbread-man",
    "guarani-sign",
    "burger-fries",
    "mug-tea",
    "border-top",
    "refresh",
    "sync",
    "arrows-rotate",
    "book-circle",
    "circle-book-open",
    "arrows-to-dotted-line",
    "fire-extinguisher",
    "magnifying-glass-arrows-rotate",
    "garage-open",
    "shelves-empty",
    "cruzeiro-sign",
    "watch-apple",
    "watch-calculator",
    "list-dropdown",
    "cabinet-filing",
    "burger-soda",
    "arrow-square-up",
    "square-arrow-up",
    "greater-than-equal",
    "pallet-box",
    "face-confounded",
    "shield-alt",
    "shield-halved",
    "truck-plow",
    "atlas",
    "book-atlas",
    "virus",
    "grid-round-2",
    "comment-middle-top",
    "wave",
    "envelope-circle-check",
    "layer-group",
    "restroom-simple",
    "arrows-to-dot",
    "border-outer",
    "hashtag-lock",
    "clock-two-thirty",
    "archway",
    "heart-circle-check",
    "house-damage",
    "house-chimney-crack",
    "file-archive",
    "file-zipper",
    "ticket-perforated",
    "heart-half",
    "comment-check",
    "square",
    "memo",
    "glass-martini",
    "martini-glass-empty",
    "couch",
    "cedi-sign",
    "italic",
    "glass-citrus",
    "calendar-lines-pen",
    "table-cells-column-lock",
    "church",
    "snowmobile",
    "person-snowmobiling",
    "face-hushed",
    "comments-dollar",
    "tickets-simple",
    "pickaxe",
    "link-simple-slash",
    "democrat",
    "face-confused",
    "pinball",
    "z",
    "skiing",
    "person-skiing",
    "deer",
    "input-pipe",
    "road-lock",
    "a",
    "bookmark-slash",
    "temperature-down",
    "temperature-arrow-down",
    "mace",
    "feather-alt",
    "feather-pointed",
    "sausage",
    "trash-can-clock",
    "p",
    "broom-wide",
    "snowflake",
    "stomach",
    "newspaper",
    "ad",
    "rectangle-ad",
    "guitar-electric",
    "arrow-turn-down-right",
    "moon-cloud",
    "bread-slice-butter",
    "arrow-circle-right",
    "circle-arrow-right",
    "users-crown",
    "user-group-crown",
    "circle-i",
    "toilet-paper-check",
    "filter-circle-xmark",
    "locust",
    "unsorted",
    "sort",
    "list-1-2",
    "list-numeric",
    "list-ol",
    "chart-waterfall",
    "sparkle",
    "face-party",
    "kidneys",
    "wifi-exclamation",
    "chart-network",
    "person-dress-burst",
    "dice-d4",
    "money-check-alt",
    "money-check-dollar",
    "vector-square",
    "bread-slice",
    "language",
    "wheat-awn-slash",
    "kiss-wink-heart",
    "face-kiss-wink-heart",
    "dagger",
    "podium",
    "memo-circle-check",
    "route-highway",
    "arrow-alt-to-bottom",
    "down-to-line",
    "filter",
    "square-g",
    "phone-circle",
    "circle-phone",
    "clipboard-prescription",
    "user-nurse-hair",
    "question",
    "file-signature",
    "toggle-large-on",
    "arrows-alt",
    "up-down-left-right",
    "dryer-alt",
    "dryer-heat",
    "house-chimney-user",
    "hand-holding-heart",
    "sort-size-up-alt",
    "arrow-up-small-big",
    "train-track",
    "puzzle-piece",
    "money-check",
    "star-half-alt",
    "star-half-stroke",
    "file-exclamation",
    "code",
    "glass-whiskey",
    "whiskey-glass",
    "moon-stars",
    "building-circle-exclamation",
    "clothes-hanger",
    "mobile-iphone",
    "mobile-notch",
    "magnifying-glass-chart",
    "external-link",
    "arrow-up-right-from-square",
    "cubes-stacked",
    "images-user",
    "krw",
    "won",
    "won-sign",
    "image-polaroid-user",
    "virus-covid",
    "square-ellipsis",
    "pie",
    "chess-knight-alt",
    "chess-knight-piece",
    "austral-sign",
    "cloud-plus",
    "f",
    "leaf",
    "bed-bunk",
    "road",
    "cab",
    "taxi",
    "person-circle-plus",
    "pie-chart",
    "chart-pie",
    "bolt-lightning",
    "clock-eight",
    "sack-xmark",
    "file-xls",
    "file-excel",
    "file-contract",
    "fish-fins",
    "circle-q",
    "building-flag",
    "grin-beam",
    "face-grin-beam",
    "object-ungroup",
    "face-disguise",
    "circle-arrow-down-right",
    "alien-monster",
    "alien-8bit",
    "hand-point-ribbon",
    "poop",
    "object-exclude",
    "telescope",
    "map-marker",
    "location-pin",
    "square-list",
    "kaaba",
    "toilet-paper",
    "hard-hat",
    "hat-hard",
    "helmet-safety",
    "comment-code",
    "sim-cards",
    "starship",
    "eject",
    "arrow-alt-circle-right",
    "circle-right",
    "plane-circle-check",
    "seal",
    "user-cowboy",
    "hexagon-vertical-nft",
    "meh-rolling-eyes",
    "face-rolling-eyes",
    "bread-loaf",
    "rings-wedding",
    "object-group",
    "french-fries",
    "line-chart",
    "chart-line",
    "calendar-download",
    "calendar-arrow-down",
    "send-back",
    "mask-ventilator",
    "tickets",
    "signature-lock",
    "arrow-right",
    "map-signs",
    "signs-post",
    "plus-octagon",
    "octagon-plus",
    "cash-register",
    "person-circle-question",
    "melon-slice",
    "space-station-moon",
    "comment-alt-smile",
    "message-smile",
    "cup-straw",
    "arrow-alt-from-right",
    "left-from-line",
    "h",
    "shopping-basket-alt",
    "basket-shopping-simple",
    "hands-heart",
    "hands-holding-heart",
    "clock-nine",
    "hammer-brush",
    "tarp",
    "face-sleepy",
    "hand-horns",
    "tools",
    "screwdriver-wrench",
    "arrows-to-eye",
    "circle-three-quarters",
    "trophy-alt",
    "trophy-star",
    "plug-circle-bolt",
    "face-thermometer",
    "grid-round-4",
    "sign-posts-wrench",
    "shirt-running",
    "book-circle-arrow-up",
    "face-nauseated",
    "heart",
    "file-chart-pie",
    "mars-and-venus",
    "home-user",
    "house-user",
    "circle-arrow-down-left",
    "dumpster-fire",
    "minus-hexagon",
    "hexagon-minus",
    "arrow-alt-to-left",
    "left-to-line",
    "house-crack",
    "paw-alt",
    "paw-simple",
    "arrow-left-long-to-line",
    "parentheses",
    "brackets-round",
    "cocktail",
    "martini-glass-citrus",
    "user-shakespeare",
    "arrow-right-to-arc",
    "surprise",
    "face-surprise",
    "bottle-water",
    "pause-circle",
    "circle-pause",
    "gauge-circle-plus",
    "folders",
    "angel",
    "value-absolute",
    "rabbit",
    "toilet-paper-slash",
    "circle-euro",
    "apple-alt",
    "apple-whole",
    "kitchen-set",
    "diamond-half",
    "lock-alt",
    "lock-keyhole",
    "r",
    "temperature-1",
    "thermometer-1",
    "thermometer-quarter",
    "temperature-quarter",
    "info-square",
    "square-info",
    "wifi-slash",
    "toilet-paper-xmark",
    "hands-usd",
    "hands-holding-dollar",
    "cube",
    "sort-shapes-down",
    "arrow-down-triangle-square",
    "bitcoin-sign",
    "shutters",
    "shield-dog",
    "solar-panel",
    "lock-open",
    "table-tree",
    "house-chimney-heart",
    "tally-3",
    "elevator",
    "money-bill-transfer",
    "money-bill-trend-up",
    "house-flood-water-circle-arrow-right",
    "poll-h",
    "square-poll-horizontal",
    "circle",
    "left-to-bracket",
    "cart-circle-exclamation",
    "sword",
    "fast-backward",
    "backward-fast",
    "recycle",
    "user-astronaut",
    "interrobang",
    "plane-slash",
    "circle-dashed",
    "trademark",
    "basketball-ball",
    "basketball",
    "utensils-alt",
    "fork-knife",
    "satellite-dish",
    "badge-check",
    "arrow-alt-circle-up",
    "circle-up",
    "slider",
    "mobile-alt",
    "mobile-screen-button",
    "clock-one-thirty",
    "inbox-arrow-up",
    "inbox-out",
    "cloud-slash",
    "volume-up",
    "volume-high",
    "users-rays",
    "wallet",
    "octagon-check",
    "flatbread-stuffed",
    "clipboard-check",
    "cart-circle-plus",
    "shipping-timed",
    "truck-clock",
    "pool-8-ball",
    "file-audio",
    "turn-down-left",
    "lock-hashtag",
    "chart-radar",
    "staff",
    "hamburger",
    "burger",
    "utility-pole",
    "transporter-6",
    "arrow-turn-left",
    "wrench",
    "bugs",
    "vector-polygon",
    "diagram-nested",
    "rupee",
    "rupee-sign",
    "file-image",
    "question-circle",
    "circle-question",
    "tickets-perforated",
    "image-user",
    "buoy",
    "plane-departure",
    "handshake-slash",
    "book-bookmark",
    "border-center-h",
    "can-food",
    "typewriter",
    "arrow-right-from-arc",
    "circle-k",
    "face-hand-over-mouth",
    "popcorn",
    "house-flood",
    "house-water",
    "object-subtract",
    "code-branch",
    "warehouse-alt",
    "warehouse-full",
    "hat-cowboy",
    "bridge",
    "phone-alt",
    "phone-flip",
    "arrow-down-from-dotted-line",
    "file-doc",
    "square-quarters",
    "truck-front",
    "cat",
    "trash-xmark",
    "caret-circle-left",
    "circle-caret-left",
    "files",
    "anchor-circle-exclamation",
    "face-clouds",
    "user-crown",
    "basket-shopping-plus",
    "truck-field",
    "route",
    "cart-circle-check",
    "clipboard-question",
    "panorama",
    "comment-medical",
    "teeth-open",
    "user-tie-hair-long",
    "file-circle-minus",
    "head-side-medical",
    "arrow-turn-right",
    "tags",
    "wine-glass",
    "fast-forward",
    "forward-fast",
    "meh-blank",
    "face-meh-blank",
    "user-robot",
    "parking",
    "square-parking",
    "card-diamond",
    "face-zipper",
    "face-raised-eyebrow",
    "house-signal",
    "chevron-square-up",
    "square-chevron-up",
    "nfc-symbol",
    "tasks-alt",
    "bars-progress",
    "faucet-drip",
    "arrows-to-line",
    "dolphin",
    "arrow-up-right",
    "circle-r",
    "dolly-flatbed",
    "cart-flatbed",
    "smoking-ban",
    "ban-smoking",
    "sort-circle-up",
    "circle-sort-up",
    "terminal",
    "mobile-button",
    "house-medical-flag",
    "shopping-basket",
    "basket-shopping",
    "tape",
    "chestnut",
    "bus-alt",
    "bus-simple",
    "eye",
    "sad-cry",
    "face-sad-cry",
    "heat",
    "ticket-perforated-plane",
    "ticket-plane",
    "ticket-airline",
    "boot-heeled",
    "compress-arrows",
    "arrows-minimize",
    "audio-description",
    "person-military-to-person",
    "file-shield",
    "hexagon",
    "manhole",
    "user-slash",
    "pen",
    "tower-observation",
    "floppy-disks",
    "toilet-paper-reverse-alt",
    "toilet-paper-blank-under",
    "file-code",
    "signal-5",
    "signal-perfect",
    "signal",
    "pump",
    "bus",
    "heart-circle-xmark",
    "arrow-up-left-from-circle",
    "home-lg",
    "house-chimney",
    "window-maximize",
    "dryer",
    "frown",
    "face-frown",
    "chess-bishop-alt",
    "chess-bishop-piece",
    "shirt-tank-top",
    "scroll-ribbon",
    "diploma",
    "screencast",
    "walker",
    "prescription",
    "store-alt",
    "shop",
    "save",
    "floppy-disk",
    "vihara",
    "face-kiss-closed-eyes",
    "balance-scale-left",
    "scale-unbalanced",
    "file-user",
    "user-police-tie",
    "face-tongue-money",
    "tennis-ball",
    "square-l",
    "sort-asc",
    "sort-up",
    "calendar-upload",
    "calendar-arrow-up",
    "commenting",
    "comment-dots",
    "plant-wilt",
    "scarf",
    "album-circle-plus",
    "user-nurse-hair-long",
    "diamond",
    "arrow-alt-square-left",
    "square-left",
    "grin-squint",
    "face-grin-squint",
    "circle-ellipsis-vertical",
    "hand-holding-usd",
    "hand-holding-dollar",
    "grid-dividers",
    "bacterium",
    "hand-pointer",
    "drum-steelpan",
    "hand-scissors",
    "praying-hands",
    "hands-praying",
    "face-pensive",
    "user-music",
    "arrow-right-rotate",
    "arrow-rotate-forward",
    "redo",
    "arrow-rotate-right",
    "comments-alt-dollar",
    "messages-dollar",
    "sensor-on",
    "balloon",
    "web-awesome",
    "biohazard",
    "chess-queen-alt",
    "chess-queen-piece",
    "location",
    "location-crosshairs",
    "mars-double",
    "left-from-bracket",
    "house-leave",
    "house-person-depart",
    "house-person-leave",
    "ruler-triangle",
    "card-club",
    "child-dress",
    "users-between-lines",
    "lungs-virus",
    "spinner-third",
    "grin-tears",
    "face-grin-tears",
    "phone",
    "mouse-alt",
    "computer-mouse-scrollwheel",
    "calendar-times",
    "calendar-xmark",
    "child-reaching",
    "table-layout",
    "narwhal",
    "ramp-loading",
    "calendar-circle-plus",
    "toothbrush",
    "border-inner",
    "paw-claws",
    "kiwi-fruit",
    "traffic-light-slow",
    "rectangle-code",
    "head-side-virus",
    "keyboard-brightness",
    "books-medical",
    "lightbulb-slash",
    "home-blank",
    "house-blank",
    "square-5",
    "heart-square",
    "square-heart",
    "puzzle",
    "user-cog",
    "user-gear",
    "pipe-circle-check",
    "sort-numeric-up",
    "arrow-up-1-9",
    "octagon-exclamation",
    "dial-low",
    "door-closed",
    "phone-laptop",
    "laptop-mobile",
    "conveyor-belt-alt",
    "conveyor-belt-boxes",
    "shield-virus",
    "starfighter-alt-advanced",
    "starfighter-twin-ion-engine-advanced",
    "dice-six",
    "starfighter-alt",
    "starfighter-twin-ion-engine",
    "rocket-launch",
    "mosquito-net",
    "vent-damper",
    "bridge-water",
    "debug",
    "ban-bug",
    "person-booth",
    "text-width",
    "garage-car",
    "square-kanban",
    "hat-wizard",
    "chart-kanban",
    "pen-fancy",
    "coffee-pot",
    "mouse-field",
    "digging",
    "person-digging",
    "shower-alt",
    "shower-down",
    "box-circle-check",
    "brightness",
    "car-side-bolt",
    "file-xml",
    "ornament",
    "phone-arrow-down",
    "phone-incoming",
    "phone-arrow-down-left",
    "cloud-word",
    "hand-fingers-crossed",
    "trash",
    "gauge-simple-med",
    "tachometer-average",
    "gauge-simple",
    "sort-size-down-alt",
    "arrow-down-small-big",
    "book-medical",
    "face-melting",
    "poo",
    "pen-alt-slash",
    "pen-clip-slash",
    "quote-right-alt",
    "quote-right",
    "scroll-old",
    "guitars",
    "phone-xmark",
    "hose",
    "clock-six",
    "t-shirt",
    "tshirt",
    "shirt",
    "billboard",
    "square-r",
    "cubes",
    "envelope-open-dollar",
    "divide",
    "sun-cloud",
    "lamp-floor",
    "square-7",
    "tenge",
    "tenge-sign",
    "headphones",
    "hands-holding",
    "campfire",
    "circle-ampersand",
    "snowflakes",
    "hands-clapping",
    "republican",
    "leaf-maple",
    "arrow-left",
    "person-circle-xmark",
    "ruler",
    "arrow-left-from-bracket",
    "cup-straw-swoosh",
    "temperature-hot",
    "temperature-sun",
    "align-left",
    "dice-d6",
    "restroom",
    "rectangle-hd",
    "high-definition",
    "j",
    "galaxy",
    "users-viewfinder",
    "file-video",
    "cherries",
    "external-link-alt",
    "up-right-from-square",
    "sort-circle",
    "circle-sort",
    "th",
    "table-cells",
    "bag-shopping-minus",
    "file-pdf",
    "siren",
    "arrow-up-to-dotted-line",
    "landscape",
    "image-landscape",
    "tank-water",
    "curling",
    "curling-stone",
    "gamepad-alt",
    "gamepad-modern",
    "messages-question",
    "bible",
    "book-bible",
    "o",
    "medkit",
    "suitcase-medical",
    "briefcase-arrow-right",
    "expand-wide",
    "clock-eleven-thirty",
    "rv",
    "user-secret",
    "otter",
    "dreidel",
    "female",
    "person-dress",
    "comment-dollar",
    "briefcase-clock",
    "business-time",
    "flower-tulip",
    "people-pants-simple",
    "cloud-drizzle",
    "th-large",
    "table-cells-large",
    "tanakh",
    "book-tanakh",
    "solar-system",
    "seal-question",
    "volume-control-phone",
    "phone-volume",
    "disc-drive",
    "hat-cowboy-side",
    "rows",
    "table-rows",
    "map-marker-exclamation",
    "location-exclamation",
    "face-fearful",
    "clipboard-user",
    "bus-school",
    "film-slash",
    "square-arrow-down-right",
    "book-spells",
    "book-sparkles",
    "washer",
    "washing-machine",
    "child",
    "lira-sign",
    "user-visor",
    "file-plus-minus",
    "chess-clock-alt",
    "chess-clock-flip",
    "satellite",
    "truck-fire",
    "plane-lock",
    "steering-wheel",
    "tag",
    "stretcher",
    "book-law",
    "book-section",
    "inboxes",
    "coffee-bean",
    "circle-yen",
    "brackets-curly",
    "ellipsis-v-alt",
    "ellipsis-stroke-vertical",
    "comment",
    "square-1",
    "birthday-cake",
    "cake",
    "cake-candles",
    "head-side",
    "truck-ladder",
    "envelope",
    "dolly-empty",
    "face-tissue",
    "angle-double-up",
    "angles-up",
    "bin-recycle",
    "paperclip",
    "chart-line-down",
    "arrow-right-to-city",
    "lock-a",
    "ribbon",
    "lungs",
    "person-pinball",
    "sort-numeric-up-alt",
    "arrow-up-9-1",
    "apple-core",
    "circle-y",
    "h6",
    "litecoin-sign",
    "bottle-baby",
    "circle-small",
    "border-none",
    "arrow-turn-down-left",
    "circle-wifi-group",
    "circle-wifi-circle-wifi",
    "circle-nodes",
    "parachute-box",
    "reflect-horizontal",
    "comment-alt-medical",
    "message-medical",
    "rugby-ball",
    "comment-music",
    "indent",
    "tree-alt",
    "tree-deciduous",
    "puzzle-piece-alt",
    "puzzle-piece-simple",
    "truck-field-un",
    "nfc-trash",
    "hourglass-empty",
    "hourglass",
    "mountain",
    "file-times",
    "file-xmark",
    "home-heart",
    "house-heart",
    "house-chimney-blank",
    "meter-bolt",
    "user-md",
    "user-doctor",
    "slash-back",
    "info-circle",
    "circle-info",
    "fishing-rod",
    "hammer-crash",
    "message-heart",
    "cloud-meatball",
    "camera-polaroid",
    "camera-alt",
    "camera",
    "square-virus",
    "cart-arrow-up",
    "meteor",
    "car-on",
    "sleigh",
    "sort-numeric-asc",
    "sort-numeric-down",
    "arrow-down-1-9",
    "buoy-mooring",
    "square-4",
    "hand-holding-water",
    "hand-holding-droplet",
    "file-eps",
    "tricycle-adult",
    "waveform",
    "water",
    "star-sharp-half-alt",
    "star-sharp-half-stroke",
    "nfc-signal",
    "plane-prop",
    "calendar-check",
    "clock-desk",
    "calendar-time",
    "calendar-clock",
    "braille",
    "prescription-bottle-alt",
    "prescription-bottle-medical",
    "plate-utensils",
    "family-pants",
    "hose-reel",
    "house-window",
    "landmark",
    "truck",
    "music-magnifying-glass",
    "crosshairs",
    "cloud-rainbow",
    "person-cane",
    "alien",
    "tent",
    "laptop-binary",
    "vest-patches",
    "people-dress-simple",
    "check-double",
    "sort-alpha-asc",
    "sort-alpha-down",
    "arrow-down-a-z",
    "bowling-ball-pin",
    "bell-school-slash",
    "plus-large",
    "money-bill-wheat",
    "screenshot",
    "camera-viewfinder",
    "comment-alt-music",
    "message-music",
    "car-building",
    "border-style-alt",
    "border-bottom-right",
    "octagon",
    "comment-arrow-up-right",
    "octagon-divide",
    "cookie",
    "arrow-left-rotate",
    "arrow-rotate-back",
    "arrow-rotate-backward",
    "undo",
    "arrow-rotate-left",
    "tv-music",
    "hdd",
    "hard-drive",
    "reel",
    "grin-squint-tears",
    "face-grin-squint-tears",
    "dumbbell",
    "list-alt",
    "rectangle-list",
    "tarp-droplet",
    "alarm-exclamation",
    "house-medical-circle-check",
    "traffic-cone",
    "grate",
    "arrow-down-right",
    "skiing-nordic",
    "person-skiing-nordic",
    "calendar-plus",
    "portal-exit",
    "person-from-portal",
    "plane-arrival",
    "cowbell-more",
    "cowbell-circle-plus",
    "arrow-alt-circle-left",
    "circle-left",
    "distribute-spacing-vertical",
    "signal-alt-2",
    "signal-bars-fair",
    "sportsball",
    "game-console-handheld-crank",
    "subway",
    "train-subway",
    "chart-gantt",
    "face-smile-upside-down",
    "ball-pile",
    "badge-dollar",
    "money-bills-alt",
    "money-bills-simple",
    "list-timeline",
    "indian-rupee",
    "inr",
    "indian-rupee-sign",
    "crop-alt",
    "crop-simple",
    "money-bill-alt",
    "money-bill-1",
    "long-arrow-alt-left",
    "left-long",
    "keyboard-down",
    "circle-up-right",
    "thunderstorm-moon",
    "cloud-bolt-moon",
    "turn-left-up",
    "dna",
    "virus-slash",
    "bracket-round-right",
    "circle-sterling",
    "circle-5",
    "subtract",
    "minus",
    "flame",
    "fire-flame",
    "arrow-alt-to-right",
    "right-to-line",
    "gif",
    "chess",
    "trash-slash",
    "long-arrow-left",
    "arrow-left-long",
    "plug-circle-check",
    "font-case",
    "street-view",
    "arrow-down-left",
    "franc-sign",
    "flask-poison",
    "flask-round-poison",
    "volume-off",
    "book-circle-arrow-right",
    "user-chart",
    "chart-user",
    "american-sign-language-interpreting",
    "asl-interpreting",
    "hands-american-sign-language-interpreting",
    "hands-asl-interpreting",
    "presentation",
    "presentation-screen",
    "circle-bolt",
    "face-smile-halo",
    "cart-circle-arrow-down",
    "house-person-arrive",
    "house-return",
    "house-person-return",
    "comment-alt-times",
    "message-times",
    "message-xmark",
    "file-award",
    "file-certificate",
    "user-doctor-hair-long",
    "camera-home",
    "camera-security",
    "cog",
    "gear",
    "tint-slash",
    "droplet-slash",
    "book-heart",
    "mosque",
    "duck",
    "mosquito",
    "star-of-david",
    "flag-alt",
    "flag-swallowtail",
    "person-military-rifle",
    "car-garage",
    "shopping-cart",
    "cart-shopping",
    "book-font",
    "shield-plus",
    "vials",
    "eye-dropper-full",
    "distribute-spacing-horizontal",
    "tablet-rugged",
    "temperature-frigid",
    "temperature-snow",
    "moped",
    "smile-plus",
    "face-smile-plus",
    "radio-alt",
    "radio-tuner",
    "face-swear",
    "water-lower",
    "water-arrow-down",
    "scanner-touchscreen",
    "circle-7",
    "plug-circle-plus",
    "ski-jump",
    "person-ski-jumping",
    "place-of-worship",
    "water-rise",
    "water-arrow-up",
    "waveform-path",
    "waveform-lines",
    "split",
    "film-cannister",
    "film-canister",
    "folder-times",
    "folder-xmark",
    "toilet-paper-alt",
    "toilet-paper-blank",
    "tablet-android-alt",
    "tablet-screen",
    "hexagon-vertical-nft-slanted",
    "folder-music",
    "desktop-medical",
    "display-medical",
    "share-all",
    "peapod",
    "chess-clock",
    "axe",
    "square-d",
    "grip-vertical",
    "mobile-signal-out",
    "level-up",
    "arrow-turn-up",
    "u",
    "arrow-up-from-dotted-line",
    "square-root-alt",
    "square-root-variable",
    "light-switch-on",
    "sort-alt",
    "arrow-down-arrow-up",
    "raindrops",
    "minus-large",
    "dash",
    "clock-four",
    "clock",
    "input-numeric",
    "truck-tow",
    "step-backward",
    "backward-step",
    "pallet",
    "car-bolt",
    "expand-arrows",
    "arrows-maximize",
    "faucet",
    "cloud-sleet",
    "lamp-street",
    "list-radio",
    "pen-nib-slash",
    "baseball-bat-ball",
    "square-up-left",
    "overline",
    "s",
    "timeline",
    "keyboard",
    "arrows-from-dotted-line",
    "usb-drive",
    "ballot",
    "caret-down",
    "map-marker-alt-slash",
    "location-dot-slash",
    "cards",
    "clinic-medical",
    "house-chimney-medical",
    "glove-boxing",
    "boxing-glove",
    "temperature-3",
    "thermometer-3",
    "thermometer-three-quarters",
    "temperature-three-quarters",
    "bell-school",
    "mobile-android-alt",
    "mobile-screen",
    "plane-up",
    "folder-heart",
    "location-circle",
    "circle-location-arrow",
    "face-head-bandage",
    "maki-roll",
    "makizushi",
    "sushi-roll",
    "car-bump",
    "piggy-bank",
    "racquet",
    "car-mirrors",
    "industry-alt",
    "industry-windows",
    "bolt-auto",
    "battery-3",
    "battery-half",
    "flux-capacitor",
    "mountain-city",
    "coins",
    "honey-pot",
    "olive",
    "khanda",
    "filter-list",
    "outlet",
    "sliders-h",
    "sliders",
    "cauldron",
    "people",
    "folder-tree",
    "network-wired",
    "croissant",
    "map-pin",
    "hamsa",
    "cent-sign",
    "swords-laser",
    "flask",
    "person-pregnant",
    "square-u",
    "wand-sparkles",
    "router",
    "ellipsis-v",
    "ellipsis-vertical",
    "sword-laser-alt",
    "ticket",
    "power-off",
    "coin",
    "laptop-slash",
    "long-arrow-alt-right",
    "right-long",
    "circle-b",
    "person-dress-simple",
    "pipe-collar",
    "lights-holiday",
    "citrus",
    "flag-usa",
    "laptop-file",
    "teletype",
    "tty",
    "chart-tree-map",
    "diagram-next",
    "person-rifle",
    "clock-five-thirty",
    "pipe-valve",
    "arrow-up-from-arc",
    "face-spiral-eyes",
    "compress-wide",
    "phone-circle-down",
    "circle-phone-hangup",
    "gear-complex-code",
    "house-medical-circle-exclamation",
    "badminton",
    "closed-captioning",
    "hiking",
    "person-hiking",
    "arrow-alt-from-left",
    "right-from-line",
    "venus-double",
    "images",
    "calculator",
    "shuttlecock",
    "user-hair",
    "eye-evil",
    "people-pulling",
    "n",
    "swap",
    "garage",
    "tram",
    "cable-car",
    "shovel-snow",
    "cloud-rain",
    "face-lying",
    "sprinkler",
    "building-circle-xmark",
    "sledding",
    "person-sledding",
    "game-console-handheld",
    "ship",
    "clock-six-thirty",
    "battery-slash",
    "tugrik-sign",
    "arrows-down-to-line",
    "download",
    "angles-up-down",
    "inventory",
    "shelves",
    "cloud-snow",
    "grin",
    "face-grin",
    "backspace",
    "delete-left",
    "oven",
    "cloud-binary",
    "eye-dropper-empty",
    "eyedropper",
    "eye-dropper",
    "comment-captions",
    "comments-question",
    "scribble",
    "rotate-exclamation",
    "file-circle-check",
    "glass",
    "loader",
    "forward",
    "user-pilot",
    "mobile-android",
    "mobile-phone",
    "mobile",
    "code-pull-request-closed",
    "meh",
    "face-meh",
    "align-center",
    "book-dead",
    "book-skull",
    "drivers-license",
    "id-card",
    "face-dotted",
    "face-worried",
    "dedent",
    "outdent",
    "court-sport",
    "heart-circle-exclamation",
    "home",
    "home-alt",
    "home-lg-alt",
    "house",
    "vector-circle",
    "car-circle-bolt",
    "calendar-week",
    "flying-disc",
    "laptop-medical",
    "square-down-right",
    "b",
    "seat-airline",
    "eclipse-alt",
    "moon-over-sun",
    "pipe",
    "file-medical",
    "potato",
    "dice-one",
    "circle-a",
    "helmet-battle",
    "butter",
    "blanket-fire",
    "kiwi-bird",
    "castle",
    "golf-club",
    "exchange",
    "arrow-right-arrow-left",
    "redo-alt",
    "rotate-forward",
    "rotate-right",
    "cutlery",
    "utensils",
    "sort-amount-up",
    "arrow-up-wide-short",
    "chart-pie-simple-circle-dollar",
    "balloons",
    "mill-sign",
    "bowl-rice",
    "timeline-arrow",
    "skull",
    "game-board-alt",
    "game-board-simple",
    "video-circle",
    "circle-video",
    "chart-scatter-bubble",
    "house-turret",
    "banana",
    "hand-holding-skull",
    "people-dress",
    "couch-small",
    "loveseat",
    "broadcast-tower",
    "tower-broadcast",
    "truck-pickup",
    "block-quote",
    "long-arrow-alt-up",
    "up-long",
    "stop",
    "code-merge",
    "money-check-edit-alt",
    "money-check-dollar-pen",
    "arrow-alt-from-bottom",
    "up-from-line",
    "upload",
    "hurricane",
    "grid-round-2-plus",
    "people-pants",
    "mound",
    "windsock",
    "circle-half",
    "brake-warning",
    "toilet-portable",
    "compact-disc",
    "file-download",
    "file-arrow-down",
    "sax-hot",
    "saxophone-fire",
    "webcam-slash",
    "camera-web-slash",
    "folder-medical",
    "folder-cog",
    "folder-gear",
    "hand-wave",
    "sort-up-down",
    "arrow-up-arrow-down",
    "caravan",
    "shield-cat",
    "comment-alt-slash",
    "message-slash",
    "zap",
    "bolt",
    "trash-can-check",
    "glass-water",
    "oil-well",
    "person-simple",
    "arrow-turn-left-up",
    "vault",
    "mars",
    "toilet",
    "plane-circle-xmark",
    "cny",
    "jpy",
    "rmb",
    "yen",
    "yen-sign",
    "gear-code",
    "notes",
    "rouble",
    "rub",
    "ruble",
    "ruble-sign",
    "trash-arrow-turn-left",
    "trash-undo",
    "glass-champagne",
    "champagne-glass",
    "objects-align-center-horizontal",
    "sun",
    "trash-alt-slash",
    "trash-can-slash",
    "users-class",
    "screen-users",
    "guitar",
    "arrow-square-left",
    "square-arrow-left",
    "square-8",
    "face-smile-hearts",
    "brackets",
    "brackets-square",
    "laptop-arrow-down",
    "hockey-stick-puck",
    "house-tree",
    "signal-2",
    "signal-fair",
    "laugh-wink",
    "face-laugh-wink",
    "dollar-circle",
    "usd-circle",
    "circle-dollar",
    "horse-head",
    "repeat-alt",
    "arrows-repeat",
    "bore-hole",
    "industry",
    "image-polaroid",
    "wave-triangle",
    "turn-left-down",
    "person-running-fast",
    "arrow-alt-circle-down",
    "circle-down",
    "grill",
    "arrows-turn-to-dots",
    "analytics",
    "chart-mixed",
    "florin-sign",
    "sort-amount-desc",
    "sort-amount-down-alt",
    "arrow-down-short-wide",
    "less-than",
    "desktop-code",
    "display-code",
    "face-drooling",
    "oil-temp",
    "oil-temperature",
    "question-square",
    "square-question",
    "air-conditioner",
    "angle-down",
    "mountains",
    "omega",
    "car-tunnel",
    "person-dolly-empty",
    "pan-food",
    "head-side-cough",
    "grip-lines",
    "thumbs-down",
    "user-lock",
    "long-arrow-right",
    "arrow-right-long",
    "tickets-perforated-plane",
    "tickets-plane",
    "tickets-airline",
    "tent-double-peak",
    "anchor-circle-xmark",
    "ellipsis-h",
    "ellipsis",
    "nfc-slash",
    "chess-pawn",
    "first-aid",
    "kit-medical",
    "grid-2-plus",
    "bells",
    "person-through-window",
    "toolbox",
    "envelope-badge",
    "envelope-dot",
    "magnifying-glass-waveform",
    "hands-holding-circle",
    "bug",
    "bowl-chopsticks",
    "credit-card-alt",
    "credit-card",
    "circle-s",
    "box-ballot",
    "automobile",
    "car",
    "hand-holding-hand",
    "user-tie-hair",
    "podium-star",
    "business-front",
    "party-back",
    "trian-balbot",
    "user-hair-mullet",
    "microphone-stand",
    "book-reader",
    "book-open-reader",
    "family-dress",
    "circle-x",
    "cabin",
    "mountain-sun",
    "chart-simple-horizontal",
    "bluetooth",
    "arrows-left-right-to-line",
    "hand-back-point-left",
    "comment-alt-dots",
    "messaging",
    "message-dots",
    "file-heart",
    "beer-foam",
    "beer-mug",
    "dice-d20",
    "drone",
    "truck-droplet",
    "file-circle-xmark",
    "temperature-up",
    "temperature-arrow-up",
    "medal",
    "person-fairy",
    "bed",
    "book-copy",
    "h-square",
    "square-h",
    "square-c",
    "clock-two",
    "square-ellipsis-vertical",
    "calendar-users",
    "podcast",
    "bee",
    "temperature-4",
    "thermometer-4",
    "thermometer-full",
    "temperature-full",
    "bell",
    "chocolate-bar",
    "candy-bar",
    "xmark-large",
    "pinata",
    "file-ppt",
    "arrows-from-line",
    "superscript",
    "bowl-spoon",
    "hexagon-check",
    "plug-circle-xmark",
    "star-of-life",
    "phone-slash",
    "traffic-light-stop",
    "paint-roller",
    "accent-grave",
    "hands-helping",
    "handshake-angle",
    "circle-0",
    "dial-med-low",
    "map-marker-alt",
    "location-dot",
    "crab",
    "box-full",
    "box-open-full",
    "file",
    "greater-than",
    "quotes",
    "pretzel",
    "t-rex",
    "swimmer",
    "person-swimming",
    "arrow-down",
    "user-robot-xmarks",
    "comment-alt-quote",
    "message-quote",
    "candy-corn",
    "folder-search",
    "folder-magnifying-glass",
    "notebook",
    "circle-wifi",
    "tint",
    "droplet",
    "bullseye-pointer",
    "eraser",
    "hexagon-image",
    "earth",
    "earth-america",
    "globe-americas",
    "earth-americas",
    "file-svg",
    "apple-crate",
    "crate-apple",
    "person-burst",
    "game-board",
    "hat-chef",
    "hand-back-point-right",
    "dove",
    "snowflake-droplets",
    "battery-0",
    "battery-empty",
    "grid-4",
    "socks",
    "face-sunglasses",
    "inbox",
    "square-0",
    "section",
    "box-up",
    "square-this-way-up",
    "tachometer-alt",
    "tachometer-alt-fast",
    "gauge-high",
    "square-ampersand",
    "envelope-open-text",
    "lamp-desk",
    "hospital-alt",
    "hospital-wide",
    "hospital",
    "poll-people",
    "glass-whiskey-rocks",
    "whiskey-glass-ice",
    "wine-bottle",
    "chess-rook",
    "user-bounty-hunter",
    "reorder",
    "stream",
    "bars-staggered",
    "diagram-sankey",
    "cloud-hail-mixed",
    "circle-up-left",
    "dharmachakra",
    "objects-align-left",
    "oil-can-drip",
    "face-smiling-hands",
    "broccoli",
    "route-interstate",
    "ear-muffs",
    "hotdog",
    "transporter-empty",
    "blind",
    "person-walking-with-cane",
    "angle-90",
    "rectangle-terminal",
    "kite",
    "drum",
    "scrubber",
    "ice-cream",
    "heart-circle-bolt",
    "fish-bones",
    "deer-rudolph",
    "fax",
    "paragraph",
    "head-side-heart",
    "square-e",
    "meter-fire",
    "cloud-hail",
    "vote-yea",
    "check-to-slot",
    "money-from-bracket",
    "star-half",
    "car-bus",
    "speaker",
    "timer",
    "boxes",
    "boxes-alt",
    "boxes-stacked",
    "landmark-magnifying-glass",
    "grill-hot",
    "ballot-check",
    "chain",
    "link",
    "assistive-listening-systems",
    "ear-listen",
    "file-minus",
    "tree-city",
    "play",
    "font",
    "coffee-togo",
    "cup-togo",
    "square-down-left",
    "burger-lettuce",
    "table-cells-row-lock",
    "rupiah-sign",
    "search",
    "magnifying-glass",
    "ping-pong-paddle-ball",
    "table-tennis",
    "table-tennis-paddle-ball",
    "diagnoses",
    "person-dots-from-line",
    "chevron-double-down",
    "chevrons-down",
    "trash-restore-alt",
    "trash-can-arrow-up",
    "signal-3",
    "signal-good",
    "map-marker-question",
    "location-question",
    "floppy-disk-times",
    "save-circle-xmark",
    "save-times",
    "floppy-disk-circle-xmark",
    "naira-sign",
    "peach",
    "taxi-bus",
    "bracket-curly-left",
    "bracket-curly",
    "lobster",
    "dolly-flatbed-empty",
    "cart-flatbed-empty",
    "colon",
    "cart-arrow-down",
    "wand",
    "walkie-talkie",
    "file-edit",
    "file-pen",
    "receipt",
    "table-picnic",
    "pen-square",
    "pencil-square",
    "square-pen",
    "microphone-circle-alt",
    "circle-microphone-lines",
    "desktop-slash",
    "display-slash",
    "suitcase-rolling",
    "person-circle-exclamation",
    "transporter-2",
    "hand-receiving",
    "hands-holding-diamond",
    "money-bill-simple-wave",
    "chevron-down",
    "battery",
    "battery-5",
    "battery-full",
    "bell-plus",
    "book-arrow-right",
    "hospitals",
    "club",
    "skull-crossbones",
    "dewpoint",
    "droplet-degree",
    "code-compare",
    "list-dots",
    "list-ul",
    "hand-holding-magic",
    "watermelon-slice",
    "circle-ellipsis",
    "school-lock",
    "tower-cell",
    "sd-cards",
    "jug-bottle",
    "long-arrow-alt-down",
    "down-long",
    "envelopes",
    "phone-office",
    "ranking-star",
    "chess-king",
    "nfc-pen",
    "person-harassing",
    "magnifying-glass-play",
    "hat-winter",
    "brazilian-real-sign",
    "landmark-alt",
    "landmark-dome",
    "bone-break",
    "arrow-up",
    "down-from-dotted-line",
    "television",
    "tv-alt",
    "tv",
    "border-left",
    "circle-divide",
    "shrimp",
    "tasks",
    "list-check",
    "diagram-subtask",
    "jug-detergent",
    "user-circle",
    "circle-user",
    "square-y",
    "user-doctor-hair",
    "planet-ringed",
    "mushroom",
    "user-shield",
    "megaphone",
    "wreath-laurel",
    "circle-exclamation-check",
    "wind",
    "box-usd",
    "box-dollar",
    "car-crash",
    "car-burst",
    "y",
    "user-headset",
    "retweet-alt",
    "arrows-retweet",
    "snowboarding",
    "person-snowboarding",
    "chevron-square-right",
    "square-chevron-right",
    "lacrosse-stick-ball",
    "shipping-fast",
    "truck-fast",
    "user-magnifying-glass",
    "star-sharp",
    "comment-heart",
    "circle-1",
    "star-circle",
    "circle-star",
    "fish",
    "fog",
    "cloud-fog",
    "waffle",
    "music-alt",
    "music-note",
    "hexagon-exclamation",
    "cart-shopping-fast",
    "object-union",
    "user-graduate",
    "starfighter",
    "adjust",
    "circle-half-stroke",
    "arrow-right-long-to-line",
    "arrow-square-down",
    "square-arrow-down",
    "diamond-half-stroke",
    "clapperboard",
    "chevron-square-left",
    "square-chevron-left",
    "phone-intercom",
    "chain-horizontal",
    "link-horizontal",
    "mango",
    "music-alt-slash",
    "music-note-slash",
    "radiation-alt",
    "circle-radiation",
    "face-tongue-sweat",
    "globe-stand",
    "baseball-ball",
    "baseball",
    "circle-p",
    "award-simple",
    "jet-fighter-up",
    "project-diagram",
    "diagram-project",
    "pedestal",
    "chart-pyramid",
    "sidebar",
    "frosty-head",
    "snowman-head",
    "copy",
    "burger-glass",
    "volume-mute",
    "volume-times",
    "volume-xmark",
    "hand-sparkles",
    "bars-filter",
    "paintbrush-pencil",
    "party-bell",
    "user-vneck-hair",
    "jack-o-lantern",
    "grip-horizontal",
    "grip",
    "share-square",
    "share-from-square",
    "keynote",
    "child-rifle",
    "child-combatant",
    "gun",
    "phone-square",
    "square-phone",
    "hat-beach",
    "add",
    "plus",
    "expand",
    "computer",
    "fort",
    "cloud-check",
    "close",
    "multiply",
    "remove",
    "times",
    "xmark",
    "face-smirking",
    "arrows",
    "arrows-up-down-left-right",
    "chalkboard-teacher",
    "chalkboard-user",
    "rhombus",
    "claw-marks",
    "peso-sign",
    "face-smile-tongue",
    "cart-circle-xmark",
    "building-shield",
    "phone-circle-alt",
    "circle-phone-flip",
    "baby",
    "users-line",
    "quote-left-alt",
    "quote-left",
    "tractor",
    "down-from-bracket",
    "key-skeleton",
    "trash-restore",
    "trash-arrow-up",
    "arrow-down-up-lock",
    "arrow-down-to-bracket",
    "lines-leaning",
    "square-q",
    "ruler-combined",
    "icons-alt",
    "symbols",
    "copyright",
    "flask-gear",
    "highlighter-line",
    "bracket",
    "bracket-left",
    "bracket-square",
    "island-tree-palm",
    "island-tropical",
    "arrow-from-left",
    "arrow-right-from-line",
    "h2",
    "equals",
    "shortcake",
    "cake-slice",
    "building-magnifying-glass",
    "peanut",
    "wrench-simple",
    "blender",
    "teeth",
    "tally-2",
    "ils",
    "shekel",
    "sheqel",
    "sheqel-sign",
    "shekel-sign",
    "cars",
    "axe-battle",
    "user-hair-long",
    "map",
    "arrow-left-from-arc",
    "file-circle-info",
    "face-disappointed",
    "lasso-sparkles",
    "clock-eleven",
    "rocket",
    "siren-on",
    "clock-ten",
    "candle-holder",
    "video-arrow-down-left",
    "photo-video",
    "photo-film",
    "save-circle-arrow-right",
    "floppy-disk-circle-arrow-right",
    "folder-minus",
    "planet-moon",
    "face-eyes-xmarks",
    "chart-scatter",
    "circle-gf",
    "display-arrow-down",
    "store",
    "arrow-trend-up",
    "plug-circle-minus",
    "olive-branch",
    "angle",
    "vacuum-robot",
    "sign",
    "sign-hanging",
    "square-divide",
    "folder-check",
    "signal-stream-slash",
    "bezier-curve",
    "eye-dropper-half",
    "store-lock",
    "bell-slash",
    "thunderstorm-sun",
    "cloud-bolt-sun",
    "camera-slash",
    "comment-quote",
    "tablet-android",
    "tablet",
    "school-flag",
    "message-code",
    "glass-half-empty",
    "glass-half-full",
    "glass-half",
    "fill",
    "comment-alt-minus",
    "message-minus",
    "angle-up",
    "dinosaur",
    "drumstick-bite",
    "chain-horizontal-slash",
    "link-horizontal-slash",
    "holly-berry",
    "nose",
    "arrow-left-to-arc",
    "chevron-left",
    "bacteria",
    "clouds",
    "money-bill-simple",
    "hand-lizard",
    "table-pivot",
    "filter-slash",
    "trash-can-arrow-turn-left",
    "trash-undo-alt",
    "trash-can-undo",
    "notdef",
    "disease",
    "person-to-door",
    "turntable",
    "briefcase-medical",
    "genderless",
    "chevron-right",
    "signal-1",
    "signal-weak",
    "clock-five",
    "retweet",
    "car-alt",
    "car-rear",
    "pump-soap",
    "computer-classic",
    "frame",
    "video-slash",
    "battery-2",
    "battery-quarter",
    "ellipsis-h-alt",
    "ellipsis-stroke",
    "radio",
    "carriage-baby",
    "baby-carriage",
    "face-expressionless",
    "down-to-dotted-line",
    "cloud-music",
    "traffic-light",
    "cloud-minus",
    "thermometer",
    "shield-minus",
    "vr-cardboard",
    "car-tilt",
    "gauge-circle-minus",
    "brightness-low",
    "hand-middle-finger",
    "percentage",
    "percent",
    "truck-moving",
    "glass-water-droplet",
    "conveyor-belt",
    "map-marker-check",
    "location-check",
    "coin-vertical",
    "display",
    "person-sign",
    "smile",
    "face-smile",
    "phone-hangup",
    "signature-slash",
    "thumb-tack",
    "thumbtack",
    "wheat-slash",
    "trophy",
    "clouds-sun",
    "pray",
    "person-praying",
    "hammer",
    "face-vomit",
    "speakers",
    "teletype-answer",
    "tty-answer",
    "mug-tea-saucer",
    "diagram-lean-canvas",
    "alt",
    "dial-med-high",
    "dial",
    "hand-peace",
    "trash-circle",
    "circle-trash",
    "sync-alt",
    "rotate",
    "circle-quarters",
    "spinner",
    "tower-control",
    "sort-shapes-up",
    "arrow-up-triangle-square",
    "whale",
    "robot",
    "peace",
    "party-horn",
    "cogs",
    "gears",
    "sun-alt",
    "sun-bright",
    "warehouse",
    "conveyor-belt-arm",
    "lock-open-alt",
    "lock-keyhole-open",
    "box-fragile",
    "square-wine-glass-crack",
    "square-fragile",
    "arrow-up-right-dots",
    "square-n",
    "splotch",
    "grin-hearts",
    "face-grin-hearts",
    "meter",
    "mandolin",
    "dice-four",
    "sim-card",
    "transgender-alt",
    "transgender",
    "mercury",
    "up-from-bracket",
    "knife-kitchen",
    "border-right",
    "level-down",
    "arrow-turn-down",
    "spade",
    "card-spade",
    "line-columns",
    "ant",
    "arrow-to-right",
    "arrow-right-to-line",
    "person-falling-burst",
    "pennant",
    "flag-pennant",
    "conveyor-belt-empty",
    "user-group-simple",
    "award",
    "ticket-alt",
    "ticket-simple",
    "building",
    "angle-double-left",
    "angles-left",
    "video-handheld",
    "camcorder",
    "pancakes",
    "album-circle-user",
    "subtitles-slash",
    "qrcode",
    "dice-d10",
    "fireplace",
    "browser",
    "pencil-paintbrush",
    "pen-paintbrush",
    "fish-cooked",
    "chair-office",
    "magnifying-glass-music",
    "nesting-dolls",
    "history",
    "clock-rotate-left",
    "trumpet",
    "grin-beam-sweat",
    "face-grin-beam-sweat",
    "fire-smoke",
    "phone-missed",
    "arrow-right-from-file",
    "file-export",
    "shield-blank",
    "shield",
    "sort-amount-up-alt",
    "arrow-up-short-wide",
    "repeat-1-alt",
    "arrows-repeat-1",
    "gun-slash",
    "avocado",
    "binary",
    "glasses-alt",
    "glasses-round",
    "phone-plus",
    "ditto",
    "person-seat",
    "house-medical",
    "golf-ball",
    "golf-ball-tee",
    "chevron-circle-left",
    "circle-chevron-left",
    "house-chimney-window",
    "scythe",
    "pen-nib",
    "parking-circle-slash",
    "ban-parking",
    "tent-arrow-turn-left",
    "face-diagonal-mouth",
    "diagram-cells",
    "cricket",
    "cricket-bat-ball",
    "tents",
    "magic",
    "wand-magic",
    "dog",
    "pen-line",
    "atom-alt",
    "atom-simple",
    "ampersand",
    "carrot",
    "arrow-from-bottom",
    "arrow-up-from-line",
    "moon",
    "pen-slash",
    "wine-glass-alt",
    "wine-glass-empty",
    "square-star",
    "cheese",
    "send-backward",
    "yin-yang",
    "music",
    "compass-slash",
    "clock-one",
    "file-music",
    "code-commit",
    "temperature-low",
    "biking",
    "person-biking",
    "display-chart-up-circle-currency",
    "skeleton",
    "circle-g",
    "circle-arrow-up-left",
    "coin-blank",
    "broom",
    "vacuum",
    "shield-heart",
    "card-heart",
    "lightbulb-cfl-on",
    "melon",
    "gopuram",
    "globe-oceania",
    "earth-oceania",
    "container-storage",
    "face-pouting",
    "times-square",
    "xmark-square",
    "square-xmark",
    "exploding-head",
    "face-explode",
    "hashtag",
    "expand-alt",
    "up-right-and-down-left-from-center",
    "oil-can",
    "t",
    "transformer-bolt",
    "hippo",
    "chart-column",
    "vhs",
    "cassette-vhs",
    "infinity",
    "vial-circle-check",
    "chimney",
    "object-intersect",
    "person-arrow-down-to-line",
    "voicemail",
    "wall-brick",
    "block-brick",
    "fan",
    "bags-shopping",
    "paragraph-rtl",
    "paragraph-left",
    "person-walking-luggage",
    "caravan-alt",
    "caravan-simple",
    "turtle",
    "pencil-mechanical",
    "arrows-alt-v",
    "up-down",
    "cloud-moon-rain",
    "booth-curtain",
    "calendar",
    "box-heart",
    "trailer",
    "user-md-chat",
    "user-doctor-message",
    "haykal",
    "bahai",
    "lighthouse",
    "amp-guitar",
    "sd-card",
    "volume-slash",
    "border-bottom",
    "wifi-1",
    "wifi-weak",
    "dragon",
    "shoe-prints",
    "plus-circle",
    "circle-plus",
    "grin-tongue-wink",
    "face-grin-tongue-wink",
    "hand-holding",
    "plug-circle-exclamation",
    "chain-broken",
    "chain-slash",
    "unlink",
    "link-slash",
    "clone",
    "person-walking-arrow-loop-left",
    "sort-alpha-up-alt",
    "arrow-up-z-a",
    "fire-alt",
    "fire-flame-curved",
    "tornado",
    "file-circle-plus",
    "delete-right",
    "quran",
    "book-quran",
    "circle-quarter",
    "anchor",
    "border-all",
    "function",
    "angry",
    "face-angry",
    "people-simple",
    "cookie-bite",
    "arrow-trend-down",
    "feed",
    "rss",
    "face-monocle",
    "draw-polygon",
    "balance-scale",
    "scale-balanced",
    "calendar-note",
    "calendar-lines",
    "sort-size-down",
    "arrow-down-big-small",
    "tachometer",
    "tachometer-fast",
    "gauge-simple-high",
    "do-not-enter",
    "shower",
    "dice-d8",
    "desktop-alt",
    "desktop",
    "m",
    "spinner-scale",
    "grip-dots-vertical",
    "face-viewfinder",
    "creemee",
    "soft-serve",
    "h5",
    "hand-back-point-down",
    "th-list",
    "table-list",
    "basket-shopping-minus",
    "sms",
    "comment-sms",
    "rectangle-landscape",
    "rectangle",
    "clipboard-list-check",
    "turkey",
    "book",
    "user-plus",
    "ice-skate",
    "check",
    "battery-4",
    "battery-three-quarters",
    "tomato",
    "sword-laser",
    "house-circle-check",
    "buildings",
    "angle-left",
    "dolly-flatbed-alt",
    "cart-flatbed-boxes",
    "diagram-successor",
    "truck-arrow-right",
    "square-w",
    "arrows-split-up-and-left",
    "lamp",
    "airplay",
    "fist-raised",
    "hand-fist",
    "shield-quartered",
    "slash-forward",
    "map-marker-edit",
    "location-pen",
    "cloud-moon",
    "pot-food",
    "briefcase",
    "person-falling",
    "portrait",
    "image-portrait",
    "user-tag",
    "rug",
    "print-slash",
    "globe-europe",
    "earth-europe",
    "luggage-cart",
    "cart-flatbed-suitcase",
    "hand-back-point-ribbon",
    "rectangle-times",
    "times-rectangle",
    "window-close",
    "rectangle-xmark",
    "tire-rugged",
    "lightbulb-dollar",
    "cowbell",
    "baht-sign",
    "corner",
    "chevron-double-right",
    "chevrons-right",
    "book-open",
    "journal-whills",
    "book-journal-whills",
    "inhaler",
    "handcuffs",
    "snake",
    "exclamation-triangle",
    "warning",
    "triangle-exclamation",
    "note-medical",
    "database",
    "down-left",
    "mail-forward",
    "share",
    "face-thinking",
    "turn-down-right",
    "bottle-droplet",
    "mask-face",
    "hill-rockslide",
    "scanner-keyboard",
    "circle-o",
    "grid-horizontal",
    "comment-alt-dollar",
    "message-dollar",
    "exchange-alt",
    "right-left",
    "columns-3",
    "paper-plane",
    "road-circle-exclamation",
    "dungeon",
    "hand-holding-box",
    "input-text",
    "window-alt",
    "window-flip",
    "align-right",
    "scanner",
    "scanner-gun",
    "tire",
    "engine",
    "money-bill-wave-alt",
    "money-bill-1-wave",
    "life-ring",
    "sign-language",
    "signing",
    "hands",
    "caret-circle-right",
    "circle-caret-right",
    "turn-left",
    "wheat",
    "file-spreadsheet",
    "audio-description-slash",
    "bell-ring",
    "calendar-day",
    "ladder-water",
    "swimming-pool",
    "water-ladder",
    "arrows-v",
    "arrows-up-down",
    "chess-pawn-alt",
    "chess-pawn-piece",
    "grimace",
    "face-grimace",
    "wheelchair-alt",
    "wheelchair-move",
    "level-down-alt",
    "turn-down",
    "square-s",
    "barcode-alt",
    "rectangle-barcode",
    "person-walking-arrow-right",
    "envelope-square",
    "square-envelope",
    "dice",
    "unicorn",
    "bowling-ball",
    "pompebled",
    "brain",
    "watch-smart",
    "book-user",
    "sensor-smoke",
    "sensor-cloud",
    "clapperboard-play",
    "band-aid",
    "bandage",
    "calendar-minus",
    "times-circle",
    "xmark-circle",
    "circle-xmark",
    "circle-4",
    "gifts",
    "album-collection",
    "hotel",
    "globe-asia",
    "earth-asia",
    "id-card-alt",
    "id-card-clip",
    "search-plus",
    "magnifying-glass-plus",
    "thumbs-up",
    "cloud-showers",
    "user-clock",
    "onion",
    "clock-twelve-thirty",
    "arrow-down-to-dotted-line",
    "allergies",
    "hand-dots",
    "file-invoice",
    "window-minimize",
    "rectangle-wide",
    "comment-arrow-up",
    "garlic",
    "coffee",
    "mug-saucer",
    "brush",
    "tree-decorated",
    "mask",
    "calendar-heart",
    "search-minus",
    "magnifying-glass-minus",
    "flower",
    "arrow-down-from-arc",
    "right-left-large",
    "ruler-vertical",
    "circles-overlap",
    "user-alt",
    "user-large",
    "starship-freighter",
    "train-tram",
    "bridge-suspension",
    "trash-check",
    "user-nurse",
    "boombox",
    "syringe",
    "cloud-sun",
    "shield-exclamation",
    "stopwatch-20",
    "square-full",
    "grip-dots",
    "comment-exclamation",
    "pen-swirl",
    "falafel",
    "circle-2",
    "magnet",
    "jar",
    "gramophone",
    "dice-d12",
    "sticky-note",
    "note-sticky",
    "arrow-alt-down",
    "down",
    "100",
    "hundred-points",
    "paperclip-vertical",
    "wind-circle-exclamation",
    "wind-warning",
    "map-marker-slash",
    "location-pin-slash",
    "face-sad-sweat",
    "bug-slash",
    "cupcake",
    "light-switch-off",
    "toggle-large-off",
    "pen-fancy-slash",
    "truck-container",
    "boot",
    "arrow-up-from-water-pump",
    "file-check",
    "bone",
    "cards-blank",
    "circle-3",
    "bench-tree",
    "keyboard-brightness-low",
    "ski-boot-ski",
    "brain-circuit",
    "user-injured",
    "firewall",
    "block-brick-fire",
    "sad-tear",
    "face-sad-tear",
    "plane",
    "tent-arrows-down",
    "exclamation",
    "arrows-spin",
    "face-smile-relaxed",
    "comment-times",
    "comment-xmark",
    "print",
    "try",
    "turkish-lira",
    "turkish-lira-sign",
    "face-nose-steam",
    "waveform-circle",
    "circle-waveform-lines",
    "dollar",
    "usd",
    "dollar-sign",
    "ferris-wheel",
    "computer-speaker",
    "skull-cow",
    "x",
    "search-dollar",
    "magnifying-glass-dollar",
    "users-cog",
    "users-gear",
    "person-military-pointing",
    "bank",
    "institution",
    "museum",
    "university",
    "building-columns",
    "circle-t",
    "sack",
    "grid-2",
    "cctv",
    "camera-cctv",
    "umbrella",
    "trowel",
    "horizontal-rule",
    "bed-alt",
    "bed-front",
    "d",
    "stapler",
    "theater-masks",
    "masks-theater",
    "file-gif",
    "kip-sign",
    "face-woozy",
    "cloud-question",
    "pineapple",
    "hand-point-left",
    "gallery-thumbnails",
    "circle-j",
    "eyes",
    "handshake-alt",
    "handshake-simple",
    "file-caret-up",
    "page-caret-up",
    "fighter-jet",
    "jet-fighter",
    "comet",
    "share-alt-square",
    "square-share-nodes",
    "reflect-vertical",
    "shield-keyhole",
    "file-mp4",
    "barcode",
    "bulldozer",
    "plus-minus",
    "sliders-v-square",
    "square-sliders-vertical",
    "video-camera",
    "video",
    "comment-middle-alt",
    "message-middle",
    "mortar-board",
    "graduation-cap",
    "hand-holding-medical",
    "person-circle-check",
    "square-z",
    "comment-alt-text",
    "message-text",
    "level-up-alt",
    "turn-up"
  ]
}; 
export default faMetadata;